webpackJsonp([0],{

/***/ 108:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FANTASY_ACTION_TYPES = undefined;

var _object = __webpack_require__(12);

var FANTASY_ACTION_TYPES = exports.FANTASY_ACTION_TYPES = (0, _object.namespacedConsts)({
  TOURNAMENT: {
    LOAD_MORE: true,
    GET_TOURNAMENTS_FEED: true,
    SELECT_TOURNAMENT: true
  }
});

/***/ }),

/***/ 1136:
/***/ (function(module, exports, __webpack_require__) {

"use strict";



module.exports = __webpack_require__(1139);


/***/ }),

/***/ 1137:
/***/ (function(module, exports) {

/*
 * File: iframeResizer.contentWindow.js
 * Desc: Include this file in any page being loaded into an iframe
 *       to force the iframe to resize to the content size.
 * Requires: iframeResizer.js on host page.
 * Doc: https://github.com/davidjbradshaw/iframe-resizer
 * Author: David J. Bradshaw - dave@bradshaw.net
 * Contributor: Jure Mav - jure.mav@gmail.com
 * Contributor: Ian Caunce - ian@hallnet.co.uk
 */

;(function() {
	'use strict';

	var
		autoResize            = true,
		base                  = 10,
		bodyBackground        = '',
		bodyMargin            = 0,
		bodyMarginStr         = '',
		bodyPadding           = '',
		calculateWidth        = false,
		doubleEventList       = {'resize':1,'click':1},
		eventCancelTimer      = 128,
		firstRun              = true,
		height                = 1,
		heightCalcModeDefault = 'offset',
		heightCalcMode        = heightCalcModeDefault,
		initLock              = true,
		initMsg               = '',
		inPageLinks           = {},
		interval              = 32,
		logging               = false,
		msgID                 = '[iFrameSizer]',  //Must match host page msg ID
		msgIdLen              = msgID.length,
		myID                  = '',
		publicMethods         = false,
		resetRequiredMethods  = {max:1,scroll:1,bodyScroll:1,documentElementScroll:1},
		resizeFrom            = 'parent',
		targetOriginDefault   = '*',
		target                = window.parent,
		tolerance             = 0,
		triggerLocked         = false,
		triggerLockedTimer    = null,
		width                 = 1;


	function addEventListener(el,evt,func){
		if ('addEventListener' in window){
			el.addEventListener(evt,func, false);
		} else if ('attachEvent' in window){ //IE
			el.attachEvent('on'+evt,func);
		}
	}

	function formatLogMsg(msg){
		return msgID + '[' + myID + ']' + ' ' + msg;
	}

	function log(msg){
		if (logging && ('object' === typeof window.console)){
			console.log(formatLogMsg(msg));
		}
	}

	function warn(msg){
		if ('object' === typeof window.console){
			console.warn(formatLogMsg(msg));
		}
	}


	function init(){
		log('Initialising iFrame');
		readData();
		setMargin();
		setBodyStyle('background',bodyBackground);
		setBodyStyle('padding',bodyPadding);
		injectClearFixIntoBodyElement();
		checkHeightMode();
		stopInfiniteResizingOfIFrame();
		setupPublicMethods();
		startEventListeners();
		inPageLinks = setupInPageLinks();
		sendSize('init','Init message from host page');
	}

	function readData(){

		var data = initMsg.substr(msgIdLen).split(':');

		function strBool(str){
			return 'true' === str ? true : false;
		}

		myID               = data[0];
		bodyMargin         = (undefined !== data[1]) ? Number(data[1])   : bodyMargin; //For V1 compatibility
		calculateWidth     = (undefined !== data[2]) ? strBool(data[2])  : calculateWidth;
		logging            = (undefined !== data[3]) ? strBool(data[3])  : logging;
		interval           = (undefined !== data[4]) ? Number(data[4])   : interval;
		publicMethods      = (undefined !== data[5]) ? strBool(data[5])  : publicMethods;
		autoResize         = (undefined !== data[6]) ? strBool(data[6])  : autoResize;
		bodyMarginStr      = data[7];
		heightCalcMode     = (undefined !== data[8]) ? data[8]           : heightCalcMode;
		bodyBackground     = data[9];
		bodyPadding        = data[10];
		tolerance          = (undefined !== data[11]) ? Number(data[11]) : tolerance;
		inPageLinks.enable = (undefined !== data[12]) ? strBool(data[12]): false;
		resizeFrom         = data[13];
	}

	function chkCSS(attr,value){
		if (-1 !== value.indexOf('-')){
			warn('Negative CSS value ignored for '+attr);
			value='';
		}
		return value;
	}

	function setBodyStyle(attr,value){
		if ((undefined !== value) && ('' !== value) && ('null' !== value)){
			document.body.style[attr] = value;
			log('Body '+attr+' set to "'+value+'"');
		}
	}

	function setMargin(){
		//If called via V1 script, convert bodyMargin from int to str
		if (undefined === bodyMarginStr){
			bodyMarginStr = bodyMargin+'px';
		}
		chkCSS('margin',bodyMarginStr);
		setBodyStyle('margin',bodyMarginStr);
	}

	function stopInfiniteResizingOfIFrame(){
		document.documentElement.style.height = '';
		document.body.style.height = '';
		log('HTML & body height set to "auto"');
	}


	function addTriggerEvent(options){
		function addListener(eventName){
			addEventListener(window,eventName,function(){
				sendSize(options.eventName,options.eventType);
			});
		}

		if(options.eventNames && Array.prototype.map){
			options.eventName = options.eventNames[0];
			options.eventNames.map(addListener);
		} else {
			addListener(options.eventName);
		}

		log('Added event listener: ' + options.eventType);
	}

	function initEventListeners(){
		addTriggerEvent({ eventType: 'Animation Start',           eventNames: ['animationstart','webkitAnimationStart'] });
		addTriggerEvent({ eventType: 'Animation Iteration',       eventNames: ['animationiteration','webkitAnimationIteration'] });
		addTriggerEvent({ eventType: 'Animation End',             eventNames: ['animationend','webkitAnimationEnd'] });
		addTriggerEvent({ eventType: 'Device Orientation Change', eventName:  'deviceorientation' });
		addTriggerEvent({ eventType: 'Transition End',            eventNames: ['transitionend','webkitTransitionEnd','MSTransitionEnd','oTransitionEnd','otransitionend'] });
		addTriggerEvent({ eventType: 'Window Clicked',            eventName:  'click' });
		//addTriggerEvent({ eventType: 'Window Mouse Down',         eventName:  'mousedown' });
		//addTriggerEvent({ eventType: 'Window Mouse Up',           eventName:  'mouseup' });
		if('child' === resizeFrom){
			addTriggerEvent({ eventType: 'IFrame Resized',        eventName:  'resize' });
		}
	}

	function checkHeightMode(){
		if (heightCalcModeDefault !== heightCalcMode){
			if (!(heightCalcMode in getHeight)){
				warn(heightCalcMode + ' is not a valid option for heightCalculationMethod.');
				heightCalcMode='bodyScroll';
			}
			log('Height calculation method set to "'+heightCalcMode+'"');
		}
	}

	function startEventListeners(){
		if ( true === autoResize ) {
			initEventListeners();
			setupMutationObserver();
		}
		else {
			log('Auto Resize disabled');
		}
	}

	function injectClearFixIntoBodyElement(){
		var clearFix = document.createElement('div');
		clearFix.style.clear = 'both';
		clearFix.style.display = 'block'; //Guard against this having been globally redefined in CSS.
		document.body.appendChild(clearFix);
	}

	function setupInPageLinks(){

		function getPagePosition (){
			return {
				x: (window.pageXOffset !== undefined) ? window.pageXOffset : document.documentElement.scrollLeft,
				y: (window.pageYOffset !== undefined) ? window.pageYOffset : document.documentElement.scrollTop
			};
		}

		function getElementPosition(el){
			var
				elPosition   = el.getBoundingClientRect(),
				pagePosition = getPagePosition();

			return {
				x: parseInt(elPosition.left,10) + parseInt(pagePosition.x,10),
				y: parseInt(elPosition.top,10)  + parseInt(pagePosition.y,10)
			};
		}

		function findTarget(location){
			var hash = location.split("#")[1] || "";
			var hashData = decodeURIComponent(hash);

			function jumpToTarget(target){
				var jumpPosition = getElementPosition(target);

				log('Moving to in page link (#'+hash+') at x: '+jumpPosition.x+' y: '+jumpPosition.y);
				sendMsg(jumpPosition.y, jumpPosition.x, 'scrollToOffset'); // X&Y reversed at sendMsg uses height/width
			}

			var target = document.getElementById(hashData) || document.getElementsByName(hashData)[0];

			if (target){
				jumpToTarget(target);
			} else {
				log('In page link (#' + hash + ') not found in iFrame, so sending to parent');
				sendMsg(0,0,'inPageLink','#'+hash);
			}
		}

		function checkLocationHash(){
			if ('' !== location.hash && '#' !== location.hash){
				findTarget(location.href);
			}
		}

		function bindAnchors(){
			function setupLink(el){
				function linkClicked(e){
					e.preventDefault();

					/*jshint validthis:true */
					findTarget(this.getAttribute('href'));
				}

				if ('#' !== el.getAttribute('href')){
					addEventListener(el,'click',linkClicked);
				}
			}

			Array.prototype.forEach.call( document.querySelectorAll( 'a[href^="#"]' ), setupLink );
		}

		function bindLocationHash(){
			addEventListener(window,'hashchange',checkLocationHash);
		}

		function initCheck(){ //check if page loaded with location hash after init resize
			setTimeout(checkLocationHash,eventCancelTimer);
		}

		function enableInPageLinks(){
			if(Array.prototype.forEach && document.querySelectorAll){
				log('Setting up location.hash handlers');
				bindAnchors();
				bindLocationHash();
				initCheck();
			} else {
				warn('In page linking not fully supported in this browser! (See README.md for IE8 workaround)');
			}
		}

		if(inPageLinks.enable){
			enableInPageLinks();
		} else {
			log('In page linking not enabled');
		}

		return {
			findTarget:findTarget
		};
	}

	function setupPublicMethods(){
		if (publicMethods) {
			log('Enable public methods');

			window.parentIFrame = {
				close: function closeF(){
					sendMsg(0,0,'close');
				},

				getId: function getIdF(){
					return myID;
				},

				moveToAnchor: function moveToAnchorF(hash){
					inPageLinks.findTarget(hash);
				},

				reset: function resetF(){
					resetIFrame('parentIFrame.reset');
				},

				scrollTo: function scrollToF(x,y){
					sendMsg(y,x,'scrollTo'); // X&Y reversed at sendMsg uses height/width
				},

				scrollToOffset: function scrollToF(x,y){
					sendMsg(y,x,'scrollToOffset'); // X&Y reversed at sendMsg uses height/width
				},

				sendMessage: function sendMessageF(msg,targetOrigin){
					sendMsg(0,0,'message',JSON.stringify(msg),targetOrigin);
				},

				setHeightCalculationMethod: function setHeightCalculationMethodF(heightCalculationMethod){
					heightCalcMode = heightCalculationMethod;
					checkHeightMode();
				},

				setTargetOrigin: function setTargetOriginF(targetOrigin){
					log('Set targetOrigin: '+targetOrigin);
					targetOriginDefault = targetOrigin;
				},

				size: function sizeF(customHeight, customWidth){
					var valString = ''+(customHeight?customHeight:'')+(customWidth?','+customWidth:'');
					lockTrigger();
					sendSize('size','parentIFrame.size('+valString+')', customHeight, customWidth);
				}
			};
		}
	}

	function initInterval(){
		if ( 0 !== interval ){
			log('setInterval: '+interval+'ms');
			setInterval(function(){
				sendSize('interval','setInterval: '+interval);
			},Math.abs(interval));
		}
	}

	function setupInjectElementLoadListners(mutations){
		function addLoadListener(element){
			if (element.height === undefined || element.width === undefined || 0 === element.height || 0 === element.width){
				log('Attach listerner to '+element.src);
				addEventListener(element,'load', function imageLoaded(){
					sendSize('imageLoad','Image loaded');
				});
			}
		}

		mutations.forEach(function (mutation) {
			if (mutation.type === 'attributes' && mutation.attributeName === 'src'){
				addLoadListener(mutation.target);
			} else if (mutation.type === 'childList'){
				var images = mutation.target.querySelectorAll('img');
				Array.prototype.forEach.call(images,function (image) {
					addLoadListener(image);
				});
			}
		});
	}

	function setupMutationObserver(){

		var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;

		function createMutationObserver(){
			var
				target = document.querySelector('body'),

				config = {
					attributes            : true,
					attributeOldValue     : false,
					characterData         : true,
					characterDataOldValue : false,
					childList             : true,
					subtree               : true
				},

				observer = new MutationObserver(function(mutations) {
					sendSize('mutationObserver','mutationObserver: ' + mutations[0].target + ' ' + mutations[0].type);
					setupInjectElementLoadListners(mutations); //Deal with WebKit asyncing image loading when tags are injected into the page
				});

			log('Enable MutationObserver');
			observer.observe(target, config);
		}

		if (MutationObserver){
			if (0 > interval) {
				initInterval();
			} else {
				createMutationObserver();
			}
		}
		else {
			warn('MutationObserver not supported in this browser!');
			initInterval();
		}
	}


	// document.documentElement.offsetHeight is not reliable, so
	// we have to jump through hoops to get a better value.
	function getBodyOffsetHeight(){
		function getComputedBodyStyle(prop) {
			function convertUnitsToPxForIE8(value) {
				var PIXEL = /^\d+(px)?$/i;

				if (PIXEL.test(value)) {
					return parseInt(value,base);
				}

				var
					style = el.style.left,
					runtimeStyle = el.runtimeStyle.left;

				el.runtimeStyle.left = el.currentStyle.left;
				el.style.left = value || 0;
				value = el.style.pixelLeft;
				el.style.left = style;
				el.runtimeStyle.left = runtimeStyle;

				return value;
			}

			var
				el = document.body,
				retVal = 0;

			if (('defaultView' in document) && ('getComputedStyle' in document.defaultView)) {
				retVal = document.defaultView.getComputedStyle(el, null);
				retVal = (null !== retVal) ? retVal[prop] : 0;
			} else {//IE8
				retVal =  convertUnitsToPxForIE8(el.currentStyle[prop]);
			}

			return parseInt(retVal,base);
		}

		return  document.body.offsetHeight +
				getComputedBodyStyle('marginTop') +
				getComputedBodyStyle('marginBottom');
	}

	function getBodyScrollHeight(){
		return document.body.scrollHeight;
	}

	function getDEOffsetHeight(){
		return document.documentElement.offsetHeight;
	}

	function getDEScrollHeight(){
		return document.documentElement.scrollHeight;
	}

	//From https://github.com/guardian/iframe-messenger
	function getLowestElementHeight() {
		var
			allElements       = document.querySelectorAll('body *'),
			allElementsLength = allElements.length,
			maxBottomVal      = 0,
			timer             = new Date().getTime();

		for (var i = 0; i < allElementsLength; i++) {
			if (allElements[i].getBoundingClientRect().bottom > maxBottomVal) {
				maxBottomVal = allElements[i].getBoundingClientRect().bottom;
			}
		}

		timer = new Date().getTime() - timer;

		log('Parsed '+allElementsLength+' HTML elements');
		log('LowestElement bottom position calculated in ' + timer + 'ms');

		return maxBottomVal;
	}

	function getAllHeights(){
		return [
			getBodyOffsetHeight(),
			getBodyScrollHeight(),
			getDEOffsetHeight(),
			getDEScrollHeight()
		];
	}

	function getMaxHeight(){
		return Math.max.apply(null,getAllHeights());
	}

	function getMinHeight(){
		return Math.min.apply(null,getAllHeights());
	}

	function getBestHeight(){
		return Math.max(getBodyOffsetHeight(),getLowestElementHeight());
	}

	var getHeight = {
		offset                : getBodyOffsetHeight, //Backward compatability
		bodyOffset            : getBodyOffsetHeight,
		bodyScroll            : getBodyScrollHeight,
		documentElementOffset : getDEOffsetHeight,
		scroll                : getDEScrollHeight, //Backward compatability
		documentElementScroll : getDEScrollHeight,
		max                   : getMaxHeight,
		min                   : getMinHeight,
		grow                  : getMaxHeight,
		lowestElement         : getBestHeight
	};

	function getWidth(){
		return Math.max(
			document.documentElement.scrollWidth,
			document.body.scrollWidth
		);
	}

	function sendSize(triggerEvent, triggerEventDesc, customHeight, customWidth){

		var	currentHeight,currentWidth;

		function recordTrigger(){
			if (!(triggerEvent in {'reset':1,'resetPage':1,'init':1})){
				log( 'Trigger event: ' + triggerEventDesc );
			}
		}

		function resizeIFrame(){
			height = currentHeight;
			width  = currentWidth;

			sendMsg(height,width,triggerEvent);
		}

		function isDoubleFiredEvent(){
			return  triggerLocked && (triggerEvent in doubleEventList);
		}

		function isSizeChangeDetected(){
			function checkTolarance(a,b){
				var retVal = Math.abs(a-b) <= tolerance;
				return !retVal;
			}

			currentHeight = (undefined !== customHeight)  ? customHeight : getHeight[heightCalcMode]();
			currentWidth  = (undefined !== customWidth )  ? customWidth  : getWidth();

			return	checkTolarance(height,currentHeight) || (calculateWidth && checkTolarance(width,currentWidth));
		}

		function isForceResizableEvent(){
			return !(triggerEvent in {'init':1,'interval':1,'size':1});
		}

		function isForceResizableHeightCalcMode(){
			return (heightCalcMode in resetRequiredMethods);
		}

		function logIgnored(){
			log('No change in size detected');
		}

		function checkDownSizing(){
			if (isForceResizableEvent() && isForceResizableHeightCalcMode()){
				resetIFrame(triggerEventDesc);
			} else if (!(triggerEvent in {'interval':1})){
				recordTrigger();
				logIgnored();
			}
		}

		if (!isDoubleFiredEvent()){
			if (isSizeChangeDetected() || 'init' === triggerEvent){
				recordTrigger();
				lockTrigger();
				resizeIFrame();
			} else {
				checkDownSizing();
			}
		} else {
			log('Trigger event cancelled: '+triggerEvent);
		}
	}

	function lockTrigger(){
		if (!triggerLocked){
			triggerLocked = true;
			log('Trigger event lock on');
		}
		clearTimeout(triggerLockedTimer);
		triggerLockedTimer = setTimeout(function(){
			triggerLocked = false;
			log('Trigger event lock off');
			log('--');
		},eventCancelTimer);
	}

	function triggerReset(triggerEvent){
		height = getHeight[heightCalcMode]();
		width  = getWidth();

		sendMsg(height,width,triggerEvent);
	}

	function resetIFrame(triggerEventDesc){
		var hcm = heightCalcMode;
		heightCalcMode = heightCalcModeDefault;

		log('Reset trigger event: ' + triggerEventDesc);
		lockTrigger();
		triggerReset('reset');

		heightCalcMode = hcm;
	}

	function sendMsg(height,width,triggerEvent,msg,targetOrigin){
		function setTargetOrigin(){
			if (undefined === targetOrigin){
				targetOrigin = targetOriginDefault;
			} else {
				log('Message targetOrigin: '+targetOrigin);
			}
		}

		function sendToParent(){
			var
				size  = height + ':' + width,
				message = myID + ':' +  size + ':' + triggerEvent + (undefined !== msg ? ':' + msg : '');

			log('Sending message to host page (' + message + ')');
			target.postMessage( msgID + message, targetOrigin);
		}

		setTargetOrigin();
		sendToParent();
	}

	function receiver(event) {
		function isMessageForUs(){
			return msgID === (''+event.data).substr(0,msgIdLen); //''+ Protects against non-string messages
		}

		function initFromParent(){
			initMsg = event.data;
			target  = event.source;

			init();
			firstRun = false;
			setTimeout(function(){ initLock = false;},eventCancelTimer);
		}

		function resetFromParent(){
			if (!initLock){
				log('Page size reset by host page');
				triggerReset('resetPage');
			} else {
				log('Page reset ignored by init');
			}
		}

		function resizeFromParent(){
			sendSize('resizeParent','Parent window resized');
		}

		function getMessageType(){
			return event.data.split(']')[1];
		}

		function isMiddleTier(){
			return ('iFrameResize' in window);
		}

		function isInitMsg(){
			//Test if this message is from a child below us. This is an ugly test, however, updating
			//the message format would break backwards compatibity.
			return event.data.split(':')[2] in {'true':1,'false':1};
		}

		if (isMessageForUs()){
			if (false === firstRun) {
				switch (getMessageType()){
				case 'reset':
					resetFromParent();
					break;
				case 'resize':
					resizeFromParent();
					break;
				default:
					if (!isMiddleTier()){
						warn('Unexpected message ('+event.data+')');
					}
				}
			} else if (isInitMsg()) {
				initFromParent();
			} else {
				log('Ignored message of type "' + getMessageType() + '". Received before initialization.');
			}
		}
	}

	addEventListener(window, 'message', receiver);

})();


/***/ }),

/***/ 1138:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 * File: iframeResizer.js
 * Desc: Force iframes to size to content.
 * Requires: iframeResizer.contentWindow.js to be loaded into the target frame.
 * Doc: https://github.com/davidjbradshaw/iframe-resizer
 * Author: David J. Bradshaw - dave@bradshaw.net
 * Contributor: Jure Mav - jure.mav@gmail.com
 * Contributor: Reed Dadoune - reed@dadoune.com
 */
;(function() {
	'use strict';

	var
		count                 = 0,
		logEnabled            = false,
		msgHeader             = 'message',
		msgHeaderLen          = msgHeader.length,
		msgId                 = '[iFrameSizer]', //Must match iframe msg ID
		msgIdLen              = msgId.length,
		pagePosition          = null,
		requestAnimationFrame = window.requestAnimationFrame,
		resetRequiredMethods  = {max:1,scroll:1,bodyScroll:1,documentElementScroll:1},
		settings              = {},
		timer                 = null,

		defaults              = {
			autoResize                : true,
			bodyBackground            : null,
			bodyMargin                : null,
			bodyMarginV1              : 8,
			bodyPadding               : null,
			checkOrigin               : true,
			enableInPageLinks         : false,
			enablePublicMethods       : false,
			heightCalculationMethod   : 'offset',
			interval                  : 32,
			log                       : false,
			maxHeight                 : Infinity,
			maxWidth                  : Infinity,
			minHeight                 : 0,
			minWidth                  : 0,
			resizeFrom                : 'parent',
			scrolling                 : false,
			sizeHeight                : true,
			sizeWidth                 : false,
			tolerance                 : 0,
			closedCallback            : function(){},
			initCallback              : function(){},
			messageCallback           : function(){},
			resizedCallback           : function(){},
			scrollCallback            : function(){return true;}
		};

	function addEventListener(obj,evt,func){
		if ('addEventListener' in window){
			obj.addEventListener(evt,func, false);
		} else if ('attachEvent' in window){//IE
			obj.attachEvent('on'+evt,func);
		}
	}

	function setupRequestAnimationFrame(){
		var
			vendors = ['moz', 'webkit', 'o', 'ms'],
			x;

		// Remove vendor prefixing if prefixed and break early if not
		for (x = 0; x < vendors.length && !requestAnimationFrame; x += 1) {
			requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
		}

		if (!(requestAnimationFrame)){
			log(' RequestAnimationFrame not supported');
		}
	}

	function getMyID(){
		var retStr = 'Host page';

		if (window.top!==window.self){
			if (window.parentIFrame){
				retStr = window.parentIFrame.getId();
			} else {
				retStr = 'Nested host page';
			}
		}

		return retStr;
	}

	function formatLogMsg(msg){
		return msgId + '[' + getMyID() + ']' + msg;
	}

	function log(msg){
		if (logEnabled && ('object' === typeof window.console)){
			console.log(formatLogMsg(msg));
		}
	}

	function warn(msg){
		if ('object' === typeof window.console){
			console.warn(formatLogMsg(msg));
		}
	}

	function iFrameListener(event){
		function resizeIFrame(){
			function resize(){
				setSize(messageData);
				setPagePosition();
				settings[iframeId].resizedCallback(messageData);
			}

			ensureInRange('Height');
			ensureInRange('Width');

			syncResize(resize,messageData,'resetPage');
		}

		function closeIFrame(iframe){
			var iframeId = iframe.id;

			log(' Removing iFrame: '+iframeId);
			iframe.parentNode.removeChild(iframe);
			settings[iframeId].closedCallback(iframeId);
			delete settings[iframeId];
			log(' --');
		}

		function processMsg(){
			var data = msg.substr(msgIdLen).split(':');

			return {
				iframe: document.getElementById(data[0]),
				id:     data[0],
				height: data[1],
				width:  data[2],
				type:   data[3]
			};
		}

		function ensureInRange(Dimension){
			var
				max  = Number(settings[iframeId]['max'+Dimension]),
				min  = Number(settings[iframeId]['min'+Dimension]),
				dimension = Dimension.toLowerCase(),
				size = Number(messageData[dimension]);

			if (min>max){
				throw new Error('Value for min'+Dimension+' can not be greater than max'+Dimension);
			}

			log(' Checking '+dimension+' is in range '+min+'-'+max);

			if (size<min) {
				size=min;
				log(' Set '+dimension+' to min value');
			}

			if (size>max) {
				size=max;
				log(' Set '+dimension+' to max value');
			}

			messageData[dimension]=''+size;
		}


		function isMessageFromIFrame(){
			function checkAllowedOrigin(){
				function checkList(){
					log(' Checking connection is from allowed list of origins: ' + checkOrigin);
					var i;
					for (i = 0; i < checkOrigin.length; i++) {
						if (checkOrigin[i] === origin) {
							return true;
						}
					}
					return false;
				}

				function checkSingle(){
					log(' Checking connection is from: '+remoteHost);
					return origin === remoteHost;
				}

				return checkOrigin.constructor === Array ? checkList() : checkSingle();
			}

			var
				origin      = event.origin,
				checkOrigin = settings[iframeId].checkOrigin,
				remoteHost  = messageData.iframe.src.split('/').slice(0,3).join('/');

			if (checkOrigin) {
				if ((''+origin !== 'null') && !checkAllowedOrigin()) {
					throw new Error(
						'Unexpected message received from: ' + origin +
						' for ' + messageData.iframe.id +
						'. Message was: ' + event.data +
						'. This error can be disabled by setting the checkOrigin: false option or by providing of array of trusted domains.'
					);
				}
			}

			return true;
		}

		function isMessageForUs(){
			return msgId === ('' + msg).substr(0,msgIdLen); //''+Protects against non-string msg
		}

		function isMessageFromMetaParent(){
			//Test if this message is from a parent above us. This is an ugly test, however, updating
			//the message format would break backwards compatibity.
			var retCode = messageData.type in {'true':1,'false':1,'undefined':1};

			if (retCode){
				log(' Ignoring init message from meta parent page');
			}

			return retCode;
		}

		function getMsgBody(offset){
			return msg.substr(msg.indexOf(':')+msgHeaderLen+offset);
		}

		function forwardMsgFromIFrame(msgBody){
			log(' MessageCallback passed: {iframe: '+ messageData.iframe.id + ', message: ' + msgBody + '}');
			settings[iframeId].messageCallback({
				iframe: messageData.iframe,
				message: JSON.parse(msgBody)
			});
			log(' --');
		}

		function checkIFrameExists(){
			if (null === messageData.iframe) {
				warn(' IFrame ('+messageData.id+') not found');
				return false;
			}
			return true;
		}

		function getElementPosition(target){
			var
				iFramePosition = target.getBoundingClientRect();

			getPagePosition();

			return {
				x: parseInt(iFramePosition.left, 10) + parseInt(pagePosition.x, 10),
				y: parseInt(iFramePosition.top, 10)  + parseInt(pagePosition.y, 10)
			};
		}

		function scrollRequestFromChild(addOffset){
			function reposition(){
				pagePosition = newPosition;

				scrollTo();

				log(' --');
			}

			function calcOffset(){
				return {
					x: Number(messageData.width) + offset.x,
					y: Number(messageData.height) + offset.y
				};
			}

			var
				offset = addOffset ? getElementPosition(messageData.iframe) : {x:0,y:0},
				newPosition = calcOffset();

			log(' Reposition requested from iFrame (offset x:'+offset.x+' y:'+offset.y+')');

			if(window.top!==window.self){
				if (window.parentIFrame){
					if (addOffset){
						window.parentIFrame.scrollToOffset(newPosition.x,newPosition.y);
					} else {
						window.parentIFrame.scrollTo(messageData.width,messageData.height);
					}
				} else {
					warn(' Unable to scroll to requested position, window.parentIFrame not found');
				}
			} else {
				reposition();
			}

		}

		function scrollTo(){
			if (false !== settings[iframeId].scrollCallback(pagePosition)){
				setPagePosition();
			}
		}

		function findTarget(location){
			function jumpToTarget(target){
				var jumpPosition = getElementPosition(target);

				log(' Moving to in page link (#'+hash+') at x: '+jumpPosition.x+' y: '+jumpPosition.y);
				pagePosition = {
					x: jumpPosition.x,
					y: jumpPosition.y
				};

				scrollTo();
				log(' --');
			}

			var
				hash     = location.split('#')[1] || '',
				hashData = decodeURIComponent(hash),
				target   = document.getElementById(hashData) || document.getElementsByName(hashData)[0];

			if(window.top!==window.self){
				if (window.parentIFrame){
					window.parentIFrame.moveToAnchor(hash);
				} else {
					log(' In page link #'+hash+' not found and window.parentIFrame not found');
				}
			} else if (target){
				jumpToTarget(target);
			} else {
				log(' In page link #'+hash+' not found');
			}
		}

		function actionMsg(){
			switch(messageData.type){
				case 'close':
					closeIFrame(messageData.iframe);
					break;
				case 'message':
					forwardMsgFromIFrame(getMsgBody(6));
					break;
				case 'scrollTo':
					scrollRequestFromChild(false);
					break;
				case 'scrollToOffset':
					scrollRequestFromChild(true);
					break;
				case 'inPageLink':
					findTarget(getMsgBody(9));
					break;
				case 'reset':
					resetIFrame(messageData);
					break;
				case 'init':
					resizeIFrame();
					settings[iframeId].initCallback(messageData.iframe);
					break;
				default:
					resizeIFrame();
			}
		}

		function hasSettings(iframeId){
			var retBool = true;

			if (!settings[iframeId]){
				retBool = false;
				warn(messageData.type + ' No settings for ' + iframeId + '. Message was: ' + msg);
			}

			return retBool;
		}

		var
			msg = event.data,
			messageData = {},
			iframeId = null;

		if (isMessageForUs()){
			messageData = processMsg();
			iframeId    = messageData.id;

			if (!isMessageFromMetaParent() && hasSettings(iframeId)){
				logEnabled  = settings[iframeId].log;
				log(' Received: '+msg);

				if ( checkIFrameExists() && isMessageFromIFrame() ){
					settings[iframeId].firstRun = false;
					actionMsg();
				}
			}
		}
	}


	function getPagePosition (){
		if(null === pagePosition){
			pagePosition = {
				x: (window.pageXOffset !== undefined) ? window.pageXOffset : document.documentElement.scrollLeft,
				y: (window.pageYOffset !== undefined) ? window.pageYOffset : document.documentElement.scrollTop
			};
			log(' Get page position: '+pagePosition.x+','+pagePosition.y);
		}
	}

	function setPagePosition(){
		if(null !== pagePosition){
			window.scrollTo(pagePosition.x,pagePosition.y);
			log(' Set page position: '+pagePosition.x+','+pagePosition.y);
			pagePosition = null;
		}
	}

	function resetIFrame(messageData){
		function reset(){
			setSize(messageData);
			trigger('reset','reset',messageData.iframe,messageData.id);
		}

		log(' Size reset requested by '+('init'===messageData.type?'host page':'iFrame'));
		getPagePosition();
		syncResize(reset,messageData,'init');
	}

	function setSize(messageData){
		function setDimension(dimension){
			messageData.iframe.style[dimension] = messageData[dimension] + 'px';
			log(
				' IFrame (' + iframeId +
				') ' + dimension +
				' set to ' + messageData[dimension] + 'px'
			);
		}
		var iframeId = messageData.iframe.id;
		if( settings[iframeId].sizeHeight) { setDimension('height'); }
		if( settings[iframeId].sizeWidth ) { setDimension('width'); }
	}

	function syncResize(func,messageData,doNotSync){
		if(doNotSync!==messageData.type && requestAnimationFrame){
			log(' Requesting animation frame');
			requestAnimationFrame(func);
		} else {
			func();
		}
	}

	function trigger(calleeMsg,msg,iframe,id){
		if(iframe && iframe.contentWindow){
			log('[' + calleeMsg + '] Sending msg to iframe ('+msg+')');
			iframe.contentWindow.postMessage( msgId + msg, '*' );
		} else {
			warn('[' + calleeMsg + '] IFrame not found');
			if(settings[id]) {
				delete settings[id];
			}
		}
	}


	function setupIFrame(options){
		function setLimits(){
			function addStyle(style){
				if ((Infinity !== settings[iframeId][style]) && (0 !== settings[iframeId][style])){
					iframe.style[style] = settings[iframeId][style] + 'px';
					log(' Set '+style+' = '+settings[iframeId][style]+'px');
				}
			}

			addStyle('maxHeight');
			addStyle('minHeight');
			addStyle('maxWidth');
			addStyle('minWidth');
		}

		function ensureHasId(iframeId){
			if (''===iframeId){
				iframe.id = iframeId = 'iFrameResizer' + count++;
				logEnabled = (options || {}).log;
				log(' Added missing iframe ID: '+ iframeId +' (' + iframe.src + ')');
			}

			return iframeId;
		}

		function setScrolling(){
			log(' IFrame scrolling ' + (settings[iframeId].scrolling ? 'enabled' : 'disabled') + ' for ' + iframeId);
			iframe.style.overflow = false === settings[iframeId].scrolling ? 'hidden' : 'auto';
			iframe.scrolling      = false === settings[iframeId].scrolling ? 'no' : 'yes';
		}

		//The V1 iFrame script expects an int, where as in V2 expects a CSS
		//string value such as '1px 3em', so if we have an int for V2, set V1=V2
		//and then convert V2 to a string PX value.
		function setupBodyMarginValues(){
			if (('number'===typeof(settings[iframeId].bodyMargin)) || ('0'===settings[iframeId].bodyMargin)){
				settings[iframeId].bodyMarginV1 = settings[iframeId].bodyMargin;
				settings[iframeId].bodyMargin   = '' + settings[iframeId].bodyMargin + 'px';
			}
		}

		function createOutgoingMsg(){
			return iframeId +
				':' + settings[iframeId].bodyMarginV1 +
				':' + settings[iframeId].sizeWidth +
				':' + settings[iframeId].log +
				':' + settings[iframeId].interval +
				':' + settings[iframeId].enablePublicMethods +
				':' + settings[iframeId].autoResize +
				':' + settings[iframeId].bodyMargin +
				':' + settings[iframeId].heightCalculationMethod +
				':' + settings[iframeId].bodyBackground +
				':' + settings[iframeId].bodyPadding +
				':' + settings[iframeId].tolerance +
				':' + settings[iframeId].enableInPageLinks +
				':' + settings[iframeId].resizeFrom;
		}

		function init(msg){
			//We have to call trigger twice, as we can not be sure if all
			//iframes have completed loading when this code runs. The
			//event listener also catches the page changing in the iFrame.
			addEventListener(iframe,'load',function(){
				var fr = settings[iframeId].firstRun;   // Reduce scope of var to function, because IE8's JS execution
                                                        // context stack is borked and this value gets externally
                                                        // changed midway through running this function.
				trigger('iFrame.onload',msg,iframe);
				if (!fr && settings[iframeId].heightCalculationMethod in resetRequiredMethods){
					resetIFrame({
						iframe:iframe,
						height:0,
						width:0,
						type:'init'
					});
				}
			});
			trigger('init',msg,iframe);
		}

		function checkOptions(options){
			if ('object' !== typeof options){
				throw new TypeError('Options is not an object.');
			}
		}

		function processOptions(options){
			options = options || {};
			settings[iframeId] = {
				firstRun: true
			};

			checkOptions(options);

			for (var option in defaults) {
				if (defaults.hasOwnProperty(option)){
					settings[iframeId][option] = options.hasOwnProperty(option) ? options[option] : defaults[option];
				}
			}

			logEnabled = settings[iframeId].log;
		}

		var
			/*jshint validthis:true */
			iframe   = this,
			iframeId = ensureHasId(iframe.id);

		processOptions(options);
		setScrolling();
		setLimits();
		setupBodyMarginValues();
		init(createOutgoingMsg());
	}

	function throttle(fn,time){
		if (null === timer){
			timer = setTimeout(function(){
				timer = null;
				fn();
			}, time);
		}
	}

	function winResize(){
		function isIFrameResizeEnabled(iframeId) {
			return	'parent' === settings[iframeId].resizeFrom &&
					settings[iframeId].autoResize &&
					!settings[iframeId].firstRun;
		}

		throttle(function(){
			for (var iframeId in settings){
				if(isIFrameResizeEnabled(iframeId)){
					trigger('Window resize','resize',document.getElementById(iframeId),iframeId);
				}
			}
		},66);
	}

	function factory(){
		function init(element, options){
			if(!element.tagName) {
				throw new TypeError('Object is not a valid DOM element');
			} else if ('IFRAME' !== element.tagName.toUpperCase()) {
				throw new TypeError('Expected <IFRAME> tag, found <'+element.tagName+'>.');
			} else {
				setupIFrame.call(element, options);
			}
		}

		setupRequestAnimationFrame();
		addEventListener(window,'message',iFrameListener);
		addEventListener(window,'resize', winResize);

		return function iFrameResizeF(options,target){
			switch (typeof(target)){
			case 'undefined':
			case 'string':
				Array.prototype.forEach.call( document.querySelectorAll( target || 'iframe' ), function (element) {
					init(element, options);
				});
				break;
			case 'object':
				init(target, options);
				break;
			default:
				throw new TypeError('Unexpected data type ('+typeof(target)+').');
			}
		};
	}

	function createJQueryPublicMethod($){
		$.fn.iFrameResize = function $iFrameResizeF(options) {
			return this.filter('iframe').each(function (index, element) {
				setupIFrame.call(element, options);
			}).end();
		};
	}

	if (window.jQuery) { createJQueryPublicMethod(jQuery); }

	if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module === 'object' && typeof module.exports === 'object') { //Node for browserfy
		module.exports = factory();
	} else {
		window.iFrameResize = window.iFrameResize || factory();
	}

})();


/***/ }),

/***/ 1139:
/***/ (function(module, exports, __webpack_require__) {

exports.iframeResizer = __webpack_require__(1138);
exports.iframeResizerContentWindow = __webpack_require__(1137);


/***/ }),

/***/ 121:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FACEBOOK_BOT_ACTION_TYPES = undefined;

var _object = __webpack_require__(12);

var FACEBOOK_BOT_ACTION_TYPES = exports.FACEBOOK_BOT_ACTION_TYPES = (0, _object.namespacedConsts)({
  GO_TO_MESSENGER_BOT: true
});

/***/ }),

/***/ 124:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.injectPostCampaigns = exports.injectHeaderCampaigns = undefined;

var _defineProperty2 = __webpack_require__(14);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _campaignInjectors;

var _campaignManagerProvider = __webpack_require__(155);

var _appStore = __webpack_require__(23);

var _logo = __webpack_require__(222);

var _geolocationProvider = __webpack_require__(44);

var _initCampaigns = __webpack_require__(144);

var _CampaignInjector = __webpack_require__(143);

var _CampaignInjector2 = _interopRequireDefault(_CampaignInjector);

var _ua = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var COMMERCIAL_WIDGET_TABOOLA_FEED_PLACEHOLDER = 'commercialWidgetTaboolaFeedPlaceHolder';
var VIEWABILITY_LABEL = 'data-viewability_label';
var MINIMUM_NUMBER_OF_PARAGRAPHS = 3;
var isEmbedded = _ua.path.isEmbedded;


var canInjectHeader = function canInjectHeader() {
  return true;
};

var canInjectBelowArticle = function canInjectBelowArticle() {
  return (0, _initCampaigns.postCategoriesAllowCampaigns)();
};

var canInjectInArticle = function canInjectInArticle() {
  var index = (0, _initCampaigns.findPositionToInjectCampaign)();
  return (0, _initCampaigns.postCategoriesAllowCampaigns)() && (0, _initCampaigns.postHasAtLeastParagraphs)(MINIMUM_NUMBER_OF_PARAGRAPHS) && index !== -1 && !window.location.search.includes('app=1') && !isEmbedded;
};

var headerCampaignInjector = function headerCampaignInjector(payload) {
  (0, _appStore.dispatch)((0, _logo.changeLogo)(payload.src));
};

var inArticleCampaignInjector = function inArticleCampaignInjector(payload) {
  var campaignElement = (0, _initCampaigns.generateCampaignElement)(payload.embedCode);
  var index = -1;
  if ((0, _geolocationProvider.getCountryCode)() === 'ES') {
    index = (0, _initCampaigns.findPositionToInjectCampaignEs)();
  } else {
    index = (0, _initCampaigns.findPositionToInjectCampaign)();
  }
  var paragraph = (0, _initCampaigns.getPostItems)()[index];
  paragraph && paragraph.insertAdjacentElement('afterend', campaignElement);

  (0, _initCampaigns.registerElementToViewabilityTracker)(campaignElement.firstChild);
  (0, _initCampaigns.dispatchWidgetEmbed)(campaignElement.firstChild, VIEWABILITY_LABEL);
};

var belowArticleCampaignInjector = function belowArticleCampaignInjector(payload) {
  var campaignElement = (0, _initCampaigns.generateCampaignElement)(payload.embedCode);

  var taboolaPlaceholder = document.getElementsByClassName(COMMERCIAL_WIDGET_TABOOLA_FEED_PLACEHOLDER)[0];
  taboolaPlaceholder && taboolaPlaceholder.insertAdjacentElement('beforeend', campaignElement);

  (0, _initCampaigns.registerElementToViewabilityTracker)(campaignElement.firstChild);
  (0, _initCampaigns.dispatchWidgetEmbed)(campaignElement.firstChild, VIEWABILITY_LABEL);
};

var POSITIONS = {
  HEADER: 'header',
  IN_ARTICLE: 'inArticle',
  BELOW_ARTICLE: 'belowArticle'
};

var campaignInjectors = (_campaignInjectors = {}, (0, _defineProperty3.default)(_campaignInjectors, POSITIONS.HEADER, new _CampaignInjector2.default(headerCampaignInjector, canInjectHeader)), (0, _defineProperty3.default)(_campaignInjectors, POSITIONS.IN_ARTICLE, new _CampaignInjector2.default(inArticleCampaignInjector, canInjectInArticle)), (0, _defineProperty3.default)(_campaignInjectors, POSITIONS.BELOW_ARTICLE, new _CampaignInjector2.default(belowArticleCampaignInjector, canInjectBelowArticle)), _campaignInjectors);

var injectHeaderCampaigns = exports.injectHeaderCampaigns = function injectHeaderCampaigns() {
  return (0, _campaignManagerProvider.getCampaignsFromCampaignManager)().then(function (campaigns) {
    campaigns.filter(function (campaign) {
      return campaign.position === POSITIONS.HEADER;
    }).forEach(function (campaign) {
      var _campaignInjectors$ca = campaignInjectors[campaign.position],
          validate = _campaignInjectors$ca.validate,
          inject = _campaignInjectors$ca.inject;

      if (validate()) {
        inject(campaign.payload);
      }
    });
  });
};

var injectPostCampaigns = exports.injectPostCampaigns = function injectPostCampaigns() {
  return (0, _campaignManagerProvider.getCampaignsFromCampaignManager)().then(function (campaigns) {
    campaigns.filter(function (campaign) {
      return campaign.position !== POSITIONS.HEADER;
    }).forEach(function (campaign) {
      var _campaignInjectors$ca2 = campaignInjectors[campaign.position],
          validate = _campaignInjectors$ca2.validate,
          inject = _campaignInjectors$ca2.inject;

      if (validate()) {
        inject(campaign.payload);
      }
    });
  });
};

/***/ }),

/***/ 125:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(71);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dom = __webpack_require__(13);

var _ua = __webpack_require__(10);

var _BaseAdView2 = __webpack_require__(215);

var _BaseAdView3 = _interopRequireDefault(_BaseAdView2);

var _mithril = __webpack_require__(54);

var _adsConfig = __webpack_require__(27);

var _pageDataObject = __webpack_require__(5);

var _window = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var STICKY = _adsConfig.CLASS_NAMES.STICKY;
var debugStickyHeader = _window.queryString.debugStickyHeader;

var topSlot = null;

function displayStickyAdForSite(stickyConf) {
  return !stickyConf.exceptOnSites || stickyConf.exceptOnSites.length === 0 || stickyConf.exceptOnSites.some(function (site) {
    return site !== (0, _pageDataObject.getPageDomain)();
  });
}

function isSticky(stickyConf) {
  var isStickyByDefault = stickyConf.default;
  var isStickyNotBlacklisted = isStickyByDefault && displayStickyAdForSite(stickyConf);
  var isntStickyAndWhitelisted = !isStickyByDefault && !displayStickyAdForSite(stickyConf);
  return isStickyNotBlacklisted || isntStickyAndWhitelisted;
}

var RegularAdView = function (_BaseAdView) {
  (0, _inherits3.default)(RegularAdView, _BaseAdView);

  function RegularAdView() {
    (0, _classCallCheck3.default)(this, RegularAdView);
    return (0, _possibleConstructorReturn3.default)(this, (RegularAdView.__proto__ || (0, _getPrototypeOf2.default)(RegularAdView)).apply(this, arguments));
  }

  (0, _createClass3.default)(RegularAdView, [{
    key: 'view',
    value: function view(ctrl) {
      return (0, _mithril.createElementWithCallback)('div', this.renderParams);
    }
  }, {
    key: 'adjustTopSlot',
    value: function adjustTopSlot() {
      // eslint-disable-line complexity
      topSlot = topSlot || (0, _dom.node)('.ad[data-slot-id="' + _adsConfig.AD_FORMATS.Top + '"]');
      if (!topSlot) {
        return this;
      }
      var _adVm = this.adVm,
          topHeight = _adVm.topHeight,
          stickyConf = _adVm.stickyConf;

      if ((0, _ua.getIsDesktop)() && topSlot && topHeight) {
        topSlot.style.height = topHeight + 24 + 'px';
      }
      if (isSticky(stickyConf)) {
        if (!topSlot.classList.contains(STICKY)) {
          if (debugStickyHeader) {
            this.info('adding class \'' + STICKY + '\' to top slot', { topSlot: topSlot });
          }
          topSlot.classList.add(STICKY);
        }
      } else {
        if (topSlot.classList.contains(STICKY)) {
          // eslint-disable-line no-lonely-if
          if (debugStickyHeader) {
            this.info('removing class \'' + STICKY + '\' to top slot', { topSlot: topSlot });
          }
          topSlot.classList.remove(STICKY);
        }
      }
      return this;
    }
  }, {
    key: 'renderParams',
    get: function get() {
      var params = (0, _get3.default)(RegularAdView.prototype.__proto__ || (0, _getPrototypeOf2.default)(RegularAdView.prototype), 'renderParams', this);
      if (this.adId === _adsConfig.AD_FORMATS.Top) {
        (0, _window.addOnOrientationChangeEvent)(this.adjustTopSlot.bind(this), this.adjustTopSlot.bind(this));
        this.adjustTopSlot();
      }
      return params;
    }
  }]);
  return RegularAdView;
}(_BaseAdView3.default);

exports.default = RegularAdView;

/***/ }),

/***/ 127:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(156), __esModule: true };

/***/ }),

/***/ 1297:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.defaultMemoize = defaultMemoize;
exports.createSelectorCreator = createSelectorCreator;
exports.createStructuredSelector = createStructuredSelector;
function defaultEqualityCheck(a, b) {
  return a === b;
}

function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
  if (prev === null || next === null || prev.length !== next.length) {
    return false;
  }

  // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
  var length = prev.length;
  for (var i = 0; i < length; i++) {
    if (!equalityCheck(prev[i], next[i])) {
      return false;
    }
  }

  return true;
}

function defaultMemoize(func) {
  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;

  var lastArgs = null;
  var lastResult = null;
  // we reference arguments instead of spreading them for performance reasons
  return function () {
    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
      // apply arguments instead of spreading for performance.
      lastResult = func.apply(null, arguments);
    }

    lastArgs = arguments;
    return lastResult;
  };
}

function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep;
    }).join(', ');
    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptions[_key - 1] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }

    var recomputations = 0;
    var resultFunc = funcs.pop();
    var dependencies = getDependencies(funcs);

    var memoizedResultFunc = memoize.apply(undefined, [function () {
      recomputations++;
      // apply arguments instead of spreading for performance.
      return resultFunc.apply(null, arguments);
    }].concat(memoizeOptions));

    // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
    var selector = defaultMemoize(function () {
      var params = [];
      var length = dependencies.length;

      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        params.push(dependencies[i].apply(null, arguments));
      }

      // apply arguments instead of spreading for performance.
      return memoizedResultFunc.apply(null, params);
    });

    selector.resultFunc = resultFunc;
    selector.recomputations = function () {
      return recomputations;
    };
    selector.resetRecomputations = function () {
      return recomputations = 0;
    };
    return selector;
  };
}

var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);

function createStructuredSelector(selectors) {
  var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createSelector;

  if (typeof selectors !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
  }
  var objectKeys = Object.keys(selectors);
  return selectorCreator(objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      values[_key3] = arguments[_key3];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
}

/***/ }),

/***/ 1343:
/***/ (function(module, exports) {

/*!
 * verge 1.9.1+201402130803
 * https://github.com/ryanve/verge
 * MIT License 2013 Ryan Van Etten
 */

(function(root, name, make) {
  if (typeof module != 'undefined' && module['exports']) module['exports'] = make();
  else root[name] = make();
}(this, 'verge', function() {

  var xports = {}
    , win = typeof window != 'undefined' && window
    , doc = typeof document != 'undefined' && document
    , docElem = doc && doc.documentElement
    , matchMedia = win['matchMedia'] || win['msMatchMedia']
    , mq = matchMedia ? function(q) {
        return !!matchMedia.call(win, q).matches;
      } : function() {
        return false;
      }
    , viewportW = xports['viewportW'] = function() {
        var a = docElem['clientWidth'], b = win['innerWidth'];
        return a < b ? b : a;
      }
    , viewportH = xports['viewportH'] = function() {
        var a = docElem['clientHeight'], b = win['innerHeight'];
        return a < b ? b : a;
      };
  
  /** 
   * Test if a media query is active. Like Modernizr.mq
   * @since 1.6.0
   * @return {boolean}
   */  
  xports['mq'] = mq;

  /** 
   * Normalized matchMedia
   * @since 1.6.0
   * @return {MediaQueryList|Object}
   */ 
  xports['matchMedia'] = matchMedia ? function() {
    // matchMedia must be binded to window
    return matchMedia.apply(win, arguments);
  } : function() {
    // Gracefully degrade to plain object
    return {};
  };

  /**
   * @since 1.8.0
   * @return {{width:number, height:number}}
   */
  function viewport() {
    return {'width':viewportW(), 'height':viewportH()};
  }
  xports['viewport'] = viewport;
  
  /** 
   * Cross-browser window.scrollX
   * @since 1.0.0
   * @return {number}
   */
  xports['scrollX'] = function() {
    return win.pageXOffset || docElem.scrollLeft; 
  };

  /** 
   * Cross-browser window.scrollY
   * @since 1.0.0
   * @return {number}
   */
  xports['scrollY'] = function() {
    return win.pageYOffset || docElem.scrollTop; 
  };

  /**
   * @param {{top:number, right:number, bottom:number, left:number}} coords
   * @param {number=} cushion adjustment
   * @return {Object}
   */
  function calibrate(coords, cushion) {
    var o = {};
    cushion = +cushion || 0;
    o['width'] = (o['right'] = coords['right'] + cushion) - (o['left'] = coords['left'] - cushion);
    o['height'] = (o['bottom'] = coords['bottom'] + cushion) - (o['top'] = coords['top'] - cushion);
    return o;
  }

  /**
   * Cross-browser element.getBoundingClientRect plus optional cushion.
   * Coords are relative to the top-left corner of the viewport.
   * @since 1.0.0
   * @param {Element|Object} el element or stack (uses first item)
   * @param {number=} cushion +/- pixel adjustment amount
   * @return {Object|boolean}
   */
  function rectangle(el, cushion) {
    el = el && !el.nodeType ? el[0] : el;
    if (!el || 1 !== el.nodeType) return false;
    return calibrate(el.getBoundingClientRect(), cushion);
  }
  xports['rectangle'] = rectangle;

  /**
   * Get the viewport aspect ratio (or the aspect ratio of an object or element)
   * @since 1.7.0
   * @param {(Element|Object)=} o optional object with width/height props or methods
   * @return {number}
   * @link http://w3.org/TR/css3-mediaqueries/#orientation
   */
  function aspect(o) {
    o = null == o ? viewport() : 1 === o.nodeType ? rectangle(o) : o;
    var h = o['height'], w = o['width'];
    h = typeof h == 'function' ? h.call(o) : h;
    w = typeof w == 'function' ? w.call(o) : w;
    return w/h;
  }
  xports['aspect'] = aspect;

  /**
   * Test if an element is in the same x-axis section as the viewport.
   * @since 1.0.0
   * @param {Element|Object} el
   * @param {number=} cushion
   * @return {boolean}
   */
  xports['inX'] = function(el, cushion) {
    var r = rectangle(el, cushion);
    return !!r && r.right >= 0 && r.left <= viewportW();
  };

  /**
   * Test if an element is in the same y-axis section as the viewport.
   * @since 1.0.0
   * @param {Element|Object} el
   * @param {number=} cushion
   * @return {boolean}
   */
  xports['inY'] = function(el, cushion) {
    var r = rectangle(el, cushion);
    return !!r && r.bottom >= 0 && r.top <= viewportH();
  };

  /**
   * Test if an element is in the viewport.
   * @since 1.0.0
   * @param {Element|Object} el
   * @param {number=} cushion
   * @return {boolean}
   */
  xports['inViewport'] = function(el, cushion) {
    // Equiv to `inX(el, cushion) && inY(el, cushion)` but just manually do both 
    // to avoid calling rectangle() twice. It gzips just as small like this.
    var r = rectangle(el, cushion);
    return !!r && r.bottom >= 0 && r.right >= 0 && r.top <= viewportH() && r.left <= viewportW();
  };

  return xports;
}));

/***/ }),

/***/ 135:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actions = exports.FRESH8_ACTION_TYPES = undefined;

var _object = __webpack_require__(12);

var FRESH8_ACTION_TYPES = exports.FRESH8_ACTION_TYPES = (0, _object.namespacedConsts)({
  DISPLAY_POPUP: true,
  HIDE_POPUP: true,
  DISPLAY_FLOATING_BUTTON: true
});
function displayPopup() {
  return function (dispatch, getState) {
    dispatch({
      type: FRESH8_ACTION_TYPES.DISPLAY_POPUP,
      state: {
        isPopupVisible: true
      }
    });
  };
}
function hidePopup() {
  return function (dispatch, getState) {
    dispatch({
      type: FRESH8_ACTION_TYPES.HIDE_POPUP,
      state: {
        isPopupVisible: false
      }
    });
  };
}
function displayFloatingButton() {
  return function (dispatch, getState) {
    dispatch({
      type: FRESH8_ACTION_TYPES.DISPLAY_FLOATING_BUTTON,
      state: {
        isFloatingButtongVisible: true
      }
    });
  };
}
var actions = exports.actions = { displayPopup: displayPopup, hidePopup: hidePopup, displayFloatingButton: displayFloatingButton, FRESH8_ACTION_TYPES: FRESH8_ACTION_TYPES };

/***/ }),

/***/ 1359:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(107);
__webpack_require__(558);
module.exports = __webpack_require__(578);


/***/ }),

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(14);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends4 = __webpack_require__(9);

var _extends5 = _interopRequireDefault(_extends4);

var _slicedToArray2 = __webpack_require__(39);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = __webpack_require__(87);

var _entries2 = _interopRequireDefault(_entries);

exports.default = addAnalyticsClickDelegator;

var _console = __webpack_require__(11);

var _dom = __webpack_require__(13);

var _window = __webpack_require__(8);

var _appStore = __webpack_require__(23);

var _analyticsActions = __webpack_require__(31);

var _analyticsActions2 = _interopRequireDefault(_analyticsActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FEATURE_FLAGS = {
  debug: _window.queryString.debugAnalyticsClickHandler
}; /* eslint consistent-return:0 */


var hasAnalyticsClickEventCategoryAttribute = function hasAnalyticsClickEventCategoryAttribute(target) {
  return target && target.hasAttribute('data-analytics-event-category');
};

var isAnchor = function isAnchor(el) {
  return el instanceof HTMLAnchorElement;
};

var isButton = function isButton(el) {
  return el instanceof HTMLButtonElement;
};

var isAnalyticsElement = function isAnalyticsElement(el) {
  return (isAnchor(el) || isButton(el)) && hasAnalyticsClickEventCategoryAttribute(el);
};

var parentUntilCategoryAttribute = (0, _dom.parentElementUntil)(hasAnalyticsClickEventCategoryAttribute);

var parentUntilClickable = (0, _dom.parentElementUntil)(isAnalyticsElement);

function debug() {
  FEATURE_FLAGS.debug && _console.info.apply(undefined, ['[analytics click handler]'].concat(Array.prototype.slice.call(arguments)));
}

function lowerCaseIfString(value) {
  return typeof value === 'string' ? value.toLowerCase() : value;
}

function normalizeEventData(eventMetadata) {
  return (0, _entries2.default)(eventMetadata).reduce(function (acc, _ref, idx) {
    var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    if (idx === 0) {
      return (0, _extends5.default)({}, acc, (0, _defineProperty3.default)({}, key, value));
    }
    return value === undefined ? acc : (0, _extends5.default)({}, acc, (0, _defineProperty3.default)({}, key, lowerCaseIfString(value)));
  }, {});
}

function addGtmAnchorCallback(evt) {
  var maybeClickable = parentUntilClickable(evt.target);
  if (!maybeClickable || !maybeClickable.target || maybeClickable.target.length > 0) {
    return;
  }

  evt.preventDefault();
  return {
    eventCallback: function eventCallback() {
      window.location = maybeClickable.href;
    },

    eventTimeout: 1000
  };
}

function delegatedAnalyticsClickHandler(evt) {
  var gtmAnchorCallback = addGtmAnchorCallback(evt);
  var target = evt.target;
  debug('target', target);
  var targetDataValue = target.dataset.analyticsEventValue;
  var analyticsElementOrNull = parentUntilCategoryAttribute(target);
  if (!analyticsElementOrNull) {
    return;
  }
  var _analyticsElementOrNu = analyticsElementOrNull.dataset,
      eventCategory = _analyticsElementOrNu.analyticsEventCategory,
      eventAction = _analyticsElementOrNu.analyticsEventAction,
      eventLabel = _analyticsElementOrNu.analyticsEventLabel,
      eventValue = _analyticsElementOrNu.analyticsEventValue;

  if (eventCategory && eventAction) {
    (0, _appStore.dispatch)(_analyticsActions2.default.pageClicked(normalizeEventData({
      eventCategory: eventCategory,
      eventAction: eventAction,
      eventLabel: eventLabel,
      eventValue: eventValue || targetDataValue,
      gtmAnchorCallback: gtmAnchorCallback
    })));
  }
}

function addAnalyticsClickDelegator() {
  document.body.addEventListener('click', delegatedAnalyticsClickHandler);
}

/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _initCampaigns = __webpack_require__(124);

var _initGlobalRejectionHandler = __webpack_require__(145);

var _initGlobalRejectionHandler2 = _interopRequireDefault(_initGlobalRejectionHandler);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Initializes modules, which are used across all pages in app.
 */
(0, _initGlobalRejectionHandler2.default)();
(0, _initCampaigns.injectHeaderCampaigns)();

/***/ }),

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.receivedError = exports.dataReceived = exports.TYPES = undefined;

var _AppDispatcher = __webpack_require__(55);

var _object = __webpack_require__(12);

/* eslint semi:0 */
var ACTION_COUNTER_PROVIDER_CONSTS = (0, _object.namespacedConsts)({
  ACTIONS: {
    DATA_RECEIVED: true,
    RECEIVED_ERROR: true
  }
});

var TYPES = exports.TYPES = ACTION_COUNTER_PROVIDER_CONSTS.ACTIONS;

var dataReceived = exports.dataReceived = function dataReceived(data) {
  _AppDispatcher.appDispatcher.dispatchAction.external({
    type: TYPES.DATA_RECEIVED,
    data: data,
    fluxToRedux: true
  });
};

var receivedError = exports.receivedError = function receivedError(error) {
  _AppDispatcher.appDispatcher.dispatchAction.external({
    type: TYPES.RECEIVED_ERROR,
    error: error,
    fluxToRedux: true
  });
};

/***/ }),

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.analyticsServices = undefined;

var _getIterator2 = __webpack_require__(58);

var _getIterator3 = _interopRequireDefault(_getIterator2);

exports.default = init;

var _analyticsStore = __webpack_require__(51);

var _analyticsStore2 = _interopRequireDefault(_analyticsStore);

var _pageDataObject = __webpack_require__(5);

var _pageDataObject2 = _interopRequireDefault(_pageDataObject);

var _window = __webpack_require__(8);

var _ua = __webpack_require__(10);

var _pageContext = __webpack_require__(61);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var analyticsServicesConditions = {
  default_services: function default_services() {
    return true;
  },
  slideshow_native_app_services: function slideshow_native_app_services() {
    return _pageDataObject2.default.isSlideshow && (0, _ua.getIsNativeApp)();
  },
  non_native_app_services: function non_native_app_services() {
    return !(0, _ua.getIsNativeApp)();
  },
  facebook_analytics: function facebook_analytics() {
    return !(0, _ua.getIsNativeApp)() && _pageDataObject2.default.get('config.facebook_pixel') && !(0, _pageContext.getInfluencerId)();
  },
  full_layout_services: function full_layout_services() {
    return _ua.path.isFullLayout;
  }
};

var supportedAnalyticsServices = _pageDataObject2.default.get('config.analytics_services');
var analyticsServices = exports.analyticsServices = [];
var site = NM.pdo.get('context.site');
for (var analyticsServicesGroup in supportedAnalyticsServices) {
  var condition = analyticsServicesConditions[analyticsServicesGroup];
  if (condition()) {
    var services = supportedAnalyticsServices[analyticsServicesGroup] || [];
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = (0, _getIterator3.default)(services), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var service = _step.value;

        analyticsServices.push(__webpack_require__(175)("./" + service + 'Service').default);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }
}

var analyticsStore = _analyticsStore2.default.create();

function init() {
  analyticsServices.forEach(function (Class) {
    Class.create({ store: analyticsStore });
  });
}

/***/ }),

/***/ 143:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CampaignInjector = function CampaignInjector(inject, validate) {
  (0, _classCallCheck3.default)(this, CampaignInjector);

  this.inject = inject;
  this.validate = validate;
};

exports.default = CampaignInjector;

/***/ }),

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dispatchWidgetEmbed = exports.registerElementToViewabilityTracker = exports.generateCampaignElement = exports.findPositionToInjectCampaignEs = exports.findPositionToInjectCampaign = exports.getPostItems = exports.postCategoriesAllowCampaigns = exports.postHasAtLeastParagraphs = exports.generateEmbedContent = exports.generateInsertableHTML = undefined;

var _toConsumableArray2 = __webpack_require__(33);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _from = __webpack_require__(49);

var _from2 = _interopRequireDefault(_from);

var _pageDataObject = __webpack_require__(5);

var _viewbilityTracker = __webpack_require__(99);

var _appStore = __webpack_require__(23);

var _analyticsActions = __webpack_require__(31);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var copyAttributes = function copyAttributes(elemFrom, elemTo) {
  return (0, _from2.default)(elemFrom.attributes).forEach(function (attr) {
    return elemTo.setAttribute(attr.name, attr.value);
  });
};

var convertToExecutableScripts = function convertToExecutableScripts(scripts) {
  return scripts.map(function (script) {
    var executable = document.createElement('script');
    executable.innerHTML = script.innerHTML ? script.innerHTML : '';
    copyAttributes(script, executable);
    return executable;
  });
};

var isJS = function isJS(script) {
  return script.type === '' || script.type.indexOf('javascript') >= 0;
};

var findJavaScriptElements = function findJavaScriptElements(wrapper) {
  var scripts = (0, _from2.default)(wrapper.getElementsByTagName('script'));
  return scripts.filter(isJS);
};

var removeScripts = function removeScripts(scripts) {
  scripts.forEach(function (script) {
    return script.remove();
  });
};

var wrapHTML = function wrapHTML(html) {
  var tempWrapper = window.parent.document.createElement('div');
  tempWrapper.innerHTML = html;
  return tempWrapper;
};

var generateInsertableHTML = exports.generateInsertableHTML = function generateInsertableHTML(html) {
  var wrapper = wrapHTML(html);
  var scripts = findJavaScriptElements(wrapper);
  // Remove injected scripts and leave only created executable scripts
  removeScripts(scripts);
  var elements = (0, _from2.default)(wrapper.childNodes);
  return {
    elements: elements,
    scripts: convertToExecutableScripts(scripts)
  };
};

var generateEmbedContent = exports.generateEmbedContent = function generateEmbedContent(data) {
  var elements = data.elements,
      scripts = data.scripts;

  var el = document.createElement('div');
  el.style.width = '100%';
  elements.forEach(function (elem) {
    el.appendChild(elem);
  });
  scripts.forEach(function (script) {
    el.appendChild(script);
  });
  return el;
};

var postHasAtLeastParagraphs = exports.postHasAtLeastParagraphs = function postHasAtLeastParagraphs(minimumParagraphs) {
  var initialParagraphs = document.querySelectorAll('.post-content > p').length;
  var emptyParagraphs = document.querySelectorAll('.post-content > p > br').length;
  return initialParagraphs - emptyParagraphs > minimumParagraphs;
};

var postCategoriesAllowCampaigns = exports.postCategoriesAllowCampaigns = function postCategoriesAllowCampaigns() {
  var postCategories = (0, _pageDataObject.getPostCategories)();
  return !postCategories.includes('no-campaign-manager') && (!postCategories.includes('sponsored') || postCategories.includes('wirewax'));
};

var isParagraph = function isParagraph(node) {
  var nodeHTML = node.innerHTML;
  var isBoldTitle = nodeHTML.match('<strong>.+<\\/strong>') !== null;
  return node.innerText !== '' && nodeHTML !== '<span style="font-size: 1em;"><br></span>' && nodeHTML !== '<strong><br></strong>' && !isBoldTitle && nodeHTML !== '&nbsp;';
};

var getPostItems = exports.getPostItems = function getPostItems() {
  return [].concat((0, _toConsumableArray3.default)(document.querySelectorAll('.post-content > *')));
};

var findPositionToInjectCampaign = exports.findPositionToInjectCampaign = function findPositionToInjectCampaign() {
  var postItems = getPostItems();
  var isParagraphArray = postItems.map(function (x) {
    return isParagraph(x);
  });
  var startPoint = parseInt(isParagraphArray.length / 2, 10);
  for (var i = startPoint; i < isParagraphArray.length - 2; i++) {
    if (isParagraphArray[i] && isParagraphArray[i + 1]) {
      return i;
    }
  }
  return -1;
};

var findPositionToInjectCampaignEs = exports.findPositionToInjectCampaignEs = function findPositionToInjectCampaignEs() {
  var postItems = getPostItems();
  var isParagraphArray = postItems.map(function (x) {
    return isParagraph(x);
  });
  var startPoint = parseInt(isParagraphArray.length, 1);
  for (var i = startPoint; i < isParagraphArray.length - 2; i++) {
    if (isParagraphArray[i]) {
      return i;
    }
  }
  return -1;
};

var generateCampaignElement = exports.generateCampaignElement = function generateCampaignElement(script) {
  var parsedScript = generateInsertableHTML('' + script);
  return generateEmbedContent(parsedScript);
};

var registerElementToViewabilityTracker = exports.registerElementToViewabilityTracker = function registerElementToViewabilityTracker(element) {
  (0, _viewbilityTracker.register)('.' + element.className);
};

var dispatchWidgetEmbed = exports.dispatchWidgetEmbed = function dispatchWidgetEmbed(element, viewabilityLabel) {
  (0, _appStore.dispatch)((0, _analyticsActions.widgetEmbedEvent)(element.getAttribute(viewabilityLabel)));
};

/***/ }),

/***/ 145:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initGlobalPromiseRejectionHandler;

var _dom = __webpack_require__(13);

var _console = __webpack_require__(11);

// https://devdocs.io/dom_events/unhandledrejection
function globalPromiseRejectionHandler(event) {
  // eslint-disable-line no-shadow
  var reason = event.reason,
      promise = event.promise;

  (0, _console.warn)('Unhandled Promise rejection caught: \'' + reason + '\'!', { event: event, reason: reason, promise: promise });
}

function initGlobalPromiseRejectionHandler() {
  return (0, _dom.addWindowEvent)('unhandledrejection', globalPromiseRejectionHandler);
}

/***/ }),

/***/ 146:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = setLocaleCookie;

var _cookies = __webpack_require__(180);

var _window = __webpack_require__(8);

function setLocaleCookie() {
  if (_window.queryString.setLocale) {
    (0, _cookies.set)('locale', _window.path.substr(1), { path: '/', expires: new Date('2020', '1', '1') });
  }
}

/***/ }),

/***/ 147:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(16);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _userStore = __webpack_require__(38);

var _userStore2 = _interopRequireDefault(_userStore);

var _window = __webpack_require__(8);

var _ua = __webpack_require__(10);

var _pageContext = __webpack_require__(61);

var _pageDataObject = __webpack_require__(5);

var _analyticsBaseService = __webpack_require__(28);

var _analyticsBaseService2 = _interopRequireDefault(_analyticsBaseService);

var _currentPostActionCounterProvider = __webpack_require__(91);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PAGE_DATA_OBJECT_FALLBACK = {
  post: {
    // Defaults for failed pageDataObject parsing
    id: null,
    author: {
      id: null,
      league: null
    }
  },
  page: {}
}; /* eslint semi:0 */

var ActionCounterService = function (_AnalyticsBaseService) {
  (0, _inherits3.default)(ActionCounterService, _AnalyticsBaseService);

  function ActionCounterService() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck3.default)(this, ActionCounterService);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ActionCounterService.__proto__ || (0, _getPrototypeOf2.default)(ActionCounterService)).call(this, options));

    _this.facebookShare = _this.twitterShare = _this.whatsappShare = _this.socialShare;
    var post = (0, _pageDataObject.get)('post', PAGE_DATA_OBJECT_FALLBACK.post);
    var author = post.author,
        actionCounterTag = post.action_counter_tag;

    _this.basicPostAndAuthorData = {
      post: post.id,
      author: author.id,
      league: actionCounterTag
    };
    if (_userStore2.default.state.id) {
      _this.basicPostAndAuthorData.user = _userStore2.default.state.id;
    }
    return _this;
  }

  (0, _createClass3.default)(ActionCounterService, [{
    key: 'routeChanged',
    value: function routeChanged(action) {
      //Empty override to prevent a read report on slideshows on each slide change
    }
  }, {
    key: 'pageViewed',
    value: function pageViewed() {
      if (this.shouldReportPageview()) {
        this.trackEvent('reads', this.pageViewData);
      }
    }
  }, {
    key: 'shouldReportPageview',
    value: function shouldReportPageview() {
      var postId = (0, _pageDataObject.get)('post.id', false);
      if (postId === false) {
        return false;
      }
      return _userStore2.default.recentReads[postId].readsCount <= 1;
    }
  }, {
    key: 'socialShare',
    value: function socialShare() {
      this.trackEvent('shares', this.basicPostAndAuthorData);
    }
  }, {
    key: 'trackEvent',
    value: function trackEvent(type, params) {
      if (!(0, _ua.getIsBot)()) {
        this.logAnalytics(type, params);
        (0, _currentPostActionCounterProvider.sendData)(type, params);
      }
    }
  }, {
    key: 'className',
    get: function get() {
      return 'ActionCounterService';
    }
  }, {
    key: 'pageViewData',
    get: function get() {
      var _Object$assign = (0, _assign2.default)(PAGE_DATA_OBJECT_FALLBACK, {
        post: (0, _pageDataObject.get)('post', PAGE_DATA_OBJECT_FALLBACK.post),
        page: (0, _pageDataObject.get)('page', PAGE_DATA_OBJECT_FALLBACK.page)
      }),
          post = _Object$assign.post,
          page = _Object$assign.page;

      var author = post.author;

      var data = (0, _assign2.default)({}, this.basicPostAndAuthorData, {
        locale: page.locale,
        domain: page.site,
        aid: (0, _pageContext.getInfluencerId)() || _window.queryString.af,
        featured_to_site: post.featured_to_site // eslint-disable-line camelcase
      });
      return data;
    }
  }]);
  return ActionCounterService;
}(_analyticsBaseService2.default);

exports.default = ActionCounterService;

/***/ }),

/***/ 148:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _userStore = __webpack_require__(38);

var _userStore2 = _interopRequireDefault(_userStore);

var _window = __webpack_require__(8);

var _externalScripts = __webpack_require__(52);

var _fn = __webpack_require__(15);

var _script = __webpack_require__(19);

var _analyticsBaseService = __webpack_require__(28);

var _analyticsBaseService2 = _interopRequireDefault(_analyticsBaseService);

var _i18nProvider = __webpack_require__(18);

var _pageDataObject = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable camelcase, key-spacing, no-multi-spaces, lines-around-comment, */
/* eslint semi:0 */
var AGOF_DEFAULT_PARAMS = {
  sv: 'i2',
  st: 'ftbpro'
};
var AGOF_DEFAULT_TAG = { cp: 'dTxUcCpOqKyFz02', co: '/other' };
var AGOF_STATIC_PAGE_TAG = { cp: 'dTxRcCpOqKyFz20serv', co: '/service' };
var AGOF_TAGS_DICTIONARY = {
  league: AGOF_DEFAULT_TAG,
  homepage: { cp: 'dTxRcHpOqKyFz02home', co: '/homepage', sv: 'ke' },
  league_articles: { cp: 'dTxUcCpOqKyFz02arti', co: '/artikel' },
  league_leaderboard: { cp: 'dTxUcCpOqKyFz27auto', co: '/autoren' },
  team: { cp: 'dTxUcCpOqKyFz02mann', co: '/mannschaften' },
  team_articles: { cp: 'dTxUcCpOqKyFz02arti', co: '/artikel' },
  users: { cp: 'dTxUcCpOqKyFz27prof', co: '/profile' },
  post: { cp: 'dTxUcCpOqKyFz02arti', co: '/meldungen' },
  about: AGOF_STATIC_PAGE_TAG,
  writersfaq: AGOF_STATIC_PAGE_TAG,
  rules: AGOF_STATIC_PAGE_TAG,
  terms: AGOF_STATIC_PAGE_TAG,
  contact: AGOF_STATIC_PAGE_TAG,
  privacy_policy: AGOF_STATIC_PAGE_TAG,
  mobile_apps: AGOF_STATIC_PAGE_TAG,
  affiliates: AGOF_STATIC_PAGE_TAG
  /* eslint-enable */

  // NOTICE: this class should be (and is) used only when not in native app
};
var AgofService = function (_AnalyticsBaseService) {
  (0, _inherits3.default)(AgofService, _AnalyticsBaseService);

  function AgofService() {
    var _ref;

    (0, _classCallCheck3.default)(this, AgofService);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = AgofService.__proto__ || (0, _getPrototypeOf2.default)(AgofService)).call.apply(_ref, [this].concat(args)));

    if (_this.shouldReportPageview()) {
      _this.agofLoader = _script.external.load({ name: _externalScripts.externalScriptsConfig.agof.name });
    }
    return _this;
  }

  (0, _createClass3.default)(AgofService, [{
    key: 'pageViewed',
    value: function pageViewed() {
      if (this.shouldReportPageview()) {
        this.trackEvent(this.pageViewData);
      }
    }
  }, {
    key: 'shouldReportPageview',
    value: function shouldReportPageview() {
      var forceAgofReport = _window.queryString.forceAgofReport;

      return forceAgofReport || (0, _fn.allTrue)((0, _pageDataObject.isSupportedForDomain)('Agof'), _i18nProvider.locale === _i18nProvider.AVAILABLE_LOCALES.DE, (0, _pageDataObject.get)('config.env') !== 'development');
    }
  }, {
    key: 'trackEvent',
    value: function trackEvent(data) {
      if (this.shouldReportPageview()) {
        this.logAnalytics(data);
        this.agofLoader((0, _fn.makeSafeFn)(function () {
          return window.iom.c(data, 2);
        }));
      }
    }
  }, {
    key: 'className',
    get: function get() {
      return 'AgofService';
    }
  }, {
    key: 'pageViewData',
    get: function get() {
      var currentTag = AGOF_TAGS_DICTIONARY[(0, _pageDataObject.get)('page.type')] || AGOF_DEFAULT_TAG;
      var tagWithDefaults = (0, _extends3.default)({}, AGOF_DEFAULT_PARAMS, currentTag);
      var sha1 = _userStore2.default.state.sha1;

      if (sha1) {
        tagWithDefaults.mc = sha1;
      }
      return tagWithDefaults;
    }
  }]);
  return AgofService;
}(_analyticsBaseService2.default);

exports.default = AgofService;

/***/ }),

/***/ 149:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _analyticsBaseService = __webpack_require__(28);

var _analyticsBaseService2 = _interopRequireDefault(_analyticsBaseService);

var _dom = __webpack_require__(13);

var _ua = __webpack_require__(10);

var _mithril = __webpack_require__(34);

var _mithril2 = _interopRequireDefault(_mithril);

var _adStore = __webpack_require__(69);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HOST = 'ec2-54-185-154-151.us-west-2.compute.amazonaws.com'; /* eslint semi:0 */

var AnalyticsCounterService = function (_AnalyticsBaseService) {
  (0, _inherits3.default)(AnalyticsCounterService, _AnalyticsBaseService);

  function AnalyticsCounterService() {
    (0, _classCallCheck3.default)(this, AnalyticsCounterService);
    return (0, _possibleConstructorReturn3.default)(this, (AnalyticsCounterService.__proto__ || (0, _getPrototypeOf2.default)(AnalyticsCounterService)).apply(this, arguments));
  }

  (0, _createClass3.default)(AnalyticsCounterService, [{
    key: 'pageViewed',
    value: function pageViewed() {
      this.trackEvent('pageview', { platform: (0, _ua.getPlatform)() });
    }
  }, {
    key: 'routeChanged',
    value: function routeChanged(action) {
      //Empty override to prevent a read report on slideshows on each slide change
    }
  }, {
    key: 'adBlockDetectionFinished',
    value: function adBlockDetectionFinished() {
      this.trackEvent('adblock', {
        platform: (0, _ua.getPlatform)(),
        adblock_detected: _adStore.adStore.isAdblockPresent
      });
    }
  }, {
    key: 'slotRendered',
    value: function slotRendered(action) {
      var lineitem = void 0;
      if (action.event.isEmpty) {
        lineitem = 'empty';
      } else {
        lineitem = action.event.lineItemId || 'adx';
      }
      this.trackEvent('ad_served', {
        platform: (0, _ua.getPlatform)(),
        ad_unit: action.adId,
        lineitem: lineitem
      });
    }
  }, {
    key: 'trackEvent',
    value: function trackEvent(type, params) {
      for (var k in params) {
        params[k] = params[k].toString().replace(' ', '-');
      }
      params.ts = Date.now();
      this.logAnalytics(type, params);
      var serializedParams = _mithril2.default.route.buildQueryString(params);
      (0, _dom.makeImage)({ src: '//' + HOST + '/' + type + '?' + serializedParams });
    }
  }, {
    key: 'className',
    get: function get() {
      return 'AnalyticsCounterService';
    }
  }]);
  return AnalyticsCounterService;
}(_analyticsBaseService2.default);

exports.default = AnalyticsCounterService;

/***/ }),

/***/ 150:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _analyticsBaseService = __webpack_require__(28);

var _analyticsBaseService2 = _interopRequireDefault(_analyticsBaseService);

var _script = __webpack_require__(19);

var _fn = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var comscore = _script.external.load({
  name: 'comscore',
  loadNow: true
});

//NOTICE: this class should be (and is) used only when not in native app
/* eslint semi:0 */

var ComscoreService = function (_AnalyticsBaseService) {
  (0, _inherits3.default)(ComscoreService, _AnalyticsBaseService);

  function ComscoreService() {
    (0, _classCallCheck3.default)(this, ComscoreService);
    return (0, _possibleConstructorReturn3.default)(this, (ComscoreService.__proto__ || (0, _getPrototypeOf2.default)(ComscoreService)).apply(this, arguments));
  }

  (0, _createClass3.default)(ComscoreService, [{
    key: 'pageViewed',
    value: function pageViewed() {
      this.trackEvent({});
    }
  }, {
    key: 'trackEvent',
    value: function trackEvent(data) {
      this.logAnalytics(data);
      comscore((0, _fn.makeSafeFn)(function () {
        return window.COMSCORE.beacon(data);
      }));
    }
  }, {
    key: 'className',
    get: function get() {
      return 'ComscoreService';
    }
  }]);
  return ComscoreService;
}(_analyticsBaseService2.default);

exports.default = ComscoreService;

/***/ }),

/***/ 151:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(16);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ua = __webpack_require__(10);

var _dom = __webpack_require__(13);

var _fn = __webpack_require__(15);

var _userStore = __webpack_require__(38);

var _userStore2 = _interopRequireDefault(_userStore);

var _window = __webpack_require__(8);

var _script = __webpack_require__(19);

var _analyticsStore = __webpack_require__(51);

var _analyticsBaseService = __webpack_require__(28);

var _analyticsBaseService2 = _interopRequireDefault(_analyticsBaseService);

var _preRenderedSelectorsConfig = __webpack_require__(17);

var _pageDataObject = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// const fbPixel = externalScript.load({ name: 'facebookPixel' })
// fbPixel(makeSafeFn(_ => window.fbq('init', getFromPdo('config.facebook_pixel.id'))))

/* eslint semi:0 */
var DEFINED_EVENTS = ['PageView', 'ViewContent', 'Search', 'AddToCart', 'AddToWishlist', 'InitiateCheckout', 'AddPaymentInfo', 'Purchase', 'Lead', 'CompleteRegistration'];

var FacebookAnalyticsService = function (_AnalyticsBaseService) {
  (0, _inherits3.default)(FacebookAnalyticsService, _AnalyticsBaseService);

  function FacebookAnalyticsService() {
    (0, _classCallCheck3.default)(this, FacebookAnalyticsService);
    return (0, _possibleConstructorReturn3.default)(this, (FacebookAnalyticsService.__proto__ || (0, _getPrototypeOf2.default)(FacebookAnalyticsService)).apply(this, arguments));
  }

  (0, _createClass3.default)(FacebookAnalyticsService, [{
    key: 'pageViewed',
    value: function pageViewed() {}
    // const oldPixels = getFromPdo('config.facebook_pixel.old_pixels') || []
    // for (const oldPixel of oldPixels) {
    //   this.trackEventOld(oldPixel)
    // }
    // this.trackEvent('PageView')
    // this.multiPageViews()
    // this.desktopPageview()


    // multiPageViews() {
    //   const postsInSession = Object.keys(userStore.recentReads).length
    //   if (postsInSession > 1) {
    //     this.trackEvent('multiPostsViews', { numPosts: postsInSession })
    //   }
    // }

    // desktopPageview() {
    //   if (getIsDesktop()) {
    //     this.trackEvent('desktopPageview')
    //   }
    // }

  }, {
    key: 'routeChanged',
    value: function routeChanged(action) {}
    //Empty override to prevent a read report on slideshows on each slide change


    // scrollAnchorReached(action) {
    //   if (action.payload.anchor === SCROLL_EVENTS_SELECTORS.SHARE_BUTTONS_BOTTOM) {
    //     this.reportOnce(action, () => {
    //       this.trackEvent('ScrolledToArticleEnd')
    //     })
    //   }
    // }

    // heartBeat() {
    //   const millisecondsPassed = this.store.heartbeatsCount * HEART_BEAT_PERIOD
    //   if (millisecondsPassed === 30000) {
    //     this.trackEvent('HalfMinuteOnPage')
    //   }
    // }

    // socialShare(action) {
    //   this.trackEvent('SharedArticle')
    // }

  }, {
    key: 'trackEvent',
    value: function trackEvent(type, args) {
      var data = (0, _assign2.default)({}, this.defaultEventArgs, args); //NOTICE: for some reason when using makeEmptyObj in Object.assign instead of {}, then it doesn't work and the fbq SDK raise an error
      var trackType = DEFINED_EVENTS.includes(type) ? 'track' : 'trackCustom';
      this.logAnalytics(type, data);
      // fbPixel(makeSafeFn(_ => window.fbq(trackType, type, data)))
    }

    // trackEventOld(pixelUrl) {
    //   this.logAnalytics(pixelUrl)
    //   makeImage({ src: pixelUrl })
    // }

  }, {
    key: 'className',
    get: function get() {
      return 'FacebookAnalyticsService';
    }
  }, {
    key: 'defaultEventArgs',
    get: function get() {
      return {};
    }
  }]);
  return FacebookAnalyticsService;
}(_analyticsBaseService2.default);

exports.default = FacebookAnalyticsService;

/***/ }),

/***/ 152:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(22);

var _keys2 = _interopRequireDefault(_keys);

var _toConsumableArray2 = __webpack_require__(33);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _slicedToArray2 = __webpack_require__(39);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = __webpack_require__(87);

var _entries2 = _interopRequireDefault(_entries);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ua = __webpack_require__(10);

var _window2 = __webpack_require__(8);

var _userStore = __webpack_require__(38);

var _userStore2 = _interopRequireDefault(_userStore);

var _pageDataObject = __webpack_require__(5);

var _script = __webpack_require__(19);

var _analyticsStore = __webpack_require__(51);

var _analyticsBaseService = __webpack_require__(28);

var _analyticsBaseService2 = _interopRequireDefault(_analyticsBaseService);

var _console = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var debugAnalyticsClickHandler = _window2.queryString.debugAnalyticsClickHandler; /* eslint semi:0 */

var CUSTOM_DIMENSIONS = {
  SESSION: {
    PLATFORM: 'dimension1',
    USER_LOGGED_IN: 'dimension3'
  },
  HIT: {
    POST_TEMPLATE: 'dimension2'
  }
};
var YAHOO_FANTASY_TOURNAMENTS_BASE_PARAMS = ['event', 'Y! DF'];
var googleAnalytics = _script.external.load({ name: 'googleAnalytics', loadNow: true });

var GoogleAnalyticsService = function (_AnalyticsBaseService) {
  (0, _inherits3.default)(GoogleAnalyticsService, _AnalyticsBaseService);

  function GoogleAnalyticsService() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck3.default)(this, GoogleAnalyticsService);

    var _this = (0, _possibleConstructorReturn3.default)(this, (GoogleAnalyticsService.__proto__ || (0, _getPrototypeOf2.default)(GoogleAnalyticsService)).call(this, options));

    _this.setCustomDimension(CUSTOM_DIMENSIONS.SESSION.PLATFORM, (0, _ua.getPlatform)());
    _this.setCustomDimension(CUSTOM_DIMENSIONS.SESSION.USER_LOGGED_IN, _userStore2.default.isLoggedIn ? 'loggedIn' : 'loggedOut');
    _this.existingUserAuthenticated = _this.newUserAuthenticated = _this.userAuthenticated;
    return _this;
  }

  (0, _createClass3.default)(GoogleAnalyticsService, [{
    key: 'riddleEmbedMessage',
    value: function riddleEmbedMessage(_ref) {
      var _ref$payload = _ref.payload,
          category = _ref$payload.category,
          label = _ref$payload.label;

      return this.trackEvent('event', 'riddle', category, label);
    }
  }, {
    key: 'pageViewed',
    value: function pageViewed() {
      this.trackEvent('pageview');
    }
  }, {
    key: 'slotRendered',
    value: function slotRendered(action) {
      if (action.adId === 'Interstitial') {
        this.trackEvent('event', 'Ads', 'Interstitial', 'Display', { nonInteraction: true });
      }
    }
  }, {
    key: 'heartBeat',
    value: function heartBeat() {
      var millisecondsPassed = this.store.heartbeatsCount * _analyticsStore.HEART_BEAT_PERIOD;
      this.trackEvent('event', 'Post', 'Read', millisecondsPassed / 1000 + ' seconds');
    }
  }, {
    key: 'socialShare',
    value: function socialShare(action) {
      var position = action.e.target.parentNode.className;
      var shareTarget = action.type.split(':').pop();
      this.trackEvent('social', shareTarget, position, _window2.path);
    }
  }, {
    key: 'analyticsActionsClickEvent',
    value: function analyticsActionsClickEvent(action) {
      var dataToSend = (0, _entries2.default)(action.state.payload).reduce(function (acc, _ref2) {
        var _ref3 = (0, _slicedToArray3.default)(_ref2, 2),
            key = _ref3[0],
            value = _ref3[1];

        return [].concat((0, _toConsumableArray3.default)(acc), [value]);
      }, []);

      if (debugAnalyticsClickHandler) {
        (0, _console.info)('CLICK SERVICE RECIEVED ACTION WITH PAYLOAD: ', action.state.payload);
        (0, _console.info)('SENDING TO GA: ', ['event'].concat((0, _toConsumableArray3.default)(dataToSend)));
      }

      this.trackEvent.apply(this, ['event'].concat((0, _toConsumableArray3.default)(dataToSend)));
    }
  }, {
    key: 'jwplayerAnalytics',
    value: function jwplayerAnalytics(_ref4) {
      var _ref4$payload = _ref4.payload,
          eventName = _ref4$payload.eventName,
          videoId = _ref4$payload.videoId;

      this.trackEvent('event', 'Article page', eventName, videoId);
    }

    //videoPlay(action){
    //  this.jwplayerAnalytics(action)
    //}
    //
    //videoPause(action){
    //  this.jwplayerAnalytics(action)
    //}
    //
    //videoComplete(action){
    //  this.jwplayerAnalytics(action)
    //}
    //
    //videoPause(action){
    //  this.jwplayerAnalytics(action)
    //}
    //
    //videoError(action){
    //  this.jwplayerAnalytics(action)
    //}
    //
    //videoBufferChange({ payload: { eventName, videoId, buffer } }){
    //  this.trackEvent('event', 'Article Page', eventName, `videoId: ${videoId}, buffered: ${buffer.bufferPercent}`);
    //}

  }, {
    key: 'scrollAnchorReached',
    value: function scrollAnchorReached(action) {
      var _this2 = this;

      this.reportOnce(action, function () {
        _this2.setCustomDimension(CUSTOM_DIMENSIONS.HIT.POST_TEMPLATE, (0, _pageDataObject.get)('post.template'));
        _this2.trackEvent('event', 'Scroll', 'Reached', action.payload.anchor);
      });
    }
  }, {
    key: 'userAuthenticated',
    value: function userAuthenticated(action) {
      if (!action.isReauthenticated) {
        this.trackEvent('event', 'User', 'Logged In', null, null, { sessionControl: 'end' });
        this.setCustomDimension(CUSTOM_DIMENSIONS.SESSION.USER_LOGGED_IN, 'loggedIn');
      }
    }
  }, {
    key: 'fbLogin',
    value: function fbLogin(action) {}
  }, {
    key: 'logout',
    value: function logout(action) {
      // on user logged out
      this.trackEvent('event', 'User', 'Logged out', null, null, { sessionControl: 'end' });
      this.setCustomDimension(CUSTOM_DIMENSIONS.SESSION.USER_LOGGED_IN, 'loggedOut');
    }
  }, {
    key: 'vote',
    value: function vote(action) {}
  }, {
    key: 'placeBet',
    value: function placeBet(action) {}
  }, {
    key: 'tournamentGetTournamentsFeed',
    value: function tournamentGetTournamentsFeed(_ref5) {
      var numberOfTournaments = _ref5.state.tournaments.length;

      if (numberOfTournaments) {
        this.trackEvent.apply(this, YAHOO_FANTASY_TOURNAMENTS_BASE_PARAMS.concat(['view', 'contest widget']));
      }
    }
  }, {
    key: 'tournamentSelectTournament',
    value: function tournamentSelectTournament(action) {
      this.trackEvent.apply(this, YAHOO_FANTASY_TOURNAMENTS_BASE_PARAMS.concat(['enter clicked', 'contest widget']));
    }
  }, {
    key: 'tournamentLoadMore',
    value: function tournamentLoadMore(action) {
      this.trackEvent.apply(this, YAHOO_FANTASY_TOURNAMENTS_BASE_PARAMS.concat(['show more', 'contest widget']));
    }
  }, {
    key: 'goToMessengerBot',
    value: function goToMessengerBot(_ref6) {
      var displayMessage = _ref6.state.displayMessage;

      this.trackEvent('event', 'FB bot', 'button click', displayMessage);
    }
  }, {
    key: 'reactionsDisplay',
    value: function reactionsDisplay(action) {
      var reactionsCampaign = (0, _pageDataObject.get)('post.reactions.campaign.name', '');
      var buttonLocation = (0, _keys2.default)(action.state.reactionsComponentState)[0];
      this.trackEvent('event', 'Reactions Web ' + reactionsCampaign, 'Reaction Button Click', buttonLocation);
    }
  }, {
    key: 'reactionsSendVote',
    value: function reactionsSendVote(action) {
      var actionState = action.state;

      var reactionsCampaign = (0, _pageDataObject.get)('post.reactions.campaign.name', '');
      var buttonLocation = actionState.componentPosition,
          reactionId = actionState.selectedReaction;

      this.trackEvent('event', 'Reactions Web ' + reactionsCampaign, 'Reaction Selection ' + buttonLocation, reactionId);
    }
  }, {
    key: 'jwplayerEvent',
    value: function jwplayerEvent(action) {}
  }, {
    key: 'setCustomDimension',
    value: function setCustomDimension(dimension, value) {
      googleAnalytics(function () {
        return window.ga('set', dimension, value);
      });
    }
  }, {
    key: 'trackEvent',
    value: function trackEvent() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      args.unshift('send');
      this.logAnalytics.apply(this, args);
      googleAnalytics(function () {
        var _window;

        return (_window = window).ga.apply(_window, args);
      });
    }
  }, {
    key: 'className',
    get: function get() {
      return 'GoogleAnalyticsService';
    }
  }]);
  return GoogleAnalyticsService;
}(_analyticsBaseService2.default);

exports.default = GoogleAnalyticsService;

/***/ }),

/***/ 154:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _fn = __webpack_require__(15);

var _BaseClass2 = __webpack_require__(43);

var _BaseClass3 = _interopRequireDefault(_BaseClass2);

var _adActions = __webpack_require__(50);

var _mithril = __webpack_require__(54);

var _dom = __webpack_require__(13);

var _pageDataObject = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint semi:0 */
var AdblockDetectorProvider = function (_BaseClass) {
  (0, _inherits3.default)(AdblockDetectorProvider, _BaseClass);

  function AdblockDetectorProvider() {
    (0, _classCallCheck3.default)(this, AdblockDetectorProvider);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AdblockDetectorProvider.__proto__ || (0, _getPrototypeOf2.default)(AdblockDetectorProvider)).call(this));

    !(0, _pageDataObject.getIsDraft)() && _this.loadAdblockTestScript();
    return _this;
  }

  (0, _createClass3.default)(AdblockDetectorProvider, [{
    key: 'loadAdblockTestScript',
    value: function loadAdblockTestScript() {
      (0, _mithril.safeRequest)({
        method: 'GET',
        url: 'https://static.minutemediacdn.com/assets/qa4/ads-adblock-test.js',
        deserialize: _fn.identity //This is simply to avoid the warning that the response is not a JSON
      }).then(this.onAdblockTestScriptLoaded.bind(this), this.onAdblockTestScriptError.bind(this));
    }
  }, {
    key: 'onAdblockTestScriptLoaded',
    value: function onAdblockTestScriptLoaded() {
      var ad = this.createDummyAd();
      this.adblockDetected = this.isAdHidden(ad);
      this.onAdblockDetectingFinished();
    }
  }, {
    key: 'createDummyAd',
    value: function createDummyAd() {
      var ad = (0, _dom.createElement)('div');
      ad.id = 'adblock-test';
      ad.setAttribute('class', 'ad-dummy pub_300x250');
      ad.setAttribute('style', 'width: 1px !important; height: 1px !important; position: absolute !important; left: -10000px !important; top: -1000px !important');
      document.body.appendChild(ad);
      return ad;
    }
  }, {
    key: 'isAdHidden',
    value: function isAdHidden(ad) {
      var isHidden = ad.offsetHeight === 0 || ad.offsetWidth === 0;
      if (!isHidden && window.getComputedStyle) {
        var adStyle = window.getComputedStyle(ad, null);
        isHidden = adStyle.getPropertyValue('display') === 'none' || adStyle.getPropertyValue('visibility') === 'hidden';
      }
      return isHidden;
    }
  }, {
    key: 'onAdblockTestScriptError',
    value: function onAdblockTestScriptError(error) {
      // eslint-disable-line handle-callback-err
      this.adblockDetected = true;
      this.onAdblockDetectingFinished();
    }
  }, {
    key: 'onAdblockDetectingFinished',
    value: function onAdblockDetectingFinished() {
      (0, _adActions.adBlockDetectionFinished)({ detected: this.adblockDetected });
    }
  }]);
  return AdblockDetectorProvider;
}(_BaseClass3.default);

var initAdblockDetectorProvider = AdblockDetectorProvider.create.bind(AdblockDetectorProvider);
exports.default = initAdblockDetectorProvider;

/***/ }),

/***/ 155:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCampaignsFromCampaignManager = undefined;

var _regenerator = __webpack_require__(128);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(183);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _fetch = __webpack_require__(57);

var _window = __webpack_require__(8);

var _pageDataObject = __webpack_require__(5);

var _geolocationProvider = __webpack_require__(44);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getDate = function getDate() {
  var date = _window.queryString.localTime ? new Date(_window.queryString.localTime) : new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000);
  date.setSeconds(0, 0);
  return date.toJSON();
};

var getLocale = function getLocale() {
  return _window.queryString.language || (0, _pageDataObject.getPageLocale)();
};

var getTags = function getTags() {
  return _window.queryString.tags || (0, _pageDataObject.getPostCategories)().join(',');
};

var getCampaignsFromCampaignManagerService = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(site, country, localTime, locale, tags) {
    var result;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, _fetch.getJsonOrError)((0, _pageDataObject.getApiServicesEndpoints)().campaigns + '?site=' + site + '&country=' + country + '&localTime=' + localTime + '&language=' + locale + '&tags=' + tags);

          case 2:
            result = _context.sent;
            return _context.abrupt('return', result.data);

          case 4:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function getCampaignsFromCampaignManagerService(_x, _x2, _x3, _x4, _x5) {
    return _ref.apply(this, arguments);
  };
}();

var campaignsPromise = null;

var getCampaignsFromCampaignManager = exports.getCampaignsFromCampaignManager = function () {
  var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
    var countryCode;
    return _regenerator2.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return (0, _geolocationProvider.getCountryCode)();

          case 2:
            countryCode = _context2.sent;

            if (!campaignsPromise) {
              campaignsPromise = getCampaignsFromCampaignManagerService((0, _pageDataObject.getSite)(), countryCode, getDate(), getLocale(), getTags());
            }

            _context2.next = 6;
            return campaignsPromise;

          case 6:
            return _context2.abrupt('return', _context2.sent);

          case 7:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, undefined);
  }));

  return function getCampaignsFromCampaignManager() {
    return _ref2.apply(this, arguments);
  };
}();

/***/ }),

/***/ 156:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(159);
module.exports = __webpack_require__(20).Object.values;

/***/ }),

/***/ 159:
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(40)
  , $values = __webpack_require__(232)(false);

$export($export.S, 'Object', {
  values: function values(it){
    return $values(it);
  }
});

/***/ }),

/***/ 175:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./actionCounterService": 147,
	"./agofService": 148,
	"./analyticsBaseService": 28,
	"./analyticsCounterService": 149,
	"./comscoreService": 150,
	"./facebookAnalyticsService": 151,
	"./googleAnalyticsService": 152
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 175;

/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sdkLoaded = exports.loadSdk = exports.MONTIPLAYER_ACTION_TYPES = undefined;

var _object = __webpack_require__(12);

var MONTIPLAYER_ACTION_TYPES = exports.MONTIPLAYER_ACTION_TYPES = (0, _object.namespacedConsts)({
  SDK_LOADED: true,
  LOAD_SDK: true
});

var loadSdk = exports.loadSdk = function loadSdk(_) {
  return {
    type: MONTIPLAYER_ACTION_TYPES.LOAD_SDK
  };
};

var sdkLoaded = exports.sdkLoaded = function sdkLoaded(_) {
  return {
    type: MONTIPLAYER_ACTION_TYPES.SDK_LOADED
  };
};

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(16);

var _assign2 = _interopRequireDefault(_assign);

exports.injectElement = injectElement;
exports.logger = logger;

var _console = __webpack_require__(11);

var _preRenderedSelectorsConfig = __webpack_require__(17);

var _dom = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INSERTION_ELEMENT_SELECTOR = 'p[data-label]'; /**
                                                   * Injects dom nodes according to configuration. Used by ads and campaigns.
                                                   */

var INSERTION_ELEMENT_SELECTOR_FALLBACK = 'p';
var INSERTION_ELEMENT_NUMBER = 2;
var INJECTED_ELEMENT_DEFAULTS = {
  tagName: 'div',
  className: '',
  dataset: {}
};

function getSelectorMatches(scopeEl, selector) {
  return scopeEl && scopeEl.querySelectorAll(selector);
}

function injectElement() {
  var elementConf = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var log = arguments[1];

  var postBodyNode = (0, _dom.node)(_preRenderedSelectorsConfig.SELECTORS.POST_BODY_SELECTOR);
  var postBodySelectorMatches = getSelectorMatches.bind(postBodyNode, postBodyNode);
  var selectorMatches = postBodySelectorMatches(INSERTION_ELEMENT_SELECTOR);
  if (selectorMatches && selectorMatches.length < INSERTION_ELEMENT_NUMBER) {
    var currentSelector = INSERTION_ELEMENT_SELECTOR_FALLBACK;
    selectorMatches = postBodySelectorMatches(currentSelector);
  }
  if (selectorMatches && selectorMatches.length >= INSERTION_ELEMENT_NUMBER) {
    var injectAfterNode = selectorMatches[INSERTION_ELEMENT_NUMBER - 1];

    var _Object$assign = (0, _assign2.default)({}, INJECTED_ELEMENT_DEFAULTS, elementConf),
        tagName = _Object$assign.tagName,
        className = _Object$assign.className,
        dataset = _Object$assign.dataset;

    var injectedEl = (0, _dom.createElement)(tagName);
    injectedEl.className = className;
    (0, _assign2.default)(injectedEl.dataset, dataset);
    (0, _dom.addElementAfter)(injectedEl, injectAfterNode);
    log('Adding', { injectedEl: injectedEl, injectAfterNode: injectAfterNode, selectorMatches: selectorMatches });
    return true;
  }
  log('Skipping', { elementConf: elementConf, selectorMatches: selectorMatches });
  return false;
}

function logger(shouldLog) {
  for (var _len = arguments.length, messages = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    messages[_key - 1] = arguments[_key];
  }

  shouldLog && _console.info.apply(undefined, messages);
}

/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initDfpDynamicSlot = initDfpDynamicSlot;

var _window = __webpack_require__(8);

var _injectDynamicContent = __webpack_require__(204);

var _adsConfig = __webpack_require__(27);

var _pageDataObject = __webpack_require__(5);

var adsDebugDynamicSlot = _window.queryString.adsDebugDynamicSlot;

var isNonEmbeddedPostPageOnMobile = (0, _pageDataObject.getIsPostPage)() && !(0, _pageDataObject.getIsEmbededPost)() || (0, _pageDataObject.getIsTopX)() || (0, _pageDataObject.getIsSlideshow)();
var BLOCK = _adsConfig.CLASS_NAMES.BLOCK,
    EMPTY = _adsConfig.CLASS_NAMES.EMPTY,
    INJECTED = _adsConfig.CLASS_NAMES.INJECTED,
    DFP = _adsConfig.CLASS_NAMES.DFP;

var INJECTED_ELEMENT_CONF_DFP_SLOT = {
  className: [BLOCK, INJECTED, EMPTY, DFP].join(' '),
  dataset: {
    slotId: _adsConfig.AD_FORMATS.InArticleDynamic
  }
};

function isDfpDynamicSlotEnabled() {
  return isNonEmbeddedPostPageOnMobile;
}

function initDfpDynamicSlot(config) {
  var dfpLogger = _injectDynamicContent.logger.part(adsDebugDynamicSlot, 'dfpDynamicSlot:');
  if (!isDfpDynamicSlotEnabled()) {
    dfpLogger('disabled', { isDfpDynamicSlotEnabled: isDfpDynamicSlotEnabled, isNonEmbeddedPostPageOnMobile: isNonEmbeddedPostPageOnMobile });
    return false;
  }
  return (0, _injectDynamicContent.injectElement)(INJECTED_ELEMENT_CONF_DFP_SLOT, dfpLogger);
}

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(58);

var _getIterator3 = _interopRequireDefault(_getIterator2);

exports.default = initAds;

var _mithril = __webpack_require__(34);

var _dom = __webpack_require__(13);

var _adStore = __webpack_require__(69);

var _window = __webpack_require__(8);

var _fn = __webpack_require__(15);

var _console = __webpack_require__(11);

var _RegularAdView = __webpack_require__(125);

var _RegularAdView2 = _interopRequireDefault(_RegularAdView);

var _InjectedAdView = __webpack_require__(216);

var _InjectedAdView2 = _interopRequireDefault(_InjectedAdView);

var _adsConfig = __webpack_require__(27);

var _providerFactory = __webpack_require__(220);

var _providerFactory2 = _interopRequireDefault(_providerFactory);

var _i18nProvider = __webpack_require__(18);

var _preRenderedSelectorsConfig = __webpack_require__(17);

var _ua = __webpack_require__(10);

var _pageDataObject = __webpack_require__(5);

var _initAmazonHeaderBidder = __webpack_require__(141);

var _initAmazonHeaderBidder2 = _interopRequireDefault(_initAmazonHeaderBidder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SLIDESHOW_DISABLED_AD_FORMATS = [_adsConfig.AD_FORMATS.Outofpage];
var adsConfig = (0, _pageDataObject.get)('config.ads', __webpack_require__(27));

var EXCLUDED_GEOS_FOR_MOBILE_BOTTOM_SLOT = ['in', 'ar', 'th', 'mx'];
var noAds = _window.queryString.noAds,
    noads = _window.queryString.noads,
    debugAds = _window.queryString.debugAds;


function getAdType(adId) {
  return adsConfig.slot[adId].type;
}

function getAdView(adType) {
  var _AdViewToCreate;

  var AdViewToCreate = void 0;
  switch (adType) {
    case _adsConfig.AD_TYPES.REGULAR:
      AdViewToCreate = _RegularAdView2.default;
      break;
    case _adsConfig.AD_TYPES.INJECTED:
      AdViewToCreate = _InjectedAdView2.default;
      break;
    default:
      AdViewToCreate = _RegularAdView2.default;
  }

  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return (_AdViewToCreate = AdViewToCreate).create.apply(_AdViewToCreate, args);
}

function isAdsEnabled() {
  var shouldShowAds = _pageDataObject.ads.shouldShowAds;

  var page = (0, _pageDataObject.get)('page', null);
  var areAdsEnabled = !(noAds || noads) && page && !(0, _pageDataObject.getIsDraft)() && shouldShowAds;
  debugAds && (0, _console.info)('areAdsEnabled:', areAdsEnabled, {
    shouldShowAds: shouldShowAds,
    isEmbededPost: (0, _pageDataObject.getIsEmbededPost)(),
    isDraft: (0, _pageDataObject.getIsDraft)(),
    page: page
  });
  return areAdsEnabled;
}

function filterAdsByTypeDeviceAndGeo(adId, countryCode) {
  return EXCLUDED_GEOS_FOR_MOBILE_BOTTOM_SLOT.includes(countryCode.toLowerCase()) && adId === _adsConfig.AD_FORMATS.Bottom && (0, _ua.getIsMobile)();
}

function isSlotEnabledInCountryCode(whiteListedCountryCodes, countryCode) {
  return whiteListedCountryCodes.map(function (s) {
    return s.toLowerCase();
  }).includes(countryCode.toLowerCase());
}

function isDisabledInSlideshow(adId) {
  return (0, _pageDataObject.getIsSlideshow)() && SLIDESHOW_DISABLED_AD_FORMATS.includes(adId);
}

function notShow(adId, countryCode) {
  // eslint-disable-line complexity
  var slotConf = adsConfig.slot[adId];
  if (adId === 'Top' && (0, _ua.getIsMobile)()) {
    return true;
  }
  if (!slotConf) {
    return true;
  }
  var _adsConfig$slot$adId = adsConfig.slot[adId],
      adType = _adsConfig$slot$adId.type,
      slotConfig = _adsConfig$slot$adId.doubleClick,
      isDisabled = _adsConfig$slot$adId.isDisabled,
      enabledInCountryCodes = _adsConfig$slot$adId.enabledInCountryCodes;

  if (isDisabled || adType === _adsConfig.AD_TYPES.VIDEO || filterAdsByTypeDeviceAndGeo(adId, countryCode)) {
    return true;
  }
  if (isDisabledInSlideshow(adId)) {
    return true;
  }
  if (enabledInCountryCodes) {
    if (!isSlotEnabledInCountryCode(enabledInCountryCodes, countryCode)) {
      return true;
    }
  }
  var hideForPlatform = slotConfig.hideForPlatform,
      hideForNonMobile = slotConfig.hideForNonMobile,
      hideForLocale = slotConfig.hideForLocale,
      hideForHorizonalBreakpoint = slotConfig.hideForHorizonalBreakpoint,
      isEnabledInNativeApp = slotConfig.isEnabledInNativeApp;

  var isInDisallowedPlatform = hideForPlatform && (0, _ua.getPlatform)(hideForPlatform);
  var isHideForNonMobile = hideForNonMobile && !(0, _ua.getIsMobile)();
  var isInDisallowedLocale = hideForLocale === _i18nProvider.locale;
  var isHiddenInNativeApp = !isEnabledInNativeApp && (0, _ua.getIsNativeApp)();
  var isInDisallowedViewport = hideForHorizonalBreakpoint && !_ua.viewport.widerThanTabletBreakpoint;
  return isInDisallowedPlatform || isInDisallowedLocale || isInDisallowedViewport || isHideForNonMobile || isHiddenInNativeApp || false;
}

var pageAdSlots = {};

function mountAdComponent(adElement, countryCode) {
  var dataset = adElement.dataset;
  var slotId = dataset.slotId;

  var existingPageSlot = pageAdSlots[slotId];
  if (existingPageSlot) {
    (0, _console.warn)('slotId \'' + slotId + '\' is already mounted! Not mounting again.', {
      newPageSlot: adElement,
      existingPageSlot: existingPageSlot,
      adsConfig: adsConfig,
      newDataset: dataset,
      existingDataset: existingPageSlot.dataset
    });
    return false;
  }
  pageAdSlots[slotId] = adElement;
  if ((0, _fn.makeSafeFn)(notShow).invoke(slotId, countryCode)) {
    return false;
  }
  var adType = (0, _fn.makeSafeFn)(getAdType).invoke(slotId);
  if (!adType) {
    (0, _console.warn)('\'' + adType + '\' is falsy! wat o_O', {
      adElement: adElement,
      adsConfig: adsConfig,
      slotId: slotId
    });
    return false;
  }
  var adConfig = adsConfig.slot[slotId];
  var adView = getAdView(adType, adElement, adConfig, _adStore.adStore);
  if (!adView) {
    (0, _console.warn)('adView is falsy! How does even?', {
      adElement: adElement,
      adsConfig: adsConfig,
      adConfig: adConfig,
      adStore: _adStore.adStore,
      adType: adType,
      adView: adView
    });
    return false;
  }
  var adComponent = {
    view: adView.view.bind(adView),
    controller: _fn.noop
  };
  return (0, _mithril.mount)(adElement, adComponent);
}

function renderSlots(countryCode) {
  var adElements = (0, _dom.nodes)(_preRenderedSelectorsConfig.SELECTORS.AD);
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = (0, _getIterator3.default)(adElements), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var adElement = _step.value;

      mountAdComponent(adElement, countryCode);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  if ((0, _initAmazonHeaderBidder.isCountryCodeUnitedStates)(countryCode)) {
    (0, _initAmazonHeaderBidder2.default)();
  }
}

function initConfiant() {
  var script = document.createElement('script');
  script.src = 'https://confiant-integrations.global.ssl.fastly.net/gVg8G70ZiP2pnVNIz9TfdRQopWU/gpt/config.js';
  script.async = true;
  document.head.appendChild(script);
}

function initAds() {
  var isEnabled = isAdsEnabled();
  _adStore.adStore.isAdsEnabled = isEnabled;
  if (isEnabled) {
    if ((0, _pageDataObject.getSite)() !== 'floor8') {
      initConfiant();
    }
    var Provider = _providerFactory2.default.getProvider();
    Provider.create(renderSlots);
  }
  return isEnabled;
}

/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initGoogleAds;

var _initAds = __webpack_require__(209);

var _initAds2 = _interopRequireDefault(_initAds);

var _adInjectedDfpDynamicSlotConfig = __webpack_require__(205);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initGoogleAds() {
  // initDfpDynamicSlot()
  (0, _initAds2.default)();
}

/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initEiExternalScripts = initEiExternalScripts;

var _script = __webpack_require__(19);

var _pageDataObject = __webpack_require__(5);

function loadSocialMinerScript() {
  _script.external.load({
    name: 'socialMiner',
    loadNow: true
  });
}

function loadReactfulScript() {
  _script.external.load({
    name: 'reactful',
    loadNow: true
  });
}

function initEiExternalScripts() {
  if ('ei' === (0, _pageDataObject.getSite)()) {
    loadReactfulScript();
    loadSocialMinerScript();
  }
}

/***/ }),

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initTheDuelExternalScripts = initTheDuelExternalScripts;

var _script = __webpack_require__(19);

var _pageDataObject = __webpack_require__(5);

function loadAmplitudeScript() {
  _script.external.load({
    name: 'amplitude',
    loadNow: true
  });
}

function initTheDuelExternalScripts() {
  if ('theduel' === (0, _pageDataObject.getSite)()) {
    loadAmplitudeScript();
  }
}

/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _adActions = __webpack_require__(50);

var _console = __webpack_require__(11);

var _window3 = __webpack_require__(8);

var _adsConfig = __webpack_require__(27);

var _BaseClass2 = __webpack_require__(43);

var _BaseClass3 = _interopRequireDefault(_BaseClass2);

var _adTargeting = __webpack_require__(85);

var _adTargeting2 = _interopRequireDefault(_adTargeting);

var _ua = __webpack_require__(10);

var _pageDataObject = __webpack_require__(5);

var _initAmazonHeaderBidder = __webpack_require__(141);

var _geolocationProvider = __webpack_require__(44);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var adsDebugRefresh = _window3.queryString.adsDebugRefresh;


var canSetPageTargeting = true;
var dfpEventCallbacksRegistered = false;

function isPassbackAdType(adType) {
  return adType === _adsConfig.AD_TYPES.PASSBACK;
}

function getDimensionsObj(_ref) {
  var dimensions = _ref.dimensions;

  if ((0, _ua.getIsDesktop)()) {
    return dimensions.desktop;
  }
  if ((0, _ua.getIsMobile)()) {
    return dimensions.mobile;
  }
  var isPortrait = _ua.viewport.isPortrait;

  var tabletDimensions = dimensions[isPortrait ? 'portraitTablet' : 'landscapeTablet'];
  return tabletDimensions || dimensions.mobile;
}

function getDimensions(adData) {
  return getDimensionsObj(adData).map(function (dimensionsObj) {
    return dimensionsObj.valueOf();
  });
}

var isGtagInitialized = false;

function repeat(count) {
  var string = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '0';

  var padString = '';

  for (var i = 0; i < count; i += 1) {
    padString += string;
  }

  return padString;
}

function padLeft(string, padding) {
  return repeat(Math.max(0, padding)) + string;
}

function getCookie(name) {
  var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  if (match) return match[2];
  return null;
}
function getGoogleConsent() {
  var googleConsent = getCookie('googlepersonalization');
  if (null !== googleConsent && 'undefined' !== typeof googleConsent) {
    var bstr = atob(googleConsent);
    var inputbits = '';

    for (var i = 0; i < bstr.length; i += 1) {
      var bitString = bstr.charCodeAt(i).toString(2);
      inputbits += padLeft(bitString, 8 - bitString.length);
    }

    // convert to bit string 0s and 1s

    return inputbits[72] === '1' ? 0 : 1;
  }
  return 0;
}

var GoogleTagService = function (_BaseClass) {
  (0, _inherits3.default)(GoogleTagService, _BaseClass);

  function GoogleTagService() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck3.default)(this, GoogleTagService);

    var _this = (0, _possibleConstructorReturn3.default)(this, (GoogleTagService.__proto__ || (0, _getPrototypeOf2.default)(GoogleTagService)).call(this, options));

    var _window = window,
        gTag = _window.googletag;

    _this.merge({
      gTag: gTag = gTag || {}
    });
    gTag.renderedAdsEvents = gTag.renderedAdsEvents || {};
    gTag.cmd = gTag.cmd || [];
    return _this;
  }

  (0, _createClass3.default)(GoogleTagService, [{
    key: 'globalInitGtag',
    value: function globalInitGtag(callback) {
      if (!isGtagInitialized) {
        var _window2 = window,
            gTag = _window2.googletag;

        if (gTag) {
          gTag.cmd.push(function initializePubads() {
            if (!isGtagInitialized) {
              isGtagInitialized = true;
              gTag.pubads().setRequestNonPersonalizedAds(getGoogleConsent());
              var pubads = gTag.pubads;

              pubads().enableAsyncRendering();
              pubads().collapseEmptyDivs(true);
              if ((0, _initAmazonHeaderBidder.isCountryCodeUnitedStates)((0, _geolocationProvider.getLastKnownCountryCode)())) {
                pubads().disableInitialLoad();
              }
              gTag.enableServices();
            }
            callback();
          });
        }
      }
    }
  }, {
    key: 'defineSlot',
    value: function defineSlot(context) {
      var gTag = context.gTag,
          adConf = context.adConf,
          adType = context.adType,
          adFormat = context.adFormat;
      var slotDivId = adConf.slotDivId;

      var isOutOfPage = adConf.isOutOfPage || false;
      var adUnitPath = adConf.adUnitPath;

      adUnitPath = adUnitPath || context.adUnitPath;
      var slots = gTag.slots = gTag.slots || {};
      var slot = void 0;
      var isPassbackSlot = isPassbackAdType(adType);
      var adDimensions = null;
      if (isOutOfPage) {} else if (isPassbackSlot) {
        adDimensions = getDimensions(adConf);
        slot = gTag.pubads().definePassback(adUnitPath, adDimensions);
      } else {
        adDimensions = getDimensions(adConf);
        slot = gTag.defineSlot(adUnitPath, adDimensions, slotDivId);
      }
      if (!slot) {
        (0, _console.warn)('GoogleTagService.defineSlot: googletag.defineSlot() returned null', {
          adUnitPath: adUnitPath,
          adDimensions: adDimensions,
          adConf: adConf,
          context: context,
          isPassbackSlot: isPassbackSlot
        });
        return;
      }
      slots[adFormat] = slot;
      if (!isPassbackSlot) {
        slot.addService(gTag.pubads());
      }
    }
  }, {
    key: 'setTargeting',
    value: function setTargeting() {
      var targeting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (canSetPageTargeting) {
        (0, _adTargeting2.default)(this.gTag, targeting);
        canSetPageTargeting = false;
      }
      return this.gTag;
    }
  }, {
    key: 'resetPageTargetingLimit',
    value: function resetPageTargetingLimit() {
      canSetPageTargeting = true;
      return this;
    }
  }, {
    key: 'refreshSlot',
    value: function refreshSlot(slot) {
      adsDebugRefresh && this.info('Refreshing slot', slot);
      this.setTargeting({ isRefresh: true }).pubads().refresh([slot]);
      return this;
    }
  }, {
    key: 'initSlot',
    value: function initSlot(adConf, adType) {
      var _this2 = this;

      var adFormat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'DefaultFormat';

      this.merge({
        adFormat: adFormat,
        adConf: adConf,
        adType: adType
      }).gTag.cmd // The way DFP invokes the function prohibits the use of
      // proper 'this', so the argument is a workaround
      .push(function () {
        return _this2.defineSlot(_this2);
      });
      return this;
    }
  }, {
    key: 'registerDfpEventCallbacks',
    value: function registerDfpEventCallbacks(onSlotRenderEnded, onSlotOnload) {
      if (!dfpEventCallbacksRegistered) {
        this.gTag.pubads().addEventListener('slotRenderEnded', onSlotRenderEnded);
        this.gTag.pubads().addEventListener('slotOnload', onSlotOnload);
        dfpEventCallbacksRegistered = true;
      }
    }
  }, {
    key: 'initTargeting',
    value: function initTargeting(adData, adFormat, onSlotRenderEnded, onSlotOnload, adType) {
      var _this3 = this;

      var gTag = this.gTag;

      gTag.cmd.push(function () {
        var currentTag = gTag.slots[adFormat];
        var isPassbackSlot = isPassbackAdType(adType);
        if (!currentTag) {
          (0, _console.warn)('GoogleTagService.initTargeting: no \'' + adFormat + '\' in googletag.slots!', {
            adData: adData,
            adFormat: adFormat,
            adType: adType,
            isPassbackSlot: isPassbackSlot
          });
          return;
        }
        if (!isPassbackSlot) {
          currentTag.clearTargeting();
          //slot level targeting
          currentTag.setTargeting('format', adFormat);
        }
        _this3.registerDfpEventCallbacks(onSlotRenderEnded, onSlotOnload);
        if (!isPassbackSlot) {
          gTag.display(adData.slotDivId);
          setTimeout(function () {
            (0, _adActions.requestingAds)(adFormat);
          }, 0);
        }
      });
      return this;
    }
  }, {
    key: 'slots',
    get: function get() {
      return this.gTag.slots || [];
    }
  }, {
    key: 'renderedAdsEvents',
    get: function get() {
      return this.gTag.renderedAdsEvents;
    }
  }, {
    key: 'adUnitPath',
    get: function get() {
      var hierarchyLevels = _pageDataObject.ads.hierarchyLevels;

      hierarchyLevels.l4 = this.adFormat;
      return hierarchyLevels.toString();
    }
  }]);
  return GoogleTagService;
}(_BaseClass3.default);

exports.default = GoogleTagService;

/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _from = __webpack_require__(49);

var _from2 = _interopRequireDefault(_from);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _AdVm = __webpack_require__(217);

var _AdVm2 = _interopRequireDefault(_AdVm);

var _BaseView2 = __webpack_require__(84);

var _BaseView3 = _interopRequireDefault(_BaseView2);

var _dom = __webpack_require__(13);

var _window = __webpack_require__(8);

var _adsConfig = __webpack_require__(27);

var _adTargeting = __webpack_require__(85);

var _adTargeting2 = _interopRequireDefault(_adTargeting);

var _adStore = __webpack_require__(69);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var debugAdSizes = _window.queryString.debugAdSizes;
var EMPTY = _adsConfig.CLASS_NAMES.EMPTY;


var CLASS_CONSTANTS = {
  AD_WIDTH: 'ad-width',
  AD_HEIGHT: 'ad-height'
};
var AD_WIDTH = CLASS_CONSTANTS.AD_WIDTH,
    AD_HEIGHT = CLASS_CONSTANTS.AD_HEIGHT;

var BaseAdView = function (_BaseView) {
  (0, _inherits3.default)(BaseAdView, _BaseView);

  function BaseAdView(element, adConfig, store) {
    (0, _classCallCheck3.default)(this, BaseAdView);

    var _this = (0, _possibleConstructorReturn3.default)(this, (BaseAdView.__proto__ || (0, _getPrototypeOf2.default)(BaseAdView)).apply(this, arguments));

    var adId = element.dataset.slotId;
    var type = adConfig.type;

    var adVm = _AdVm2.default.create({
      adId: adId,
      type: type,
      adConfig: adConfig.doubleClick,
      store: store || _adStore.adStore,
      actions: _adStore.adActions
    });
    _this.merge({
      initialized: false,
      adVm: adVm,
      adId: adId
    });
    adVm.gTagService.globalInitGtag(_adTargeting2.default.part(adVm.gTagService.gTag));
    return _this;
  }

  (0, _createClass3.default)(BaseAdView, [{
    key: 'isEmptySlot',
    value: function isEmptySlot() {
      var _adVm = this.adVm,
          emptySlot = _adVm.emptySlot,
          adSize = _adVm.adSize;
      var width = adSize.width,
          height = adSize.height;

      return emptySlot.isEmpty || !width || !height;
    }
  }, {
    key: 'display',
    value: function display() {
      this.adVm.display();
      return this;
    }
  }, {
    key: 'adSizesClassNames',
    get: function get() {
      if (this.isEmptySlot()) {
        return [EMPTY];
      }
      var _adVm$adSize = this.adVm.adSize,
          width = _adVm$adSize.width,
          height = _adVm$adSize.height;

      return [AD_WIDTH + '--' + width, AD_HEIGHT + '--' + height];
    }
  }, {
    key: 'adClassList',
    get: function get() {
      var currentSlot = this.options;
      var currentSlotClassList = (0, _dom.classList)(currentSlot);
      var classNamesToFilter = [AD_WIDTH, AD_HEIGHT, EMPTY];
      return (0, _from2.default)(currentSlotClassList).filter(function (className) {
        return classNamesToFilter.every(function (classToFilter) {
          return !className.startsWith(classToFilter);
        });
      }).concat(this.adSizesClassNames);
    }
  }, {
    key: 'renderParams',
    get: function get() {
      var adVm = this.adVm;

      var params = {
        attributes: {
          id: adVm.adData.slotDivId
        }
      };
      var currentSlot = this.options;
      debugAdSizes && this.info(currentSlot.dataset.slotId, this.adId, this.adClassList);
      currentSlot.className = this.adClassList.join(' ');
      if (!this.initialized) {
        params.callback = adVm.initAndDisplay.bind(adVm);
      }
      this.initialized = true;
      return params;
    }
  }]);
  return BaseAdView;
}(_BaseView3.default);

exports.default = BaseAdView;

/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(71);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _mithril = __webpack_require__(34);

var _mithril2 = _interopRequireDefault(_mithril);

var _i18nProvider = __webpack_require__(18);

var _RegularAdView2 = __webpack_require__(125);

var _RegularAdView3 = _interopRequireDefault(_RegularAdView2);

var _adsConfig = __webpack_require__(27);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InjectedAdView = function (_RegularAdView) {
  (0, _inherits3.default)(InjectedAdView, _RegularAdView);

  function InjectedAdView() {
    (0, _classCallCheck3.default)(this, InjectedAdView);
    return (0, _possibleConstructorReturn3.default)(this, (InjectedAdView.__proto__ || (0, _getPrototypeOf2.default)(InjectedAdView)).apply(this, arguments));
  }

  (0, _createClass3.default)(InjectedAdView, [{
    key: 'view',
    value: function view(ctrl) {
      return [(0, _mithril2.default)('h5.' + _adsConfig.CLASS_NAMES.BLOCK + '__title', (0, _i18nProvider.t)('post_page.ad')), (0, _get3.default)(InjectedAdView.prototype.__proto__ || (0, _getPrototypeOf2.default)(InjectedAdView.prototype), 'view', this).call(this, ctrl)];
    }
  }]);
  return InjectedAdView;
}(_RegularAdView3.default);

exports.default = InjectedAdView;

/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(22);

var _keys2 = _interopRequireDefault(_keys);

var _stringify = __webpack_require__(126);

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(71);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _slicedToArray2 = __webpack_require__(39);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _BaseVm2 = __webpack_require__(63);

var _BaseVm3 = _interopRequireDefault(_BaseVm2);

var _dom = __webpack_require__(13);

var _window2 = __webpack_require__(8);

var _GoogleTagService = __webpack_require__(213);

var _GoogleTagService2 = _interopRequireDefault(_GoogleTagService);

var _adsConfig = __webpack_require__(27);

var _preRenderedSelectorsConfig = __webpack_require__(17);

var _ua = __webpack_require__(10);

var _adStore = __webpack_require__(69);

var _adActions = __webpack_require__(50);

var _analyticsActions = __webpack_require__(31);

var _appStore = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var debugAdSizes = _window2.queryString.debugAdSizes,
    debugAdEvents = _window2.queryString.debugAdEvents;
var EMPTY_AD = _adsConfig.CLASS_NAMES.EMPTY;


function isDfpEventSize1x1(dfpEvent) {
  return dfpEvent.size && dfpEvent.size.length > 1 && dfpEvent.size[0] === 1 && dfpEvent.size[1] === 1;
}

function isEmptyAd(dfpEvent) {
  return dfpEvent.isEmpty || isDfpEventSize1x1(dfpEvent);
}

function getAdSlotSizeFromDfpEvent(dfpEvent) {
  var _dfpEvent$size = (0, _slicedToArray3.default)(dfpEvent.size, 2),
      _dfpEvent$size$ = _dfpEvent$size[0],
      width = _dfpEvent$size$ === undefined ? 0 : _dfpEvent$size$,
      _dfpEvent$size$2 = _dfpEvent$size[1],
      height = _dfpEvent$size$2 === undefined ? 0 : _dfpEvent$size$2;

  return { width: width, height: height };
}

function setSizeToZeroIfEmpty(dfpEvent) {
  dfpEvent.size = isEmptyAd(dfpEvent) ? _adStore.EMPTY_SLOT_DIMENSIONS : dfpEvent.size;
}

var AdVm = function (_BaseVm) {
  (0, _inherits3.default)(AdVm, _BaseVm);

  function AdVm() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck3.default)(this, AdVm);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AdVm.__proto__ || (0, _getPrototypeOf2.default)(AdVm)).call(this, options));

    var _window = window,
        gTag = _window.googletag;
    var actions = options.actions,
        adId = options.adId,
        adData = options.adConfig,
        type = options.type;

    _this.merge({
      actions: actions,
      adData: adData,
      adId: adId,
      gTag: gTag,
      type: type,
      slotRenderEndedEvents: {}
    });
    _this.gTagService = _GoogleTagService2.default.create();
    return _this;
  }

  (0, _createClass3.default)(AdVm, [{
    key: 'onChange',
    value: function onChange() {
      var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        event: { isEmpty: null, slideshowRefreshAction: false, resetPageTargetingLimit: false }
      };
      var adId = payload.adId,
          _payload$event = payload.event,
          isEmpty = _payload$event.isEmpty,
          slideshowRefreshAction = _payload$event.slideshowRefreshAction,
          resetPageTargetingLimit = _payload$event.resetPageTargetingLimit;

      if (isEmpty !== null && adId === this.adId) {
        this.emptySlot = {
          isEmpty: isEmpty,
          adId: adId
        };
      }
      if (slideshowRefreshAction && _adStore.adStore.shouldRefreshSlot) {
        _adStore.adStore.state.topSlotHeight = false;
        this.gTagService.refreshSlot(this.gTagService.slots[this.adId]);
      }
      if (resetPageTargetingLimit) {
        this.gTagService.resetPageTargetingLimit();
      }
      return (0, _get3.default)(AdVm.prototype.__proto__ || (0, _getPrototypeOf2.default)(AdVm.prototype), 'onChange', this).call(this);
    }
  }, {
    key: 'initSlot',
    value: function initSlot() {
      var adId = this.adId,
          type = this.type,
          adData = this.adData;

      this.gTagService.initSlot(adData, type, adId);
      return this;
    }
  }, {
    key: 'display',
    value: function display() {
      this.initTargeting();
      return this;
    }
  }, {
    key: 'initAndDisplay',
    value: function initAndDisplay() {
      var headerAd = (0, _dom.node)(_preRenderedSelectorsConfig.SELECTORS.HEADER_AD_UNIT);
      this.initSlot().display();
      if (!headerAd) {
        return this;
      }
      if (_adStore.adStore.isAdblockPresent) {
        headerAd.classList.add(EMPTY_AD);
      }

      return this;
    }
  }, {
    key: 'initDisplayAndHideOnTimeOut',
    value: function initDisplayAndHideOnTimeOut(timeout) {
      this.initAndDisplay();
      setTimeout(function hideAdOnTimeout() {
        this.hide();
      }.bind(this), timeout);
      return this;
    }
  }, {
    key: 'hide',
    value: function hide() {
      this.actions.slotHide(this.adId);
      return this;
    }
  }, {
    key: 'normalizeDfpData',
    value: function normalizeDfpData(data) {
      return data !== null ? data : 'none';
    }
  }, {
    key: 'getCustomDimensions',
    value: function getCustomDimensions(dfpEvent) {
      return {
        advertiserId: this.normalizeDfpData(dfpEvent.advertiserId),
        creativeId: this.normalizeDfpData(dfpEvent.creativeId),
        lineItemId: this.normalizeDfpData(dfpEvent.lineItemId),
        sourceAgnosticCreativeId: this.normalizeDfpData(dfpEvent.sourceAgnosticCreativeId),
        sourceAgnosticLineItemId: this.normalizeDfpData(dfpEvent.sourceAgnosticLineItemId),
        yieldGroupIds: this.normalizeDfpData(dfpEvent.yieldGroupIds),
        isBackfill: this.normalizeDfpData(dfpEvent.isBackfill),
        size: this.normalizeDfpData(dfpEvent.size),
        adUnitPath: this.normalizeDfpData(dfpEvent.slot.getAdUnitPath())
      };
    }
  }, {
    key: 'getAdId',
    value: function getAdId(dfpEvent) {
      var slotElementId = dfpEvent.slot.getAdUnitPath();
      var slotElementIdParts = slotElementId.split('/');

      return slotElementIdParts[slotElementIdParts.length - 1];
    }
  }, {
    key: 'shouldReportSlotData',
    value: function shouldReportSlotData(dfpEvent) {
      if ((0, _stringify2.default)(dfpEvent.size) === (0, _stringify2.default)([0, 0])) {
        return true;
      }

      var slotElementId = dfpEvent.slot.getSlotElementId();
      var element = document.getElementById(slotElementId);
      var elementParentHasAdEmptyClass = element.parentElement.classList.contains('ad--empty');
      var elementHasDisplayNoneStyle = element.getAttribute('style').includes('display: none;');

      return !elementParentHasAdEmptyClass && !elementHasDisplayNoneStyle;
    }
  }, {
    key: 'reportSlotDataToGA',
    value: function reportSlotDataToGA(dfpEvent) {
      if (this.shouldReportSlotData(dfpEvent)) {
        var payload = this.getCustomDimensions(dfpEvent);
        var adId = this.getAdId(dfpEvent);
        debugAdEvents && this.info(adId, 'reportSlotDataToGA', payload);
        (0, _appStore.dispatch)((0, _analyticsActions.dfpSlotOnloadEvent)(payload));
      }
    }
  }, {
    key: 'onSlotOnload',
    value: function onSlotOnload(dfpEvent) {
      var adId = this.getAdId(dfpEvent);
      debugAdEvents && this.info(adId, 'onSlotOnload', dfpEvent);
      var slotRenderEndedEvent = this.slotRenderEndedEvents[adId];
      this.reportSlotDataToGA(slotRenderEndedEvent);
    }
  }, {
    key: 'onSlotRenderEnded',
    value: function onSlotRenderEnded(dfpEvent) {
      this.adId = this.getAdId(dfpEvent);
      var adId = this.adId;

      debugAdEvents && this.info(adId, 'onSlotRenderEnded', dfpEvent);
      this.slotRenderEndedEvents[adId] = dfpEvent;

      if (dfpEvent.slot !== this.gTagService.slots[adId]) {
        return this;
      }

      debugAdSizes && this.warn('onSlotRenderEnded:', adId, dfpEvent);

      var isAdEmpty = dfpEvent.isEmpty;

      setSizeToZeroIfEmpty(dfpEvent);
      (0, _adActions.slotRendered)({
        adId: adId,
        isAdEmpty: isAdEmpty,
        size: getAdSlotSizeFromDfpEvent(dfpEvent),
        adRenderedEvent: dfpEvent
      });
      this.gTagService.renderedAdsEvents[adId] = dfpEvent;

      var isAllSlotsRendered = (0, _keys2.default)(this.gTagService.slots).length === (0, _keys2.default)(this.gTagService.renderedAdsEvents).length;

      if (isAllSlotsRendered) {
        // TODO: Remove this bad interstitial hack once the interstitial rendering code is moved from the SLIM to the client JS code
        if (window.__NMinterstitialEventHack) {
          this.gTagService.renderedAdsEvents.Interstitial = window.__NMinterstitialEventHack;
        }
        (0, _adActions.allSlotsRendered)(this.gTagService.renderedAdsEvents);
      }

      return this;
    }
  }, {
    key: 'initTargeting',
    value: function initTargeting() {
      var adId = this.adId,
          adData = this.adData,
          type = this.type;

      this.gTagService.initTargeting(adData, adId, this.onSlotRenderEnded.bind(this), this.onSlotOnload.bind(this), type);
      return this;
    }
  }, {
    key: 'emptySlot',
    get: function get() {
      return (_adStore.adStore.state[this.adId] || {}).emptySlot || false;
    },
    set: function set(emptySlot) {
      _adStore.adStore.state[this.adId] = _adStore.adStore.state[this.adId] || {};
      _adStore.adStore.state[this.adId].emptySlot = emptySlot;
    }
  }, {
    key: 'topHeight',
    get: function get() {
      return _adStore.adStore.state.topSlotHeight;
    }
  }, {
    key: 'adSize',
    get: function get() {
      return (_adStore.adStore.state[this.adId] || {}).adSize || _adStore.EMPTY_SLOT_SIZES_OBJECT;
    }
  }, {
    key: 'stickyConf',
    get: function get() {
      var isStickyOnPlatformMap = this.adData.isSticky || {};
      if (!(0, _keys2.default)(isStickyOnPlatformMap).length) {
        return false;
      }
      var stickyPlatform = void 0;
      if ((0, _ua.getIsTabletInPortrait)()) {
        stickyPlatform = 'portraitTablet';
      } else if ((0, _ua.getIsMobile)()) {
        stickyPlatform = 'mobile';
      } else {
        stickyPlatform = 'desktop';
      }
      return isStickyOnPlatformMap[stickyPlatform];
    }
  }]);
  return AdVm;
}(_BaseVm3.default);

exports.default = AdVm;

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getVideoAdsTag = getVideoAdsTag;

var _adTargeting = __webpack_require__(85);

function getVideoAdsTag() {
  window.getVideoTag = _adTargeting.getVideoTag;
}

/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DoubleClickProvider = undefined;

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _promise = __webpack_require__(64);

var _promise2 = _interopRequireDefault(_promise);

var _console = __webpack_require__(11);

var _window = __webpack_require__(8);

var _ua = __webpack_require__(10);

var _BaseClass2 = __webpack_require__(43);

var _BaseClass3 = _interopRequireDefault(_BaseClass2);

var _externalScripts = __webpack_require__(52);

var _script = __webpack_require__(19);

var _headerBidderScriptConfig = __webpack_require__(247);

var _geolocationProvider = __webpack_require__(44);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var debugAds = _window.queryString.debugAds;


function conditionallyAddHeaderBidderScript(countryCode) {
  var shouldLoadHeaderBidderScript = _externalScripts.externalScriptsConfig.headerBidder.shouldLoad(countryCode);
  (0, _headerBidderScriptConfig.debug)('shouldLoadHeaderBidderScript', shouldLoadHeaderBidderScript);
  return shouldLoadHeaderBidderScript ? new _promise2.default(function headerBidderIsLoadedPromiseResolver(resolve, reject) {
    window[_headerBidderScriptConfig.HB_NAMESAPCE] = {
      jsLoaded: _externalScripts.externalScriptsConfig.headerBidder.afterLoad(resolve, countryCode, _headerBidderScriptConfig.HB_MS_TIMEOUT)
    };
    window[_headerBidderScriptConfig.HB_NAMESAPCE].pagetype = (0, _ua.getIsMobile)() ? 'mobile' : 'desktop';
    (0, _headerBidderScriptConfig.debug)('window.' + _headerBidderScriptConfig.HB_NAMESAPCE + '.pagetype is set to:', window[_headerBidderScriptConfig.HB_NAMESAPCE].pagetype);
    _script.external.load((0, _extends3.default)({}, _externalScripts.externalScriptsConfig.headerBidder, {
      loadNow: true
    }));
  }) : countryCode;
}

function loadDfpScript(callback) {
  return _script.external.load({
    name: _externalScripts.externalScriptsConfig.dfp.name,
    loadNow: true
  })(callback);
}

// Disabled because _base.html.slim has the script already.
function conditionallyAddDfpScript(countryCode, callback) {
  var shouldLoadDfpScript = _externalScripts.externalScriptsConfig.dfp.beforeLoad();
  var callbackWithCountryCode = callback.bind(0, countryCode);
  return shouldLoadDfpScript ? loadDfpScript(callbackWithCountryCode) : callbackWithCountryCode();
}

var DoubleClickProvider = exports.DoubleClickProvider = function (_BaseClass) {
  (0, _inherits3.default)(DoubleClickProvider, _BaseClass);

  function DoubleClickProvider(initAds) {
    (0, _classCallCheck3.default)(this, DoubleClickProvider);

    var _this = (0, _possibleConstructorReturn3.default)(this, (DoubleClickProvider.__proto__ || (0, _getPrototypeOf2.default)(DoubleClickProvider)).call(this));

    (0, _geolocationProvider.getCountryCode)().then(conditionallyAddHeaderBidderScript).then(function (countryCode) {
      return conditionallyAddDfpScript(countryCode, initAds);
    }).catch(conditionallyAddDfpScript.bind(0, _geolocationProvider.NO_LOCATION, initAds));
    debugAds && (0, _console.info)('Initializing DoubleClickProvider with callback', initAds);
    return _this;
  }

  return DoubleClickProvider;
}(_BaseClass3.default);

/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  getProvider: function getProvider() {
    return __webpack_require__(219).DoubleClickProvider;
  }
};

/***/ }),

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(16);

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _getOwnPropertyNames = __webpack_require__(824);

var _getOwnPropertyNames2 = _interopRequireDefault(_getOwnPropertyNames);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _verge = __webpack_require__(1343);

var _console = __webpack_require__(11);

var _fn = __webpack_require__(15);

var _BaseClass2 = __webpack_require__(43);

var _BaseClass3 = _interopRequireDefault(_BaseClass2);

var _dom = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SCROLLING_CONSTS = {
  top: 'top',
  bottom: 'bottom'
}; /**
    * Allows attaching events to elelments, when they enter or leave viewport.
    * LEGACY: SHOULD BE REWRITTEN FOR A BETTER API AND USE intersectionObserver.
    */

var ScrollingEventsProvider = function (_BaseClass) {
  (0, _inherits3.default)(ScrollingEventsProvider, _BaseClass);

  function ScrollingEventsProvider() {
    (0, _classCallCheck3.default)(this, ScrollingEventsProvider);
    return (0, _possibleConstructorReturn3.default)(this, (ScrollingEventsProvider.__proto__ || (0, _getPrototypeOf2.default)(ScrollingEventsProvider)).apply(this, arguments));
  }

  (0, _createClass3.default)(ScrollingEventsProvider, [{
    key: 'register',
    value: function register(eventDefinitionObject) {
      if (eventDefinitionObject.element) {
        var scrollingEventConf = this.calculateEventVariables(eventDefinitionObject);
        this.addScrollingEvent(scrollingEventConf.handler);
        return scrollingEventConf.handler;
      }
      return _fn.noop;
    }
  }, {
    key: 'addScrollingEvent',
    value: function addScrollingEvent(scrollingEventConf, useCapture) {
      (0, _dom.addDocumentEvent)('scroll', scrollingEventConf, useCapture || false);
    }
  }, {
    key: 'removeScrollingEvent',
    value: function removeScrollingEvent(scrollingEventConf, useCapture) {
      (0, _dom.removeDocumentEvent)('scroll', scrollingEventConf, useCapture || false);
    }
  }, {
    key: 'triggerEventOnce',
    value: function triggerEventOnce(eventConfig) {
      var isInViewport = eventConfig.isInViewport,
          triggerFlag = eventConfig.triggerFlag,
          triggerEvent = eventConfig.triggerEvent,
          customCondition = eventConfig.customCondition,
          store = eventConfig.store;

      var activeFlag = void 0;
      if (!store[triggerFlag] && !isInViewport && customCondition) {
        activeFlag = true;
      } else if (store[triggerFlag] && isInViewport) {
        activeFlag = false;
      }
      this.emitEvent({ triggerFlag: triggerFlag, triggerEvent: triggerEvent, store: store, activeFlag: activeFlag });
    }
  }, {
    key: 'emitEvent',
    value: function emitEvent(_ref) {
      var triggerFlag = _ref.triggerFlag,
          triggerEvent = _ref.triggerEvent,
          store = _ref.store,
          activeFlag = _ref.activeFlag;

      store[triggerFlag] = activeFlag;
      store[triggerEvent]();
      return this;
    }
  }, {
    key: 'getCalculatedHeightBreakpoint',
    value: function getCalculatedHeightBreakpoint(eventConfig) {
      var element = eventConfig.element,
          triggerPosition = eventConfig.triggerPosition,
          relativeTopElement = eventConfig.relativeTopElement;

      var safeGetComputedHeight = (0, _fn.makeSafeFn)(function getElComputedHeight(el) {
        return parseFloat(getComputedStyle(el).height);
      });
      var doElementsExist = Boolean(element && relativeTopElement);
      if (!doElementsExist) {
        (0, _console.warn)('scrollingEventsProvider eventConfig is misconfigured: at least one element is missing!', { eventConfig: eventConfig, doElementsExist: doElementsExist });
      }
      var height = doElementsExist ? safeGetComputedHeight(element) || 0 : 0;
      var relativeTopElementHeight = doElementsExist ? safeGetComputedHeight(relativeTopElement) || 0 : 0;
      var heightPercentage = void 0;
      var deltaHeight = void 0;
      switch ((0, _getOwnPropertyNames2.default)(triggerPosition)[0]) {
        case SCROLLING_CONSTS.top:
          heightPercentage = triggerPosition.top;
          deltaHeight = height - height * (heightPercentage / 100);
          break;
        case SCROLLING_CONSTS.bottom:
          heightPercentage = triggerPosition.bottom;
          deltaHeight = height - height * ((100 - heightPercentage) / 100);
          break;
        default:
          deltaHeight = 0;
      }
      return { deltaHeight: deltaHeight, relativeTopElementHeight: relativeTopElementHeight };
    }
  }, {
    key: 'checkIfElementInViewport',
    value: function checkIfElementInViewport(eventConfig) {
      var heightBreakpoint = this.getCalculatedHeightBreakpoint(eventConfig);

      return (0, _verge.inViewport)(eventConfig.element, -heightBreakpoint.relativeTopElementHeight - heightBreakpoint.deltaHeight);
    }
  }, {
    key: 'parseEventConfig',
    value: function parseEventConfig(eConfig, objectWithHandler) {
      var vm = eConfig.vm,
          actionCallerFn = eConfig.event,
          payload = eConfig.payload,
          fireOnlyOnce = eConfig.fireOnlyOnce;

      var isInViewport = this.checkIfElementInViewport(eConfig);
      eConfig.previousInViewportFlag = eConfig.previousInViewportFlag === undefined ? isInViewport : eConfig.previousInViewportFlag;
      if (eConfig.previousInViewportFlag !== isInViewport) {
        vm[actionCallerFn]((0, _extends3.default)({}, payload, { sub_label: (0, _verge.scrollY)() }) || isInViewport);

        if (fireOnlyOnce) {
          this.removeScrollingEvent(objectWithHandler.handler);
        }
        eConfig.previousInViewportFlag = isInViewport;
      }
      return this;
    }
  }, {
    key: 'calculateEventVariables',
    value: function calculateEventVariables(eventConfig) {
      var obj = {};
      var handler = this.parseEventConfig.bind(this, eventConfig, obj);
      return (0, _assign2.default)(obj, { handler: handler });
    }
  }]);
  return ScrollingEventsProvider;
}(_BaseClass3.default);

var scrollingEventsProvider = ScrollingEventsProvider.create();

exports.default = scrollingEventsProvider;

/***/ }),

/***/ 223:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SET_PLAYLIST = exports.RECEIVED_RECOMMENDATIONS_DATA_ERROR = exports.RECEIVED_RECOMMENDATIONS_DATA = undefined;

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

exports.receivedRecommedationsAction = receivedRecommedationsAction;
exports.receivedErrorAction = receivedErrorAction;
exports.setPlaylistId = setPlaylistId;
exports.newVideoLoaded = newVideoLoaded;

var _recommendedVideos = __webpack_require__(321);

var _appStore = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RECEIVED_RECOMMENDATIONS_DATA = exports.RECEIVED_RECOMMENDATIONS_DATA = 'RECEIVED_RECOMMENDATIONS_DATA';
var RECEIVED_RECOMMENDATIONS_DATA_ERROR = exports.RECEIVED_RECOMMENDATIONS_DATA_ERROR = 'RECEIVED_RECOMMENDATIONS_DATA_ERROR';
var SET_PLAYLIST = exports.SET_PLAYLIST = 'SET_PLAYLIST';

function receivedRecommedationsAction(payload) {
  return {
    type: RECEIVED_RECOMMENDATIONS_DATA,
    payload: (0, _extends3.default)({}, payload, {
      isInitialized: true,
      recievedError: false
    })
  };
}

function receivedErrorAction(payload) {
  return {
    type: RECEIVED_RECOMMENDATIONS_DATA_ERROR,
    payload: {
      isInitialized: false,
      recievedError: true
    }
  };
}

function setPlaylistId(playlist) {
  return {
    type: SET_PLAYLIST,
    payload: playlist
  };
}

function payloadMapper(playerId, item) {
  item.hlink = '/videos/' + playerId + '/' + item.mediaId;
  return item;
}

function normalizePayload(playerId, payload) {
  var recommendedItemsMapper = payloadMapper.bind(null, playerId);
  return {
    recommendedItems: payload.map(recommendedItemsMapper)
  };
}

function dispatchNormalizedVideoPaylaod(payload) {
  return (0, _appStore.dispatch)(receivedRecommedationsAction(payload));
}

function dispatchReceivedError(payload) {
  return (0, _appStore.dispatch)(receivedErrorAction(payload));
}

function newVideoLoaded(providerName, playerId, videoId) {
  var normalizeVideoPayload = normalizePayload.bind(null, playerId);
  (0, _recommendedVideos.getDataByProvider)({ providerName: providerName, playlistId: (0, _appStore.getState)().recommendedVideos.playlistId, videoId: videoId }).then(normalizeVideoPayload).then(dispatchNormalizedVideoPaylaod).catch(dispatchReceivedError);
}

/***/ }),

/***/ 251:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(22);

var _keys2 = _interopRequireDefault(_keys);

var _assign = __webpack_require__(16);

var _assign2 = _interopRequireDefault(_assign);

exports.getAnalyticsPageType = getAnalyticsPageType;
exports.getVideoPostWrapperName = getVideoPostWrapperName;
exports.calculateVideoTimePercent = calculateVideoTimePercent;

var _dom = __webpack_require__(13);

var _pageDataObject = __webpack_require__(5);

var _pageDataObject2 = _interopRequireDefault(_pageDataObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getAnalyticsPageType() {
  var optionalPageTypes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var analyticsPageType = (0, _assign2.default)({
    homepage: 'Home page',
    post: 'Article page',
    video_page: 'Video page', // eslint-disable-line camelcase
    hubs: 'Partner page'
  }, optionalPageTypes);

  return analyticsPageType[_pageDataObject2.default.getPageType()] || 'cant get pagetype from pdo';
}

function getVideoPostWrapperName(playerRef) {
  var analyticsWrappersDescription = {
    'post-cover': 'cover',
    'post-body-wrap': 'body'
  };

  var articleSectionVideoWrapper = (0, _dom.parentElementUntil)(function (ancestorWrapper) {
    return ancestorWrapper.classList.contains('post-cover') || ancestorWrapper.classList.contains('post-body-wrap');
  });

  var postAncestorNode = articleSectionVideoWrapper(playerRef);
  var wrapperName = 'no wrapper';

  return postAncestorNode ? (0, _keys2.default)(analyticsWrappersDescription).reduce(function (acc, currentValue) {
    return postAncestorNode.classList.contains(currentValue) ? analyticsWrappersDescription[currentValue] : acc;
  }, wrapperName) : wrapperName;
}

function calculateVideoTimePercent(duration, currentTime) {
  var videoPercentageStops = [5, 25, 50, 75, 90];
  var computedVideoStepPercentage = Math.round(currentTime / (duration / 100));

  return videoPercentageStops.indexOf(computedVideoStepPercentage) !== -1 ? computedVideoStepPercentage : false;
}

/***/ }),

/***/ 28:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(126);

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _BaseVm2 = __webpack_require__(63);

var _BaseVm3 = _interopRequireDefault(_BaseVm2);

var _string = __webpack_require__(47);

var _window = __webpack_require__(8);

var _analyticsStore = __webpack_require__(51);

var _analyticsStore2 = _interopRequireDefault(_analyticsStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint semi:0 */
var AnalyticsBaseService = function (_BaseVm) {
  (0, _inherits3.default)(AnalyticsBaseService, _BaseVm);

  function AnalyticsBaseService() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck3.default)(this, AnalyticsBaseService);

    options.store = options.store || _analyticsStore2.default.create();

    var _this = (0, _possibleConstructorReturn3.default)(this, (AnalyticsBaseService.__proto__ || (0, _getPrototypeOf2.default)(AnalyticsBaseService)).call(this, options));

    _this.state.reportOnce = {};
    _this.facebookShare = _this.twitterShare = _this.whatsappShare = _this.socialShare;
    return _this;
  }

  (0, _createClass3.default)(AnalyticsBaseService, [{
    key: 'onChange',
    value: function onChange(action) {
      var legacyActionHandlerName = (0, _string.toCamelCase)(action.type.split(':').pop());
      var actionHandlerName = action.analyticsActionName;
      var actionHandler = this[legacyActionHandlerName] || this[actionHandlerName];
      if (actionHandler instanceof Function) {
        actionHandler.bind(this)(action);
      }
    }
  }, {
    key: 'logAnalytics',
    value: function logAnalytics() {
      if (_window.queryString.showAnalytics) {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        this.info('tracking ' + this.className + ': ', args);
      }
    }
  }, {
    key: 'routeChanged',
    value: function routeChanged(action) {
      this.pageViewed();
    }

    // NOTICE - to identify an action and determine if it was already reported,
    // it does JSON.stringify(action) and uses that as key
    // if an action has properties that contain objects (and not just primitive values)
    // this may not work properly!

  }, {
    key: 'reportOnce',
    value: function reportOnce(action, reportMethod) {
      var reporter = this.className;
      this.state.reportOnce[reporter] = this.state.reportOnce[reporter] || {};
      var actionId = (0, _stringify2.default)(action);
      var wasReported = this.state.reportOnce[reporter][actionId];
      if (!wasReported) {
        reportMethod();
        this.state.reportOnce[reporter][actionId] = true;
      }
    }
  }, {
    key: 'pageViewed',
    value: function pageViewed() {}
  }, {
    key: 'socialShare',
    value: function socialShare() {}
  }, {
    key: 'className',
    get: function get() {
      return 'AnalyticsBaseService';
    }
  }]);
  return AnalyticsBaseService;
}(_BaseVm3.default);

exports.default = AnalyticsBaseService;

/***/ }),

/***/ 280:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// UMD: https://github.com/umdjs/umd/blob/master/returnExports.js
(function (root, factory) {
	if (true) {
		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof exports === 'object') {
		// Node. Does not work with strict CommonJS, but
		// only CommonJS-like environments that support module.exports,
		// like Node.
		module.exports = factory();
	} else {
		// Browser globals (root is window)
		root.humanFormat = factory();
	}
}(this, function () {
	'use strict';

	//==================================================================

	function assignBase(dst, src) {
		var prop;
		for (prop in src) {
			if (has(src, prop)) {
				dst[prop] = src[prop];
			}
		}
	}
	function assign(dst, src) {
		var i, n;
		for (i = 0, n = arguments.length; i < n; ++i) {
			src = arguments[i];
			if (src) {
				assignBase(dst, src);
			}
		}
		return dst;
	}

	function compareLongestFirst(a, b) {
		return b.length - a.length;
	}

	function compareSmallestFactorFirst(a, b) {
		return a.factor - b.factor;
	}

	// https://www.npmjs.org/package/escape-regexp
	function escapeRegexp(str) {
		return str.replace(/([.*+?=^!:${}()|[\]\/\\])/g, '\\$1');
	}

	function forEach(arr, iterator) {
		var i, n;
		for (i = 0, n = arr.length; i < n; ++i) {
			iterator(arr[i], i);
		}
	}

	function forOwn(obj, iterator) {
		var prop;
		for (prop in obj) {
			if (has(obj, prop)) {
				iterator(obj[prop], prop);
			}
		}
	}

	var has = (function (hasOwnProperty) {
		return function has(obj, prop) {
			return obj && hasOwnProperty.call(obj, prop);
		};
	})(Object.prototype.hasOwnProperty);

	var toString = (function (toString_) {
		return function toString(val) {
			return toString_.call(val);
		};
	})(Object.prototype.toString);

	function isDefined(val) {
		/* jshint eqnull:true */
		return val != null;
	}

	var isNumber = (function (tag) {
		return function isNumber(value) {
			return (value === value) && (toString(value) === tag);
		};
	})(toString(0));

	var isString = (function (tag) {
		return function isString(value) {
			return (toString(value) === tag);
		};
	})(toString(''));

	function resolve(container, entry) {
		while (isString(entry)) {
			entry = container[entry];
		}
		return entry;
	}

	function round(f, n) {
		if (!n) {
			return Math.round(f);
		}

		var p = Math.pow(10, n);
		return Math.round(f * p) / p;
	}

	//==================================================================

	function Scale(prefixes) {
		this._prefixes = prefixes;

		var escapedPrefixes = [];
		var list = [];
		forOwn(prefixes, function (factor, prefix) {
			escapedPrefixes.push(escapeRegexp(prefix));

			list.push({
				factor: factor,
				prefix: prefix
			});
		});

		list.sort(compareSmallestFactorFirst);
		this._list = list;

		escapedPrefixes.sort(compareLongestFirst);
		this._regexp = new RegExp(
			'^\\s*(\\d+(?:\\.\\d+)?)\\s*(' +
				escapedPrefixes.join('|') +
				')\\s*(.*)\\s*?$',
			'i'
		);
	}

	Scale.create = function Scale$create(prefixesList, base, initExp) {
		var prefixes = {};
		var factor = initExp ? Math.pow(base, initExp) : 1;
		forEach(prefixesList, function (prefix, i) {
			prefixes[prefix] = Math.pow(base, i + (initExp || 0));
			factor *= base;
		});

		return new Scale(prefixes);
	};

	// Binary search to find the greatest index which has a value <=.
	Scale.prototype.findPrefix = function Scale$findPrefix(value) {
		/* jshint bitwise: false */

		var list = this._list;
		var low = 0;
		var high = list.length - 1;

		var mid, current;
		while (low !== high) {
			mid = (low + high + 1) >> 1;
			current = list[mid].factor;

			if (current > value) {
				high = mid - 1;
			} else {
				low = mid;
			}
		}

		return list[low];
	};

	Scale.prototype.parse = function Scale$parse(str, strict) {
		var matches = str.match(this._regexp);

		if (!matches) {
			return null;
		}

		var prefix = matches[2];

		if (!has(this._prefixes, prefix)) {
			if (strict) {
				return null;
			}

			// FIXME
			return null;
		}

		return {
			factor: this._prefixes[prefix],
			prefix: prefix,
			unit: matches[3],
			value: +matches[1]
		};
	};

	//==================================================================

	var scales = {
		// https://en.wikipedia.org/wiki/Binary_prefix
		binary: Scale.create(
			',ki,Mi,Gi,Ti,Pi,Ei,Zi,Yi'.split(','),
			1024
		),

		// https://en.wikipedia.org/wiki/Metric_prefix
		//
		// Not all prefixes are present, only those which are multiple of
		// 1000, because humans usually prefer to see close numbers using
		// the same unit to ease the comparison.
		SI: Scale.create(
			'y,z,a,f,p,n,µ,m,,k,M,G,T,P,E,Z,Y'.split(','),
			1000, -8
		)
	};

	var defaults = {
		scale: 'SI',

		// Strict mode prevents parsing of incorrectly cased prefixes.
		strict: false,

		// Unit to use for formatting.
		unit: '', 

		// Defauls decimals if not specified
		decimals: 2
	};

	function humanFormat(value, opts){
		opts = assign({}, defaults, opts);

		var info = humanFormat$raw(value, opts);
		var suffix = info.prefix + opts.unit;
		return round(info.value, opts.decimals) + (suffix ? ' ' + suffix : '');
	}

	function humanFormat$parse(str, opts) {
		var info = humanFormat$parse$raw(str, opts);

		return info.value * info.factor;
	}

	function humanFormat$parse$raw(str, opts) {
		if (!isString(str)) {
			throw new TypeError('str must be a string');
		}

		// Merge default options.
		opts = assign({}, defaults, opts);

		// Get current scale.
		var scale = resolve(scales, opts.scale);
		if (!scale) {
			throw new Error('missing scale');
		}

		// TODO: the unit should be checked: it might be absent but it
		// should not differ from the one expected.
		//
		// TODO: if multiple units are specified, at least must match and
		// the returned value should be: { value: <value>, unit: matchedUnit }

		var info = scale.parse(str, opts.strict);
		if (!info) {
			throw new Error('cannot parse str');
		}

		return info;
	}

	function humanFormat$raw(value, opts) {
		// Zero is a special case, it never has any prefix.
		if (value === 0) {
			return {
				value: 0,
				prefix: ''
			};
		}

		if (!isNumber(value)) {
			throw new TypeError('value must be a number');
		}

		// Merge default options.
		opts = assign({}, defaults, opts);

		// Get current scale.
		var scale = resolve(scales, opts.scale);
		if (!scale) {
			throw new Error('missing scale');
		}

		var prefix = opts.prefix;
		var factor;
		if (isDefined(prefix)) {
			if (!has(scale._prefixes, prefix)) {
				throw new Error('invalid prefix');
			}

			factor = scale._prefixes[prefix];
		} else {
			var _ref = scale.findPrefix(value);
			prefix = _ref.prefix;
			factor = _ref.factor;
		}

		// Rebase using current factor.
		value /= factor;

		return {
			prefix: prefix,
			value: value
		};
	}

	humanFormat.parse = humanFormat$parse;
	humanFormat$parse.raw = humanFormat$parse$raw;
	humanFormat.raw = humanFormat$raw;
	humanFormat.Scale = Scale;

	return humanFormat;
}));


/***/ }),

/***/ 291:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(14);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _assign = __webpack_require__(16);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

exports.default = initMontiPlayers;

var _dom = __webpack_require__(13);

var _reactRedux = __webpack_require__(37);

var _string = __webpack_require__(47);

var _reactDom = __webpack_require__(116);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _reduxMounter = __webpack_require__(45);

var _reduxMounter2 = _interopRequireDefault(_reduxMounter);

var _montiplayerActions = __webpack_require__(198);

var montiplayerActions = _interopRequireWildcard(_montiplayerActions);

var _reactUtils = __webpack_require__(86);

var _script = __webpack_require__(19);

var _preRenderedSelectorsConfig = __webpack_require__(17);

var _spinner = __webpack_require__(309);

var _externalScripts = __webpack_require__(52);

var _recommendedVideos = __webpack_require__(223);

var _video = __webpack_require__(251);

var _montiReducer = __webpack_require__(292);

var _pageDataObject = __webpack_require__(5);

var _pageDataObject2 = _interopRequireDefault(_pageDataObject);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint semi:0 */
function shouldSendMontiTagServerUrl() {
  return _pageDataObject2.default.ads.property !== 'EI';
}

var MontiPlayerContainerComponent = function (_Component) {
  (0, _inherits3.default)(MontiPlayerContainerComponent, _Component);

  function MontiPlayerContainerComponent(props) {
    (0, _classCallCheck3.default)(this, MontiPlayerContainerComponent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (MontiPlayerContainerComponent.__proto__ || (0, _getPrototypeOf2.default)(MontiPlayerContainerComponent)).call(this, props));

    (0, _assign2.default)(_this, {
      id: 'ID' + (0, _string.randId)(),
      initPlayer: _this.initPlayer.bind(_this)
    });
    return _this;
  }

  (0, _createClass3.default)(MontiPlayerContainerComponent, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          isInitialized = _props.isInitialized,
          sdkLoadingState = _props.sdkLoadingState,
          loadSdk = _props.loadSdk,
          sdkLoaded = _props.sdkLoaded,
          options = _props.options;

      this.dataset = options.dataset;
      if (!isInitialized && !sdkLoadingState) {
        loadSdk();
        var src = _pageDataObject2.default.getPostId() === 6346773 ? _externalScripts.externalScriptsConfig.montiSEOtest.src(this.dataset.player_id) : _externalScripts.externalScriptsConfig.monti.src(this.dataset.player_id);
        _script.external.load({
          config: {
            src: src,
            name: 'montiApiPlayer'
          }
        })(sdkLoaded);
      }
    }
  }, {
    key: 'initPlayer',
    value: function initPlayer(playerRef) {
      var _this2 = this;

      //media_id calculation with the if is a hack to support the VMS - this won't appear in the new site so once 90min makes the transition this code is dead
      var media_id = void 0;
      if (this.dataset.player_id.startsWith('01')) {
        media_id = this.dataset.player_id;
      } else {
        media_id = this.dataset.video_id;
      }
      var montiConfig = this.montiSetupBaseConfig(playerRef, media_id);
      this.setupMontiPlayer(montiConfig).then(function (player) {
        (0, _recommendedVideos.newVideoLoaded)('jw', _this2.dataset.player_id, media_id);
        _this2.onMontiSetup(player, media_id);
      }).catch(function () {
        return (0, _recommendedVideos.newVideoLoaded)('jw', _this2.dataset.player_id, media_id);
      });
    }
  }, {
    key: 'montiSetupBaseConfig',
    value: function montiSetupBaseConfig(playerRef, media_id) {
      var playerPos = (0, _reactDom.findDOMNode)(playerRef);
      playerPos.style.marginTop = '-16px'; // HACK: solve in MPlayer - shouldn't add margin
      return {
        config_name: 'Editor Embedded player in ' + _pageDataObject2.default.getSiteDomainWithTld(),
        uniq_key: 'mm-article-player',
        publisher_contribution: _pageDataObject2.default.getSiteDomainWithTld(),
        content_id: media_id,
        content_type: media_id.startsWith('01') ? 'specific' : 'curated',
        player_pos: playerPos,
        category_name: (0, _video.getAnalyticsPageType)(),
        monetization: {
          vpaid_mode: 'ENABLED',
          strategy: 'on_player_load',
          ad_type: 'auto_dynamic_tag',
          ad_request_timeout: '10000',
          ad_break_slots: {
            on: [0]
          }
        },
        brand_color: '#EEEEEE',
        playback_method: 'none',
        powered_by_strip: false
      };
    }
  }, {
    key: 'setupMontiPlayer',
    value: function setupMontiPlayer(montiConfig) {
      var monti = window.monti();
      if (shouldSendMontiTagServerUrl()) {
        return monti.initiate(montiConfig);
      }
      return monti.initiate((0, _extends3.default)({}, montiConfig, {
        monetization: {
          ad_type: 'jw_scheduler'
        }
      }));
    }
  }, {
    key: 'onMontiSetup',
    value: function onMontiSetup(player, media_id) {
      var _this3 = this;

      player.on('loadstart', function () {
        (0, _recommendedVideos.newVideoLoaded)('jw', _this3.dataset.player_id, player.getConfig().playlistItem.mediaid || media_id);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var isPlayerInitalized = this.props.isInitialized;
      return isPlayerInitalized ? _react2.default.createElement('div', { id: this.id, ref: this.initPlayer }) : _react2.default.createElement(_spinner.Spinner, { isInitialized: isPlayerInitalized, contrastModifier: this.dataset.contrast });
    }
  }]);
  return MontiPlayerContainerComponent;
}(_react.Component);

var COMPONENT_NAME = 'montiplayerContainer';

function mapStateToProps(state) {
  return {
    isInitialized: (0, _montiReducer.isInitializedSelector)(state),
    sdkLoadingState: (0, _montiReducer.sdkLoadingStateSelector)(state)
  };
}

var montiContainer = {
  name: COMPONENT_NAME,
  stateKey: _montiReducer.STATE_KEY,
  component: (0, _reactRedux.connect)(mapStateToProps, montiplayerActions)((0, _reactUtils.withParentAttributesAsProps)(MontiPlayerContainerComponent)),
  reducer: _montiReducer.montiReducer
};

function shouldMountMontiPlayer() {
  return (0, _dom.nodes)(_preRenderedSelectorsConfig.MOUNT_POINTS.MONTI_BODY).length !== 0;
}

function initMontiPlayers() {
  if (!shouldMountMontiPlayer()) {
    return false;
  }
  return (0, _reduxMounter2.default)((0, _defineProperty3.default)({}, _preRenderedSelectorsConfig.MOUNT_POINTS.MONTI_BODY, montiContainer));
}

/***/ }),

/***/ 292:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STATE_KEY = undefined;

var _defineProperty2 = __webpack_require__(14);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _handlers;

exports.isInitializedSelector = isInitializedSelector;
exports.sdkLoadingStateSelector = sdkLoadingStateSelector;
exports.montiReducer = montiReducer;

var _montiplayerActions = __webpack_require__(198);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var STATE_KEY = exports.STATE_KEY = 'montiplayer';

var INITIAL_STATE = {
  players: [],
  isInitialized: false,
  sdkLoading: false
};

function sdkLoaded(state) {
  return (0, _extends3.default)({}, state, { isInitialized: true });
}

function sdkStartLoading(state) {
  return (0, _extends3.default)({}, state, { sdkLoading: true });
}

var handlers = (_handlers = {}, (0, _defineProperty3.default)(_handlers, _montiplayerActions.MONTIPLAYER_ACTION_TYPES.SDK_LOADED, sdkLoaded), (0, _defineProperty3.default)(_handlers, _montiplayerActions.MONTIPLAYER_ACTION_TYPES.LOAD_SDK, sdkStartLoading), _handlers);

function isInitializedSelector(state) {
  return state[STATE_KEY].isInitialized;
}

function sdkLoadingStateSelector(state) {
  return state[STATE_KEY].sdkLoading;
}

function montiReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments[1];

  return handlers[action.type] && handlers[action.type](state, action.payload) || state;
}

/***/ }),

/***/ 293:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StatsItem = StatsItem;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function StatsItem(_ref) {
  var children = _ref.children,
      _ref$blockName = _ref.blockName,
      blockName = _ref$blockName === undefined ? 'stats' : _ref$blockName,
      modifier = _ref.modifier;

  var blockElement = blockName + '__item';
  var blockElementModifier = modifier ? blockElement + '--' + modifier : '';
  return _react2.default.createElement(
    'li',
    { className: blockElement + ' ' + blockElementModifier },
    children
  );
}

/***/ }),

/***/ 294:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(39);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = __webpack_require__(87);

var _entries2 = _interopRequireDefault(_entries);

exports.StatsWrapper = StatsWrapper;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _humanFormat = __webpack_require__(280);

var _humanFormat2 = _interopRequireDefault(_humanFormat);

var _StatsItem = __webpack_require__(293);

var _reactUtils = __webpack_require__(86);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var statsBemModifiers = {
  reads: 'view',
  shares: 'share'
};

function formatNumber(number, opts) {
  return (0, _humanFormat2.default)(Number(number), opts);
}

function statItemView(stat, modifier, key) {
  var statsItemProps = {
    key: key,
    modifier: modifier,
    children: formatNumber(stat, { decimals: 0 })
  };
  return _react2.default.createElement(_StatsItem.StatsItem, statsItemProps);
}

function getStats(stats, modifiers) {
  return (0, _entries2.default)(stats).map(function (_ref, index) {
    var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
        statName = _ref2[0],
        stat = _ref2[1];

    return statItemView(stat, modifiers[statName], index);
  });
}

function StatsWrapper(_ref3) {
  var children = _ref3.children;

  var blockName = 'stats';
  return _react2.default.createElement(
    'ul',
    { className: blockName },
    (0, _reactUtils.cloneChildrenWithProps)(getStats(children, statsBemModifiers), { blockName: blockName })
  );
}

/***/ }),

/***/ 295:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.postMetadataActions = undefined;

var _console = __webpack_require__(11);

var _actionCounterProviderActions = __webpack_require__(139);

var _currentPostActionCounterProvider = __webpack_require__(91);

var _actionCounterBaseProvider = __webpack_require__(153);

var DATA_RECEIVED = _actionCounterProviderActions.TYPES.DATA_RECEIVED;


function getPostData() {
  return function (dispatch, getState) {
    return (0, _currentPostActionCounterProvider.fetchPostMetadata)().then(function (state) {
      return dispatch({
        type: DATA_RECEIVED,
        state: state
      });
    }).catch(_console.warn);
  };
}

function getSpecificPostReadsData(postId) {
  return function (dispatch, getState) {
    return (0, _actionCounterBaseProvider.fetchCountersIndependent)('Post_' + postId).then(function (state) {
      state.postId = postId;
      return dispatch({
        type: DATA_RECEIVED,
        state: state
      });
    }).catch(_console.warn);
  };
}

var postMetadataActions = exports.postMetadataActions = {
  fetchData: getPostData,
  fetchSpecificData: getSpecificPostReadsData
};

/***/ }),

/***/ 296:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.postMetadataStatsContainer = undefined;

var _defineProperty2 = __webpack_require__(14);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

exports.default = initPostMetadataStats;

var _ua = __webpack_require__(10);

var _reactRedux = __webpack_require__(37);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(60);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reduxMounter = __webpack_require__(45);

var _reduxMounter2 = _interopRequireDefault(_reduxMounter);

var _window = __webpack_require__(8);

var _console = __webpack_require__(11);

var _StatsWrapper = __webpack_require__(294);

var _postMetadataReducer = __webpack_require__(297);

var _postMetadataActions = __webpack_require__(295);

var _preRenderedSelectorsConfig = __webpack_require__(17);

var _pageDataObject = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint semi:0 */
var POST_METADATA_STATS_FEATURE_ID = 'PostMetadataStats';
var COMPONENT_NAME = 'statsContainer';
var STATE_KEY = 'postMetadataStats';
var shouldDisplayPostStatsInEmbedLayout = _window.queryString.showReadsCounter,
    debugPostStats = _window.queryString.debugPostStats;
var isEmbedded = _ua.path.isEmbedded;


function fetchPostData(props) {
  var fetchData = props.fetchData,
      fetchSpecificData = props.fetchSpecificData;
  var postId = props.options.dataset.postId;

  if (postId) {
    fetchSpecificData(postId);
  } else {
    fetchData();
  }
}

var PostMetadataStats = function (_React$Component) {
  (0, _inherits3.default)(PostMetadataStats, _React$Component);

  function PostMetadataStats() {
    (0, _classCallCheck3.default)(this, PostMetadataStats);
    return (0, _possibleConstructorReturn3.default)(this, (PostMetadataStats.__proto__ || (0, _getPrototypeOf2.default)(PostMetadataStats)).apply(this, arguments));
  }

  (0, _createClass3.default)(PostMetadataStats, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var IS_OVERRIDE = this.props.IS_OVERRIDE;

      if (!IS_OVERRIDE) {
        fetchPostData(this.props);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var stats = this.props.stats;
      var postId = this.props.options.dataset.postId;

      var statsForComponent = postId ? (0, _extends3.default)({}, stats[postId]) : stats;
      if (debugPostStats) {
        (0, _console.info)('[QS] Rendering component with: ', stats);
      }
      return _react2.default.createElement(
        _StatsWrapper.StatsWrapper,
        null,
        statsForComponent
      );
    }
  }]);
  return PostMetadataStats;
}(_react2.default.Component);

function definePropTypes(component) {
  var bool = _propTypes2.default.bool,
      func = _propTypes2.default.func,
      object = _propTypes2.default.object;

  component.propTypes = {
    stats: object,
    IS_INITIALIZED: bool,
    IS_OVERRIDE: bool,
    mountAction: func
  };
  return component;
}

function mapStatsStateToProps(state) {
  var _state$STATE_KEY = state[STATE_KEY],
      stats = _state$STATE_KEY.stats,
      IS_OVERRIDE = _state$STATE_KEY.IS_OVERRIDE;

  return { stats: stats, IS_OVERRIDE: IS_OVERRIDE };
}

var postMetadataStatsContainer = exports.postMetadataStatsContainer = {
  name: COMPONENT_NAME,
  stateKey: STATE_KEY,
  component: (0, _reactRedux.connect)(mapStatsStateToProps, _postMetadataActions.postMetadataActions)(definePropTypes(PostMetadataStats)),
  reducer: _postMetadataReducer.postMetadataReducer
};

function shouldMountPostMetadataStats() {
  return (0, _pageDataObject.isSupportedForDomain)(POST_METADATA_STATS_FEATURE_ID) && !isEmbedded || shouldDisplayPostStatsInEmbedLayout;
}

function mountPostMetadataStats() {
  return (0, _reduxMounter2.default)((0, _defineProperty3.default)({}, _preRenderedSelectorsConfig.MOUNT_POINTS.POST_METADATA_STATS, postMetadataStatsContainer));
}

function initPostMetadataStats() {
  var shouldMountPostMetadata = shouldMountPostMetadataStats();
  if (shouldMountPostMetadata) {
    mountPostMetadataStats();
  }
  return shouldMountPostMetadata;
}

/***/ }),

/***/ 297:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(39);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _extends3 = __webpack_require__(9);

var _extends4 = _interopRequireDefault(_extends3);

var _defineProperty2 = __webpack_require__(14);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.postMetadataReducer = postMetadataReducer;

var _ua = __webpack_require__(10);

var _window = __webpack_require__(8);

var _console = __webpack_require__(11);

var _object = __webpack_require__(12);

var _actionCounterProviderActions = __webpack_require__(139);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var shouldDisplayPostStatsInEmbedLayout = _window.queryString.readsCounter; /* eslint semi:0 */

var DATA_RECEIVED = _actionCounterProviderActions.TYPES.DATA_RECEIVED,
    RECEIVED_ERROR = _actionCounterProviderActions.TYPES.RECEIVED_ERROR;

var STATS = ['reads', 'shares'];
var FILTER_STATS = ['reads'];

function toNumber(string) {
  return parseInt(string, 10);
}

function getQueryStringKey(key) {
  return toNumber(_window.queryString[key]);
}

function isOverride(queryStringStats) {
  return !STATS.some(function (statName) {
    return !(statName in queryStringStats);
  });
}

function mapAllKeysFromQuery(key) {
  return (0, _defineProperty3.default)({}, key, getQueryStringKey(key) || 0);
}

function mapExistingKeysFromQuery(key) {
  var queryStringKey = getQueryStringKey(key);
  return queryStringKey ? (0, _defineProperty3.default)({}, key, queryStringKey) : '';
}

function mapReduceArrayToObject(stats, fn) {
  return stats.map(fn).reduce(function (acc, statObj) {
    return (0, _extends4.default)({}, acc, statObj);
  }, {});
}

function getStatsFromDebugQuery(mapFn) {
  return mapReduceArrayToObject(STATS, mapFn);
}

function parseObjectValuesOrZero(parsedObject, _ref3) {
  var _ref4 = (0, _slicedToArray3.default)(_ref3, 2),
      key = _ref4[0],
      value = _ref4[1];

  return (0, _extends4.default)({}, parsedObject, (0, _defineProperty3.default)({}, key, toNumber(value) || 0));
}

function removeZeroValuesFromObject(zeroLessObject, _ref5) {
  var _ref6 = (0, _slicedToArray3.default)(_ref5, 2),
      key = _ref6[0],
      value = _ref6[1];

  var newKey = value > 0 ? (0, _defineProperty3.default)({}, key, value) : {};
  return (0, _extends4.default)({}, zeroLessObject, newKey);
}

function queryStatsReducer(filterStats, statsObject) {
  return filterStats.reduce(function (filteredStats, stat) {
    var isUnvalidStat = stat === undefined;
    var validStat = isUnvalidStat ? {} : (0, _defineProperty3.default)({}, stat, statsObject[stat]);
    return (0, _extends4.default)({}, filteredStats, validStat);
  }, {});
}

var parseObjectValues = _object.reduceObjectEntries.part(parseObjectValuesOrZero);
var removeZeroValuePropertiesFromObject = _object.reduceObjectEntries.part(removeZeroValuesFromObject);

function filterStatsByQueryStringOrAll(isStatsInQuery, filterStats) {
  return function (originalStats) {
    return isStatsInQuery ? parseObjectValues(queryStatsReducer(filterStats, originalStats)) : removeZeroValuePropertiesFromObject(parseObjectValues(originalStats));
  };
}

var getFilteredStats = filterStatsByQueryStringOrAll(shouldDisplayPostStatsInEmbedLayout, FILTER_STATS);

function setReceivedState(state, action) {
  var _action$state = action.state,
      reads = _action$state.reads,
      shares = _action$state.shares,
      postId = _action$state.postId;

  var statsCopy = (0, _extends4.default)({}, state.stats);
  if (postId) {
    statsCopy[postId] = (0, _extends4.default)({}, getFilteredStats({ reads: reads, shares: shares }), getStatsFromDebugQuery(mapExistingKeysFromQuery));
  } else {
    statsCopy = (0, _extends4.default)({}, getFilteredStats({ reads: reads, shares: shares }), getStatsFromDebugQuery(mapExistingKeysFromQuery));
  }
  return {
    stats: statsCopy
  };
}

function setState(state, newState) {
  return (0, _extends4.default)({}, state, newState);
}

function recievedData(state, action) {
  if (state.IS_DRAFT) {
    return setState(state, getStatsFromDebugQuery(mapAllKeysFromQuery));
  }
  if (!state.IS_OVERRIDE) {
    return setState(state, setReceivedState(state, action));
  }
  return state;
}

function recievedError(state, action) {
  var error = action.state.error;

  (0, _console.warn)('Error recieving data from external source, check with provier', { error: error, action: action });
  return setState(state, getStatsFromDebugQuery(mapAllKeysFromQuery));
}

var INITIAL_STATE = {
  stats: {},
  IS_OVERRIDE: isOverride(getStatsFromDebugQuery(mapExistingKeysFromQuery)),
  IS_DRAFT: _ua.path.isDraft
};

function postMetadataReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments[1];

  switch (action.type) {
    case DATA_RECEIVED:
      return recievedData(state, action);
    case RECEIVED_ERROR:
      return recievedError(state, action);
    default:
      return state;
  }
}

/***/ }),

/***/ 298:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(14);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = __webpack_require__(9);

var _extends4 = _interopRequireDefault(_extends3);

exports.cacheVote = cacheVote;
exports.getReactions = getReactions;
exports.getClientVotes = getClientVotes;
exports.setUserVote = setUserVote;

var _ua = __webpack_require__(10);

var _window = __webpack_require__(8);

var _socialButtonsConfig = __webpack_require__(248);

var _socialButtonsConfig2 = _interopRequireDefault(_socialButtonsConfig);

var _pageDataObject = __webpack_require__(5);

var _safeLocalStorageProvider = __webpack_require__(178);

var _safeLocalStorageProvider2 = _interopRequireDefault(_safeLocalStorageProvider);

var _socialBarDataMock = __webpack_require__(408);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint semi:0 */
var FEATURE_FLAGS = {
  reactionsMock: _window.queryString.reactionsMock,
  reactionsCampaignMock: _window.queryString.reactionsCampaignMock,
  votesMock: _window.queryString.votesMock,
  reactionsNoCachedVotes: _window.queryString.reactionsNoCachedVotes
};
var CLIENT_VOTES_KEY = 'CLIENT_VOTES_KEY';

function getVotesFromLocalStorage() {
  if (FEATURE_FLAGS.reactionsNoCachedVotes) {
    return {};
  }
  return _safeLocalStorageProvider2.default.get(CLIENT_VOTES_KEY, {});
}

function cacheVote(_ref) {
  var postId = _ref.postId,
      reactionId = _ref.reactionId;

  var curr = _safeLocalStorageProvider2.default.get(CLIENT_VOTES_KEY, {});
  curr[postId] = reactionId;
  _safeLocalStorageProvider2.default.set(CLIENT_VOTES_KEY, curr);
}

function getReactions() {
  if (FEATURE_FLAGS.reactionsMock) {
    return (0, _socialBarDataMock.getMockReactions)({ doesIncludeCampaign: FEATURE_FLAGS.reactionsCampaignMock });
  }
  return (0, _pageDataObject.getReactionsList)();
}

function getClientVotes() {
  if (FEATURE_FLAGS.votesMock) {
    return (0, _socialBarDataMock.getClientVotes)();
  }
  return getVotesFromLocalStorage();
}

function setUserVote(_ref2) {
  var postId = _ref2.postId,
      reactionId = _ref2.reactionId;

  var currVotesData = getVotesFromLocalStorage();
  var newVotesData = (0, _extends4.default)({}, currVotesData, (0, _defineProperty3.default)({}, postId, reactionId));
  _safeLocalStorageProvider2.default.set(CLIENT_VOTES_KEY, newVotesData);
}

/***/ }),

/***/ 309:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Spinner = Spinner;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initSpinner(contrastModifier) {
  return _react2.default.createElement('div', { className: contrastModifier ? 'spinner spinner--' + contrastModifier : 'spinner' });
}

function Spinner(_ref) {
  var isInitialized = _ref.isInitialized,
      contrastModifier = _ref.contrastModifier;

  return isInitialized ? _react2.default.createElement('noscript', null) : initSpinner(contrastModifier);
}

/***/ }),

/***/ 313:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TYPES = undefined;
exports.socialComponentScrollerReached = socialComponentScrollerReached;
exports.titleScrollerReached = titleScrollerReached;
exports.navbarMobileShare = navbarMobileShare;
exports.navbarMobileMessageShare = navbarMobileMessageShare;
exports.navbarMobileGooglePlusShare = navbarMobileGooglePlusShare;

var _object = __webpack_require__(12);

var _AppDispatcher = __webpack_require__(55);

/* eslint semi:0 */
var CLASS_CONSTATNTS = (0, _object.namespacedConsts)({
  NAVBAR: {
    ACTIONS: {
      REACHED_COVER_SOCIAL_COMPONENT: true,
      REACHED_POST_TITLE: true,
      NAVBAR_MOBILE_SHARE_ACTION: true
    }
  }
});

var TYPES = exports.TYPES = CLASS_CONSTATNTS.NAVBAR.ACTIONS;

function socialComponentScrollerReached(scrollingEventObject) {
  _AppDispatcher.appDispatcher.dispatchAction.view({
    type: TYPES.REACHED_COVER_SOCIAL_COMPONENT,
    payload: {
      scrollingEventObject: scrollingEventObject,
      isInViewport: scrollingEventObject
    },
    dispatchToRedux: true
  });
}

function titleScrollerReached(scrollingEventObject) {
  _AppDispatcher.appDispatcher.dispatchAction.view({
    type: TYPES.REACHED_POST_TITLE,
    payload: {
      scrollingEventObject: scrollingEventObject,
      isInViewport: scrollingEventObject
    },
    dispatchToRedux: true
  });
}

function navbarMobileShare(mobileShareButtonsList) {
  _AppDispatcher.appDispatcher.dispatchAction.view({
    type: TYPES.NAVBAR_MOBILE_SHARE_ACTION,
    mobileShareButtonsList: mobileShareButtonsList
  });
}

function navbarMobileMessageShare() {
  _AppDispatcher.appDispatcher.dispatchAction.view({
    type: TYPES.NAVBAR_MOBILE_SHARE_ACTION
  });
}

function navbarMobileGooglePlusShare() {
  _AppDispatcher.appDispatcher.dispatchAction.view({
    type: TYPES.NAVBAR_MOBILE_SHARE_ACTION
  });
}

/***/ }),

/***/ 315:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initBrowsi;

var _script = __webpack_require__(19);

var _browsiScriptConfig = __webpack_require__(314);

function loadBrowsiScript() {
  _script.external.load({
    name: 'browsi',
    loadNow: true
  });
}
function initBrowsi() {
  if ((0, _browsiScriptConfig.isBrowsiEnabled)()) {
    loadBrowsiScript();
  }
}

/***/ }),

/***/ 321:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDataByProvider = getDataByProvider;

var _fetch = __webpack_require__(57);

var _window = __webpack_require__(8);

var _console = __webpack_require__(11);

var featureFlags = {
  debug: _window.queryString.debugRecommendedVideos
};

function warn() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  featureFlags.debug && _console.info.apply(undefined, ['[recommended videos]'].concat(args));
}

var dataProviders = {
  jw: function jw(_ref) {
    var providerName = _ref.providerName,
        playlistId = _ref.playlistId,
        videoId = _ref.videoId;

    return (0, _fetch.getJsonOrError)('https://cdn.jwplayer.com/v2/playlists/' + playlistId + '?related_media_id=' + videoId + '&page_limit=5').then(function (data) {
      warn({ providerName: providerName, data: data });
      return data;
    });
  },
  yt: function yt(providerConf) {
    return 'provider: youtube';
  }
};

function mapOverRecommendedPlaylist(item, idx) {
  return {
    id: idx,
    title: item.title,
    mediaId: item.mediaid,
    description: item.description || 'no description',
    image: item.image,
    hlink: item.link
  };
}

function parseRecommendedData(data) {
  return data && data.playlist && data.playlist.map(mapOverRecommendedPlaylist);
}

function getDataByProvider(providerConf) {
  switch (providerConf.providerName) {
    case 'jw':
      return dataProviders.jw(providerConf).then(parseRecommendedData);
    case 'yt':
      return dataProviders.yt(providerConf).then(parseRecommendedData);
    default:
      return warn('no provider configuration was supplied to recommendatioList');
  }
}

/***/ }),

/***/ 403:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CURRENCY_DISPLAY_TYPES = undefined;
exports.transformFantasyTournaments = transformFantasyTournaments;

var _window = __webpack_require__(8);

var _console = __webpack_require__(11);

var _object = __webpack_require__(12);

var overrideNumFantasyTournaments = _window.queryString.overrideNumFantasyTournaments,
    debugFantasyTournaments = _window.queryString.debugFantasyTournaments,
    mockFantasyTournamentsCurrency = _window.queryString.mockFantasyTournamentsCurrency;

var currencyName2Symbol = {
  USD: '$',
  GBP: '£'
};
var CURRENCY_DISPLAY_TYPES = exports.CURRENCY_DISPLAY_TYPES = (0, _object.namespacedConsts)({
  SYMBOL: true, // eg: $, £
  NAME: true // eg: USD, EUR, GBP, NIS, CNY
});

function getCurrencyData(currencyName) {
  if (mockFantasyTournamentsCurrency && mockFantasyTournamentsCurrency.length) {
    (0, _console.info)('[YAHOO_FANTASY] getCurrencyData: mocking tournament currency with \'' + mockFantasyTournamentsCurrency + '\'', { currencyName: currencyName, mockFantasyTournamentsCurrency: mockFantasyTournamentsCurrency, currencyName2Symbol: currencyName2Symbol });
    currencyName = mockFantasyTournamentsCurrency; // eslint-disable-line no-param-reassign
  }
  var symbol = currencyName2Symbol[currencyName.toUpperCase()];
  if (symbol) {
    return {
      type: CURRENCY_DISPLAY_TYPES.SYMBOL,
      value: symbol
    };
  }
  return {
    type: CURRENCY_DISPLAY_TYPES.NAME,
    value: currencyName
  };
}

function getLinkFromId(id) {
  return 'https://sports.yahoo.com/dailyfantasy/contest/' + id + '/setlineup';
}

function transformTournament(_ref) {
  var id = _ref.id,
      title = _ref.title,
      totalEntries = _ref.entryLimit,
      currentEntriesCount = _ref.entryCount,
      paidEntryFee = _ref.paidEntryFee,
      paidTotalPrize = _ref.paidTotalPrize;
  var entryFeeAmount = paidEntryFee.amount,
      currency = paidEntryFee.currency;

  var currencyData = getCurrencyData(currency);
  var prizeAmount = paidTotalPrize.amount;

  var link = getLinkFromId(id);
  return {
    title: title,
    currentEntriesCount: currentEntriesCount,
    currency: currencyData,
    totalEntries: totalEntries,
    entryFeeAmount: entryFeeAmount,
    prizeAmount: prizeAmount,
    redirectionUrl: '',
    link: link
  };
}

function transformFantasyTournaments(_ref2) {
  var contests = _ref2.contests;

  var args = arguments;
  if (debugFantasyTournaments) {
    (0, _console.info)('[YAHOO_FANTASY] transformFantasyTournaments', { contests: contests, args: args });
  }
  if (!contests || !contests.result) {
    return [];
  }
  var tournaments = contests.result;
  // allow faking number of tournaments for QA

  if (overrideNumFantasyTournaments && !isNaN(overrideNumFantasyTournaments)) {
    var len = parseInt(overrideNumFantasyTournaments, 10);
    return Array(len).fill(transformTournament(tournaments[0]));
  }
  return tournaments.map(transformTournament);
}

/***/ }),

/***/ 408:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

exports.getMockReactions = getMockReactions;
exports.getClientVotes = getClientVotes;
exports.getPostVotes = getPostVotes;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getMockCampaign() {
  return {
    campaign: {
      image: 'https://s31.postimg.org/s036o6sd7/Suicide_Squad_logo_English_2.png'
    }
  };
}
function addSelectedImage(reaction) {
  var selectedImage = reaction.image.replace('.svg', '_chosen.svg');
  var ret = (0, _extends3.default)({}, reaction, { selectedImage: selected_image });
  return ret;
}
function getMockReactions(_ref) {
  var _ref$doesIncludeCampa = _ref.doesIncludeCampaign,
      doesIncludeCampaign = _ref$doesIncludeCampa === undefined ? false : _ref$doesIncludeCampa;

  //todo: OREN - for a start, please add this JSON to the pdo
  // we can add more images later on
  var campaign = doesIncludeCampaign ? getMockCampaign() : {};
  var menuIcon = {
    default_icon: 'http://dev.90min.com/assets/reactions_web/90min_default_icon.svg'
  };
  var reactions = {
    reactions: [{
      id: "543b93b91669f8e5b0000002",
      text: "Love It",
      image: 'http://dev.90min.com/assets/reactions_web/90min_love_it_icon.svg'
    }, {
      id: "543b93b91669f8e5b0000003",
      text: "Must Read",
      image: 'http://dev.90min.com/assets/reactions_web/90min_must_read_icon.svg'
    }, {
      id: "543b93b91669f8e5b0000004",
      text: "LOL",
      image: 'http://dev.90min.com/assets/reactions_web/90min_lol_icon.svg'
    }, {
      id: "543b93b91669f8e5b0000005",
      text: "No Way!",
      image: 'http://dev.90min.com/assets/reactions_web/90min_no_way_icon.svg'
    }, {
      id: "543b93b91669f8e5b0000006",
      text: "Shocked",
      selectedImage: 'http://dev.90min.com/assets/reactions_web/90min_shocked_icon.svg_chosen',
      image: 'http://dev.90min.com/assets/reactions_web/90min_shocked_icon.svg'
    }].map(addSelectedImage)

  };
  return (0, _extends3.default)({}, reactions, campaign, menuIcon);
}
function getClientVotes() {
  return { 2558602: '543b93b91669f8e5b0000006' };
}
function getPostVotes() {
  return {
    '543b93b91669f8e5b0000006': 4,
    '543b93b91669f8e5b0000005': 3,
    '543b93b91669f8e5b0000004': 2
  };
}

/***/ }),

/***/ 420:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _object = __webpack_require__(12);

var _AppDispatcher = __webpack_require__(55);

/* eslint semi:0 */
var CLASS_CONSTATNTS = (0, _object.namespacedConsts)({
  LAZY_LOAD: {
    ACTIONS: {
      REACHED_LOAD_TARGET: true
    }
  }
});

var TYPES = CLASS_CONSTATNTS.LAZY_LOAD.ACTIONS;

var lazyLoadActions = {
  TYPES: TYPES,

  loadTargetReached: function loadTargetReached(scrollingEventObject) {
    _AppDispatcher.appDispatcher.dispatchAction.view({
      type: TYPES.REACHED_LOAD_TARGET,
      scrollingEventObject: scrollingEventObject
    });
  }
};

exports.default = lazyLoadActions;

/***/ }),

/***/ 426:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(58);

var _getIterator3 = _interopRequireDefault(_getIterator2);

exports.default = initNewscorp;

var _dom = __webpack_require__(13);

var _fn = __webpack_require__(15);

var _externalScripts = __webpack_require__(52);

var _nm = __webpack_require__(26);

var _preRenderedSelectorsConfig = __webpack_require__(17);

var _script = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint semi:0 */
var NEWSCORP_ELEMENT_ID_PREFIX = 'newscorp-id-';

function initializeNewscorpEmbed(elementId, embedVideoId) {
  window.ballball_player_generate(elementId, 'in-id', embedVideoId, 'www.ballball.com');
}

function initializeNewscorpEmbeds(newscorpEmbedContainers) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = (0, _getIterator3.default)(newscorpEmbedContainers), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var newscorpEmbedContainer = _step.value;

      var embedVideoId = newscorpEmbedContainer.dataset.id;
      var elementId = '' + NEWSCORP_ELEMENT_ID_PREFIX + embedVideoId;
      (0, _fn.makeSafeFn)(initializeNewscorpEmbed.part(elementId, embedVideoId)).invoke();
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}

function initNewscorp() {
  var newscorpEmbedContainers = (0, _dom.nodes)(_preRenderedSelectorsConfig.SELECTORS.NEWSCORP_EMBED_CONTAINER);
  if (newscorpEmbedContainers.length) {
    var newscorpLoader = _script.external.load({ name: _externalScripts.externalScriptsConfig.newscorp.name });
    newscorpLoader(initializeNewscorpEmbeds.part(newscorpEmbedContainers));
  }
}

(0, _nm.registerProvider)({ initNewscorp: initNewscorp });

/***/ }),

/***/ 51:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HEART_BEAT_PERIOD = undefined;

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _values = __webpack_require__(127);

var _values2 = _interopRequireDefault(_values);

var _toConsumableArray2 = __webpack_require__(33);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _baseStore = __webpack_require__(77);

var _baseStore2 = _interopRequireDefault(_baseStore);

var _adActions = __webpack_require__(50);

var _window = __webpack_require__(8);

var _ua = __webpack_require__(10);

var _console = __webpack_require__(11);

var _object = __webpack_require__(12);

var _routerActions = __webpack_require__(208);

var _browsiActions = __webpack_require__(207);

var _string = __webpack_require__(47);

var _userToolbarActions = __webpack_require__(76);

var _analyticsActions = __webpack_require__(31);

var _pageDataObject = __webpack_require__(5);

var _socialButtonsActions = __webpack_require__(140);

var _fresh8Actions = __webpack_require__(135);

var _fantasyActionTypes = __webpack_require__(108);

var _socialBarActionTypes = __webpack_require__(98);

var _facebookBotActionTypes = __webpack_require__(121);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var debugAnalyticsStore = _window.queryString.debugAnalyticsStore; /* eslint semi:0 */

var ANALYTICS_ACTION_TYPES = [].concat((0, _toConsumableArray3.default)((0, _values2.default)(_analyticsActions.TYPES)), (0, _toConsumableArray3.default)((0, _values2.default)(_socialButtonsActions.TYPES)), (0, _toConsumableArray3.default)((0, _values2.default)(_adActions.TYPES)), (0, _toConsumableArray3.default)((0, _values2.default)(_userToolbarActions.TYPES)), (0, _toConsumableArray3.default)((0, _values2.default)(_browsiActions.BROWSI_ACTIONS)), [_fresh8Actions.actions.FRESH8_ACTION_TYPES.DISPLAY_POPUP, _routerActions.TYPES.ROUTE_CHANGED, _socialBarActionTypes.SOCIAL_BAR_ACTION_TYPES.REACTIONS.DISPLAY, _socialBarActionTypes.SOCIAL_BAR_ACTION_TYPES.REACTIONS.SEND_VOTE, _fantasyActionTypes.FANTASY_ACTION_TYPES.TOURNAMENT.LOAD_MORE, _fantasyActionTypes.FANTASY_ACTION_TYPES.TOURNAMENT.GET_TOURNAMENTS_FEED, _fantasyActionTypes.FANTASY_ACTION_TYPES.TOURNAMENT.SELECT_TOURNAMENT, _facebookBotActionTypes.FACEBOOK_BOT_ACTION_TYPES.GO_TO_MESSENGER_BOT]);

var HEART_BEAT_PERIOD = 30e3; // half a minute
var HEART_BEAT_BLACK_LIST_BY_DOMAIN = ['12up'];

function isHeartBeatNotBlackListedForCurrentDomain() {
  return !HEART_BEAT_BLACK_LIST_BY_DOMAIN.includes(_ua.domainFromFqdn);
}

var AnalyticsStore = function (_BaseStore) {
  (0, _inherits3.default)(AnalyticsStore, _BaseStore);

  function AnalyticsStore() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck3.default)(this, AnalyticsStore);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AnalyticsStore.__proto__ || (0, _getPrototypeOf2.default)(AnalyticsStore)).call(this, options));

    _this.reset();
    _this.listenToBrowserEvents();
    return _this;
  }

  (0, _createClass3.default)(AnalyticsStore, [{
    key: 'listenToBrowserEvents',
    value: function listenToBrowserEvents() {
      window.addEventListener('DOMContentLoaded', _analyticsActions.pageViewed);
    }
  }, {
    key: 'routeAction',
    value: function routeAction(action) {
      if (debugAnalyticsStore) {
        (0, _console.info)('STORE EMIT ACTION: ', action);
      }
      action.analyticsActionName = (0, _string.toCamelCase)(action.type.replace(/:/g, '_'));
      if (this.isAnalyticsAction(action.type)) {
        this.analyticsEvents.push(action); //Note: maybe this is not really needed... probably will be used just for debugging purpose
        this.recordActionInState(action);
        this.emitChange(action);
      }
    }
  }, {
    key: 'reset',
    value: function reset() {
      var analyticsEvents = this.state.analyticsEvents || [];
      this.state = (0, _object.makeEmptyObj)();
      this.state.analyticsEvents = analyticsEvents;
      this.generatePageviewUid();
      if ((0, _pageDataObject.getIsPostPage)() && isHeartBeatNotBlackListedForCurrentDomain()) {
        if (this.heartbeatIntervalId) {
          clearInterval(this.heartbeatIntervalId);
        }
        this.heartbeatIntervalId = setInterval(_analyticsActions.heartBeat, HEART_BEAT_PERIOD);
      }
    }
  }, {
    key: 'generatePageviewUid',
    value: function generatePageviewUid() {
      this.state.pageviewUid = (0, _string.randId)() + (0, _string.randId)() + (0, _string.randId)() + (0, _string.randId)() + (0, _string.randId)() + (0, _string.randId)() + (0, _string.randId)() + (0, _string.randId)() + Date.now();
      return this.state.pageviewUid;
    }
  }, {
    key: 'isAnalyticsAction',
    value: function isAnalyticsAction(actionType) {
      return ANALYTICS_ACTION_TYPES.includes(actionType);
    }
  }, {
    key: 'emitChange',
    value: function emitChange(action) {
      this.emit(this.constructor.EVENTS.CHANGE, action);
      return this;
    }
  }, {
    key: 'recordActionInState',
    value: function recordActionInState(action) {
      var actionType = (0, _string.toCamelCase)(action.type.split(':').pop());
      this.state[actionType] = (this.state[actionType] || 0) + 1;
    }
  }, {
    key: 'analyticsEvents',
    get: function get() {
      return this.state.analyticsEvents;
    }
  }, {
    key: 'heartbeatsCount',
    get: function get() {
      return this.state.heartBeat || 0;
    }
  }, {
    key: 'pageviewUid',
    get: function get() {
      return this.state.pageviewUid;
    }
  }]);
  return AnalyticsStore;
}(_baseStore2.default);

exports.default = AnalyticsStore;
exports.HEART_BEAT_PERIOD = HEART_BEAT_PERIOD;

/***/ }),

/***/ 558:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _defineProperty2 = __webpack_require__(14);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _mountAll; /* eslint semi:0 */

// redux


__webpack_require__(227);

__webpack_require__(702);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _hypernovaReact = __webpack_require__(191);

var _component = __webpack_require__(70);

var _navbarComponent = __webpack_require__(708);

var _navbarComponent2 = _interopRequireDefault(_navbarComponent);

var _preRenderedSelectorsConfig = __webpack_require__(17);

var _userToolbarComponent = __webpack_require__(423);

var _userToolbarComponent2 = _interopRequireDefault(_userToolbarComponent);

var _googleSearchComponent = __webpack_require__(421);

var _googleSearchComponent2 = _interopRequireDefault(_googleSearchComponent);

var _searchInjector = __webpack_require__(413);

var _editionDropdown = __webpack_require__(402);

var _editionDropdown2 = _interopRequireDefault(_editionDropdown);

var _trackAnalyticsClickEvents = __webpack_require__(137);

var _trackAnalyticsClickEvents2 = _interopRequireDefault(_trackAnalyticsClickEvents);

var _trackAnalyticsYoutubeEvents = __webpack_require__(695);

var _externalScriptsViewabilityRegistration = __webpack_require__(701);

var _googleAnalyticaSessionTracker = __webpack_require__(641);

var _freshEightInjector = __webpack_require__(640);

var _fixture_widget = __webpack_require__(639);

var _initLiveBlog = __webpack_require__(655);

var _taboolaFeedEventsTracker = __webpack_require__(694);

var _initCampaigns = __webpack_require__(124);

var _postMetadataContainer = __webpack_require__(296);

var _postMetadataContainer2 = _interopRequireDefault(_postMetadataContainer);

var _socialBarContainer = __webpack_require__(671);

var _socialBarContainer2 = _interopRequireDefault(_socialBarContainer);

var _communityDisclaimerContainer = __webpack_require__(608);

var _communityDisclaimerContainer2 = _interopRequireDefault(_communityDisclaimerContainer);

var _montiContainer = __webpack_require__(291);

var _montiContainer2 = _interopRequireDefault(_montiContainer);

var _socialButtons = __webpack_require__(692);

var _recommendedVideos = __webpack_require__(680);

var _recommendedVideos2 = _interopRequireDefault(_recommendedVideos);

var _common = __webpack_require__(203);

var _transferNews = __webpack_require__(696);

var _articleImage = __webpack_require__(606);

var _postActionsWithStore = __webpack_require__(663);

var _recommendedPostsWithStoreContainer = __webpack_require__(409);

var _performanceTimings = __webpack_require__(815);

var _videoAdTag = __webpack_require__(218);

var _viewbilityTracker = __webpack_require__(99);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _performanceTimings.markTiming)('start post page javascript');
(0, _editionDropdown2.default)();


(0, _component.mountAll)((_mountAll = {}, (0, _defineProperty3.default)(_mountAll, _preRenderedSelectorsConfig.MOUNT_POINTS.SEARCH_COMPONENT, _googleSearchComponent2.default), (0, _defineProperty3.default)(_mountAll, _preRenderedSelectorsConfig.MOUNT_POINTS.NAVBAR_SOCIAL_COMPONENT, _navbarComponent2.default), (0, _defineProperty3.default)(_mountAll, _preRenderedSelectorsConfig.MOUNT_POINTS.USER_MENU_DROPDOWN, _userToolbarComponent2.default), _mountAll));

(0, _googleAnalyticaSessionTracker.trackGoogleAnalyticsSessionId)();
(0, _postMetadataContainer2.default)();
(0, _socialBarContainer2.default)();
(0, _communityDisclaimerContainer2.default)();
(0, _montiContainer2.default)();
(0, _trackAnalyticsClickEvents2.default)();
(0, _socialButtons.initSocialButtons)();
(0, _trackAnalyticsYoutubeEvents.trackAnalyticsYoutubeEvents)();
(0, _recommendedVideos2.default)();
(0, _common.initCommonComponents)();
(0, _videoAdTag.getVideoAdsTag)();
(0, _recommendedPostsWithStoreContainer.initRecommendedPosts)();
(0, _hypernovaReact.renderReact)('TransferNewsContainer', _transferNews.TransferNewsContainer);
(0, _hypernovaReact.renderReact)('ArticleImageContainer', _articleImage.ArticleImageContainer);
(0, _hypernovaReact.renderReact)('PostActionsContainer', (0, _postActionsWithStore.PostActionsContainerWithStore)());
(0, _externalScriptsViewabilityRegistration.registerExternalScripts)();
(0, _initCampaigns.injectPostCampaigns)();
(0, _taboolaFeedEventsTracker.taboolaFeedEventsReporter)();
(0, _searchInjector.injectSearch)();
(0, _initLiveBlog.initILiveBlog)();
(0, _freshEightInjector.injectFreshEight)();
(0, _viewbilityTracker.register)('.related-topics-container');

/***/ }),

/***/ 578:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 606:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArticleImageContainer = undefined;

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _image = __webpack_require__(245);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ArticleImageContainer = exports.ArticleImageContainer = function (_React$Component) {
  (0, _inherits3.default)(ArticleImageContainer, _React$Component);

  function ArticleImageContainer() {
    (0, _classCallCheck3.default)(this, ArticleImageContainer);
    return (0, _possibleConstructorReturn3.default)(this, (ArticleImageContainer.__proto__ || (0, _getPrototypeOf2.default)(ArticleImageContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(ArticleImageContainer, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'figure',
        { className: 'post-cover__media-wrap post-cover__media-wrap--image' },
        _react2.default.createElement(_image.Image, {
          lazyLoad: this.props.lazy_load,
          src: this.props.url,
          srcSet: this.props.srcset,
          className: 'post-cover__media post-cover__media--image',
          title: this.props.credit,
          alt: this.props.caption
        })
      );
    }
  }]);
  return ArticleImageContainer;
}(_react2.default.Component);

/***/ }),

/***/ 607:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.communityDisclaimerActions = undefined;

var _console = __webpack_require__(11);

var _actionCounterProviderActions = __webpack_require__(139);

var _currentPostActionCounterProvider = __webpack_require__(91);

var DATA_RECEIVED = _actionCounterProviderActions.TYPES.DATA_RECEIVED;


function getPostData() {
  return function (dispatch, getState) {
    return (0, _currentPostActionCounterProvider.fetchPostMetadata)().then(function (state) {
      return dispatch({
        type: DATA_RECEIVED,
        state: state
      });
    }).catch(_console.warn);
  };
}

var communityDisclaimerActions = exports.communityDisclaimerActions = {
  fetchData: getPostData
};

/***/ }),

/***/ 608:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.communityDisclaimerContainer = undefined;

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _defineProperty2 = __webpack_require__(14);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = __webpack_require__(9);

var _extends4 = _interopRequireDefault(_extends3);

exports.default = initCommunityDisclaimer;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _fn = __webpack_require__(15);

var _reactRedux = __webpack_require__(37);

var _ua = __webpack_require__(10);

var _reduxMounter = __webpack_require__(45);

var _reduxMounter2 = _interopRequireDefault(_reduxMounter);

var _i18nProvider = __webpack_require__(18);

var _preRenderedSelectorsConfig = __webpack_require__(17);

var _disclaimerHeader = __webpack_require__(610);

var _disclaimerMessage = __webpack_require__(611);

var _disclaimerWrapper = __webpack_require__(612);

var _communityDisclaimerReducer = __webpack_require__(609);

var _communityDisclaimerActions = __webpack_require__(607);

var _pageDataObject = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var COMPONENT_NAME = 'communityDisclaimerContainer'; /* eslint semi:0 */

var STATE_KEY = 'communityDisclaimer';
var COMMUNITY_DISCLAIMER_EPOCH = 1422788400;
var EXCLUDED_CASTR_STATUSES = ['published'];
var PDO_PATH = 'post';
var REQUIRED_DATA_FROM_PDO = ['created_at', 'castr_status', 'author'];
var COMMUNITY_DISCLAIMER_FEATURE_ID = 'CommunityDisclaimer';

function getPageData(path, pdoFields) {
  var dataObject = (0, _pageDataObject.get)(path, {});
  return pdoFields.reduce(function (dataFromPdo, field) {
    return (0, _extends4.default)({}, dataFromPdo, (0, _defineProperty3.default)({}, field, dataObject[field]));
  }, {});
}

function shouldMountComponent() {
  return false;
}

var CommunityDisclaimer = function (_React$Component) {
  (0, _inherits3.default)(CommunityDisclaimer, _React$Component);

  function CommunityDisclaimer() {
    (0, _classCallCheck3.default)(this, CommunityDisclaimer);
    return (0, _possibleConstructorReturn3.default)(this, (CommunityDisclaimer.__proto__ || (0, _getPrototypeOf2.default)(CommunityDisclaimer)).apply(this, arguments));
  }

  (0, _createClass3.default)(CommunityDisclaimer, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.fetchData();
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.isFeatured ? this.disclaimer : false;
    }
  }, {
    key: 'disclaimer',
    get: function get() {
      return _react2.default.createElement(
        _disclaimerWrapper.DisclaimerWrapper,
        null,
        _react2.default.createElement(
          _disclaimerHeader.DisclaimerHeader,
          null,
          (0, _i18nProvider.t)('post_page.community_content')
        ),
        _react2.default.createElement(
          _disclaimerMessage.DisclaimerMessage,
          null,
          this.props.communityDisclaimerI18nKeysByDomain[(0, _ua.domainFromFqdn)()]
        )
      );
    }
  }]);
  return CommunityDisclaimer;
}(_react2.default.Component);

function mapStateToProps(state) {
  var _state$STATE_KEY = state[STATE_KEY],
      isFeatured = _state$STATE_KEY.isFeatured,
      communityDisclaimerI18nKeysByDomain = _state$STATE_KEY.communityDisclaimerI18nKeysByDomain;

  return {
    isFeatured: isFeatured,
    communityDisclaimerI18nKeysByDomain: communityDisclaimerI18nKeysByDomain
  };
}

var communityDisclaimerContainer = exports.communityDisclaimerContainer = {
  name: COMPONENT_NAME,
  stateKey: STATE_KEY,
  component: (0, _reactRedux.connect)(mapStateToProps, _communityDisclaimerActions.communityDisclaimerActions)(CommunityDisclaimer),
  reducer: _communityDisclaimerReducer.communityDisclaimerReducer
};

function mountCommunityDisclaimer() {
  return (0, _reduxMounter2.default)((0, _defineProperty3.default)({}, _preRenderedSelectorsConfig.MOUNT_POINTS.COMMUNITY_DISCLAIMER, communityDisclaimerContainer));
}

function initCommunityDisclaimer() {
  var shouldMountCommunityDisclaimer = shouldMountComponent();
  if (shouldMountCommunityDisclaimer) {
    mountCommunityDisclaimer();
  }
  return shouldMountCommunityDisclaimer;
}

/***/ }),

/***/ 609:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(14);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends4 = __webpack_require__(9);

var _extends5 = _interopRequireDefault(_extends4);

exports.communityDisclaimerReducer = communityDisclaimerReducer;

var _window = __webpack_require__(8);

var _i18nProvider = __webpack_require__(18);

var _actionCounterProviderActions = __webpack_require__(139);

var _console = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var communityFeaturedQuery = _window.queryString.communityFeatured;
var DATA_RECEIVED = _actionCounterProviderActions.TYPES.DATA_RECEIVED,
    RECEIVED_ERROR = _actionCounterProviderActions.TYPES.RECEIVED_ERROR;

var DOMAINS = ['90min', '12up', 'ftb90', 'dbltap'];
var I18N_BASE_PATH = 'post_page.community_disclaimer';
var INITIAL_STATE = {
  isFeatured: false,
  communityDisclaimerI18nKeysByDomain: DOMAINS.reduce(function (i18nDefaultKeysObject, domain) {
    return (0, _extends5.default)({}, i18nDefaultKeysObject, (0, _defineProperty3.default)({}, domain, ''));
  }, {})
};

function toNumber(string) {
  return string === undefined ? undefined : parseInt(string, 10);
}

function shouldShowDisclaimer(communityFeaturedQuery, featured) {
  return false;
}

var isFeatured = shouldShowDisclaimer.part(communityFeaturedQuery);

function getI18nKeysByDomains(domains, basePath) {
  return domains.reduce(function (i18nKeysObject, domain) {
    return (0, _extends5.default)({}, i18nKeysObject, (0, _defineProperty3.default)({}, domain, (0, _i18nProvider.t)(basePath + '_' + domain)));
  }, {});
}

var getI18nKeys = getI18nKeysByDomains.part(DOMAINS, I18N_BASE_PATH);

function setStateDataRecived(state, action) {
  var featured = action.state.featured;

  return {
    isFeatured: isFeatured(featured),
    communityDisclaimerI18nKeysByDomain: getI18nKeys()
  };
}

function setStateDataError(state, action) {
  var error = action.state.error;

  (0, _console.warn)('Error recieving data from external source, check with provier', { error: error, action: action });
  return {
    isFeatured: isFeatured(undefined),
    communityDisclaimerI18nKeysByDomain: getI18nKeys()
  };
}

function setState(state, newState) {
  return (0, _extends5.default)({}, state, newState);
}

function communityDisclaimerReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments[1];

  switch (action.type) {
    case DATA_RECEIVED:
      return setState(state, setStateDataRecived(state, action));
    case RECEIVED_ERROR:
      return setState(state, setStateDataError(state, action));
    default:
      return setState(state, action.state);
  }
}

/***/ }),

/***/ 610:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DisclaimerHeader = DisclaimerHeader;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function DisclaimerHeader(_ref) {
  var blockName = _ref.blockName,
      children = _ref.children;

  var elementName = '__header';
  var bemClass = '' + blockName + elementName;
  return _react2.default.createElement(
    'div',
    { className: bemClass },
    _react2.default.createElement(
      'div',
      { className: bemClass + '-shape' },
      _react2.default.createElement(
        'h5',
        { className: bemClass + '-text' },
        children
      )
    )
  );
}

/***/ }),

/***/ 611:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DisclaimerMessage = DisclaimerMessage;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function DisclaimerMessage(_ref) {
  var blockName = _ref.blockName,
      children = _ref.children;

  var elementName = '__message';
  var bemClass = '' + blockName + elementName;
  return _react2.default.createElement(
    'div',
    { className: bemClass },
    _react2.default.createElement(
      'p',
      { className: bemClass + '-paragraph' },
      children
    )
  );
}

/***/ }),

/***/ 612:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DisclaimerWrapper = DisclaimerWrapper;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _reactUtils = __webpack_require__(86);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function DisclaimerWrapper(_ref) {
  var children = _ref.children;

  var blockName = 'community-disclaimer';
  return _react2.default.createElement(
    'div',
    { className: blockName + '__wrapper' },
    (0, _reactUtils.cloneChildrenWithProps)(children, { blockName: blockName })
  );
}

/***/ }),

/***/ 614:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getRandomFacebookBotButtonMessage;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function classWithModifier(modifier, className) {
  return [className, className + '--' + modifier].join(' ');
}

function facebookButtonMessage(blockName, _ref) {
  var modifier = _ref.modifier,
      prefix = _ref.prefix,
      suffix = _ref.suffix;

  var getClassWithModifier = classWithModifier.part(modifier);
  return _react2.default.createElement(
    'h5',
    { className: getClassWithModifier(blockName + '__message') },
    prefix + ' ',
    _react2.default.createElement(
      'strong',
      { className: getClassWithModifier(blockName + '__latest-news') },
      'latest news'
    ),
    ' ' + suffix
  );
}

var FACEBOOK_BOT_BUTTON_MESSAGES = [{
  modifier: 'long',
  prefix: 'Click here to get the',
  suffix: 'about your favourite team on Facebook Messenger'
}];

function createFacebookBotMessages(blockName) {
  var facebookButtonMessageWithBlockName = facebookButtonMessage.part(blockName);
  return FACEBOOK_BOT_BUTTON_MESSAGES.map(facebookButtonMessageWithBlockName);
}

function getIndexInRange(requestedIndex, size) {
  return requestedIndex >= size ? requestedIndex % size : requestedIndex;
}

var NO_INDEX = null;
function getRequestedIndexOrRandomMessage(size) {
  var requestedIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : NO_INDEX;

  return requestedIndex === NO_INDEX ? Math.floor(Math.random() * size) : getIndexInRange(requestedIndex, size);
}

function getRandomFacebookBotButtonMessage(blockName, index) {
  var messages = createFacebookBotMessages.apply(undefined, arguments);
  return messages[getRequestedIndexOrRandomMessage(messages.length, index)];
}

/***/ }),

/***/ 615:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(16);

var _assign2 = _interopRequireDefault(_assign);

var _from = __webpack_require__(49);

var _from2 = _interopRequireDefault(_from);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _window = __webpack_require__(8);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(60);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _facebookBotButtonMessages = __webpack_require__(614);

var _facebookBotButtonMessages2 = _interopRequireDefault(_facebookBotButtonMessages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BLOCK_NAME = 'facebook-bot';
var DEFAULT_HREF = 'https://m.me/90minFootball';
var forceFacebookBotCount = parseInt(_window.queryString.forceFacebookBot, 10) || 0;

var FacebookBotComponent = function (_Component) {
  (0, _inherits3.default)(FacebookBotComponent, _Component);

  function FacebookBotComponent() {
    (0, _classCallCheck3.default)(this, FacebookBotComponent);
    return (0, _possibleConstructorReturn3.default)(this, (FacebookBotComponent.__proto__ || (0, _getPrototypeOf2.default)(FacebookBotComponent)).apply(this, arguments));
  }

  (0, _createClass3.default)(FacebookBotComponent, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          href = _props.href,
          goToMessengerBot = _props.goToMessengerBot;

      var anchorProps = {
        className: [BLOCK_NAME, className].join(' '),
        onClick: goToMessengerBot,
        target: '_blank',
        rel: 'noopener',
        href: href
      };
      var facebookBotAnchor = function facebookBotAnchor(_, key) {
        return _react2.default.createElement(
          'a',
          (0, _extends3.default)({}, anchorProps, { key: key }),
          _react2.default.createElement(
            'div',
            { className: BLOCK_NAME + '__message-wrap' },
            (0, _facebookBotButtonMessages2.default)(BLOCK_NAME, key)
          )
        );
      };
      return forceFacebookBotCount ? _react2.default.createElement(
        'section',
        null,
        (0, _from2.default)(Array(forceFacebookBotCount), facebookBotAnchor)
      ) : facebookBotAnchor();
    }
  }]);
  return FacebookBotComponent;
}(_react.Component);

exports.default = FacebookBotComponent;
var string = _propTypes2.default.string;


(0, _assign2.default)(FacebookBotComponent, {
  propTypes: {
    className: string,
    href: string
  },
  defaultProps: {
    href: DEFAULT_HREF
  }
});

/***/ }),

/***/ 616:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.facebookBotActions = undefined;

var _facebookBotActionTypes = __webpack_require__(121);

function goToMessengerBot(_ref) {
  var currentTarget = _ref.currentTarget;

  return function (dispatch, getState) {
    return dispatch({
      type: _facebookBotActionTypes.FACEBOOK_BOT_ACTION_TYPES.GO_TO_MESSENGER_BOT,
      state: {
        displayMessage: currentTarget.innerText.trim()
      }
    });
  };
}

var facebookBotActions = exports.facebookBotActions = {
  goToMessengerBot: goToMessengerBot
};

/***/ }),

/***/ 617:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(14);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.default = mountFacebookBot;

var _reactRedux = __webpack_require__(37);

var _reduxMounter = __webpack_require__(45);

var _reduxMounter2 = _interopRequireDefault(_reduxMounter);

var _redux = __webpack_require__(174);

var _window = __webpack_require__(8);

var _console = __webpack_require__(11);

var _externalScripts = __webpack_require__(52);

var _campaignConfig = __webpack_require__(206);

var _facebookBotReducer = __webpack_require__(620);

var _facebookBotActions = __webpack_require__(616);

var _facebookBotMounterConfig = __webpack_require__(618);

var _script = __webpack_require__(19);

var _preRenderedSelectorsConfig = __webpack_require__(17);

var _facebookBotComponent = __webpack_require__(615);

var _facebookBotComponent2 = _interopRequireDefault(_facebookBotComponent);

var _facebookBotNodeInjector = __webpack_require__(619);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FACEBOOK_BOT_MOUNT_POINT = _preRenderedSelectorsConfig.MOUNT_POINTS.FACEBOOK_BOT_MOUNT_POINT;

var COMPONENT_NAME = "FacebookBot";
var STATE_KEY = "facebookBot";
var forceFacebookBot = _window.queryString.forceFacebookBot;

var facebookScriptLoader = (0, _script.load)({
  name: _externalScripts.externalScriptsConfig.facebook.name });

function mapStateToProps(state) {
  var _state$STATE_KEY = state[STATE_KEY],
      displayMessage = _state$STATE_KEY.displayMessage,
      appId = _state$STATE_KEY.appId,
      pageId = _state$STATE_KEY.pageId;

  return {
    className: 'post-body-wrap__facebook-bot',
    displayMessage: displayMessage,
    pageId: pageId,
    appId: appId
  };
}

function mapStateToDispatch(dispatch) {
  return (0, _redux.bindActionCreators)(_facebookBotActions.facebookBotActions, dispatch);
}

var FacebookBotContainer = {
  name: COMPONENT_NAME,
  stateKey: STATE_KEY,
  component: (0, _reactRedux.connect)(mapStateToProps, mapStateToDispatch)(_facebookBotComponent2.default),
  reducer: _facebookBotReducer.facebookBotReducer
};

function injectFacebookBotMountPointAndMount() {
  (0, _facebookBotNodeInjector.injectFacebookBotInsideArticle)();
  (0, _reduxMounter2.default)((0, _defineProperty3.default)({}, FACEBOOK_BOT_MOUNT_POINT, FacebookBotContainer));
}

function loadFbScriptInjectAndMount() {
  facebookScriptLoader(injectFacebookBotMountPointAndMount);
}

function runFacebookBotCampaign(_ref) {
  var isFacebookBotCampaignEnabled = _ref.isCampaignEnabled;

  if (isFacebookBotCampaignEnabled) {
    loadFbScriptInjectAndMount();
  }
}

function mountFacebookBot() {
  if (forceFacebookBot) {
    (0, _console.info)('[QS] forcing facebook bot');
    return loadFbScriptInjectAndMount();
  }
  return (0, _campaignConfig.isCampaignEnabled)(_facebookBotMounterConfig.facebookBotConfig).then(runFacebookBotCampaign).catch(_console.warn);
}

/***/ }),

/***/ 618:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var facebookBotConfig = exports.facebookBotConfig = {
  pageTypes: ['post'],
  locales: [],
  isEmbedded: false,
  isHybrid: false,
  featureId: 'FacebookBot',
  isSlideshow: false
};

/***/ }),

/***/ 619:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.injectFacebookBotInsideArticle = injectFacebookBotInsideArticle;

var _preRenderedSelectorsConfig = __webpack_require__(17);

var _dom = __webpack_require__(13);

var POST_BODY_WRAP_SELECTOR = _preRenderedSelectorsConfig.SELECTORS.POST_BODY_WRAP_SELECTOR;

var INJECTION_CONF = {
  TAG_NAME: 'div',
  PARENT_NODE: POST_BODY_WRAP_SELECTOR,
  CLASS_NAME: _preRenderedSelectorsConfig.MOUNT_POINTS.FACEBOOK_BOT_MOUNT_POINT.slice(1)
};

function injectFacebookBotInsideArticle() {
  var TAG_NAME = INJECTION_CONF.TAG_NAME,
      PARENT_NODE = INJECTION_CONF.PARENT_NODE,
      CLASS_NAME = INJECTION_CONF.CLASS_NAME;

  var injectedNode = (0, _dom.createElement)(TAG_NAME);
  (0, _dom.classList)(injectedNode).add(CLASS_NAME);
  var parentNode = (0, _dom.node)(PARENT_NODE);
  parentNode.insertBefore(injectedNode, parentNode.childNodes[0]);
}

/***/ }),

/***/ 620:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.facebookBotReducer = facebookBotReducer;

var _pageDataObject = __webpack_require__(5);

var _array = __webpack_require__(101);

var _safeLocalStorageProvider = __webpack_require__(178);

var _safeLocalStorageProvider2 = _interopRequireDefault(_safeLocalStorageProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NO_MESSAGE_IN_LOCAL_STORAGE = null;
var FB_BOT_MSG_KEY = 'NM_FB_BOT_MSG_KEY';
var messengerBotDisplayMessages = ['Get the latest football news', 'Get the latest breaking news', 'Never miss a breaking story'];

function getDisplayMessage() {
  var cachedMessage = _safeLocalStorageProvider2.default.get(FB_BOT_MSG_KEY, NO_MESSAGE_IN_LOCAL_STORAGE);
  if (cachedMessage !== NO_MESSAGE_IN_LOCAL_STORAGE) {
    return cachedMessage;
  }
  var selectedMsg = (0, _array.getRandomElement)(messengerBotDisplayMessages);
  _safeLocalStorageProvider2.default.set(FB_BOT_MSG_KEY, selectedMsg);
  return selectedMsg;
}

var DEFAULT_STATE = {
  displayMessage: getDisplayMessage(),
  appId: (0, _pageDataObject.get)('config.facebook.app_id'),
  pageId: (0, _pageDataObject.get)('config.facebook.page_id')
};

function facebookBotReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
  var action = arguments[1];

  return state;
}

/***/ }),

/***/ 621:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _fantasyHeader = __webpack_require__(623);

var _fantasyFooter = __webpack_require__(622);

var _fantasyTournament = __webpack_require__(624);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BLOCK_NAME = 'fantasy';

var FantasyComponent = function (_React$Component) {
  (0, _inherits3.default)(FantasyComponent, _React$Component);

  function FantasyComponent() {
    (0, _classCallCheck3.default)(this, FantasyComponent);
    return (0, _possibleConstructorReturn3.default)(this, (FantasyComponent.__proto__ || (0, _getPrototypeOf2.default)(FantasyComponent)).apply(this, arguments));
  }

  (0, _createClass3.default)(FantasyComponent, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isInitialized = _props.isInitialized,
          getTournamentsFeed = _props.getTournamentsFeed,
          tournaments = _props.tournaments;

      if (!isInitialized) {
        getTournamentsFeed();
        return this.loadingProgressComponent;
      }
      if (!tournaments.length) {
        return false;
      }
      return this.fantasyComponent;
    }
  }, {
    key: 'tournamentsList',
    get: function get() {
      var _props2 = this.props,
          tournaments = _props2.tournaments,
          numVisibleTournaments = _props2.numVisibleTournaments,
          selectTournament = _props2.selectTournament;

      return tournaments.slice(0, numVisibleTournaments).map(function (item, i) {
        return _react2.default.createElement(_fantasyTournament.FantasyTournament, {
          key: i,
          blockName: BLOCK_NAME,
          tournament: item,
          onSelectTournament: selectTournament
        });
      });
    }
  }, {
    key: 'loadingProgressComponent',
    get: function get() {
      return _react2.default.createElement('div', { className: BLOCK_NAME + '__loading' });
    }
  }, {
    key: 'fantasyComponent',
    get: function get() {
      var _props3 = this.props,
          loadMoreTournaments = _props3.loadMoreTournaments,
          isLoadMoreVisible = _props3.isLoadMoreVisible;

      var blockClassNames = BLOCK_NAME + (isLoadMoreVisible ? '' : ' ' + BLOCK_NAME + '--load-more-invisible');
      return _react2.default.createElement(
        'section',
        {
          className: blockClassNames
        },
        _react2.default.createElement(_fantasyHeader.FantasyHeader, { blockName: BLOCK_NAME }),
        _react2.default.createElement(
          'ul',
          { className: BLOCK_NAME + '__tournament-list' },
          this.tournamentsList
        ),
        _react2.default.createElement(_fantasyFooter.FantasyFooter, {
          blockName: BLOCK_NAME,
          isLoadMoreVisible: isLoadMoreVisible,
          onLoadMoreClicked: loadMoreTournaments
        })
      );
    }
  }]);
  return FantasyComponent;
}(_react2.default.Component);

exports.default = FantasyComponent;

/***/ }),

/***/ 622:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FantasyFooter = FantasyFooter;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FantasyFooter(_ref) {
  var blockName = _ref.blockName,
      onLoadMoreClicked = _ref.onLoadMoreClicked,
      isLoadMoreVisible = _ref.isLoadMoreVisible;

  var classPrefix = blockName + '__footer';
  return _react2.default.createElement(
    'footer',
    {
      className: '' + classPrefix
    },
    isLoadMoreVisible ? _react2.default.createElement(
      'button',
      {
        type: 'button',
        className: classPrefix + '-load-more-button',
        onClick: onLoadMoreClicked
      },
      'Load More'
    ) : false
  );
}

/***/ }),

/***/ 623:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FantasyHeader = FantasyHeader;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FantasyHeader(_ref) {
  var blockName = _ref.blockName;

  var classPrefix = blockName + "__header";
  return _react2.default.createElement(
    "header",
    {
      className: "" + classPrefix
    },
    _react2.default.createElement("div", { className: classPrefix + "-logo-container" }),
    _react2.default.createElement(
      "div",
      { className: classPrefix + "-label-promotion" },
      "Use Promo Code",
      _react2.default.createElement(
        "span",
        { className: classPrefix + "-label-promotion-code" },
        " FANTASY50 "
      ),
      "For \xA350 Bonus"
    ),
    _react2.default.createElement(
      "a",
      { href: "https://login.yahoo.com/account/create?src=dailyfantasy&specId=usernameReg&context=reg&intl=GB&.lang=en-GB&.done=https%3A%2F%2Fuk.sports.yahoo.com%2Fdailyfantasy%2F%3F", className: classPrefix + "-sign-up-button" },
      "SIGN UP"
    ),
    _react2.default.createElement(
      "div",
      { className: classPrefix + "-label-starts-today" },
      "Starts Today"
    )
  );
}

/***/ }),

/***/ 624:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FantasyTournament = FantasyTournament;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _fantasyTournamentTransformer = __webpack_require__(403);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint semi:0 */
function formatEntrySize(amount) {
  return amount < 1000 ? amount : (amount / 1000).toFixed(2) + 'k';
}

function getEntryPerSize(currentEntriesCount, totalEntries) {
  return formatEntrySize(currentEntriesCount) + '/' + formatEntrySize(totalEntries);
}

function getPriceString(amount, _ref) {
  var value = _ref.value,
      type = _ref.type;

  if (type === _fantasyTournamentTransformer.CURRENCY_DISPLAY_TYPES.SYMBOL) {
    return value + amount;
  }
  return amount + ' ' + value;
}

function FantasyTournament(_ref2) {
  var blockName = _ref2.blockName,
      tournament = _ref2.tournament,
      onSelectTournament = _ref2.onSelectTournament;

  var classPrefix = blockName + '__tournament';
  var title = tournament.title,
      currentEntriesCount = tournament.currentEntriesCount,
      currency = tournament.currency,
      totalEntries = tournament.totalEntries,
      entryFeeAmount = tournament.entryFeeAmount,
      prizeAmount = tournament.prizeAmount,
      link = tournament.link;

  var entryPerSize = getEntryPerSize(currentEntriesCount, totalEntries);
  var entryFeeString = getPriceString(entryFeeAmount, currency);
  var entryPrizeString = getPriceString(prizeAmount, currency);
  var linkProps = {
    href: link,
    rel: 'noopener',
    target: '_blank',
    children: 'Enter',
    onClick: onSelectTournament,
    className: classPrefix + '-enter-link'
  };
  return _react2.default.createElement(
    'li',
    { className: '' + classPrefix },
    _react2.default.createElement(
      'h6',
      { className: classPrefix + '-title' },
      title
    ),
    _react2.default.createElement(
      'div',
      { className: classPrefix + '-content-wrapper' },
      _react2.default.createElement(
        'span',
        { className: classPrefix + '-num-entries-wrapper' },
        _react2.default.createElement(
          'label',
          { className: classPrefix + '-num-entries-label' },
          'Entries/Size:'
        ),
        _react2.default.createElement(
          'span',
          { className: classPrefix + '-num-entries-content' },
          entryPerSize
        )
      ),
      _react2.default.createElement(
        'span',
        { className: classPrefix + '-entry-fee-wrapper' },
        _react2.default.createElement(
          'label',
          { className: classPrefix + '-entry-fee-label' },
          'Entry:'
        ),
        _react2.default.createElement(
          'span',
          { className: classPrefix + '-entry-fee-content' },
          entryFeeString
        )
      ),
      _react2.default.createElement(
        'span',
        { className: classPrefix + '-entry-prize-wrapper' },
        _react2.default.createElement(
          'label',
          { className: classPrefix + '-entry-prize-label' },
          'Prizes:'
        ),
        _react2.default.createElement(
          'span',
          { className: classPrefix + '-entry-prize-content' },
          entryPrizeString
        )
      ),
      _react2.default.createElement(
        'div',
        { className: classPrefix + '-enter-container' },
        _react2.default.createElement('a', linkProps)
      )
    )
  );
}

/***/ }),

/***/ 625:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fantasyActions = undefined;

var _dom = __webpack_require__(13);

var _fetch = __webpack_require__(57);

var _window = __webpack_require__(8);

var _console = __webpack_require__(11);

var _pageDataObject = __webpack_require__(5);

var _fantasyActionTypes = __webpack_require__(108);

var _fantasyTournamentTransformer = __webpack_require__(403);

var TOURNAMENT = _fantasyActionTypes.FANTASY_ACTION_TYPES.TOURNAMENT;
var debugFantasyTournaments = _window.queryString.debugFantasyTournaments,
    mockFantasyTournaments = _window.queryString.mockFantasyTournaments;

var TOURNAMENTS_MOCK_URL = 'https://s3-us-west-2.amazonaws.com/90min-widgets/yahoo-fantasy/soccer_tournaments_dummy.json';
var TOURNAMENTS_TRACKING_URLS = {
  PAGE_VIEW: 'https://ad.doubleclick.net/ddm/trackimp/N1881.206593290MIN/B20215410.203384788;dc_trk_aid=403216671;dc_trk_cid=91973336;ord=[timestamp];dc_lat=;dc_rdid=;tag_for_child_directed_treatment=?',
  CLICK: 'https://ad.doubleclick.net/ddm/trackclk/N1881.206593290MIN/B20215410.203384788;dc_trk_aid=403216671;dc_trk_cid=91973336;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
};

function loadMoreTournaments() {
  return function (dispatch, getState) {
    return dispatch({
      type: TOURNAMENT.LOAD_MORE
    });
  };
}

function dispatchGetTournamentsFeed(dispatch, tournaments) {
  dispatch({
    type: TOURNAMENT.GET_TOURNAMENTS_FEED,
    state: {
      tournaments: tournaments,
      isInitialized: true
    }
  });
  (0, _dom.makeImage)({ src: TOURNAMENTS_TRACKING_URLS.PAGE_VIEW });
}

function getTournamentsFeed() {
  if (!(0, _pageDataObject.getCampaigns)() || !(0, _pageDataObject.getCampaigns)().yahoo_fantasy) {
    return (0, _console.warn)("[YAHOO_FANTASY] can't find yahoo fantasy campaign url", (0, _pageDataObject.getCampaigns)());
  }
  var tournamentsUrlToFetch = mockFantasyTournaments ? TOURNAMENTS_MOCK_URL : (0, _pageDataObject.getCampaigns)().yahoo_fantasy.tournaments;
  if (mockFantasyTournaments) {
    (0, _console.info)('[YAHOO_FANTASY] Fetching mock!');
  }
  if (debugFantasyTournaments) {
    (0, _console.info)('[YAHOO_FANTASY] Fetching tournaments from \'' + tournamentsUrlToFetch + '\'');
  }
  return function (dispatch, getState) {
    return (0, _fetch.getJsonOrError)(tournamentsUrlToFetch).then(_fantasyTournamentTransformer.transformFantasyTournaments).then(dispatchGetTournamentsFeed.bind(0, dispatch)).catch(_console.warn);
  };
}

function trackTournamentsClick() {
  return (0, _dom.makeImage)({ src: TOURNAMENTS_TRACKING_URLS.CLICK });
}

function selectTournament() {
  trackTournamentsClick();
  return function (dispatch, getState) {
    return dispatch({
      type: TOURNAMENT.SELECT_TOURNAMENT
    });
  };
}

var fantasyActions = exports.fantasyActions = {
  loadMoreTournaments: loadMoreTournaments,
  getTournamentsFeed: getTournamentsFeed,
  selectTournament: selectTournament
};

/***/ }),

/***/ 626:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(64);

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = __webpack_require__(14);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.default = mountFantasyComponent;

var _reactRedux = __webpack_require__(37);

var _redux = __webpack_require__(174);

var _reduxMounter = __webpack_require__(45);

var _reduxMounter2 = _interopRequireDefault(_reduxMounter);

var _window = __webpack_require__(8);

var _console = __webpack_require__(11);

var _fantasyReducer = __webpack_require__(629);

var _fantasyActions = __webpack_require__(625);

var _fantasyMounterConfig = __webpack_require__(627);

var _campaignConfig = __webpack_require__(206);

var _fantasyComponent = __webpack_require__(621);

var _fantasyComponent2 = _interopRequireDefault(_fantasyComponent);

var _preRenderedSelectorsConfig = __webpack_require__(17);

var _fantasyNodeInjector = __webpack_require__(628);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint semi:0 */
var YAHOO_FANTASY_MOUNT_POINT = _preRenderedSelectorsConfig.MOUNT_POINTS.YAHOO_FANTASY_MOUNT_POINT;

var COMPONENT_NAME = 'FantasyContainer';
var STATE_KEY = 'fantasy';
var IS_YAHOO_FANTASY_ENABLED = false;
var forceFantasy = _window.queryString.forceFantasy;


function mapStateToProps(state) {
  var _state$STATE_KEY = state[STATE_KEY],
      isInitialized = _state$STATE_KEY.isInitialized,
      tournaments = _state$STATE_KEY.tournaments,
      numVisibleTournaments = _state$STATE_KEY.numVisibleTournaments,
      isLoadMoreVisible = _state$STATE_KEY.isLoadMoreVisible;

  return {
    isInitialized: isInitialized,
    tournaments: tournaments,
    numVisibleTournaments: numVisibleTournaments,
    isLoadMoreVisible: isLoadMoreVisible
  };
}

var FantasyContainer = {
  name: COMPONENT_NAME,
  stateKey: STATE_KEY,
  component: (0, _reactRedux.connect)(mapStateToProps, _fantasyActions.fantasyActions)(_fantasyComponent2.default),
  reducer: _fantasyReducer.fantasyReducer
};

function injectAndMount() {
  (0, _fantasyNodeInjector.injectFantasyInsideArticle)();
  (0, _reduxMounter2.default)((0, _defineProperty3.default)({}, YAHOO_FANTASY_MOUNT_POINT, FantasyContainer));
}

function injectAndMountFantasyIfEnabled(_ref) {
  var isFantasyCampaignEnabled = _ref.isCampaignEnabled;

  if (isFantasyCampaignEnabled) {
    injectAndMount();
  }
}

function mountFantasyComponent() {
  if (forceFantasy) {
    (0, _console.info)('[YAHOO_FANTASY] forcing mount', _fantasyMounterConfig.fantasyConfig);
    return _promise2.default.resolve(injectAndMount());
  }
  return IS_YAHOO_FANTASY_ENABLED && (0, _campaignConfig.isCampaignEnabled)(_fantasyMounterConfig.fantasyConfig).then(injectAndMountFantasyIfEnabled).catch(_console.warn);
}

/***/ }),

/***/ 627:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint semi:0 */
var fantasyConfig = exports.fantasyConfig = {
  whiteListCountryCodes: ['gb'],
  pageTypes: ['post'],
  locales: ['en'],
  isEmbedded: false,
  daysWhiteList: [1, 5],
  isTopX: false,
  isSlideshow: false,
  featureId: 'Fantasy',
  blacklistedCategories: ['sponsored']
};

/***/ }),

/***/ 628:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _from = __webpack_require__(49);

var _from2 = _interopRequireDefault(_from);

exports.injectFantasyInsideArticle = injectFantasyInsideArticle;

var _preRenderedSelectorsConfig = __webpack_require__(17);

var _dom = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var POST_CONTENT_SELECTOR = _preRenderedSelectorsConfig.SELECTORS.POST_CONTENT_SELECTOR;

var INJECTION_CONF = {
  INSERT_AFTER_ELEMENTS_COUNT: 2,
  ELEMENTS_TO_COUNT_TAGNAME: 'p',
  CLASS_NAME: _preRenderedSelectorsConfig.MOUNT_POINTS.YAHOO_FANTASY_MOUNT_POINT.slice(1),
  TAG_NAME: 'div'
};

function filterRelevantParagraphs(CONTENT_NODE_SELECTOR, elementsTagName) {
  var contentNode = (0, _dom.node)(CONTENT_NODE_SELECTOR);
  if (!contentNode) {
    return null;
  }
  return (0, _from2.default)(contentNode.children).filter(function (element) {
    var doesElementMatch = element.matches ? element.matches(elementsTagName) : element.tagName.toLowerCase() === elementsTagName;
    return doesElementMatch && element.innerText && element.children.length === 0;
  });
}

function injectFantasyInsideArticle() {
  var TAG_NAME = INJECTION_CONF.TAG_NAME,
      CLASS_NAME = INJECTION_CONF.CLASS_NAME,
      ELEMENTS_TO_COUNT_TAGNAME = INJECTION_CONF.ELEMENTS_TO_COUNT_TAGNAME,
      INSERT_AFTER_ELEMENTS_COUNT = INJECTION_CONF.INSERT_AFTER_ELEMENTS_COUNT;

  var injectedEl = (0, _dom.createElement)(TAG_NAME);
  (0, _dom.classList)(injectedEl).add(CLASS_NAME);
  var paragraphs = filterRelevantParagraphs(POST_CONTENT_SELECTOR, ELEMENTS_TO_COUNT_TAGNAME);
  if (paragraphs && paragraphs.length > INSERT_AFTER_ELEMENTS_COUNT) {
    return (0, _dom.addElementAfter)(injectedEl, paragraphs[INSERT_AFTER_ELEMENTS_COUNT - 1]);
  }
  (0, _dom.node)(POST_CONTENT_SELECTOR).appendChild(injectedEl);
}

/***/ }),

/***/ 629:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

exports.fantasyReducer = fantasyReducer;

var _fantasyActionTypes = __webpack_require__(108);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TOURNAMENT = _fantasyActionTypes.FANTASY_ACTION_TYPES.TOURNAMENT;

var NUM_TOURNAMENTS_INC = 2;
var INITIAL_NUM_TOURNAMENTS_VISIBLE = 2;
var DEFAULT_STATE = {
  isInitialized: false,
  isLoadMoreVisible: true,
  numVisibleTournaments: INITIAL_NUM_TOURNAMENTS_VISIBLE
};

function incVisibleFeedSize(state, newState) {
  var numTotalTournaments = state.tournaments.length;
  var numVisibleTournaments = state.numVisibleTournaments + NUM_TOURNAMENTS_INC;
  var isLoadMoreVisible = numVisibleTournaments < numTotalTournaments;
  return (0, _extends3.default)({}, state, newState, { numVisibleTournaments: numVisibleTournaments, isLoadMoreVisible: isLoadMoreVisible });
}

function reduceGetTournamentsFeed(state, newState) {
  var isLoadMoreVisible = state.numVisibleTournaments < newState.tournaments.length;
  return (0, _extends3.default)({}, state, newState, { isLoadMoreVisible: isLoadMoreVisible });
}

function fantasyReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
  var action = arguments[1];

  switch (action.type) {
    case TOURNAMENT.GET_TOURNAMENTS_FEED:
      return reduceGetTournamentsFeed(state, action.state);
    case TOURNAMENT.LOAD_MORE:
      return incVisibleFeedSize(state, action.state);
    default:
      return state;
  }
}

/***/ }),

/***/ 639:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.injectFixtureWidget = injectFixtureWidget;

var _campaignConfig = __webpack_require__(206);

var _viewbilityTracker = __webpack_require__(99);

var _useridentifierTracker = __webpack_require__(136);

var _pageDataObject = __webpack_require__(5);

var experimentId = parseInt((0, _useridentifierTracker.trackUserIdentifier)());

var fixtureFirstTest = 'https://cdn.deep.it/article/embed.js?containerId=deep&widgetTypes=TeamFixtures&widgetParams=WIDGET_VERSION%3DV1%26LANGUAGE_CODE%3D' + (0, _pageDataObject.getPageLocale)();
var fixtureSecondTest = 'https://cdn.deep.it/article/embed.js?containerId=deep&widgetTypes=TeamFixtures&widgetParams=WIDGET_VERSION%3DV2%26LANGUAGE_CODE%3D' + (0, _pageDataObject.getPageLocale)();

function getABTestExperimentValue(minRangeExperimentA, maxRangeExperimentA, minRangeExperimentB, maxRangeExperimentB, experimentA, experimentB) {
  if (minRangeExperimentA <= experimentId && maxRangeExperimentA >= experimentId) {
    return experimentA;
  }
  if (minRangeExperimentB <= experimentId && maxRangeExperimentB >= experimentId) {
    return experimentB;
  }
  return null;
}

var DEEP_FIXTURE_WIDGET = {
  pageTypes: ['post'],
  isEmbedded: false,
  daysWhiteList: [0, 1, 2, 3, 4, 5, 6],
  isSlideshow: false,
  blacklistedCategories: ['sponsored'],
  placeHolder: 'deepFixtureWidgetPlaceHolder',
  id: 'deep',
  src: getABTestExperimentValue(1, 50, 51, 100, fixtureFirstTest, fixtureSecondTest),
  name: 'deep_fixture',
  site: '90min',
  locales: ['it'],
  position: 2
};

var campaigns = [DEEP_FIXTURE_WIDGET];

function addPlaceHolder(campaign) {
  var placeHolder = document.querySelectorAll('.post-content > p')[campaign.position];
  if (placeHolder !== undefined && placeHolder !== null) {
    placeHolder.insertAdjacentHTML('beforeend', '<div class=' + campaign.placeHolder + ' id=' + campaign.id + ' style="margin-top:24px;margin-bottom:24px" ></div>');
  }
}

function injectScript(campaign) {
  var script = document.createElement('script');
  script.src = campaign.src;
  script.async = true;
  document.head.appendChild(script);
}

function injectFixtureWidget() {
  campaigns.forEach(function (campaign) {
    (0, _campaignConfig.isCampaignEnabled)(campaign).then(function (response) {
      if (response.isCampaignEnabled) {
        addPlaceHolder(campaign);
        injectScript(campaign);
        (0, _viewbilityTracker.register)('.' + campaign.placeHolder);
      }
    });
  });
}

/***/ }),

/***/ 640:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(33);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.injectFreshEight = injectFreshEight;

var _campaignConfig = __webpack_require__(206);

var _viewbilityTracker = __webpack_require__(99);

var _useridentifierTracker = __webpack_require__(136);

var _pageDataObject = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var experimentId = Math.floor(Math.random() * 100);

//iframe version
// const triviaFirstTest = `https://create.playgorithm.com/js/init.js?containerId=playgorithm-unit-678&token=eyJzaXRlSWQiOjE5MCwiZW1iZWRJZCI6Njc4LCJ0b2tlbiI6IiQyeSQxMCR1US5LYVQ2SmZRWWNFTVFCeTJBVW9lWVlwLjR6cFpiaTl6RzdBRjlTS3ZOYWhGVmxVY3ouTyIsInRpbWVzdGFtcCI6MTU1MDQwNjM3M30=&origin=https://frontend.playgorithm.net&customComp=MinuteMedia&className=mm-playgorithm-unit&gtagId=UA-23669758-21&partner=90min_test&uniqkey=playgorithem-monti-id&configName=playgorithem-90min&playlistId=5RhMfyF1&mobileHeight=360px&desktopHeight=460px&shine=1`
// const fotmobTriviaTest = `https://create.playgorithm.com/js/init.js?containerId=playgorithm-unit-678&token=eyJzaXRlSWQiOjE5MCwiZW1iZWRJZCI6Njc4LCJ0b2tlbiI6IiQyeSQxMCR1US5LYVQ2SmZRWWNFTVFCeTJBVW9lWVlwLjR6cFpiaTl6RzdBRjlTS3ZOYWhGVmxVY3ouTyIsInRpbWVzdGFtcCI6MTU1MDQwNjM3M30=&origin=https://frontend.playgorithm.net&lang=${getPageLocale()}&customComp=MinuteMedia&className=mm-playgorithm-unit&gtagId=UA-23669758-21&partner=fotmob&uniqkey=playgorithem-monti-id&configName=playgorithem-fotmob&playlistId=5RhMfyF1&shine=1&mobileHeight=360px&desktopHeight=460px&shine=1`
// const footballAddictTrivia = `https://create.playgorithm.com/js/init.js?containerId=playgorithm-unit-678&token=eyJzaXRlSWQiOjE5MCwiZW1iZWRJZCI6Njc4LCJ0b2tlbiI6IiQyeSQxMCR1US5LYVQ2SmZRWWNFTVFCeTJBVW9lWVlwLjR6cFpiaTl6RzdBRjlTS3ZOYWhGVmxVY3ouTyIsInRpbWVzdGFtcCI6MTU1MDQwNjM3M30=&origin=https://frontend.playgorithm.net&lang=fr&customComp=MinuteMedia&className=mm-playgorithm-unit&gtagId=UA-23669758-21&partner=football_addict&uniqkey=playgorithem-monti-id&configName=playgorithem-football_addict&playlistId=5RhMfyF1&shine=1&&mobileHeight=360px&desktopHeight=460px&videoUnitPath=/175840252/MMPlus/footballaddict/triviawidget/video`

//html version
var triviaSemantic90Min = 'https://client.playgorithm.com/latest?containerId=playgorithm-unit-1190&token=eyJzaXRlSWQiOjE5MCwiZW1iZWRJZCI6MTE5MCwidG9rZW4iOiIkMnkkMTAkRlUuMHVGdDN2OHJBVWFcLzc2OXpCTk9nVTJ1QXZZUWNjV2JObU41dFJseWFWQ3liTXNXcFJtIiwidGltZXN0YW1wIjoxNTYxMDM3OTUxfQ==&lang=en&renderMode=html&className=mm-playgorithm-unit&customComp=MinuteMedia&bannerUnitPath=/175840252/90-min/TriviaWidget/Article/300x250&collections=466,1379,465,501,1345,1346&partner=90min&semantic=1&gtagId=UA-23669758-21';

var triviaFirstTest = 'https://client.playgorithm.com/latest?containerId=playgorithm-unit-951&token=eyJzaXRlSWQiOjE5MCwiZW1iZWRJZCI6OTUxLCJ0b2tlbiI6IiQyeSQxMCQ2Q21PSy5WcDhnVzNOSlNKbE9RbExlckZmWEpCTXVRU1V0NHFEVGUxVjVcL1NkZkJtVE14ZlMiLCJ0aW1lc3RhbXAiOjE1NTYwMjQ4ODB9&customComp=MinuteMedia&className=mm-playgorithm-unit&gtagId=UA-23669758-21&partner=90min&uniqkey=playgorithem-monti-id&configName=playgorithem-90min&playlistId=5RhMfyF1&inShadow=0&bannerUnitPath=/175840252/90-min/TriviaWidget/Article/300x250&renderMode=html';
var triviaSemanticFotmob = 'https://client.playgorithm.com/latest?containerId=playgorithm-unit-1190&token=eyJzaXRlSWQiOjE5MCwiZW1iZWRJZCI6MTE5MCwidG9rZW4iOiIkMnkkMTAkRlUuMHVGdDN2OHJBVWFcLzc2OXpCTk9nVTJ1QXZZUWNjV2JObU41dFJseWFWQ3liTXNXcFJtIiwidGltZXN0YW1wIjoxNTYxMDM3OTUxfQ==&lang=' + (0, _pageDataObject.getPageLocale)() + '&renderMode=html&className=mm-playgorithm-unit&customComp=MinuteMedia&bannerUnitPath=/175840252/mmplus/fotmob/widgets/Trivia/Between&collections=466,1379,465,501,1345,1346&partner=fotmob&semantic=1&gtagId=UA-23669758-21&shouldRenderAdBetweenQuestions=2,4,6';

var triviaSemanticscore365_en = 'https://client.playgorithm.com/latest?containerId=playgorithm-unit-1190&token=eyJzaXRlSWQiOjE5MCwiZW1iZWRJZCI6MTE5MCwidG9rZW4iOiIkMnkkMTAkRlUuMHVGdDN2OHJBVWFcLzc2OXpCTk9nVTJ1QXZZUWNjV2JObU41dFJseWFWQ3liTXNXcFJtIiwidGltZXN0YW1wIjoxNTYxMDM3OTUxfQ==&lang=en&renderMode=html&className=mm-playgorithm-unit&customComp=MinuteMedia&collections=466,1379,465,501,1345,1346&partner=score365&semantic=1&gtagId=UA-23669758-21&bannerUnitPath=/175840252/mmplus/score365/widgets/Trivia/Between&displayAdAbove=1&displayAdBelow=1&shouldRenderAdBetweenQuestions=2,4,6,8';
var triviaSemanticscore365_pt = 'https://client.playgorithm.com/latest?containerId=playgorithm-unit-1190&token=eyJzaXRlSWQiOjE5MCwiZW1iZWRJZCI6MTE5MCwidG9rZW4iOiIkMnkkMTAkRlUuMHVGdDN2OHJBVWFcLzc2OXpCTk9nVTJ1QXZZUWNjV2JObU41dFJseWFWQ3liTXNXcFJtIiwidGltZXN0YW1wIjoxNTYxMDM3OTUxfQ==&lang=pt-br&renderMode=html&className=mm-playgorithm-unit&customComp=MinuteMedia&collections=1727,1728,1729,1730&partner=score365&semantic=1&gtagId=UA-23669758-21&bannerUnitPath=/175840252/mmplus/score365/widgets/Trivia/Between&displayAdAbove=1&shouldRenderAdBetweenQuestions=2,4,6,8';
var triviaSemanticscore365_es = 'https://client.playgorithm.com/latest?containerId=playgorithm-unit-1190&token=eyJzaXRlSWQiOjE5MCwiZW1iZWRJZCI6MTE5MCwidG9rZW4iOiIkMnkkMTAkRlUuMHVGdDN2OHJBVWFcLzc2OXpCTk9nVTJ1QXZZUWNjV2JObU41dFJseWFWQ3liTXNXcFJtIiwidGltZXN0YW1wIjoxNTYxMDM3OTUxfQ==&lang=es&renderMode=html&className=mm-playgorithm-unit&customComp=MinuteMedia&collections=765,571&partner=score365&semantic=1&gtagId=UA-23669758-21&bannerUnitPath=/175840252/mmplus/score365/widgets/Trivia/Between&displayAdAbove=1&shouldRenderAdBetweenQuestions=2,4,6,8';

var fotmobTriviaTest = 'https://client.playgorithm.com/latest?containerId=playgorithm-unit-951&token=eyJzaXRlSWQiOjE5MCwiZW1iZWRJZCI6OTUxLCJ0b2tlbiI6IiQyeSQxMCQ2Q21PSy5WcDhnVzNOSlNKbE9RbExlckZmWEpCTXVRU1V0NHFEVGUxVjVcL1NkZkJtVE14ZlMiLCJ0aW1lc3RhbXAiOjE1NTYwMjQ4ODB9&lang=' + (0, _pageDataObject.getPageLocale)() + '&customComp=MinuteMedia&className=mm-playgorithm-unit&gtagId=UA-23669758-21&partner=fotmob&uniqkey=playgorithem-monti-id&configName=playgorithem-fotmob&playlistId=5RhMfyF1&inShadow=0&bannerUnitPath=/175840252/MMPlus/Fotmob/TriviaWidget/300x250&renderMode=html';
var footballAddictTrivia = 'https://client.playgorithm.com/latest?containerId=playgorithm-unit-951&token=eyJzaXRlSWQiOjE5MCwiZW1iZWRJZCI6OTUxLCJ0b2tlbiI6IiQyeSQxMCQ2Q21PSy5WcDhnVzNOSlNKbE9RbExlckZmWEpCTXVRU1V0NHFEVGUxVjVcL1NkZkJtVE14ZlMiLCJ0aW1lc3RhbXAiOjE1NTYwMjQ4ODB9&lang=fr&customComp=MinuteMedia&className=mm-playgorithm-unit&gtagId=UA-23669758-21&partner=football_addict&uniqkey=playgorithem-monti-id&configName=playgorithem-football_addict&playlistId=5RhMfyF1&videoUnitPath=/175840252/MMPlus/footballaddict/triviawidget/video';

var triviaGermanSite = 'https://create.playgorithm.com/js/init.js?containerId=playgorithm-unit-693&token=eyJzaXRlSWQiOjE5MCwiZW1iZWRJZCI6NjkzLCJ0b2tlbiI6IiQyeSQxMCRFcW1cL25mck9aWFZnMzBjWTVzTjI5TzVhSC50OC56cEdielZYXC9udWN2MXptTG5JTkc4NWouIiwidGltZXN0YW1wIjoxNTUwNTA0NTMwfQ==&origin=https://frontend.playgorithm.net&lang=de&customComp=MinuteMedia&className=mm-playgorithm-unit&gtagId=UA-23669758-21&partner=90min_de&uniqkey=playgorithem-monti-id&configName=playgorithem-90min_d2&playlistId=5RhMfyF1&userIdentifier=' + experimentId + '&position=2&shine=1&shouldLoadVideo=1&mobileHeight=360px&desktopHeight=460px&bannerUnitPath=/175840252/90min.de/triviawidget/article/300x250';

var snapStories = 'https://firebasestorage.googleapis.com/v0/b/snappd-6be54.appspot.com/o/widget%2Farchive-widget%2FGaDALxOKnfgvLOo4zB7BLgcLpxC3.js?alt=media&token=snappd-widget-cloud-new&partner=90min';
// 'https://firebasestorage.googleapis.com/v0/b/snappd-6be54.appspot.com/o/widget%2Farchive-widget%2FGaDALxOKnfgvLOo4zB7BLgcLpxC3.js?alt=media&token=snappd-widget-cloud-new&partner=90min'
var triviaFloor8 = 'https://create.playgorithm.com/js/init.js?containerId=playgorithm-unit-869&token=eyJzaXRlSWQiOjE5MCwiZW1iZWRJZCI6ODY5LCJ0b2tlbiI6IiQyeSQxMCRuSDA5S3l1em9tZE9nVVlrclpsTnRlUTdCU1lLMWpjdU5iTjltTmw1RnB4aldOekNQTnY1MiIsInRpbWVzdGFtcCI6MTU1MzEwNzIzOX0=&origin=https://frontend.playgorithm.net&customComp=MinuteMedia&className=mm-playgorithm-unit&gtagId=UA-23669758-21&partner=floor8_test&uniqkey=playgorithem-monti-id&configName=playgorithem-floor8&playlistId=5RhMfyF1&userIdentifier=' + experimentId + '&position=2&shouldLoadVideo=1&&mobileHeight=360px&desktopHeight=460px&shine=1';

var deepHeadToHeadFotmob = 'https://cdn.deep.it/article/embed.js?containerId=deepHeadToHead&widgetTypes=Quiz&domain=Soccer&wp_customer=90min&wp_partner=fotmob&wp_adUnit=/175840252/mmplus/fotmob/widgets/Head2Head/Between&wp_displayFrequency=4,7';

var deepHeadToHeadFotmobStartScreen = 'https://cdn.deep.it/article/embed.js?containerId=deepHeadToHead&widgetTypes=Quiz&widgetParams=PARTNER%3Dfotmob%26configName%3DheadToHead-fotmob%26autoStart%3Dtrue';

var deepHeadToHead90min = 'https://cdn.deep.it/article/embed.js?containerId=deepHeadToHead&widgetTypes=Quiz&domain=Soccer&wp_customer=90min&wp_partner=fotmob&wp_adUnit=/175840252/90min.com/widgets/Head2Head/Betweenn&wp_displayFrequency=4,7';

var deepHeadToHead90minFr = 'https://cdn.deep.it/article/embed.js?containerId=deepHeadToHead&widgetTypes=Quiz&languageCode=fr&widgetParams=PARTNER%3D90min%26configName%3DheadToHead-fotmob';

var deepHeadToHead12upMlb = 'https://cdn.deep.it/article/embed.js?containerId=deepHeadToHead&widgetTypes=Quiz&domain=Baseball&widgetParams=PARTNER%3D12up';

var deepHeadToHead90minStartScreen = 'https://cdn.deep.it/article/embed.js?containerId=deepHeadToHead&widgetTypes=Quiz&autoStart=truewidgetParams=PARTNER%3D90min%26configName%3DheadToHead-fotmob%26autoStart%3Dtrue';

var deepHeadToHeadStatic = 'https://cdn.deep.it/script-embed/all.js?type=SoccerQuiz&containerId=deepHeadToHead&cache=true&query=89260180-7181-11e9-a8df-e724252272e2&languageCode=en&customer=90min&partner=90min';

var deepHeadToHead = 'https://cdn.deep.it/article/embed.js?containerId=deepHeadToHead&widgetTypes=Quiz&widgetParams=PARTNER%3D90min';

var deepHeadToHeadFloor8 = 'https://cdn.deep.it/script-embed/all.js?type=SoccerQuiz&containerId=deepHeadToHead&cache=true&query=1&languageCode=en&customer=floor8&partner=floor8&widgetParams=PARTNER%3Dfloor8';

var trinityNewDesign = 'https://trinitymedia.ai/sas/player/trinity.php?sCampaignID=1604966975&language=' + (0, _pageDataObject.getPageLocale)() + '&partner=90min&gaAccountId=UA-23669758-21&abtest=90minorange&FAB=t';
var trinity90minfr = 'https://trinitymedia.ai/sas/player/trinity.php?sCampaignID=1604966975&language=fr&partner=90min&gaAccountId=UA-23669758-21&abtest=French&FAB=t&loaderText=Nous%20chargeons%20votre%20contenu';
var trinity90mines = 'https://trinitymedia.ai/sas/player/trinity.php?sCampaignID=1604966975&language=es&partner=90min&gaAccountId=UA-23669758-21&abtest=Spanish&FAB=t&loaderText=Estamos%20cargando%20tu%20contenido';

var preMtachFr = 'https://client.playgorithm.com/latest?renderMode=html&containerId=playgorithm-unit-1382&token=eyJzaXRlSWQiOjE5MCwiZW1iZWRJZCI6MTM4MiwidG9rZW4iOiIkMnkkMTAkQ01iNjR5ZFlNR0JOLjhpbC5Nd3ZodWZ5djk2amE4MHVKcUNDOExWVjRUUDAuVVExUll5Ny4iLCJ0aW1lc3RhbXAiOjE1NjgxMDcxMzZ9&lang=fr&className=mm-playgorithm-unit&customComp=MinuteMedia&partner=90min_fr&bannerUnitPath=/175840252/90-min/Playgorithm/PreMatchWidget/MultiSize&gtagId=UA-23669758-21&bannerAfterEveryIndex=2';
var isParagraphArray = [];

var FACTS_CAMPAIGNS = {
  en: 'https://facts-generator.mmwidgets.com/facts/lla-lorona/',
  es: 'https://facts-generator.mmwidgets.com/facts/lla-lorona-es/',
  'pt-BR': 'https://facts-generator.mmwidgets.com/facts/lla-lorona-pt/',
  it: 'https://facts-generator.mmwidgets.com/facts/lla-lorona-it/',
  tr: 'https://facts-generator.mmwidgets.com/facts/lla-lorona-2-tr/'
};

var MOTW_CAMPAIGNS = {
  en: 'https://movers-of-the-week.mmwidgets.com/motw/week-1/'
};

function getABTestExperimentValue(minRangeExperimentA, maxRangeExperimentA, minRangeExperimentB, maxRangeExperimentB, experimentA, experimentB) {
  if (minRangeExperimentA <= experimentId && maxRangeExperimentA >= experimentId) {
    return experimentA;
  }
  if (minRangeExperimentB <= experimentId && maxRangeExperimentB >= experimentId) {
    return experimentB;
  }
  return null;
}

function isBoldTitle(node) {
  return node.match('<strong>.+<\\/strong>') !== null;
}

function isParagraph(node) {
  return node.innerText !== '' && node.innerHTML !== '<span style="font-size: 1em;"><br></span>' && node.innerHTML !== '<strong><br></strong>' && !isBoldTitle(node.innerHTML) && node.innerHTML !== '&nbsp;';
}

function setParagraphMap() {
  var postItems = [].concat((0, _toConsumableArray3.default)(document.querySelectorAll('.post-content > *')));
  isParagraphArray = postItems.map(function (x, index) {
    return isParagraph(x);
  });
}

setParagraphMap();

function getStartPoint() {
  return parseInt(isParagraphArray.length / 2 - 1);
}

function isPositionValidForCampaign(index) {
  return isParagraphArray[index] && isParagraphArray[index + 1];
}

function findPositionToInjectCampaign() {
  if (isParagraphArray.length < 6) return -1;
  for (var i = getStartPoint(); i < isParagraphArray.length - 2; i++) {
    if (isPositionValidForCampaign(i)) {
      return i;
    }
  }
  return -1;
}

function shouldLoadWidgetByRequest(param) {
  return window.location.search.includes(param);
}

var ios = function ios() {
  return navigator.userAgent.indexOf('like Mac') !== -1;
};

var safari = function safari() {
  return navigator.userAgent.indexOf('AppleWebKit') !== -1;
};

var iosAndSafari = function iosAndSafari() {
  return ios() && safari();
};

var isIosInAppBrowser = function isIosInAppBrowser() {
  return iosAndSafari() && navigator.userAgent.indexOf('Safari') === -1;
};

function shouldLoadVideoInNativeApp() {
  return window.location.search.includes('app=1&ref=Android') ? 1 : 0;
}

function findEndOfArticle() {
  return document.querySelectorAll('.post-content > *').length;
}

function getLongScrollScript() {
  return window.location.search.includes('app=1&ref=Android') ? 'https://bucket1.mm-syringe.com/prod/configs/widget-90min-transfers-longscroll.js' : 'https://bucket1.mm-syringe.com/prod/configs/widget-90min-transfers-longscroll-no-video.js';
}

var PLAYGORITHM_90_MIN = {
  pageTypes: ['post'],
  isEmbedded: false,
  daysWhiteList: [0, 1, 2, 3, 4, 5, 6],
  isSlideshow: false,
  featureId: 'Fresh8',
  blacklistedCategories: ['sponsored', 'no-campaign-manager'],
  placeHolder: 'playgorithmPlaceHolder',
  name: 'playgorithm-unit-1190',
  id: 'playgorithm-unit-1190',
  position: findPositionToInjectCampaign(),
  listPosition: 2,
  src: triviaSemantic90Min,
  embedPartners: ['app=1'],
  blacklistedPosts: [6427004],
  locales: ['en'],
  site: '90min',
  injectPosition: 'afterEnd',
  shouldRenderVideoStick: shouldLoadVideoInNativeApp(),
  shouldAddDataAttrToScriptTag: false,
  videoConfig: 'https://www.oo-syringe.com/prod/configs/fc985619-cf42-9fa3-3133-4132653b9f51.js',
  isSponsoredPost: false,
  videoWrraperMargin: '-8px',
  videoWrraperMaxWidth: '600px',
  shouldLoadSyringe: false,
  isAmondo: false
};

var PLAYGORITHM_PRE_MATCH_90_MIN_FR = {
  pageTypes: ['post'],
  isEmbedded: false,
  daysWhiteList: [0, 1, 2, 3, 4, 5, 6],
  isSlideshow: false,
  featureId: 'Fresh8',
  blacklistedCategories: ['sponsored', 'no-campaign-manager'],
  placeHolder: 'playgorithmPlaceHolder',
  name: 'playgorithm-unit-1382',
  id: 'playgorithm-unit-1382',
  position: findPositionToInjectCampaign(),
  listPosition: 2,
  src: preMtachFr,
  blacklistedPosts: [6427004],
  locales: ['fr'],
  site: '90min',
  injectPosition: 'afterEnd',
  shouldRenderVideoStick: false,
  shouldAddDataAttrToScriptTag: false,
  videoConfig: 'https://www.oo-syringe.com/prod/configs/fc985619-cf42-9fa3-3133-4132653b9f51.js',
  isSponsoredPost: false,
  videoWrraperMargin: '-8px',
  videoWrraperMaxWidth: '600px',
  shouldLoadSyringe: false,
  whiteListCountryCodes: ['IL', 'FR'],
  isAmondo: false
};

var PLAYGORITHM_90_MIN_APP_LONGSCROLL_TRANSFERS = {
  pageTypes: ['post'],
  isEmbedded: false,
  daysWhiteList: [0, 1, 2, 3, 4, 5, 6],
  isSlideshow: false,
  featureId: 'Fresh8',
  blacklistedCategories: ['sponsored', 'no-campaign-manager'],
  placeHolder: 'playgorithmPlaceHolder',
  name: 'longScroll',
  id: 'mmWidget',
  position: findEndOfArticle(),
  listPosition: 2,
  src: getLongScrollScript(),
  embedPartners: ['app=1'],
  whitelistedPosts: [6427004],
  locales: ['en'],
  site: '90min',
  injectPosition: 'afterEnd',
  shouldRenderVideoStick: false,
  shouldAddDataAttrToScriptTag: false,
  isSponsoredPost: false,
  // videoWrraperMargin: '-8px',
  // videoWrraperMaxWidth: '600px',
  shouldLoadSyringe: true,
  isAmondo: false
};

var FACTS_90_MIN = {
  pageTypes: ['post'],
  isEmbedded: false,
  daysWhiteList: [0, 1, 2, 3, 4, 5, 6],
  isSlideshow: false,
  featureId: 'Fresh8',
  placeHolder: 'facts-size',
  id: 'facts',
  position: 0,
  listPosition: 2,
  src: triviaFirstTest,
  whitelistedPosts: [6341777, 6341785, 6341791, 6341792, 6341794],
  locales: ['en', 'es', 'pt-BR', 'it', 'tr'],
  site: '90min',
  injectPosition: 'beforeBegin',
  shouldRenderVideoStick: false,
  isSponsoredPost: true,
  shouldLoadSyringe: false,
  isAmondo: false
};

var MOTW_90_MIN = {
  pageTypes: ['post'],
  isEmbedded: false,
  daysWhiteList: [0, 1, 2, 3, 4, 5, 6],
  isSlideshow: false,
  featureId: 'Fresh8',
  placeHolder: 'motw-size',
  id: 'motw',
  position: 0,
  listPosition: 2,
  src: triviaFirstTest,
  whitelistedPosts: [6353539],
  locales: ['en'],
  site: '90min',
  injectPosition: 'beforeBegin',
  shouldRenderVideoStick: false,
  isSponsoredPost: true,
  shouldLoadSyringe: false,
  isAmondo: false
};

var FRESH_EIGHT_UK = {
  pageTypes: ['post'],
  isEmbedded: false,
  daysWhiteList: [0, 1, 2, 3, 4, 5, 6],
  isSlideshow: false,
  featureId: 'Fresh8',
  placeHolder: 'fresheight-wrraper',
  id: 'fresh8',
  blacklistedPosts: [4861576, 6523228],
  position: findPositionToInjectCampaign(),
  whiteListCountryCodes: ['GB', 'IL'],
  listPosition: 2,
  src: 'https://fresh8.co/5df11cf004dd710019217dca/adtag?isAdTag=true',
  locales: ['en'],
  site: '90min',
  injectPosition: 'afterEnd',
  shouldRenderVideoStick: false,
  isFreshEight: true,
  shouldLoadSyringe: false,
  isAmondo: false
};

var PLAYGORITHM_FOTMOB_EN = {
  pageTypes: ['post'],
  isEmbedded: true,
  daysWhiteList: [0, 1, 2, 3, 4, 5, 6],
  isSlideshow: false,
  featureId: 'Fresh8',
  placeHolder: 'playgorithmPlaceHolder',
  name: 'playgorithm-unit-1190',
  id: 'playgorithm-unit-1190',
  src: triviaSemanticFotmob,
  embedPartners: ['utm_source=fotmob&utm_medium=api'],
  excludeByUrl: ['noAds'],
  position: findPositionToInjectCampaign(),
  listPosition: 2,
  locales: ['en'],
  site: '90min',
  injectPosition: 'afterEnd',
  shouldRenderVideoStick: false,
  shouldAddDataAttrToScriptTag: false,
  videoConfig: 'https://bucket1.mm-syringe.com/prod/configs/dca22f49-7426-c4e3-c13a-6eadd2c378bf.js',
  isSponsoredPost: false,
  videoWrraperMargin: '-8px',
  videoWrraperMaxWidth: '600px',
  shouldLoadSyringe: false,
  isAmondo: false
};

var HEAD_TO_HEAD_FOTMOB_EN = {
  pageTypes: ['post'],
  isEmbedded: true,
  daysWhiteList: [0, 1, 2, 3, 4, 5, 6],
  isSlideshow: false,
  featureId: 'Fresh8',
  blacklistedCategories: ['sponsored'],
  placeHolder: 'deepHeadTOHeadPlaceHolder',
  id: 'deepHeadToHead',
  position: findPositionToInjectCampaign(),
  listPosition: 2,
  src: deepHeadToHeadFotmob,
  embedPartners: ['utm_source=fotmob&utm_medium=api'],
  locales: ['en'],
  site: '90min',
  name: 'deep_head_to_head',
  injectPosition: 'afterEnd',
  shouldRenderVideoStick: false,
  shouldAddDataAttrToScriptTag: false,
  videoConfig: 'https://bucket1.mm-syringe.com/prod/configs/62ee505b-bdbc-8979-fa31-1906d46860a4.js',
  isSponsoredPost: false,
  videoWrraperMargin: '0px',
  videoWrraperMaxWidth: '600px',
  shouldLoadSyringe: false,
  isAmondo: false
};

var HEAD_TO_HEAD_90MIN_EN = {
  pageTypes: ['post'],
  isEmbedded: false,
  daysWhiteList: [0, 1, 2, 3, 4, 5, 6],
  isSlideshow: false,
  featureId: 'Fresh8',
  blacklistedCategories: ['sponsored'],
  placeHolder: 'deepHeadTOHeadPlaceHolder',
  id: 'deepHeadToHead',
  blacklistedPosts: [6427004, 5342660, 39],
  position: findPositionToInjectCampaign(),
  listPosition: 2,
  src: deepHeadToHead90min,
  embedPartners: ['app=1'],
  locales: ['en'],
  site: '90min',
  name: 'deep_head_to_head',
  injectPosition: 'afterEnd',
  shouldRenderVideoStick: shouldLoadVideoInNativeApp(),
  shouldAddDataAttrToScriptTag: false,
  videoConfig: 'https://bucket1.mm-syringe.com/prod/configs/280cce64-64e0-9dfb-d8c1-81855ae53573.js',
  isSponsoredPost: false,
  videoWrraperMargin: '0px',
  videoWrraperMaxWidth: '600px',
  shouldLoadSyringe: false,
  isAmondo: false
};

var HEAD_TO_HEAD_90MIN_FR = {
  pageTypes: ['post'],
  isEmbedded: false,
  daysWhiteList: [0, 1, 2, 3, 4, 5, 6],
  isSlideshow: false,
  featureId: 'Fresh8',
  blacklistedCategories: ['sponsored'],
  placeHolder: 'deepHeadTOHeadPlaceHolder',
  id: 'deepHeadToHead',
  blacklistedPosts: [6427004],
  position: findPositionToInjectCampaign(),
  whiteListCountryCodes: ['IL'],
  listPosition: 2,
  src: deepHeadToHead90minFr,
  locales: ['fr'],
  site: '90min',
  name: 'deep_head_to_head',
  injectPosition: 'afterEnd',
  shouldRenderVideoStick: false,
  shouldAddDataAttrToScriptTag: false,
  videoConfig: 'https://bucket1.mm-syringe.com/prod/configs/280cce64-64e0-9dfb-d8c1-81855ae53573.js',
  isSponsoredPost: false,
  videoWrraperMargin: '0px',
  videoWrraperMaxWidth: '600px',
  shouldLoadSyringe: false,
  isAmondo: false
};

var HEAD_TO_HEAD_12UP_MLB_EN = {
  pageTypes: ['post'],
  isEmbedded: false,
  daysWhiteList: [0, 1, 2, 3, 4, 5, 6],
  isSlideshow: false,
  featureId: 'Fresh8',
  blacklistedCategories: ['sponsored'],
  placeHolder: 'deepHeadTOHeadPlaceHolder',
  id: 'deepHeadToHead',
  blacklistedPosts: [6427004],
  position: findPositionToInjectCampaign(),
  listPosition: 2,
  src: shouldLoadWidgetByRequest('deepMlb') ? deepHeadToHead12upMlb : '',
  locales: ['en'],
  site: '12up',
  name: 'deep_head_to_head',
  injectPosition: 'afterEnd',
  shouldRenderVideoStick: false,
  shouldAddDataAttrToScriptTag: false,
  videoConfig: 'https://bucket1.mm-syringe.com/prod/configs/280cce64-64e0-9dfb-d8c1-81855ae53573.js',
  isSponsoredPost: false,
  videoWrraperMargin: '0px',
  videoWrraperMaxWidth: '600px',
  shouldLoadSyringe: false,
  isAmondo: false
};

var PLAYGORITHM_FOTMOB_IT = {
  pageTypes: ['post'],
  isEmbedded: true,
  daysWhiteList: [0, 1, 2, 3, 4, 5, 6],
  isSlideshow: false,
  featureId: 'Fresh8',
  placeHolder: 'playgorithmPlaceHolder',
  name: 'playgorithm-unit-951',
  id: 'playgorithm-unit-951',
  src: fotmobTriviaTest,
  embedPartners: ['utm_source=fotmob&utm_medium=api'],
  excludeByUrl: ['noAds'],
  position: findPositionToInjectCampaign(),
  locales: ['it'],
  site: '90min',
  injectPosition: 'afterEnd',
  shouldRenderVideoStick: false,
  isSponsoredPost: false,
  shouldAddDataAttrToScriptTag: false,
  videoConfig: 'https://bucket1.mm-syringe.com/prod/configs/c6c3c515-2806-e065-65b6-21421ee2d998.js',
  videoWrraperMargin: '-8px',
  videoWrraperMaxWidth: '600px',
  shouldLoadSyringe: false,
  isAmondo: false
};

var PLAYGORITHM_FOTMOB_DE = {
  pageTypes: ['post'],
  isEmbedded: true,
  daysWhiteList: [0, 1, 2, 3, 4, 5, 6],
  isSlideshow: false,
  featureId: 'Fresh8',
  placeHolder: 'playgorithmPlaceHolder',
  name: 'playgorithm-unit-951',
  id: 'playgorithm-unit-951',
  src: fotmobTriviaTest,
  embedPartners: ['utm_source=fotmob&utm_medium=api'],
  excludeByUrl: ['noAds'],
  position: findPositionToInjectCampaign(),
  locales: ['de'],
  site: '90min',
  injectPosition: 'afterEnd',
  isSponsoredPost: false,
  shouldRenderVideoStick: false,
  shouldAddDataAttrToScriptTag: false,
  videoConfig: 'https://bucket1.mm-syringe.com/prod/configs/48c18dd8-795c-2ed7-b176-9aa8d634e8a7.js',
  videoWrraperMargin: '-8px',
  videoWrraperMaxWidth: '600px',
  shouldLoadSyringe: false,
  isAmondo: false
};

var PLAYGORITHM_FOTMOB_ES = {
  pageTypes: ['post'],
  isEmbedded: true,
  daysWhiteList: [0, 1, 2, 3, 4, 5, 6],
  isSlideshow: false,
  featureId: 'Fresh8',
  placeHolder: 'playgorithmPlaceHolder',
  name: 'playgorithm-unit-951',
  id: 'playgorithm-unit-951',
  src: fotmobTriviaTest,
  embedPartners: ['utm_source=fotmob&utm_medium=api'],
  excludeByUrl: ['noAds'],
  position: findPositionToInjectCampaign(),
  locales: ['es'],
  site: '90min',
  injectPosition: 'afterEnd',
  isSponsoredPost: false,
  shouldRenderVideoStick: false,
  shouldAddDataAttrToScriptTag: false,
  videoConfig: 'https://bucket1.mm-syringe.com/prod/configs/609d9aa1-daff-5bac-5fef-efde23cca7ca.js',
  videoWrraperMargin: '-8px',
  videoWrraperMaxWidth: '600px',
  shouldLoadSyringe: false,
  isAmondo: false
};

var SNAP_90MIN = {
  pageTypes: ['post'],
  isEmbedded: false,
  daysWhiteList: [0, 1, 2, 3, 4, 5, 6],
  isSlideshow: false,
  featureId: 'Fresh8',
  blacklistedCategories: ['sponsored'],
  whitelistedCategories: [],
  placeHolder: 'GaDALxOKnfgvLOo4zB7BLgcLpxC3',
  id: 'snappdEmbedWidget',
  src: snapStories,
  blacklistedPosts: [6242836, 6296514, 6296514, 6296515, 6296517, 6296519, 6296521, 6296525],
  whiteListCountryCodes: ['IN', 'NG', 'MY', 'TH', 'ID', 'CA', 'GH'],
  position: findPositionToInjectCampaign(),
  listPosition: 2,
  excludeByUrl: ['app=1'],
  dataAttr: ['data-snappdwidget="GaDALxOKnfgvLOo4zB7BLgcLpxC3"', 'data-shape="rectangle"', 'data-border="ff9900"', 'data-hover="de8808"', 'data-size="default"', 'data-hideavatar="1"'],
  locales: ['en'],
  site: '90min',
  injectPosition: 'afterEnd',
  shouldRenderVideoStick: false,
  isSponsoredPost: false,
  shouldLoadSyringe: false,
  isAmondo: false
};

var PLAYGORITHM_FLOOR_8 = {
  pageTypes: ['post'],
  isEmbedded: false,
  whiteListCountryCodes: ['US', 'IL'],
  daysWhiteList: [0, 1, 2, 3, 4, 5, 6],
  isSlideshow: false,
  featureId: 'Fresh8',
  blacklistedCategories: ['sponsored', 'no-campaign-manager'],
  placeHolder: 'playgorithmPlaceHolder',
  id: 'playgorithm-unit-869',
  name: 'playgorithm-unit-869',
  position: findPositionToInjectCampaign(),
  listPosition: 2,
  src: shouldLoadWidgetByRequest('trivia') ? triviaFloor8 : getABTestExperimentValue(1, 20, 21, 40, triviaFloor8, triviaFloor8),
  locales: ['en'],
  site: 'floor8',
  injectPosition: 'afterEnd',
  shouldRenderVideoStick: false,
  isSponsoredPost: false,
  shouldLoadSyringe: false,
  isAmondo: false
};

var DEEP_HEAD_TO_HEAD_WIDGET_FLOOR8 = {
  pageTypes: ['post'],
  isEmbedded: false,
  daysWhiteList: [0, 1, 2, 3, 4, 5, 6],
  isSlideshow: false,
  featureId: 'Fresh8',
  blacklistedCategories: ['sponsored'],
  placeHolder: 'deepHeadTOHeadPlaceHolder',
  id: 'deepHeadToHead',
  position: 2,
  listPosition: 2,
  src: deepHeadToHeadFloor8,
  whitelistedPosts: [20023, 20030, 20059, 20064, 20097],
  locales: ['en'],
  site: 'floor8',
  name: 'deep_head_to_head',
  injectPosition: 'afterEnd',
  shouldRenderVideoStick: false,
  shouldAddDataAttrToScriptTag: false,
  isSponsoredPost: false,
  shouldLoadSyringe: false,
  isAmondo: false
};

var SPORTRADAR_FACTIVES_90MIN = {
  pageTypes: ['post'],
  isEmbedded: false,
  daysWhiteList: [0, 1, 2, 3, 4, 5, 6],
  isSlideshow: false,
  featureId: 'Fresh8',
  blacklistedCategories: ['sponsored', 'no-campaign-manager'],
  placeHolder: 'FactivePlaceHolder',
  id: 'inhabit',
  name: 'inhabit',
  position: findPositionToInjectCampaign(),
  listPosition: 2,
  injectPosition: 'afterEnd',
  src: 'https://inhabit-service.cdn.arkadiumhosted.com/Widget/v1/',
  locales: ['en'],
  dataAttr: ['data-ark-client="71c49787-8f2b-4801-b9d7-7f5879a1460d"'],
  site: '90min',
  embedPartners: ['app=1'],
  shouldRenderVideoStick: shouldLoadVideoInNativeApp(),
  shouldAddDataAttrToScriptTag: true,
  publisherDescriptionForGa: '90min',
  shouldAddSpecificPlaceHolder: true,
  specificPlaceHolder: '<ark-box data-ark-client=\'71c49787-8f2b-4801-b9d7-7f5879a1460d\'></ark-box>',
  videoConfig: 'https://www.oo-syringe.com/prod/configs/b69967cd-26a0-3865-dfbb-15a5da776ad1.js',
  isSponsoredPost: false,
  videoWrraperMargin: '0px',
  videoWrraperMaxWidth: '100%',
  shouldLoadSyringe: false,
  isAmondo: false
};

var TRINITY_90min_fr = {
  pageTypes: ['post'],
  isEmbedded: false,
  daysWhiteList: [0, 1, 2, 3, 4, 5, 6],
  isSlideshow: false,
  featureId: 'Fresh8',
  // blacklistedCategories: ['sponsored', 'no-campaign-manager'],
  placeHolder: 'trinityAudioPlaceholder',
  id: 'trinity',
  name: 'trinityAudioPlaceholder',
  position: 0,
  listPosition: 0,
  src: trinity90minfr,
  locales: ['fr'],
  site: '90min',
  injectPosition: 'beforebegin',
  shouldRenderVideoStick: false,
  shouldAddDataAttrToScriptTag: false,
  publisherDescriptionForGa: '12up',
  shouldAddSpecificPlaceHolder: false,
  isSponsoredPost: false,
  shouldLoadSyringe: false,
  isAmondo: false
};

var TRINITY_90min_es = {
  pageTypes: ['post'],
  isEmbedded: false,
  daysWhiteList: [0, 1, 2, 3, 4, 5, 6],
  isSlideshow: false,
  featureId: 'Fresh8',
  // blacklistedCategories: ['sponsored', 'no-campaign-manager'],
  placeHolder: 'trinityAudioPlaceholder',
  id: 'trinity',
  name: 'trinityAudioPlaceholder',
  position: 0,
  listPosition: 0,
  src: trinity90mines,
  blackListCountryCodes: ['ES', 'MX', 'US'],
  locales: ['es'],
  site: '90min',
  injectPosition: 'beforebegin',
  shouldRenderVideoStick: false,
  shouldAddDataAttrToScriptTag: false,
  publisherDescriptionForGa: '12up',
  shouldAddSpecificPlaceHolder: false,
  isSponsoredPost: false,
  shouldLoadSyringe: false,
  isAmondo: false
};

var SCORE365_PLAYGORITHM_EN = {
  pageTypes: ['post'],
  isEmbedded: true,
  daysWhiteList: [0, 1, 2, 3, 4, 5, 6],
  isSlideshow: false,
  featureId: 'Fresh8',
  placeHolder: 'playgorithmPlaceHolder',
  name: 'playgorithm-unit-1190',
  id: 'playgorithm-unit-1190',
  src: triviaSemanticscore365_en,
  embedPartners: ['partner=484476'],
  excludeByUrl: ['noAds'],
  position: findPositionToInjectCampaign(),
  listPosition: 2,
  locales: ['en'],
  site: '90min',
  injectPosition: 'afterEnd',
  shouldRenderVideoStick: false,
  shouldAddDataAttrToScriptTag: false,
  videoConfig: 'https://bucket1.mm-syringe.com/prod/configs/12d13a35-4885-0140-42d2-71a0b91c2933.js',
  isSponsoredPost: false,
  videoWrraperMargin: '-8px',
  videoWrraperMaxWidth: '600px',
  shouldLoadSyringe: false,
  isAmondo: false
};

var SCORE365_PLAYGORITHM_PT = {
  pageTypes: ['post'],
  isEmbedded: true,
  daysWhiteList: [0, 1, 2, 3, 4, 5, 6],
  isSlideshow: false,
  featureId: 'Fresh8',
  placeHolder: 'playgorithmPlaceHolder',
  name: 'playgorithm-unit-1190',
  id: 'playgorithm-unit-1190',
  src: triviaSemanticscore365_pt,
  embedPartners: ['partner=484476'],
  excludeByUrl: ['noAds'],
  position: findPositionToInjectCampaign(),
  listPosition: 2,
  locales: ['pt-BR'],
  site: '90min',
  injectPosition: 'afterEnd',
  shouldRenderVideoStick: false,
  shouldAddDataAttrToScriptTag: false,
  videoConfig: 'https://bucket1.mm-syringe.com/prod/configs/e6e4ede1-a6ed-ef9c-cc4f-c488b19ebf26.js',
  isSponsoredPost: false,
  videoWrraperMargin: '-8px',
  videoWrraperMaxWidth: '600px',
  shouldLoadSyringe: false,
  isAmondo: false
};

var SCORE365_PLAYGORITHM_ES = {
  pageTypes: ['post'],
  isEmbedded: true,
  daysWhiteList: [0, 1, 2, 3, 4, 5, 6],
  isSlideshow: false,
  featureId: 'Fresh8',
  placeHolder: 'playgorithmPlaceHolder',
  name: 'playgorithm-unit-1190',
  id: 'playgorithm-unit-1190',
  src: triviaSemanticscore365_es,
  embedPartners: ['partner=484476'],
  excludeByUrl: ['noAds'],
  position: findPositionToInjectCampaign(),
  listPosition: 2,
  locales: ['pt-BR'],
  site: '90min',
  injectPosition: 'afterEnd',
  shouldRenderVideoStick: false,
  shouldAddDataAttrToScriptTag: false,
  videoConfig: 'https://bucket1.mm-syringe.com/prod/configs/e6e4ede1-a6ed-ef9c-cc4f-c488b19ebf26.js',
  isSponsoredPost: false,
  videoWrraperMargin: '-8px',
  videoWrraperMaxWidth: '600px',
  shouldLoadSyringe: false,
  isAmondo: false
};

var AMONDO_90min = {
  pageTypes: ['post'],
  isEmbedded: false,
  daysWhiteList: [0, 1, 2, 3, 4, 5, 6],
  isSlideshow: false,
  featureId: 'Fresh8',
  placeHolder: 'amondo',
  id: 'amondo-container',
  name: 'amondo',
  position: findEndOfArticle(),
  listPosition: 0,
  whitelistedPosts: [4861576, 6523228],
  src: 'https://static.amondo.com/90min/amondo_initializer.js',
  site: '90min',
  injectPosition: 'afterEnd',
  shouldRenderVideoStick: false,
  shouldAddDataAttrToScriptTag: false,
  shouldAddSpecificPlaceHolder: false,
  isSponsoredPost: false,
  shouldLoadSyringe: false,
  isAmondo: true
};

var campaigns = [PLAYGORITHM_FOTMOB_IT, PLAYGORITHM_FOTMOB_DE, PLAYGORITHM_FOTMOB_ES, MOTW_90_MIN, SCORE365_PLAYGORITHM_EN, SCORE365_PLAYGORITHM_PT, SCORE365_PLAYGORITHM_ES, AMONDO_90min, TRINITY_90min_fr, TRINITY_90min_es, HEAD_TO_HEAD_90MIN_EN];

var fotmobSplitMarketplace = getABTestExperimentValue(0, 50, 51, 100, PLAYGORITHM_FOTMOB_EN, HEAD_TO_HEAD_FOTMOB_EN);

// let nintiMinSplitMarketplace = getABTestExperimentValue(
//   0,
//   50,
//   51,
//   100,
//   HEAD_TO_HEAD_90MIN_EN,
//   SPORTRADAR_FACTIVES_90MIN
// )

campaigns.push(fotmobSplitMarketplace);
// campaigns.push(nintiMinSplitMarketplace)

function renderDataAttr(campaign) {
  if (campaign.dataAttr) {
    var attrStr = '';
    campaign.dataAttr.forEach(function (attr) {
      attrStr += attr;
    });
    return attrStr;
  }
  return null;
}

function getFactsSrc(campaign) {
  return campaign.id === 'facts' ? FACTS_CAMPAIGNS[(0, _pageDataObject.getPageLocale)()] : MOTW_CAMPAIGNS[(0, _pageDataObject.getPageLocale)()];
}

function renderVideoStickToWidget(campaign) {
  return campaign.shouldRenderVideoStick ? '<div class="videoWraaperMarketPlace" style=\'margin-top:' + campaign.videoWrraperMargin + ';max-width:' + campaign.videoWrraperMaxWidth + ';background-color:black;display:none;flex-direction: row;\'>\n        <style>.montiPlaceHolderApp>div {margin: 0}</style>\n        <div class=\'montiPlaceHolderApp\' style=\'width:50%;padding-top:calc(100%/16/9);transform: translateY(-1px)\'></div>\n        <div style=\'color:white;width:50%;padding-left:14px;display: flex;justify-content:center;flex-direction:column;\'>\n            <div>This Week</div>\n            <div style=\'font-size:16px;font-weight: 700\'>MUST WATCH</div>\n         </div>\n        </div>' : '';
}

function addPlaceHolder(campaign) {
  var paragraph = document.querySelectorAll('.post-content > p')[campaign.position];
  if (paragraph === undefined) {
    paragraph = document.getElementsByClassName('post-body--top-x')[0];
  }
  if (paragraph === undefined) {
    paragraph = document.querySelectorAll('.post-content > p')[document.querySelectorAll('.post-content > p').length - 1];
  }
  if (paragraph !== undefined && paragraph !== null) {
    if (campaign.shouldAddSpecificPlaceHolder) {
      paragraph.insertAdjacentHTML(campaign.injectPosition, campaign.specificPlaceHolder + '\n        ' + renderVideoStickToWidget(campaign) + '\n        ');
    } else if (campaign.isFreshEight) {
      paragraph.insertAdjacentHTML(campaign.injectPosition, '<div class=' + campaign.placeHolder + ' data-viewability_category="Article page" data-viewability_action="widget viewable impression"\n        data-viewability_label="fresh8" style=\'border:none;margin-top:24px;margin-bottom:24px\'><iframe src=' + campaign.src + '  style="width:100%;height:150px;" scrolling="no" frameborder="0"></iframe></div>');
    } else if (campaign.isAmondo) {
      paragraph.insertAdjacentHTML(campaign.injectPosition, '<div class=' + campaign.placeHolder + ' id=' + campaign.id + ' imprintId="4839" style=\'border:none;margin-top:24px;margin-bottom:24px;width:100%\'>');
    } else {
      paragraph.insertAdjacentHTML(campaign.injectPosition, '<div class=' + campaign.placeHolder + ' id=' + campaign.id + ' ' + renderDataAttr(campaign) + '></div>\n        ' + renderVideoStickToWidget(campaign) + '\n        ');
    }
  }
}

function injectScript(campaign) {
  if (campaign.id !== 'facts') {
    var script = document.createElement('script');
    script.src = campaign.src;
    script.async = true;
    if (campaign.id === 'snappdEmbedWidget') {
      script.id = campaign.id;
    }
    if (campaign.shouldAddDataAttrToScriptTag) {
      script.setAttribute('data-ark-client', '71c49787-8f2b-4801-b9d7-7f5879a1460d');
      script.setAttribute('data-ark-partner', campaign.publisherDescriptionForGa);
    }
    document.head.appendChild(script);
  }
}

function getFirstLinkStyle() {
  return document.querySelectorAll("p > a[href='https://watch.espnplus.com/sports/?clickid=QfRzfEzooxyJT55xTp3WVUkrUkgSMf2puyk81U0&irgwc=1&ex_cid=DSS-Affiliate-Impact-Content-Minute%20Media-535101']");
}

function getSecLinkStyle() {
  return document.querySelectorAll("p > inline > a[href='http://espn.zlbu.net/c/1386087/535101/9070']");
}

function addNoFollowOnEspnLinks() {
  if ((0, _pageDataObject.getSite)() === '12up') {
    var espnLink = [].concat((0, _toConsumableArray3.default)(getFirstLinkStyle()), (0, _toConsumableArray3.default)(getSecLinkStyle()));
    if (espnLink.length > 0) {
      espnLink[0].rel = 'nofollow';
    }
  }
}

// function displayVideo(e) {
//   const widgetOrigin = 'https://frontend.playgorithm.net'
//   if (e.origin !== widgetOrigin) {
//     return
//   }
//
//   try {
//     const message = JSON.parse(e.data)
//     switch (message.type) {
//       case 'game-started':
//         break
//       case 'unit-loaded':
//         document.getElementsByClassName('videoWraaperMarketPlace')[0].style.display = 'flex'
//         window.removeEventListener('message', displayVideo)
//         break
//       default:
//         break
//     }
//   } catch (err) {
//     // Non json message, ignore
//   }
// }

function displayVideoTrivia() {
  document.getElementsByClassName('videoWraaperMarketPlace')[0].style.display = 'flex';
}

function adjustPlayerViewability() {
  if (document.getElementsByClassName('videoWraaperMarketPlace')[0] !== undefined) {
    var viewableVideoHeight = window.innerHeight - document.getElementsByClassName('videoWraaperMarketPlace')[0].getBoundingClientRect().top;
    var playerHeight = document.getElementsByClassName('videoWraaperMarketPlace')[0].getBoundingClientRect().height;
    if (viewableVideoHeight / playerHeight * 100 < 80) {
      window.scrollBy({
        top: playerHeight - viewableVideoHeight,
        left: 0,
        behavior: 'smooth'
      });
    }
  }
}

function listenToFactiveEmmiter() {
  window.__ark_app__ = {
    onload: function onload(emitter) {
      // Watch Console for the events
      emitter.on('*', function (event, data) {
        try {
          switch (event) {
            case 'module.moduleVisible':
              document.getElementsByClassName('videoWraaperMarketPlace')[0].style.display = 'flex';
              break;
            case 'module.moduleCycleStart':
              adjustPlayerViewability();
              break;
            default:
              break;
          }
        } catch (err) {
          console.log('error fetch factive events from emiter', err);
        }
      });
    }
  };
}

function loadVideo(src) {
  var s1 = document.createElement('script');
  var s2 = document.createElement('script');
  s1.src = src;
  s2.src = 'https://www.oo-syringe.com/prod/injector/injector.1.5.2.js';
  document.body.appendChild(s1);
  document.body.appendChild(s2);
  window.addEventListener('playgorithm-unit-loaded', function () {
    return displayVideoTrivia();
  });
  window.addEventListener('playgorithm-game-started', function () {
    return adjustPlayerViewability();
  });
  // window.addEventListener('message', displayVideo)
  listenToFactiveEmmiter();
  window.addEventListener('loadedDeepWidget', function (e) {
    document.getElementsByClassName('videoWraaperMarketPlace')[0].style.display = 'flex';
  });
  window.addEventListener('gameStart', function (e) {
    adjustPlayerViewability();
  });
}

function loadSyringe() {
  var s1 = document.createElement('script');
  s1.src = 'https://bucket1.mm-syringe.com/prod/injector/injector.1.6.2.js';
  document.body.appendChild(s1);
}

function injectFreshEight() {
  addNoFollowOnEspnLinks();
  campaigns.forEach(function (campaign) {
    (0, _campaignConfig.isCampaignEnabled)(campaign).then(function (response) {
      if (response.isCampaignEnabled && !window.postBodyCampaign) {
        if (campaign.shouldLoadSyringe) {
          loadSyringe();
        }
        addPlaceHolder(campaign);
        injectScript(campaign);
        if (campaign.shouldRenderVideoStick) {
          loadVideo(campaign.videoConfig);
        }
        // register('.' + campaign.placeHolder)
      }
    });
  });
}

/***/ }),

/***/ 641:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackGoogleAnalyticsSessionId = trackGoogleAnalyticsSessionId;

var _pageDataObject = __webpack_require__(5);

function getCookie(name) {
  var re = new RegExp(name + '=([^;]+)');
  var value = re.exec(document.cookie);
  return value !== null ? unescape(value[1]) : null;
}

function trackGoogleAnalyticsSessionId() {
  if ((0, _pageDataObject.getSite)() !== 'ei') {
    var id = getCookie('ga');
    if (undefined !== id && id !== null && id.length > 2) {
      window.experimentId = parseInt(id.substring(id.length - 2, id.length));
    }
  }
}

/***/ }),

/***/ 655:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initILiveBlog = initILiveBlog;
function initILiveBlog() {
  if (document.getElementsByClassName('arena-embed') !== undefined) {
    window.addEventListener('message', function (event) {
      if (event.data && event.data.source === 'lb24-auto-size') {
        var blogFrame = document.getElementsByClassName('arena-embed');
        blogFrame[0].style.height = event.data.height + 'px';
      }
    });
  }
}

/***/ }),

/***/ 660:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PostActionsContainerComponent = undefined;

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(37);

var _postActionsHeader = __webpack_require__(661);

var _postActionsList = __webpack_require__(662);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ADMIN_ACTION_ITEM_CLASS = 'admin-dropdown-action dropdown-comp__item';

var PostActionsContainerComponent = exports.PostActionsContainerComponent = function (_Component) {
  (0, _inherits3.default)(PostActionsContainerComponent, _Component);

  function PostActionsContainerComponent() {
    (0, _classCallCheck3.default)(this, PostActionsContainerComponent);
    return (0, _possibleConstructorReturn3.default)(this, (PostActionsContainerComponent.__proto__ || (0, _getPrototypeOf2.default)(PostActionsContainerComponent)).apply(this, arguments));
  }

  (0, _createClass3.default)(PostActionsContainerComponent, [{
    key: 'shouldRender',
    value: function shouldRender() {
      var _props = this.props,
          optionsList = _props.optionsList,
          hasErrors = _props.hasErrors,
          isLoading = _props.isLoading;

      return !isLoading && !hasErrors && optionsList && optionsList.length > 0;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          optionsList = _props2.optionsList,
          confirmAndExecAdminAction = _props2.confirmAndExecAdminAction;

      return this.shouldRender() ? _react2.default.createElement(
        'div',
        {
          className: 'post-admin-options has-dropdown post-metadata__admin-dropdown',
          'data-block-name': 'post-admin-options'
        },
        _react2.default.createElement(
          'div',
          { className: 'post-admin-options__container' },
          _react2.default.createElement(_postActionsHeader.PostActionsHeader, null),
          _react2.default.createElement(_postActionsList.PostActionsList, { optionsList: optionsList, confirmAndExecAdminAction: confirmAndExecAdminAction })
        )
      ) : null;
    }
  }]);
  return PostActionsContainerComponent;
}(_react.Component);

PostActionsContainerComponent.defaultProps = {
  optionsList: [],
  fetchFromServer: false
};

/***/ }),

/***/ 661:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PostActionsHeader = undefined;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PostActionsHeader = exports.PostActionsHeader = function PostActionsHeader() {
  return _react2.default.createElement(
    "label",
    { className: "label post-admin-options__label" },
    "Options"
  );
};

/***/ }),

/***/ 662:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PostActionsList = undefined;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PostActionsList = exports.PostActionsList = function PostActionsList(_ref) {
  var optionsList = _ref.optionsList,
      confirmAndExecAdminAction = _ref.confirmAndExecAdminAction;

  return _react2.default.createElement(
    "nav",
    { className: "dropdown-comp post-admin-options__dropdown-menu" },
    optionsList.map(function (_ref2) {
      var url = _ref2.url,
          text = _ref2.text,
          openInNewTab = _ref2.open_in_new_tab,
          shouldConfirm = _ref2.should_confirm;

      var boundAdminActionHandler = adminActionHandler.bind(null, url, text, shouldConfirm, confirmAndExecAdminAction);
      return _react2.default.createElement(
        "a",
        {
          key: text,
          href: url,
          rel: "nofollow noopener",
          className: "admin-dropdown-action dropdown-comp__item",
          target: openInNewTab ? '_blank' : '',
          onClick: boundAdminActionHandler
        },
        text
      );
    })
  );
};

var adminActionHandler = function adminActionHandler(url, text, shouldConfirm, actionHandler, e) {
  if (shouldConfirm) {
    e.preventDefault();
    actionHandler({ url: url, text: text });
  }
};

/***/ }),

/***/ 663:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PostActionsContainerWithStore = undefined;

var _connectWithStore = __webpack_require__(179);

var _postActions = __webpack_require__(660);

var _appStore = __webpack_require__(23);

var _postActions2 = __webpack_require__(250);

var _pageDataObject = __webpack_require__(5);

var _postActions3 = __webpack_require__(250);

var mapDispatchToProps = _interopRequireWildcard(_postActions3);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function mapStateToProps(state) {
  var _state$postActions = state.postActions,
      hasErrors = _state$postActions.hasErrors,
      isLoading = _state$postActions.isLoading,
      optionsList = _state$postActions.optionsList,
      shouldFetchOptions = _state$postActions.shouldFetchOptions,
      fetchFromServer = _state$postActions.fetchFromServer;

  return {
    hasErrors: hasErrors,
    isLoading: isLoading,
    optionsList: optionsList,
    shouldFetchOptions: shouldFetchOptions,
    fetchFromServer: fetchFromServer
  };
}

var PostActionsContainerWithStore = exports.PostActionsContainerWithStore = function PostActionsContainerWithStore() {
  (0, _appStore.dispatch)((0, _postActions2.fetchPostActions)((0, _pageDataObject.getPostId)(), false));

  return (0, _connectWithStore.connectWithStore)(_postActions.PostActionsContainerComponent, mapStateToProps, mapDispatchToProps);
};

/***/ }),

/***/ 664:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ReactionHeader;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getEmptyHeader(_ref) {
  var headerClassName = _ref.headerClassName;

  var classNames = headerClassName + ' ' + headerClassName + '--empty';
  return _react2.default.createElement('header', {
    className: classNames
  });
}
function getHeader(_ref2) {
  var headerClassName = _ref2.headerClassName,
      blockName = _ref2.blockName,
      headerText = _ref2.headerText,
      headerImage = _ref2.headerImage;

  return _react2.default.createElement(
    'header',
    {
      className: headerClassName
    },
    _react2.default.createElement(
      'span',
      { className: blockName + '__header-text' },
      headerText
    ),
    _react2.default.createElement('img', {
      className: blockName + '__header-image',
      src: headerImage
    })
  );
}
function ReactionHeader(_ref3) {
  var blockName = _ref3.blockName,
      headerText = _ref3.headerText,
      headerImage = _ref3.headerImage;

  var headerClassName = blockName + '__header-container';
  if (!headerText || !headerImage) {
    return getEmptyHeader({ headerClassName: headerClassName });
  }
  return getHeader({ headerClassName: headerClassName, blockName: blockName, headerText: headerText, headerImage: headerImage });
}

/***/ }),

/***/ 665:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ReactionsList;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _reactionListItem = __webpack_require__(666);

var _reactionListItem2 = _interopRequireDefault(_reactionListItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ReactionsList(_ref) {
  var reactions = _ref.reactions,
      blockName = _ref.blockName,
      selectedReaction = _ref.selectedReaction,
      onReactionClicked = _ref.onReactionClicked,
      _ref$percentages = _ref.percentages,
      percentages = _ref$percentages === undefined ? {} : _ref$percentages;

  var shouldShowVoteResults = !!selectedReaction && percentages;
  var isAnySelected = !!selectedReaction;
  var reactionsElements = reactions.map(function (reaction, key) {
    var id = reaction.id;

    var percentage = percentages[id] || 0;
    var isSelected = selectedReaction && selectedReaction === id;
    var reactionListItemParams = {
      reaction: reaction, percentage: percentage, shouldShowVoteResults: shouldShowVoteResults,
      blockName: blockName, key: key, isSelected: isSelected, onReactionClicked: onReactionClicked, isAnySelected: isAnySelected
    };
    return _react2.default.createElement(_reactionListItem2.default, reactionListItemParams);
  });
  return _react2.default.createElement(
    'ul',
    { className: blockName + '__list' },
    reactionsElements
  );
}

/***/ }),

/***/ 666:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ReactionListItem;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getSelectionModifier(_ref) {
  var blockName = _ref.blockName,
      isSelected = _ref.isSelected,
      isAnySelected = _ref.isAnySelected;

  if (!isSelected && !isAnySelected) {
    return '';
  }
  if (isSelected) {
    return blockName + '__item--selected';
  }
  if (isAnySelected) {
    return blockName + '__item--unselected';
  }
}

function getImage(_ref2) {
  var reaction = _ref2.reaction;

  return reaction.image;
}

function ReactionListItem(_ref3) {
  var reaction = _ref3.reaction,
      blockName = _ref3.blockName,
      percentage = _ref3.percentage,
      showVoteResults = _ref3.showVoteResults,
      isSelected = _ref3.isSelected,
      onReactionClicked = _ref3.onReactionClicked,
      isAnySelected = _ref3.isAnySelected;
  var reactionId = reaction.id;

  var percentageVisibilityModifier = showVoteResults ? blockName + '__item-percentage--visible' : '';
  var itemPercentageClassNames = blockName + '__item-percentage\n    ' + percentageVisibilityModifier;
  var selectionModifier = getSelectionModifier({
    blockName: blockName, isSelected: isSelected, isAnySelected: isAnySelected });
  var itemClassNames = blockName + '__item ' + selectionModifier;
  var text = reaction.text;

  var image = getImage({ reaction: reaction });
  return _react2.default.createElement(
    'li',
    { className: blockName + '__list-item' },
    _react2.default.createElement(
      'button',
      {
        type: 'button',
        disabled: isAnySelected,
        className: itemClassNames,
        onClick: function onClick(e) {
          return onReactionClicked({ reactionId: reactionId });
        }
      },
      _react2.default.createElement('div', {
        className: blockName + '__item-image',
        style: { backgroundImage: 'url(\'' + image + '\')' }
      }),
      _react2.default.createElement(
        'div',
        { className: blockName + '__item-text' },
        text
      ),
      _react2.default.createElement(
        'div',
        { className: itemPercentageClassNames },
        percentage,
        '%'
      )
    )
  );
}

/***/ }),

/***/ 667:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ReactionsComponent;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _reactionList = __webpack_require__(665);

var _reactionList2 = _interopRequireDefault(_reactionList);

var _reactionHeader = __webpack_require__(664);

var _reactionHeader2 = _interopRequireDefault(_reactionHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BLOCK_NAME = 'reactions';

function getTitleElement(title) {
  if (!title) {
    return false;
  }
  return _react2.default.createElement(
    'h3',
    { className: BLOCK_NAME + '__title' },
    title
  );
}

function ReactionsComponent(_ref) {
  var reactions = _ref.reactions,
      headerText = _ref.headerText,
      headerImage = _ref.headerImage,
      selectedReaction = _ref.selectedReaction,
      onReactionClicked = _ref.onReactionClicked,
      percentages = _ref.percentages,
      onReactionsListContainerClick = _ref.onReactionsListContainerClick,
      title = _ref.title;

  var blockName = BLOCK_NAME;
  var reactionsProps = {
    className: blockName,
    onClick: onReactionsListContainerClick
  };
  var reactionsHeaderProps = {
    blockName: blockName,
    headerText: headerText,
    headerImage: headerImage
  };
  var reactionsListProps = {
    blockName: blockName,
    reactions: reactions,
    selectedReaction: selectedReaction,
    percentages: percentages,
    onReactionClicked: onReactionClicked
  };
  return _react2.default.createElement(
    'section',
    reactionsProps,
    _react2.default.createElement(_reactionHeader2.default, reactionsHeaderProps),
    getTitleElement(title),
    _react2.default.createElement(_reactionList2.default, reactionsListProps)
  );
}

/***/ }),

/***/ 668:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _setImmediate2 = __webpack_require__(253);

var _setImmediate3 = _interopRequireDefault(_setImmediate2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _ua = __webpack_require__(10);

var _reactDom = __webpack_require__(116);

var _reactionsComponent = __webpack_require__(667);

var _reactionsComponent2 = _interopRequireDefault(_reactionsComponent);

var _i18nProvider = __webpack_require__(18);

var _dom = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint semi:0 */
var BLOCK_NAME = 'social-bar-container';
var noClickOutsideComponentHandler = null;

var didFetchReactions = false; // todo: this is a temp hack fix,
// the ideal solution would be to include this prop inside react's state

var SocialBarComponent = function (_React$Component) {
  (0, _inherits3.default)(SocialBarComponent, _React$Component);

  function SocialBarComponent() {
    (0, _classCallCheck3.default)(this, SocialBarComponent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SocialBarComponent.__proto__ || (0, _getPrototypeOf2.default)(SocialBarComponent)).apply(this, arguments));

    _this.state = {
      checkboxChecked: false
    };
    _this.toggleCheckbox = _this.toggleCheckbox.bind(_this);
    _this.clickOutsideComponentHandler = noClickOutsideComponentHandler;
    return _this;
  }

  (0, _createClass3.default)(SocialBarComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          reactionsComponentInitialState = _props.reactionsComponentInitialState,
          setReactionsComponentState = _props.setReactionsComponentState;

      setReactionsComponentState(reactionsComponentInitialState);
      this.getPostVotesOnce();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeCloseOutsideComponentHandler();
      var _props2 = this.props,
          componentPosition = _props2.componentPosition,
          reactionsComponentState = _props2.reactionsComponentState,
          setReactionsComponentState = _props2.setReactionsComponentState;

      setReactionsComponentState((0, _extends3.default)({}, reactionsComponentState, {
        removePosition: componentPosition
      }));
    }
  }, {
    key: 'addCloseOutsideComponentHandler',
    value: function addCloseOutsideComponentHandler() {
      if (!this.clickOutsideComponentHandler) {
        var globalClickHandler = this.globalClickHandler = this.handleGlobalClicks.bind(this);
        var globalScrollHandler = this.globalScrollHandler = this.handleGlobalClicks.bind(this);
        var globalTouchHandler = this.globalTouchHandler = this.handleGlobalClicks.bind(this);
        var globalMoveHandler = this.globalMoveHandler = this.handleGlobalClicks.bind(this);
        // next tick is required because otherwise the
        // handler is triggered immediately after it is added.
        (0, _setImmediate3.default)(function () {
          if ((0, _ua.getIsDesktop)()) {
            (0, _dom.addDocumentEvent)('click', globalClickHandler, true);
            (0, _dom.addDocumentEvent)('scroll', globalScrollHandler, true);
          } else {
            (0, _dom.addDocumentEvent)('touchstart', globalTouchHandler, true);
            (0, _dom.addDocumentEvent)('touchmove', globalMoveHandler, true);
          }
        });
      }
    }
  }, {
    key: 'removeCloseOutsideComponentHandler',
    value: function removeCloseOutsideComponentHandler() {
      var globalClickHandler = this.globalClickHandler,
          globalScrollHandler = this.globalScrollHandler,
          globalTouchHandler = this.globalTouchHandler,
          globalMoveHandler = this.globalMoveHandler;

      if (globalClickHandler && globalScrollHandler && globalTouchHandler && globalMoveHandler) {
        if ((0, _ua.getIsDesktop)()) {
          (0, _dom.removeDocumentEvent)('click', globalClickHandler, true);
          (0, _dom.removeDocumentEvent)('scroll', globalScrollHandler, true);
          this.globalClickHandler = noClickOutsideComponentHandler;
          this.globalScrollHandler = noClickOutsideComponentHandler;
        } else {
          (0, _dom.removeDocumentEvent)('touchstart', globalTouchHandler, true);
          (0, _dom.removeDocumentEvent)('touchmove', globalMoveHandler, true);
          this.globalTouchHandler = noClickOutsideComponentHandler;
          this.globalMoveHandler = noClickOutsideComponentHandler;
        }
      }
      this.setState({
        checkboxChecked: false
      });
    }
  }, {
    key: 'getPostVotesOnce',
    value: function getPostVotesOnce() {
      var _props3 = this.props,
          getPostVotes = _props3.getPostVotes,
          postId = _props3.postId;

      if (didFetchReactions) {
        return;
      }
      didFetchReactions = true;
      getPostVotes({ postId: postId });
    }
  }, {
    key: 'onReactionsButtonClick',
    value: function onReactionsButtonClick(e) {
      var areReactionsVisible = this.areReactionsVisible,
          props = this.props;
      var hideReactions = props.hideReactions,
          displayReactions = props.displayReactions,
          componentPosition = props.componentPosition;

      if (areReactionsVisible) {
        hideReactions(componentPosition);
      } else {
        displayReactions(componentPosition);
        this.addCloseOutsideComponentHandler();
        this.getPostVotesOnce();
      }
    }
  }, {
    key: 'onReactionClicked',
    value: function onReactionClicked(_ref) {
      var reactionId = _ref.reactionId;
      var _props4 = this.props,
          postId = _props4.postId,
          sendVote = _props4.sendVote,
          selectedReaction = _props4.selectedReaction,
          componentPosition = _props4.componentPosition,
          reactions = _props4.reactions.reactions;


      if (selectedReaction) {
        return;
      }
      var reactionTitle = reactions.filter(function (item) {
        return item.id === reactionId;
      })[0].translateKey.split('.').pop();

      sendVote({ postId: postId, reactionId: reactionId, componentPosition: componentPosition, reactionTitle: reactionTitle });
      this.getPostVotesOnce();
    }
  }, {
    key: 'handleGlobalClicks',
    value: function handleGlobalClicks(e) {
      var areReactionsVisible = this.areReactionsVisible,
          props = this.props;
      var hideReactions = props.hideReactions,
          componentPosition = props.componentPosition,
          reactionsComponentInitialState = props.reactionsComponentInitialState,
          didUserAlreadyVote = props.selectedReaction;

      var thisDomNode = (0, _reactDom.findDOMNode)(this);
      var isThisTheActiveComponent = !!thisDomNode;
      if (!isThisTheActiveComponent) {
        return;
      }
      this.removeCloseOutsideComponentHandler();
      var isInitialStateVisible = reactionsComponentInitialState[componentPosition].isVisible;
      if (!areReactionsVisible || isInitialStateVisible) {
        return;
      }
      var hideReactionsAndStopPropogation = function hideReactionsAndStopPropogation() {
        e.stopPropagation();
        hideReactions(componentPosition);
      };
      if (didUserAlreadyVote) {
        e.stopPropagation();
        var didUserTryToCloseReactions = !thisDomNode.contains(e.target);
        if (didUserTryToCloseReactions) {
          hideReactions(componentPosition);
        }
      } else {
        var didUserClickToVote = thisDomNode.contains(e.target);
        if (!didUserClickToVote) {
          hideReactionsAndStopPropogation();
        }
      }
    }
  }, {
    key: 'createReactionsComponent',
    value: function createReactionsComponent() {
      var _props5 = this.props,
          reactions = _props5.reactions,
          percentages = _props5.percentages,
          selectedReaction = _props5.selectedReaction,
          title = _props5.title;

      if (!this.areReactionsVisible) {
        return null;
      }
      var reactionsList = reactions.reactions,
          _reactions$campaign = reactions.campaign,
          campaign = _reactions$campaign === undefined ? {} : _reactions$campaign;
      var headerImage = campaign.image;

      var headerText = (0, _i18nProvider.t)('reactions.campaigns_poweredby');
      var reactionsComponentProps = {
        headerText: headerText,
        title: title,
        headerImage: headerImage,
        percentages: percentages,
        selectedReaction: selectedReaction,
        reactions: reactionsList,
        onReactionClicked: this.onReactionClicked.bind(this),
        onReactionsListContainerClick: this.onReactionsListContainerClick.bind(this)
      };
      return _react2.default.createElement(_reactionsComponent2.default, reactionsComponentProps);
    }
  }, {
    key: 'onReactionsListContainerClick',
    value: function onReactionsListContainerClick() {
      this.addCloseOutsideComponentHandler();
    }
  }, {
    key: 'toggleCheckbox',
    value: function toggleCheckbox(e) {
      var areReactionsVisible = this.areReactionsVisible,
          props = this.props,
          state = this.state;
      var hideReactions = props.hideReactions,
          componentPosition = props.componentPosition;

      if (areReactionsVisible) {
        hideReactions(componentPosition);
      }
      e.nativeEvent.stopImmediatePropagation();
      this.setState({
        checkboxChecked: !state.checkboxChecked
      });
      this.addCloseOutsideComponentHandler();
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.isComponentVisible) {
        return false;
      }
      return _react2.default.createElement(
        'section',
        { className: this.blockClassNames },
        this.createReactionsComponent(),
        _react2.default.createElement('div', {
          style: this.reactionsButtonInlineStyle,
          className: BLOCK_NAME + '__reactions',
          onClick: this.onReactionsButtonClick.bind(this)
        })
      );
    }
  }, {
    key: 'areReactionsVisible',
    get: function get() {
      var _props6 = this.props,
          componentPosition = _props6.componentPosition,
          reactionsComponentState = _props6.reactionsComponentState;

      if (!(componentPosition in reactionsComponentState)) {
        return false;
      }
      return reactionsComponentState[componentPosition].isVisible;
    }
  }, {
    key: 'reactionsButtonInlineStyle',
    get: function get() {
      var _props7 = this.props,
          selectedReaction = _props7.selectedReaction,
          _props7$reactions = _props7.reactions,
          reactions = _props7$reactions.reactions,
          defaultIcon = _props7$reactions.default_icon;

      var imageUrl = void 0;
      if (selectedReaction) {
        var reaction = reactions.find(function (r) {
          return r.id === selectedReaction;
        });
        var selectedImage = reaction.selected_image;

        imageUrl = selectedImage;
      } else {
        imageUrl = defaultIcon;
      }
      return { backgroundImage: 'url(\'' + imageUrl + '\')' };
    }
  }, {
    key: 'blockClassNames',
    get: function get() {
      var _props8 = this.props,
          selectedReaction = _props8.selectedReaction,
          campaign = _props8.reactions.campaign;

      var reactedModifier = selectedReaction ? 'reacted' : 'unreacted';
      var campaignModifier = campaign ? 'campaign' : '';
      var modifiers = [reactedModifier, campaignModifier].filter(function (mod) {
        return !!mod;
      }).map(function (mod) {
        return BLOCK_NAME + '--' + mod;
      }).join(' ');
      return BLOCK_NAME + ' ' + modifiers;
    }
  }, {
    key: 'isComponentVisible',
    get: function get() {
      var _props9 = this.props,
          isInCoverViewport = _props9.isInCoverViewport,
          componentPosition = _props9.componentPosition;

      if (componentPosition === 'details') {
        return true;
      }
      if (isInCoverViewport && componentPosition === 'header') {
        return false;
      }
      return true;
    }
  }]);
  return SocialBarComponent;
}(_react2.default.Component);

exports.default = SocialBarComponent;

/***/ }),

/***/ 669:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(14);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.sendVote = sendVote;
exports.getVotes = getVotes;

var _socialBarActionTypes = __webpack_require__(98);

var _socialBarDataSource = __webpack_require__(298);

var _socialBarDataMock = __webpack_require__(408);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function sendVote(_ref) {
  var postId = _ref.postId,
      reactionId = _ref.reactionId;

  return function (dispatch, getState) {
    (0, _socialBarDataSource.setUserVote)({ postId: postId, reactionId: reactionId });
    dispatch({
      type: _socialBarActionTypes.SOCIAL_BAR_ACTION_TYPES.REACTIONS.SEND_VOTE,
      state: {
        selectedReaction: reactionId
      }
    });
  };
}
// todo: move elsewhere
function mergeVotes(_ref2) {
  var myVotes = _ref2.myVotes,
      otherVotes = _ref2.otherVotes,
      postId = _ref2.postId;

  if (!(postId in myVotes)) {
    return otherVotes;
  }
  var myReaction = myVotes[postId];
  var votesWithMe = (0, _defineProperty3.default)({}, myReaction, (otherVotes[myReaction] || 0) + 1);
  var ret = (0, _extends3.default)({}, otherVotes, votesWithMe);
  return ret;
}
function getVotes(_ref3) {
  var postId = _ref3.postId;

  return function (dispatch, getState) {
    var otherVotes = (0, _socialBarDataMock.getPostVotes)();
    var myVotes = (0, _socialBarDataSource.getClientVotes)();
    var merged = mergeVotes({ myVotes: myVotes, otherVotes: otherVotes, postId: postId });
    dispatch({
      type: _socialBarActionTypes.SOCIAL_BAR_ACTION_TYPES.REACTIONS.GET_VOTES,
      state: {
        votes: merged
      }
    });
  };
}

/***/ }),

/***/ 670:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.socialBarActions = exports.API_ENDPOINTS = undefined;

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(14);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _window = __webpack_require__(8);

var _api = __webpack_require__(123);

var _socialBarActionTypes = __webpack_require__(98);

var _fn = __webpack_require__(15);

var _console = __webpack_require__(11);

var _socialBarActionsMock = __webpack_require__(669);

var _socialBarDataTransformer = __webpack_require__(672);

var _socialBarDataSource = __webpack_require__(298);

var _socialButtonsActions = __webpack_require__(140);

var _currentPostActionCounterProvider = __webpack_require__(91);

var _fetch = __webpack_require__(57);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var API_ENDPOINTS = exports.API_ENDPOINTS = {
  GET_VOTES: 'GET_REACTIONS_VOTES',
  SEND_VOTE: 'SEND_REACTIONS_VOTE'
};

var FEATURE_FLAGS = {
  mockSendVote: _window.queryString.reactionsMockSendVote,
  mockGetVotes: _window.queryString.reactionsMockGetVotes
};

var REACTIONS = _socialBarActionTypes.SOCIAL_BAR_ACTION_TYPES.REACTIONS;


function setReactionsComponentState() {
  var reactionsComponentState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _fn.throwIfMissingArgument)();

  return function (dispatch, getState) {
    return dispatch({
      type: REACTIONS.SET_REACTIONS_COMPONENT_STATE,
      state: {
        reactionsComponentState: reactionsComponentState
      }
    });
  };
}

function getStateWithComponentVisibility() {
  var componentPosition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _fn.throwIfMissingArgument)();
  var isVisible = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _fn.throwIfMissingArgument)();

  return {
    state: {
      reactionsComponentState: (0, _defineProperty3.default)({}, componentPosition, { isVisible: isVisible })
    }
  };
}

function displayReactions(componentPosition) {
  return function (dispatch, getState) {
    return dispatch((0, _extends3.default)({
      type: REACTIONS.DISPLAY
    }, getStateWithComponentVisibility(componentPosition, true)));
  };
}

function hideReactions(componentPosition) {
  return function (dispatch, getState) {
    return dispatch((0, _extends3.default)({
      type: REACTIONS.HIDE
    }, getStateWithComponentVisibility(componentPosition, false)));
  };
}

function normalizeComponentPositionStringFor360Analytics(componentPosition) {
  return componentPosition === 'bottom' ? componentPosition + ' bar' : componentPosition;
}

function sendVote(_ref) {
  var postId = _ref.postId,
      reactionId = _ref.reactionId,
      componentPosition = _ref.componentPosition,
      reactionTitle = _ref.reactionTitle;

  if (FEATURE_FLAGS.mockSendVote) {
    return (0, _socialBarActionsMock.sendVote)({ postId: postId, reactionId: reactionId });
  }

  var _memoizeFirstCall = (0, _fn.memoizeFirstCall)('SEND_VOTE', _api.getApiEndpoints, API_ENDPOINTS.SEND_VOTE),
      url = _memoizeFirstCall.SEND_VOTE.url;

  var fullUrl = url + '?post=' + postId + '&answer=' + reactionId;
  return function (dispatch, getState) {
    (0, _socialBarDataSource.cacheVote)({ postId: postId, reactionId: reactionId });
    (0, _fetch.getResponseText)(fullUrl);
    dispatch({
      type: REACTIONS.SEND_VOTE,
      state: {
        payload: {
          category: 'Article page',
          action: 'article like click',
          label: reactionTitle,
          sub_label: normalizeComponentPositionStringFor360Analytics(componentPosition)
        },
        selectedReaction: reactionId,
        componentPosition: componentPosition // for analytics
      }
    });
  };
}

function getPostVotes(_ref2) {
  var postId = _ref2.postId;

  if (FEATURE_FLAGS.mockGetVotes) {
    return (0, _socialBarActionsMock.getVotes)({ postId: postId });
  }
  return function (dispatch, getState) {
    return (0, _currentPostActionCounterProvider.fetchReactions)().then(_socialBarDataTransformer.transformGetVotesResponse).then(function (state) {
      return dispatch({
        type: REACTIONS.GET_VOTES,
        state: state
      });
    }).catch(_console.warn);
  };
}

var socialBarActions = exports.socialBarActions = {
  displayReactions: displayReactions,
  hideReactions: hideReactions,
  sendVote: sendVote,
  getPostVotes: getPostVotes,
  setReactionsComponentState: setReactionsComponentState
};

/***/ }),

/***/ 671:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(14);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = initSocialBarComponents;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(37);

var _reduxMounter = __webpack_require__(45);

var _reduxMounter2 = _interopRequireDefault(_reduxMounter);

var _ua = __webpack_require__(10);

var _socialBarActions = __webpack_require__(670);

var _socialBarReducer = __webpack_require__(673);

var _pageDataObject = __webpack_require__(5);

var _i18nProvider = __webpack_require__(18);

var _socialBarComponent = __webpack_require__(668);

var _socialBarComponent2 = _interopRequireDefault(_socialBarComponent);

var _preRenderedSelectorsConfig = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var REACTIONS_FEATURE_ID = 'Reactions'; /* eslint semi:0 */
var isEmbedded = _ua.path.isEmbedded;

var COMPONENT_NAME = 'SocialBarContainer';
var STATE_KEY = 'socialBar';
var bottomComponentWhitelistByDomain = ['ei'];

function mapStateToProps(state) {
  var _state$STATE_KEY = state[STATE_KEY],
      reactions = _state$STATE_KEY.reactions,
      selectedReaction = _state$STATE_KEY.selectedReaction,
      reactionsComponentState = _state$STATE_KEY.reactionsComponentState,
      postId = _state$STATE_KEY.postId,
      votes = _state$STATE_KEY.votes,
      percentages = _state$STATE_KEY.percentages,
      isInCoverViewport = _state$STATE_KEY.isInCoverViewport;

  return {
    reactions: reactions,
    selectedReaction: selectedReaction,
    reactionsComponentState: reactionsComponentState,
    postId: postId,
    percentages: percentages,
    votes: votes,
    isInCoverViewport: isInCoverViewport
  };
}

var SocialBarContainer = {
  name: COMPONENT_NAME,
  stateKey: STATE_KEY,
  component: (0, _reactRedux.connect)(mapStateToProps, _socialBarActions.socialBarActions)(_socialBarComponent2.default),
  reducer: _socialBarReducer.socialBarReducer
};

function getSocialBarContainer(componentPosition) {
  var initialPosition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { isVisible: false };
  var title = arguments[2];

  return (0, _extends3.default)({}, SocialBarContainer, {
    props: {
      title: title,
      componentPosition: componentPosition,
      reactionsComponentInitialState: (0, _defineProperty3.default)({}, componentPosition, initialPosition)
    }
  });
}

function shouldLoadReactionsBottomComponent(getSocialBarContainerCb) {
  return bottomComponentWhitelistByDomain.includes((0, _pageDataObject.getPageDomain)()) ? getSocialBarContainerCb('bottom', { isVisible: true }, (0, _i18nProvider.t)('reactions.your_reaction')) : getSocialBarContainerCb('bottom', { isVisible: false }, (0, _i18nProvider.t)('reactions.your_reaction'));
}

function mountSocialBarComponents() {
  var _reduxMount;

  var SOCIAL_BAR_COMPONENT__HEADER = _preRenderedSelectorsConfig.MOUNT_POINTS.SOCIAL_BAR_COMPONENT__HEADER,
      SOCIAL_BAR_COMPONENT__COVER = _preRenderedSelectorsConfig.MOUNT_POINTS.SOCIAL_BAR_COMPONENT__COVER,
      SOCIAL_BAR_COMPONENT__DETAILS = _preRenderedSelectorsConfig.MOUNT_POINTS.SOCIAL_BAR_COMPONENT__DETAILS,
      SOCIAL_BAR_COMPONENT__BOTTOM = _preRenderedSelectorsConfig.MOUNT_POINTS.SOCIAL_BAR_COMPONENT__BOTTOM;

  return (0, _reduxMounter2.default)((_reduxMount = {}, (0, _defineProperty3.default)(_reduxMount, SOCIAL_BAR_COMPONENT__HEADER, getSocialBarContainer('header')), (0, _defineProperty3.default)(_reduxMount, SOCIAL_BAR_COMPONENT__COVER, getSocialBarContainer('cover')), (0, _defineProperty3.default)(_reduxMount, SOCIAL_BAR_COMPONENT__DETAILS, getSocialBarContainer('details', { isVisible: true })), (0, _defineProperty3.default)(_reduxMount, SOCIAL_BAR_COMPONENT__BOTTOM, shouldLoadReactionsBottomComponent(getSocialBarContainer)), _reduxMount));
}

function shouldMountSocialBarComponents() {
  return (0, _pageDataObject.isSupportedForDomain)(REACTIONS_FEATURE_ID) && !(0, _pageDataObject.getIsHybrid)() && !isEmbedded && !(0, _ua.getIsNativeApp)();
}

function initSocialBarComponents() {
  var shouldMountSocialBars = shouldMountSocialBarComponents();
  if (shouldMountSocialBars) {
    mountSocialBarComponents();
  }
  return shouldMountSocialBars;
}

/***/ }),

/***/ 672:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(22);

var _keys2 = _interopRequireDefault(_keys);

exports.transformGetVotesResponse = transformGetVotesResponse;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isEmptyVotesResponse(response) {
  var keys = (0, _keys2.default)(response);
  var length = keys.length;

  if (length > 1) {
    return false;
  }
  if (length === 0 || length === 1 && keys.includes('error')) {
    return true;
  }
  return false;
}
function transformGetVotesResponse(response) {
  if (isEmptyVotesResponse(response)) {
    return {};
  }
  return {
    votes: (0, _keys2.default)(response).reduce(function (acc, curr) {
      acc[curr.replace(/answer_/i, '')] = +response[curr];
      return acc;
    }, {})
  };
}

/***/ }),

/***/ 673:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(14);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _keys = __webpack_require__(22);

var _keys2 = _interopRequireDefault(_keys);

exports.socialBarReducer = socialBarReducer;

var _pageDataObject = __webpack_require__(5);

var _navbarActions = __webpack_require__(313);

var _socialBarActionTypes = __webpack_require__(98);

var _socialBarDataSource = __webpack_require__(298);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint semi:0 */
function getSelectedReaction() {
  var votes = (0, _socialBarDataSource.getClientVotes)();
  if ((0, _pageDataObject.getPostId)() in votes) {
    return votes[(0, _pageDataObject.getPostId)()];
  }
  return null;
}

function getDefaultState() {
  return {
    reactions: (0, _socialBarDataSource.getReactions)(),
    selectedReaction: getSelectedReaction(),
    isInCoverViewport: true,
    postId: (0, _pageDataObject.getPostId)(),
    reactionsComponentState: {}
  };
}

function getPercentage(numVotes, totalVotes) {
  return parseInt(100 * numVotes / totalVotes, 10);
}

function getVoteAggregates(votes) {
  var votesKeys = (0, _keys2.default)(votes);
  var totalVotes = votesKeys.reduce(function (acc, curr) {
    return acc + votes[curr];
  }, 0);
  var totalPercent = votesKeys.reduce(function (acc, curr) {
    return acc + getPercentage(votes[curr], totalVotes);
  }, 0);
  var percentages = votesKeys.reduce(function (acc, curr) {
    acc[curr] = getPercentage(votes[curr], totalVotes);
    return acc;
  }, {});
  return { votesKeys: votesKeys, totalVotes: totalVotes, totalPercent: totalPercent, percentages: percentages };
}

function getVotesPercentages(votes) {
  var _getVoteAggregates = getVoteAggregates(votes),
      votesKeys = _getVoteAggregates.votesKeys,
      totalVotes = _getVoteAggregates.totalVotes,
      totalPercent = _getVoteAggregates.totalPercent,
      percentages = _getVoteAggregates.percentages;

  if (!totalVotes) {
    return {};
  }
  var gap = 100 - totalPercent;
  if (!gap) {
    return percentages;
  }
  var firstItemKey = votesKeys[0];
  var firstItemVal = percentages[firstItemKey] + gap;
  var firstItemKVP = (0, _defineProperty3.default)({}, firstItemKey, firstItemVal);
  return (0, _extends3.default)({}, percentages, firstItemKVP);
}

function incVotesWithSelfVote(votes, myReactionId) {
  var votesWithMe = (0, _defineProperty3.default)({}, myReactionId, (votes[myReactionId] || 0) + 1);
  return (0, _extends3.default)({}, votes, votesWithMe);
}

function filterVotesByReactions(_ref) {
  var reactions = _ref.reactions,
      votes = _ref.votes;

  var reactionIds = reactions.map(function (r) {
    return r.id;
  });
  return (0, _keys2.default)(votes).filter(function (v) {
    return reactionIds.includes(v);
  }).reduce(function (acc, curr) {
    acc[curr] = votes[curr];
    return acc;
  }, {});
}

function reduceGetVotes(state, newState) {
  var _newState$votes = newState.votes,
      votes = _newState$votes === undefined ? {} : _newState$votes;
  var reactionsData = state.reactions;
  var reactions = reactionsData.reactions;

  var votesForCurrReactions = filterVotesByReactions({ reactions: reactions, votes: votes });
  var percentages = getVotesPercentages(votesForCurrReactions);
  return (0, _extends3.default)({}, state, newState, { percentages: percentages });
}

function reduceUserVote(state, newState) {
  var reactionsData = state.reactions,
      _state$votes = state.votes,
      votes = _state$votes === undefined ? {} : _state$votes;
  var reactions = reactionsData.reactions;
  var myReactionId = newState.selectedReaction;

  var votesForCurrReactions = filterVotesByReactions({ reactions: reactions, votes: votes });
  var votesIncludingMine = incVotesWithSelfVote(votesForCurrReactions, myReactionId);
  var percentages = getVotesPercentages(votesIncludingMine);
  return (0, _extends3.default)({}, state, newState, { percentages: percentages });
}

function reduceComponentPosition(state, newState) {
  var isInCoverViewport = newState.isInViewport;

  return (0, _extends3.default)({}, state, newState, { isInCoverViewport: isInCoverViewport });
}

function getReactionsStateWithoutDeleted(state, reactionsComponentState) {
  var removePosition = reactionsComponentState.removePosition;

  var reactionsComponentStateWithoutDeleted = (0, _extends3.default)({}, reactionsComponentState);
  delete reactionsComponentStateWithoutDeleted[removePosition];
  delete reactionsComponentStateWithoutDeleted.removePosition;
  return (0, _extends3.default)({}, state, {
    reactionsComponentState: reactionsComponentStateWithoutDeleted
  });
}

function setReactionsComponentState(state, _ref2) {
  var reactionsComponentState = _ref2.reactionsComponentState;

  if (reactionsComponentState && reactionsComponentState.removePosition) {
    return getReactionsStateWithoutDeleted(state, reactionsComponentState);
  }
  return (0, _extends3.default)({}, state, {
    reactionsComponentState: (0, _extends3.default)({}, state.reactionsComponentState, reactionsComponentState)
  });
}

var REACHED_COVER_SOCIAL_COMPONENT = _navbarActions.TYPES.REACHED_COVER_SOCIAL_COMPONENT;
var REACTIONS = _socialBarActionTypes.SOCIAL_BAR_ACTION_TYPES.REACTIONS;
function socialBarReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getDefaultState();
  var action = arguments[1];

  switch (action.type) {
    case REACTIONS.SEND_VOTE:
      return reduceUserVote(state, action.state);
    case REACHED_COVER_SOCIAL_COMPONENT:
      return reduceComponentPosition(state, action.state);
    case REACTIONS.GET_VOTES:
      return reduceGetVotes(state, action.state);
    case REACTIONS.SET_REACTIONS_COMPONENT_STATE:
    case REACTIONS.DISPLAY:
    case REACTIONS.HIDE:
      return setReactionsComponentState(state, action.state);
    default:
      return state;
  }
}

/***/ }),

/***/ 676:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Loader = Loader;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var loaderClasses = ['header-top', 'left-padding', 'mid-gutter', 'line-0', 'line-1', 'line-2', 'line-3', 'blocker-0', 'blocker-1', 'blocker-2', 'right-padding', 'header-bottom'];

function initLoader() {
  return _react2.default.createElement(
    'div',
    { className: 'loader-background' },
    loaderClasses.map(function (item, idx) {
      return _react2.default.createElement('div', { className: 'background-masker ' + item, key: 'loader-' + idx });
    })
  );
}

function Loader(_ref) {
  var isInitialized = _ref.isInitialized;

  return isInitialized ? _react2.default.createElement('noscript', null) : initLoader();
}

/***/ }),

/***/ 677:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RecommendedHeader = RecommendedHeader;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _i18nProvider = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function RecommendedHeader() {
  return _react2.default.createElement(
    'h3',
    { className: 'recommended-header' },
    (0, _i18nProvider.t)('tv_template.recommended')
  );
}

/***/ }),

/***/ 678:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RecommendedList = RecommendedList;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _loader = __webpack_require__(676);

var _thumbnail = __webpack_require__(679);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function RecommendedList(_ref) {
  var itemsList = _ref.itemsList,
      isInitialized = _ref.isInitialized,
      analyticsEventAction = _ref.analyticsEventAction,
      analyticsEventCategory = _ref.analyticsEventCategory,
      analyticsEventLabel = _ref.analyticsEventLabel,
      analyticsEventValue = _ref.analyticsEventValue;

  return _react2.default.createElement(
    'ul',
    { className: 'recommended-list' },
    itemsList.map(function (item, idx) {
      return _react2.default.createElement(
        'li',
        { className: 'recommended-list__item', key: 'recommended-list-' + idx },
        _react2.default.createElement(
          'a',
          {
            href: item.hlink,
            className: 'wrap-link',
            'data-analytics-event-category': analyticsEventCategory,
            'data-analytics-event-action': analyticsEventAction,
            'data-analytics-event-label': analyticsEventLabel,
            'data-analytics-event-value': analyticsEventValue + ' ' + idx
          },
          _react2.default.createElement(_thumbnail.Thumbnail, { imageUrl: item.image, title: item.title })
        ),
        _react2.default.createElement(_loader.Loader, { isInitialized: isInitialized })
      );
    })
  );
}

/***/ }),

/***/ 679:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Thumbnail = Thumbnail;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Thumbnail(_ref) {
  var imageUrl = _ref.imageUrl,
      title = _ref.title;

  return _react2.default.createElement(
    "div",
    { className: "thumbnail" },
    _react2.default.createElement("div", { className: "thumbnail__image", style: { backgroundImage: "url(" + imageUrl + ")" } }),
    _react2.default.createElement(
      "p",
      { className: "thumbnail__excerpt" },
      title
    )
  );
}

/***/ }),

/***/ 680:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RecommendedVideosComponent = undefined;

var _defineProperty2 = __webpack_require__(14);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

exports.default = initRecommendedVideos;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(37);

var _appStore = __webpack_require__(23);

var _reduxMounter = __webpack_require__(45);

var _reduxMounter2 = _interopRequireDefault(_reduxMounter);

var _recommendedVideos = __webpack_require__(806);

var _recommendedVideos2 = __webpack_require__(223);

var _recommendedHeader = __webpack_require__(677);

var _recommendedList = __webpack_require__(678);

var _preRenderedSelectorsConfig = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var componentName = 'recommendedVideos';
var stateKey = componentName;

var RecommendedVideosComponent = exports.RecommendedVideosComponent = function (_Component) {
  (0, _inherits3.default)(RecommendedVideosComponent, _Component);

  function RecommendedVideosComponent() {
    (0, _classCallCheck3.default)(this, RecommendedVideosComponent);
    return (0, _possibleConstructorReturn3.default)(this, (RecommendedVideosComponent.__proto__ || (0, _getPrototypeOf2.default)(RecommendedVideosComponent)).apply(this, arguments));
  }

  (0, _createClass3.default)(RecommendedVideosComponent, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var playlistId = this.props.options.dataset.playlistId;

      (0, _appStore.dispatch)((0, _recommendedVideos2.setPlaylistId)(playlistId));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          itemsList = _props.recommendedItems,
          isInitialized = _props.isInitialized,
          recievedError = _props.recievedError;
      var _props$options$datase = this.props.options.dataset,
          analyticsEventAction = _props$options$datase.analyticsEventAction,
          analyticsEventCategory = _props$options$datase.analyticsEventCategory,
          analyticsEventLabel = _props$options$datase.analyticsEventLabel,
          analyticsEventValue = _props$options$datase.analyticsEventValue;

      var recommendedVideosProps = {
        itemsList: itemsList,
        isInitialized: isInitialized,
        recievedError: recievedError,
        analyticsEventAction: analyticsEventAction,
        analyticsEventCategory: analyticsEventCategory,
        analyticsEventLabel: analyticsEventLabel,
        analyticsEventValue: analyticsEventValue
      };
      return recievedError ? _react2.default.createElement('noscript', null) : _react2.default.createElement(
        'div',
        { className: 'recommended-videos' },
        _react2.default.createElement(_recommendedHeader.RecommendedHeader, null),
        _react2.default.createElement(_recommendedList.RecommendedList, recommendedVideosProps)
      );
    }
  }]);
  return RecommendedVideosComponent;
}(_react.Component);

function mapStateToProps(state) {
  var _state$stateKey = state[stateKey],
      isInitialized = _state$stateKey.isInitialized,
      recommendedItems = _state$stateKey.recommendedItems,
      recievedError = _state$stateKey.recievedError;

  return {
    isInitialized: isInitialized,
    recommendedItems: recommendedItems,
    recievedError: recievedError
  };
}

var recommendedVideosContainer = {
  name: componentName,
  stateKey: stateKey,
  component: (0, _reactRedux.connect)(mapStateToProps, { recievedRecommedationsAction: _recommendedVideos2.recievedRecommedationsAction })(RecommendedVideosComponent),
  reducer: _recommendedVideos.recommendedListReducers
};

function mountRecommendedVideos() {
  return (0, _reduxMounter2.default)((0, _defineProperty3.default)({}, _preRenderedSelectorsConfig.MOUNT_POINTS.RECOMMENDED_VIDEOS_CONTAINER, recommendedVideosContainer));
}

function initRecommendedVideos() {
  mountRecommendedVideos();
}

/***/ }),

/***/ 691:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SocialButtonOrLink = SocialButtonOrLink;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SocialLink(_ref) {
  var title = _ref.title,
      name = _ref.name,
      href = _ref.href,
      openInSameTab = _ref.openInSameTab,
      analyticsActionText = _ref.analyticsActionText;

  var socialLinkProps = {
    href: href,
    className: 'share-component__btn share-component__btn--' + name,
    title: title,
    rel: 'noopener noreferrer',
    key: name,
    'data-type': name,
    'data-analytics-action-text': analyticsActionText
  };

  if (!openInSameTab) {
    socialLinkProps.target = '_blank';
  }

  return _react2.default.createElement('a', socialLinkProps);
}

function SocialButton(_ref2) {
  var title = _ref2.title,
      name = _ref2.name,
      onClick = _ref2.onClick,
      analyticsActionText = _ref2.analyticsActionText;

  var socialbuttonProps = {
    onClick: onClick,
    className: 'share-component__btn share-component__btn--' + name,
    title: title,
    type: 'button',
    key: name,
    'data-type': name,
    'data-analytics-action-text': analyticsActionText
  };
  return _react2.default.createElement('button', socialbuttonProps);
}

function SocialButtonOrLink(props) {
  return props.href ? SocialLink(props) : SocialButton(props);
}

/***/ }),

/***/ 692:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SocialButtonsComponent = undefined;

var _defineProperty2 = __webpack_require__(14);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _values = __webpack_require__(127);

var _values2 = _interopRequireDefault(_values);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

exports.initSocialButtons = initSocialButtons;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(37);

var _reselect = __webpack_require__(1297);

var _reduxMounter = __webpack_require__(45);

var _reduxMounter2 = _interopRequireDefault(_reduxMounter);

var _pageDataObject = __webpack_require__(5);

var _preRenderedSelectorsConfig = __webpack_require__(17);

var _socialButtonsConfig = __webpack_require__(248);

var _config = __webpack_require__(790);

var _userDevice = __webpack_require__(429);

var _featureFlags = __webpack_require__(794);

var _SocialButton = __webpack_require__(691);

var _analyticsActions = __webpack_require__(31);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SOCIAL_BUTTONS_FEATURE_ID = 'SocialButtons';

var COMPONENT_NAME = 'SocialButtonsComponent';

var SocialButtons = function (_React$Component) {
  (0, _inherits3.default)(SocialButtons, _React$Component);

  function SocialButtons() {
    (0, _classCallCheck3.default)(this, SocialButtons);
    return (0, _possibleConstructorReturn3.default)(this, (SocialButtons.__proto__ || (0, _getPrototypeOf2.default)(SocialButtons)).apply(this, arguments));
  }

  (0, _createClass3.default)(SocialButtons, [{
    key: 'onClick',
    value: function onClick(_ref) {
      var target = _ref.target;

      this.props.shareButtonsAnalyticsAction(target.dataset.type, target.dataset.analyticsActionText);
    }
  }, {
    key: 'render',
    value: function render() {
      var socialButtonsProps = {
        className: (this.props.className ? this.props.className : '') + ' share-component share-component--post-cover',
        children: this.props.buttons.map(_SocialButton.SocialButtonOrLink),
        onClick: this.onClick.bind(this)
      };
      return _react2.default.createElement('div', socialButtonsProps);
    }
  }]);
  return SocialButtons;
}(_react2.default.Component);

var createIsComponentSupportedForSite = function createIsComponentSupportedForSite(state) {
  return (0, _featureFlags.isComponentSupportedForSite)(state, SOCIAL_BUTTONS_FEATURE_ID);
};

function filterOutWhatsappOnNonMobile(isMobile, item) {
  return isMobile || item !== _socialButtonsConfig.WHATSAPP;
}

function filterOutEmbedAndRedditOnMobileAndTablet(isMobileOrTablet, item) {
  return !isMobileOrTablet || isMobileOrTablet && item !== _socialButtonsConfig.EMBED && item !== _socialButtonsConfig.REDDIT;
}

function filterOutExcludedComponentsForSite(excludedFeatures, item) {
  return !excludedFeatures.some(function (excluded) {
    return excluded === item;
  });
}

function openWhatsappInSameTab(button) {
  return button.name === _socialButtonsConfig.WHATSAPP ? (0, _extends3.default)({}, button, {
    openInSameTab: true
  }) : button;
}
var getSocialButtonsSelector = (0, _reselect.createSelector)([_config.getSocialButtonsConfig, _userDevice.getIsMobile, _userDevice.getIsMobileOrTablet, createIsComponentSupportedForSite, _featureFlags.excludedComponentsForSite], function (socialButtonsConfig, isMobile, isMobileOrTablet, isSupported, excludedFeatures) {
  return (0, _values2.default)(socialButtonsConfig).filter(function () {
    return isSupported;
  }).filter(function (_ref2) {
    var name = _ref2.name;
    return filterOutEmbedAndRedditOnMobileAndTablet(isMobileOrTablet, name);
  }).filter(function (_ref3) {
    var name = _ref3.name;
    return filterOutWhatsappOnNonMobile(isMobile, name);
  }).filter(function (_ref4) {
    var name = _ref4.name;
    return filterOutExcludedComponentsForSite(excludedFeatures, name);
  }).map(function (button) {
    return openWhatsappInSameTab(button);
  });
});
var makeMapStateToProps = function makeMapStateToProps(state, props) {
  return { buttons: getSocialButtonsSelector(state, props) };
};

var mapDispatchToProps = {
  shareButtonsAnalyticsAction: _analyticsActions.shareButtonsAnalyticsAction
};

var SocialButtonsComponent = exports.SocialButtonsComponent = (0, _reactRedux.connect)(makeMapStateToProps, mapDispatchToProps)(SocialButtons);

var socialButtonsMountDetails = {
  name: COMPONENT_NAME,
  component: SocialButtonsComponent
};

function mountSocialButtons() {
  return (0, _reduxMounter2.default)((0, _defineProperty3.default)({}, _preRenderedSelectorsConfig.MOUNT_POINTS.SHARE_COMPONENT, socialButtonsMountDetails));
}

function initSocialButtons() {
  var shouldMountSocialButtons = (0, _pageDataObject.isSupportedForDomain)(SOCIAL_BUTTONS_FEATURE_ID);
  if (shouldMountSocialButtons) {
    mountSocialButtons();
  }
  return shouldMountSocialButtons;
}

/***/ }),

/***/ 694:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.taboolaFeedEventsReporter = taboolaFeedEventsReporter;

var _analyticsActions = __webpack_require__(31);

var _appStore = __webpack_require__(23);

var isReportEmbed = false;

function taboolaFeedEventsReporter() {
  window._taboola = window._taboola || [];
  window._taboola.push({
    listenTo: 'click',
    handler: function handler(e) {
      if (undefined !== e && e !== null) {
        var cardType = e.detail.type;
        if (cardType === 'sponsored') {
          cardType = 'paid content click';
        } else {
          cardType = 'article click';
        }
        var slot = e.detail.slot;
        if (undefined !== e.detail.placement) {
          var placement = e.detail.placement;
          var card = placement !== undefined ? placement.slice(-2) : '';
          var client = 'bottom';
          if (placement.includes('Desktop Sidebar')) {
            client = 'right';
          }
          (0, _appStore.dispatch)((0, _analyticsActions.taboolaFeedClickEvent)(cardType, slot, card, client));
        }
      }
    }
  });

  window._taboola.push({
    listenTo: 'render',
    handler: function handler(e) {
      if (!isReportEmbed && undefined !== e && e !== null) {
        isReportEmbed = true;
        (0, _appStore.dispatch)((0, _analyticsActions.taboolaFeedEmbedEvent)());
      }
    }
  });

  window._taboola.push({
    listenTo: 'visible',
    handler: function handler(e) {
      if (undefined !== e && e !== null) {
        var cardType = 'sponsored';
        if (null !== e.detail.baseMode) {
          cardType = e.detail.baseMode.includes('organic') ? 'article recommendations' : 'sponsored';
        }
        var placement = e.detail.placement;
        var card = placement !== undefined ? placement.slice(-2) : '';
        var client = 'bottom';
        if (placement.includes('Desktop Sidebar')) {
          client = 'right';
        }
        (0, _appStore.dispatch)((0, _analyticsActions.taboolaFeedViewabilityEvent)(cardType, card, client));
      }
    }
  });
}

/***/ }),

/***/ 695:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _map = __webpack_require__(820);

var _map2 = _interopRequireDefault(_map);

exports.trackAnalyticsYoutubeEvents = trackAnalyticsYoutubeEvents;

var _video = __webpack_require__(251);

var _appStore = __webpack_require__(23);

var _youtubeActions = __webpack_require__(414);

var _script = __webpack_require__(19);

var _externalScripts = __webpack_require__(52);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getAnalyticsVideoBaseData(videoPlayer) {
  return {
    videoID: videoPlayer.getVideoData().video_id,
    pageType: (0, _video.getAnalyticsPageType)(),
    videoMainWrapperName: (0, _video.getVideoPostWrapperName)(videoPlayer.getIframe()),
    duration: videoPlayer.getDuration(),
    currentTime: videoPlayer.getCurrentTime()
  };
}

var playerStateHandlers = [_youtubeActions.youtubeAnalyticsCompleteAction, _youtubeActions.youtubeAnalyticsPlayAction, _youtubeActions.youtubeAnalyticsPauseAction];

function onPlayerStateChange(evt) {
  var _getAnalyticsVideoBas = getAnalyticsVideoBaseData(evt.target),
      videoID = _getAnalyticsVideoBas.videoID,
      pageType = _getAnalyticsVideoBas.pageType,
      videoMainWrapperName = _getAnalyticsVideoBas.videoMainWrapperName,
      duration = _getAnalyticsVideoBas.duration,
      currentTime = _getAnalyticsVideoBas.currentTime;

  if (!playerStateHandlers[evt.data]) {
    return;
  }

  (0, _appStore.dispatch)(playerStateHandlers[evt.data](videoID, pageType, videoMainWrapperName, {
    duration: duration,
    position: currentTime
  }));
}

function handleVideoPostMessage() {
  var lastRegisteredStep = -1;

  return function videoMessage(msgEvent) {
    if (msgEvent.origin !== 'https://www.youtube.com') {
      return;
    }
    if (typeof msgEvent.data !== 'string') {
      return;
    }
    var videoMessageData = JSON.parse(msgEvent.data);

    if (videoMessageData.event !== 'infoDelivery') {
      return;
    }

    var playerIframeID = videoMessageData.channel + (videoMessageData.id + 1);
    var currentPlayer = YT.get(playerIframeID);

    var _getAnalyticsVideoBas2 = getAnalyticsVideoBaseData(currentPlayer),
        videoID = _getAnalyticsVideoBas2.videoID,
        pageType = _getAnalyticsVideoBas2.pageType,
        videoMainWrapperName = _getAnalyticsVideoBas2.videoMainWrapperName,
        duration = _getAnalyticsVideoBas2.duration,
        currentTime = _getAnalyticsVideoBas2.currentTime;

    var percentageStep = (0, _video.calculateVideoTimePercent)(duration, currentTime);

    if (percentageStep.constructor === Number && lastRegisteredStep !== percentageStep) {
      (0, _appStore.dispatch)((0, _youtubeActions.youtubeAnalyticsPercentageChangeAction)(videoID, pageType, videoMainWrapperName, {
        duration: duration,
        position: currentTime
      }, percentageStep));
      lastRegisteredStep = percentageStep;
    }
  };
}

function registerToYoutubeEvents(youtubeIframes) {
  window.onYouTubeIframeAPIReady = function () {
    (0, _map2.default)(youtubeIframes, function (currentPlayer) {
      var player = new YT.Player(currentPlayer, {
        events: {
          onStateChange: onPlayerStateChange
        }
      });
    });
    window.addEventListener('message', handleVideoPostMessage());
  };
}
function loadYoutubeApiScript() {
  _script.external.load({
    config: {
      src: _externalScripts.externalScriptsConfig.youtube.src,
      name: _externalScripts.externalScriptsConfig.youtube.name
    }
  })();
}

function trackAnalyticsYoutubeEvents() {
  var youtubeIframes = document.querySelectorAll('iframe.Youtube');
  if (youtubeIframes.length > 0) {
    loadYoutubeApiScript();
    registerToYoutubeEvents(youtubeIframes);
  }
}

/***/ }),

/***/ 696:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TransferNewsContainer = undefined;

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _image = __webpack_require__(245);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TransferNewsContainer = exports.TransferNewsContainer = function (_React$Component) {
  (0, _inherits3.default)(TransferNewsContainer, _React$Component);

  function TransferNewsContainer() {
    (0, _classCallCheck3.default)(this, TransferNewsContainer);
    return (0, _possibleConstructorReturn3.default)(this, (TransferNewsContainer.__proto__ || (0, _getPrototypeOf2.default)(TransferNewsContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(TransferNewsContainer, [{
    key: 'render',
    value: function render() {
      return this.props.news.length > 0 ? _react2.default.createElement(
        'div',
        { className: 'transfer-news--container' },
        _react2.default.createElement(
          'div',
          { className: 'section-title transfer-news--title' },
          this.props.title
        ),
        _react2.default.createElement(
          'ul',
          null,
          this.props.news.map(function (item, i) {
            return TransferNewsItem(item, i);
          })
        )
      ) : null;
    }
  }]);
  return TransferNewsContainer;
}(_react2.default.Component);

var TransferNewsItem = function TransferNewsItem(props, position) {
  return _react2.default.createElement(
    'a',
    {
      className: 'transfer-news--item',
      href: props.path,
      'data-analytics-event-category': 'Article page',
      'data-analytics-event-action': 'article click',
      'data-analytics-event-label': 'transfer news',
      'data-analytics-event-value': 'position ' + position,
      key: position
    },
    _react2.default.createElement(_image.Image, {
      lazyLoad: true,
      className: 'transfer-news--item--image',
      src: props.image,
      alt: props.title
    }),
    _react2.default.createElement(
      'span',
      { className: 'transfer-news--item--title' },
      props.title
    )
  );
};

/***/ }),

/***/ 701:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.registerExternalScripts = registerExternalScripts;

var _viewbilityTracker = __webpack_require__(99);

function registerExternalScripts() {
  (0, _viewbilityTracker.register)('.top-posts-side-bar__item');
  (0, _viewbilityTracker.register)('.riddleEmbedded');
}

/***/ }),

/***/ 702:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(138);

var _window = __webpack_require__(8);

var _initTopPosts = __webpack_require__(720);

var _initTopPosts2 = _interopRequireDefault(_initTopPosts);

var _initBrowsi = __webpack_require__(315);

var _initBrowsi2 = _interopRequireDefault(_initBrowsi);

var _deviceScreenClassifier = __webpack_require__(716);

var _deviceScreenClassifier2 = _interopRequireDefault(_deviceScreenClassifier);

var _pageTemplateClassifier = __webpack_require__(721);

var _pageTemplateClassifier2 = _interopRequireDefault(_pageTemplateClassifier);

var _analyticsInitializer = __webpack_require__(142);

var _analyticsInitializer2 = _interopRequireDefault(_analyticsInitializer);

__webpack_require__(715);

var _documentBodyClassSetter = __webpack_require__(717);

var _documentBodyClassSetter2 = _interopRequireDefault(_documentBodyClassSetter);

__webpack_require__(722);

var _localeCookieInitializer = __webpack_require__(146);

var _localeCookieInitializer2 = _interopRequireDefault(_localeCookieInitializer);

var _fantasyMounter = __webpack_require__(626);

var _fantasyMounter2 = _interopRequireDefault(_fantasyMounter);

var _facebookBotMounter = __webpack_require__(617);

var _facebookBotMounter2 = _interopRequireDefault(_facebookBotMounter);

var _initGoogleAds = __webpack_require__(210);

var _initGoogleAds2 = _interopRequireDefault(_initGoogleAds);

var _initEiExternalScripts = __webpack_require__(211);

var _initTheDuelExternalScripts = __webpack_require__(212);

var _initPPTracker = __webpack_require__(719);

var _initPPTracker2 = _interopRequireDefault(_initPPTracker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var noThirdParty = _window.queryString.noThirdParty; /* eslint semi:0 */
/**
 * Initializes post page specific modules.
 */

function initInitializers() {
  (0, _deviceScreenClassifier2.default)();
  (0, _pageTemplateClassifier2.default)();
  (0, _initTopPosts2.default)();
  (0, _analyticsInitializer2.default)();
  (0, _documentBodyClassSetter2.default)();
  (0, _localeCookieInitializer2.default)();
}

function initThirdParty() {
  (0, _initGoogleAds2.default)();
  (0, _initBrowsi2.default)();
  (0, _initEiExternalScripts.initEiExternalScripts)();
  (0, _initTheDuelExternalScripts.initTheDuelExternalScripts)();
  (0, _initPPTracker2.default)();
  (0, _fantasyMounter2.default)();
  (0, _facebookBotMounter2.default)();
}

function init() {
  initInitializers();
  if (!noThirdParty) {
    initThirdParty();
  }
}

init();

/***/ }),

/***/ 708:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _component = __webpack_require__(70);

var _BaseClass2 = __webpack_require__(43);

var _BaseClass3 = _interopRequireDefault(_BaseClass2);

var _NavbarVM = __webpack_require__(771);

var _NavbarVM2 = _interopRequireDefault(_NavbarVM);

var _NavbarView = __webpack_require__(766);

var _NavbarView2 = _interopRequireDefault(_NavbarView);

var _navbarStore = __webpack_require__(761);

var _navbarStore2 = _interopRequireDefault(_navbarStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavbarController = function (_BaseClass) {
  (0, _inherits3.default)(NavbarController, _BaseClass);

  function NavbarController() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck3.default)(this, NavbarController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (NavbarController.__proto__ || (0, _getPrototypeOf2.default)(NavbarController)).call(this, options));

    var store = options.store || _navbarStore2.default;
    _this.vm = _NavbarVM2.default.create({ store: store });
    return _this;
  }

  return NavbarController;
}(_BaseClass3.default);

exports.default = (0, _component.make)(NavbarController, _NavbarView2.default);

/***/ }),

/***/ 709:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.slideshowReducer = exports.stateKey = undefined;
exports.default = slideshowReducer;

var _appStore = __webpack_require__(23);

var _slideshowActions = __webpack_require__(246);

/* eslint semi:0 */
var START_SLIDE_CHANGE = _slideshowActions.TYPES.START_SLIDE_CHANGE;


var SLIDESHOW_INITIAL_STATE = {
  changedSlidesCount: 0
};

var stateKey = 'slideshow';

function slideshowReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : SLIDESHOW_INITIAL_STATE;
  var action = arguments[1];

  switch (action.type) {
    case START_SLIDE_CHANGE:
      return (0, _appStore.setState)(state, {
        changedSlidesCount: (0, _appStore.getState)()[stateKey].changedSlidesCount + 1
      });
    default:
  }
  return state;
}

exports.stateKey = stateKey;
exports.slideshowReducer = slideshowReducer;

/***/ }),

/***/ 710:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _mithril = __webpack_require__(34);

var _BaseClass2 = __webpack_require__(43);

var _BaseClass3 = _interopRequireDefault(_BaseClass2);

var _slideshowVm = __webpack_require__(775);

var _slideshowVm2 = _interopRequireDefault(_slideshowVm);

var _SlideshowView = __webpack_require__(768);

var _SlideshowView2 = _interopRequireDefault(_SlideshowView);

var _component = __webpack_require__(70);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SlideshowController = function (_BaseClass) {
  (0, _inherits3.default)(SlideshowController, _BaseClass);

  function SlideshowController() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck3.default)(this, SlideshowController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SlideshowController.__proto__ || (0, _getPrototypeOf2.default)(SlideshowController)).call(this, options));

    _this.vm = _slideshowVm2.default;
    _this.vm.startSlideChange({
      slideId: _this.vm.getCurrentSlideIndex(_mithril.route.param('slideId'))
    });
    return _this;
  }

  return SlideshowController;
}(_BaseClass3.default);

exports.default = (0, _component.make)(SlideshowController, _SlideshowView2.default).call();

/***/ }),

/***/ 715:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _join = __webpack_require__(432);

var _join2 = _interopRequireDefault(_join);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _getIterator2 = __webpack_require__(58);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _defineProperty2 = __webpack_require__(14);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _SCROLL_ANCHORS_BY_PL; /* eslint semi:0 */


var _analyticsActions = __webpack_require__(31);

var _analyticsActions2 = _interopRequireDefault(_analyticsActions);

var _ua = __webpack_require__(10);

var _scrollingEventsProvider = __webpack_require__(221);

var _scrollingEventsProvider2 = _interopRequireDefault(_scrollingEventsProvider);

var _dom = __webpack_require__(13);

var _preRenderedSelectorsConfig = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TITLE = _preRenderedSelectorsConfig.SCROLL_EVENTS_SELECTORS.TITLE,
    BODY_START = _preRenderedSelectorsConfig.SCROLL_EVENTS_SELECTORS.BODY_START,
    SHARE_BUTTONS_BOTTOM = _preRenderedSelectorsConfig.SCROLL_EVENTS_SELECTORS.SHARE_BUTTONS_BOTTOM,
    TOP_POSTS = _preRenderedSelectorsConfig.SCROLL_EVENTS_SELECTORS.TOP_POSTS,
    PAGE_END = _preRenderedSelectorsConfig.SCROLL_EVENTS_SELECTORS.PAGE_END;


var DESKTOP_AND_MOBILE_SCROLL_SELECTORS = [TITLE, BODY_START, SHARE_BUTTONS_BOTTOM, PAGE_END];

var SCROLL_ANCHORS_BY_PLATFORM = (_SCROLL_ANCHORS_BY_PL = {}, (0, _defineProperty3.default)(_SCROLL_ANCHORS_BY_PL, _ua.PLATFORMS.DESKTOP, DESKTOP_AND_MOBILE_SCROLL_SELECTORS), (0, _defineProperty3.default)(_SCROLL_ANCHORS_BY_PL, _ua.PLATFORMS.MOBILE_WEB, [].concat(DESKTOP_AND_MOBILE_SCROLL_SELECTORS, [TOP_POSTS])), (0, _defineProperty3.default)(_SCROLL_ANCHORS_BY_PL, _ua.PLATFORMS.NATIVE_APP, []), _SCROLL_ANCHORS_BY_PL);

function initAnalyticsAnchorScrollEventListener() {
  var header = (0, _dom.getSingleElementByClass)('header-container');
  var postCoverForEmbedLayout = (0, _dom.getSingleElementByClass)('post-cover');
  var relativeTopElement = header || postCoverForEmbedLayout;
  var anchorsSelectors = SCROLL_ANCHORS_BY_PLATFORM[(0, _ua.getPlatform)()] || [];
  var baseScrollEventConf = {
    triggerPosition: {
      top: 0
    },
    relativeTopElement: relativeTopElement,
    fireOnlyOnce: true,
    vm: _analyticsActions2.default,
    event: 'scrollAnchorReached',
    previousInViewportFlag: false
  };
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = (0, _getIterator3.default)((0, _dom.nodes)(anchorsSelectors)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var element = _step.value;

      var eventConfig = (0, _extends3.default)({}, baseScrollEventConf, {
        payload: {
          anchor: element,
          category: 'scroll',
          action: 'reached',
          label: '.' + (0, _join2.default)(element.classList, '.')
        },
        element: element
      });
      var handler = _scrollingEventsProvider2.default.register(eventConfig);

      handler(); // In case the anchor is already in the viewport, without scrolling
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}

if (!(0, _ua.getIsNativeApp)()) {
  (0, _dom.addWindowEvent)('load', initAnalyticsAnchorScrollEventListener);
}

/***/ }),

/***/ 716:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initScreenClassifer;

var _ua = __webpack_require__(10);

var _dom = __webpack_require__(13);

function initScreenClassifer() {
  var deviceTypeClassName = void 0;
  if ((0, _ua.getIsDesktop)()) {
    deviceTypeClassName = 'isDesktop';
  } else {
    deviceTypeClassName = (0, _ua.getIsTablet)() ? 'isTablet' : 'isMobile';
  }
  (0, _dom.classList)(document.body).add(deviceTypeClassName, (0, _ua.getBrowserClassName)());
}

/***/ }),

/***/ 717:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = setBodyClasses;

var _ua = __webpack_require__(10);

var _dom = __webpack_require__(13);

var _dom2 = _interopRequireDefault(_dom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function setBodyClasses() {
  var htmlTag = document.documentElement;
  htmlTag.classList.remove('no-js');
  htmlTag.classList.add('js');

  if ((0, _ua.getIsMobileOrTablet)()) {
    htmlTag.classList.add('mobile');
  }
}

/***/ }),

/***/ 719:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initPPTracker;

var _script = __webpack_require__(19);

var _pageDataObject = __webpack_require__(5);

function loadPPTrackerScript() {
  _script.external.load({
    name: 'pptracker',
    loadNow: true
  });
}

function initPPTracker() {
  if ((0, _pageDataObject.getIsPostPage)()) {
    if (_pageDataObject.postTemplate === 'slideshow') {
      if ('90min' === (0, _pageDataObject.getSite)() || '12up' === (0, _pageDataObject.getSite)()) {
        loadPPTrackerScript();
      }
    }
  }
}

/***/ }),

/***/ 720:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = handleTopPosts;

var _pageDataObject = __webpack_require__(5);

var _LazyLoadService = __webpack_require__(725);

var _LazyLoadService2 = _interopRequireDefault(_LazyLoadService);

var _preRenderedSelectorsConfig = __webpack_require__(17);

var _dom = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SECTION_TITLE_TOP_POSTS_AFTER_POST = 'section-title--top-posts-after-post';
var SECTION_TITLE_TOP_POSTS_SIDE_BAR = 'section-title--top-posts-side-bar';
var TOP_POSTS_AFTER_POST = 'top-posts-after-post';
var TOP_POSTS_SIDE_BAR = 'top-posts-side-bar';
var SECTION_TITLE = 'section-title';

function shouldShowTopPosts() {
  var postItem = (0, _dom.node)(_preRenderedSelectorsConfig.SELECTORS.TOP_POSTS_AFTER_POST_ITEM_IMAGE_CONTAINER) || (0, _dom.node)(_preRenderedSelectorsConfig.SELECTORS.TOP_POSTS_SIDE_BAR_ITEM_IMAGE_CONTAINER);
  return (0, _pageDataObject.getIsFull)() && postItem;
}

function shouldShowTopPostsAfterPosts() {
  var postAfter = (0, _dom.node)(_preRenderedSelectorsConfig.SELECTORS.POST_AFTER);
  return postAfter.dataset.shouldShowRecommendations === '0';
}

function lazyLoadMedia(container, titleElement) {
  return container && titleElement && _LazyLoadService2.default.create({
    loadCallback: function loadCallback() {
      return _LazyLoadService2.default.loadMedia(container);
    },
    loadTriggerElement: titleElement
  }) || false;
}

function initLazyLoadAfterPost() {
  var container = (0, _dom.getSingleElementByClass)(TOP_POSTS_AFTER_POST);
  var titleElement = (0, _dom.getSingleElementByClass)(SECTION_TITLE_TOP_POSTS_AFTER_POST);
  return lazyLoadMedia(container, titleElement);
}

function initLazyLoadSideBar() {
  var container = (0, _dom.getSingleElementByClass)(TOP_POSTS_SIDE_BAR);
  var titleElement = (0, _dom.getSingleElementByClass)(SECTION_TITLE_TOP_POSTS_SIDE_BAR);
  return lazyLoadMedia(container, titleElement);
}

function showTopPostsAfterPost() {
  (0, _dom.updateClassName)(_preRenderedSelectorsConfig.SELECTORS.TOP_POSTS_AFTER_POST, TOP_POSTS_AFTER_POST, '');
  var sectionTitleModifiers = {};
  sectionTitleModifiers[TOP_POSTS_AFTER_POST] = true;
  (0, _dom.updateClassName)(_preRenderedSelectorsConfig.SELECTORS.SECTION_TITLE_TOP_POSTS_AFTER_POST, SECTION_TITLE, sectionTitleModifiers);
}

function showTopPostsSideBar() {
  (0, _dom.updateClassName)(_preRenderedSelectorsConfig.SELECTORS.TOP_POSTS_SIDE_BAR, TOP_POSTS_SIDE_BAR, '');
  var sectionTitleModifiers = {};
  sectionTitleModifiers[TOP_POSTS_SIDE_BAR] = true;
  (0, _dom.updateClassName)(_preRenderedSelectorsConfig.SELECTORS.SECTION_TITLE_TOP_POSTS_SIDE_BAR, SECTION_TITLE, sectionTitleModifiers);
}

function showTopPosts() {
  if (shouldShowTopPostsAfterPosts()) {
    initLazyLoadAfterPost();
    showTopPostsAfterPost();
  } else {
    showTopPostsSideBar();
    initLazyLoadSideBar();
  }
}

function handleTopPosts() {
  if (shouldShowTopPosts()) {
    showTopPosts();
  }
}

/***/ }),

/***/ 721:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(33);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.default = initPageTemplateClassifier;

var _pageDataObject = __webpack_require__(5);

var _dom = __webpack_require__(13);

var _console = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getTemplateClassName(mediaType) {
  return 'media-type--' + mediaType;
}

function initPageTemplateClassifier() {
  var _classList;

  var classNames = (0, _pageDataObject.getPostMediaTypes)().map(getTemplateClassName);
  if (!classNames.length) {
    (0, _console.warn)('This page has no templates', { mediaTypes: (0, _pageDataObject.getPostMediaTypes)(), classNames: classNames });
    return;
  }
  (_classList = (0, _dom.classList)(document.body)).add.apply(_classList, (0, _toConsumableArray3.default)(classNames));
}

/***/ }),

/***/ 722:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _pageDataObject = __webpack_require__(5);

var _script = __webpack_require__(19);

var _ua = __webpack_require__(10);

var _externalScripts = __webpack_require__(52);

var _riddleEmbedProvider = __webpack_require__(784);

var _riddleEmbedProvider2 = _interopRequireDefault(_riddleEmbedProvider);

var _newscorpEmbedProvider = __webpack_require__(426);

var _newscorpEmbedProvider2 = _interopRequireDefault(_newscorpEmbedProvider);

var _twitterEmbedProvider = __webpack_require__(786);

var _twitterEmbedProvider2 = _interopRequireDefault(_twitterEmbedProvider);

var _adblockDetectorProvider = __webpack_require__(154);

var _adblockDetectorProvider2 = _interopRequireDefault(_adblockDetectorProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// disabled until biz issues are resolved.
// import initScribblelive from '../../providers/scribblelive/scribbleliveEmbedProvider';

// Routing initialization
__webpack_require__(785);

// Embeds initialization
__webpack_require__(779);
__webpack_require__(426);
__webpack_require__(781);
__webpack_require__(782);

var isFullLayout = _ua.path.isFullLayout,
    isEmbedded = _ua.path.isEmbedded;


if (!(0, _ua.getIsMobileOrTablet)() && isFullLayout && !(0, _pageDataObject.getIsDraft)()) {
  __webpack_require__(316);
}

(0, _twitterEmbedProvider2.default)();
(0, _riddleEmbedProvider2.default)();

function addNameAndLoadNow(scriptConf) {
  return {
    loadNow: true,
    name: scriptConf.name
  };
}

var externalsToLoad = [];

// if (!getIsNativeApp() && !isEmbedded) {
//   externalsToLoad.push(externalScriptsConfig.perimeterX)
// }

(0, _newscorpEmbedProvider2.default)();
// initScribblelive();

(0, _adblockDetectorProvider2.default)();

_script.external.loadAll.apply(null, externalsToLoad.map(addNameAndLoadNow));

/***/ }),

/***/ 723:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routes = undefined;

var _slideshowComponent = __webpack_require__(710);

var _slideshowComponent2 = _interopRequireDefault(_slideshowComponent);

var _pageDataObject = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var slideshowRoutes = {
  '/posts/:postId': _slideshowComponent2.default,
  '/posts/:postId/:slideId': _slideshowComponent2.default,
  '/:locale/posts/:postId': _slideshowComponent2.default,
  '/:locale/posts/:postId/:slideId': _slideshowComponent2.default,

  '/synd/posts/:postId': _slideshowComponent2.default,
  '/synd/posts/:postId/:slideId': _slideshowComponent2.default,
  '/embed/posts/:postId': _slideshowComponent2.default,
  '/embed/posts/:postId/:slideId': _slideshowComponent2.default,
  '/hybrid/posts/:postId': _slideshowComponent2.default,
  '/hybrid/posts/:postId/:slideId': _slideshowComponent2.default,

  '/:locale/embed/posts/:postId': _slideshowComponent2.default,
  '/:locale/embed/posts/:postId/:slideId': _slideshowComponent2.default,
  '/:locale/synd/posts/:postId': _slideshowComponent2.default,
  '/:locale/synd/posts/:postId/:slideId': _slideshowComponent2.default,

  '/:locale/hybrid/posts/:postId': _slideshowComponent2.default,
  '/:locale/hybrid/posts/:postId/:slideId': _slideshowComponent2.default,

  '/preview/:postId': _slideshowComponent2.default,
  '/preview/:postId/:slideId': _slideshowComponent2.default,
  '/:locale/preview/:postId': _slideshowComponent2.default,
  '/:locale/preview/:postId/:slideId': _slideshowComponent2.default
};

var routes = exports.routes = (0, _pageDataObject.getIsSlideshow)() ? slideshowRoutes : {};

/***/ }),

/***/ 725:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(58);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _setImmediate2 = __webpack_require__(253);

var _setImmediate3 = _interopRequireDefault(_setImmediate2);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _BaseVm2 = __webpack_require__(63);

var _BaseVm3 = _interopRequireDefault(_BaseVm2);

var _lazyLoadStore = __webpack_require__(760);

var _lazyLoadStore2 = _interopRequireDefault(_lazyLoadStore);

var _lazyLoadActions = __webpack_require__(420);

var _lazyLoadActions2 = _interopRequireDefault(_lazyLoadActions);

var _scrollingEventsProvider = __webpack_require__(221);

var _scrollingEventsProvider2 = _interopRequireDefault(_scrollingEventsProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint semi:0 */
var LazyLoadService = function (_BaseVm) {
  (0, _inherits3.default)(LazyLoadService, _BaseVm);

  function LazyLoadService() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck3.default)(this, LazyLoadService);

    options.store = options.store || _lazyLoadStore2.default;

    var _this = (0, _possibleConstructorReturn3.default)(this, (LazyLoadService.__proto__ || (0, _getPrototypeOf2.default)(LazyLoadService)).call(this, options));

    _this.loadCallback = options.loadCallback;
    _this.loadTriggerElement = options.loadTriggerElement;
    _this.loadCallbackExecuted = false;
    _this.registerScrollingActions();
    return _this;
  }

  (0, _createClass3.default)(LazyLoadService, [{
    key: 'onChange',
    value: function onChange(action) {
      if (!this.loadCallbackExecuted && this.loadCallback) {
        this.loadCallback();
        this.loadCallbackExecuted = true;
      }
    }
  }, {
    key: 'loadTargetReached',
    value: function loadTargetReached(scrollingEventObject) {
      if (scrollingEventObject.isInitial && !scrollingEventObject.isInViewport) {
        return;
      }
      _lazyLoadActions2.default.loadTargetReached({
        scrollingEventObject: scrollingEventObject,
        element: this.loadTriggerElement
      });
    }
  }, {
    key: 'registerScrollingActions',
    value: function registerScrollingActions() {
      var vm = this;
      this.scrollingEvents.forEach(function (eventConfig) {
        eventConfig.vm = vm;
        (0, _setImmediate3.default)(function () {
          vm.loadTargetReached({
            isInViewport: _scrollingEventsProvider2.default.checkIfElementInViewport(eventConfig),
            isInitial: true
          });
        });
        _scrollingEventsProvider2.default.register(eventConfig);
      });
      return this;
    }
  }, {
    key: 'scrollingEvents',
    get: function get() {
      var loadTriggerElement = this.loadTriggerElement;

      return [{
        element: loadTriggerElement,
        triggerPosition: {
          bottom: 100 //height percentage from top
          //bottom: 100 height percentage from bottom
        },
        event: 'loadTargetReached',
        relativeTopElement: loadTriggerElement
      }];
    }
  }], [{
    key: 'loadMedia',
    value: function loadMedia(el) {
      if (!el) {
        return;
      }
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(el.querySelectorAll('img')), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var media = _step.value;

          media.setAttribute('src', media.dataset.src);
          delete media.dataset.src;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }]);
  return LazyLoadService;
}(_BaseVm3.default);

exports.default = LazyLoadService;

/***/ }),

/***/ 760:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(71);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _lazyLoadActions = __webpack_require__(420);

var _lazyLoadActions2 = _interopRequireDefault(_lazyLoadActions);

var _baseStore = __webpack_require__(77);

var _dom = __webpack_require__(13);

var _scrollingEventsProvider = __webpack_require__(221);

var _scrollingEventsProvider2 = _interopRequireDefault(_scrollingEventsProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LazyLoadStore = function (_BaseStore) {
  (0, _inherits3.default)(LazyLoadStore, _BaseStore);

  function LazyLoadStore() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck3.default)(this, LazyLoadStore);

    var _this = (0, _possibleConstructorReturn3.default)(this, (LazyLoadStore.__proto__ || (0, _getPrototypeOf2.default)(LazyLoadStore)).call(this, options));

    _this.load = false;
    return _this;
  }

  (0, _createClass3.default)(LazyLoadStore, [{
    key: 'routeAction',
    value: function routeAction(action) {
      var ACTIONS = _lazyLoadActions2.default.TYPES;
      switch (action.type) {
        case ACTIONS.REACHED_LOAD_TARGET:
          this.load = this.load || true;
          this.emitChange();
      }
    }
  }, {
    key: 'emitChange',
    value: function emitChange() {
      return (0, _get3.default)(LazyLoadStore.prototype.__proto__ || (0, _getPrototypeOf2.default)(LazyLoadStore.prototype), 'emitChange', this).call(this);
    }
  }]);
  return LazyLoadStore;
}(_baseStore.BaseStore);

var lazyLoadStore = LazyLoadStore.create();

exports.default = lazyLoadStore;

/***/ }),

/***/ 761:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _adActions = __webpack_require__(50);

var _window = __webpack_require__(8);

var _baseStore = __webpack_require__(77);

var _adsConfig = __webpack_require__(27);

var _navbarActions = __webpack_require__(313);

var _dom = __webpack_require__(13);

var _scrollingEventsProvider = __webpack_require__(221);

var _scrollingEventsProvider2 = _interopRequireDefault(_scrollingEventsProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var debugAdSizes = _window.queryString.debugAdSizes;

var NavbarStore = function (_BaseStore) {
  (0, _inherits3.default)(NavbarStore, _BaseStore);

  function NavbarStore() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck3.default)(this, NavbarStore);

    var _this = (0, _possibleConstructorReturn3.default)(this, (NavbarStore.__proto__ || (0, _getPrototypeOf2.default)(NavbarStore)).call(this, options));

    _this.merge({
      isStickyEnabled: false,
      hasTitle: false
    });
    return _this;
  }

  (0, _createClass3.default)(NavbarStore, [{
    key: 'routeAction',
    value: function routeAction(action) {
      switch (action.type) {
        case _navbarActions.TYPES.REACHED_POST_TITLE:
          return this.repositionTitle(action.scrollingEventObject);
        case _adActions.TYPES.SLOT_RENDERED:
          var adId = action.adId,
              e = action.event;

          debugAdSizes && this.info(adId, e);
          if (adId === _adsConfig.AD_FORMATS.Top && e.size) {
            this.repositionMobileHeader(e.size[1]);
          }
          return this;
        default:
          return this;
      }
    }
  }, {
    key: 'repositionMobileHeader',
    value: function repositionMobileHeader(topHeight) {
      return this.emitChange({ topHeight: topHeight });
    }
  }, {
    key: 'repositionTitle',
    value: function repositionTitle(isInViewport) {
      var eventConfig = {
        isInViewport: isInViewport,
        triggerFlag: 'hasTitle',
        triggerEvent: 'emitChange',
        customCondition: window.scrollY > (0, _dom.getSingleElementByClass)('post-article__post-title').offsetTop,
        store: this
      };
      _scrollingEventsProvider2.default.triggerEventOnce(eventConfig);
      return this;
    }
  }, {
    key: 'isStickyEnabled',
    get: function get() {
      return this.state.isStickyEnabled;
    },
    set: function set(bool) {
      this.state.isStickyEnabled = bool;
    }
  }, {
    key: 'hasTitle',
    get: function get() {
      return this.state.hasTitle;
    },
    set: function set(bool) {
      this.state.hasTitle = bool;
    }
  }]);
  return NavbarStore;
}(_baseStore.BaseStore);

var navbarStore = NavbarStore.create();

exports.default = navbarStore;

/***/ }),

/***/ 762:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _baseStore = __webpack_require__(77);

var _baseStore2 = _interopRequireDefault(_baseStore);

var _window = __webpack_require__(8);

var _appStore = __webpack_require__(23);

var _slideshowActions = __webpack_require__(246);

var _slideshowReducer = __webpack_require__(709);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var adsDebugRefresh = _window.queryString.adsDebugRefresh;
var START_SLIDE_CHANGE = _slideshowActions.TYPES.START_SLIDE_CHANGE,
    COMPLETE_SLIDE_CHANGE = _slideshowActions.TYPES.COMPLETE_SLIDE_CHANGE,
    SLIDESHOW_INITIALIZATION_FINISHED = _slideshowActions.TYPES.SLIDESHOW_INITIALIZATION_FINISHED;

var SlideshowStore = function (_BaseStore) {
  (0, _inherits3.default)(SlideshowStore, _BaseStore);

  function SlideshowStore() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck3.default)(this, SlideshowStore);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SlideshowStore.__proto__ || (0, _getPrototypeOf2.default)(SlideshowStore)).call(this, options));

    _this.merge({
      currentSlideIndex: 0,
      newSlideIndex: 0,
      navigationButtonsLoaded: false
    });
    (0, _appStore.addReducer)(_slideshowReducer.stateKey, _slideshowReducer.slideshowReducer);
    return _this;
  }

  (0, _createClass3.default)(SlideshowStore, [{
    key: 'routeAction',
    value: function routeAction(action) {
      switch (action.type) {
        case START_SLIDE_CHANGE:
          adsDebugRefresh && this.info('START_SLIDE_CHANGE', { action: action });
          return this.startSlideChange(action.slideEventObject);
        case COMPLETE_SLIDE_CHANGE:
          return this.completeSlideChange(action.slideId);
        case SLIDESHOW_INITIALIZATION_FINISHED:
          return this.slideshowInitializationFinished();
        default:
      }
      return this;
    }
  }, {
    key: 'startSlideChange',
    value: function startSlideChange(slideEventObject) {
      var slideId = slideEventObject.slideId;

      if (slideId >= 0) {
        return this.emitChange(slideId);
      }
    }
  }, {
    key: 'completeSlideChange',
    value: function completeSlideChange(slideId) {
      this.currentSlideIndex = slideId;
    }
  }, {
    key: 'slideshowInitializationFinished',
    value: function slideshowInitializationFinished() {
      this.initializationFinished = true;
    }
  }, {
    key: 'initializationFinished',
    get: function get() {
      return this.state.initializationFinished;
    },
    set: function set(bool) {
      this.state.initializationFinished = bool;
    }
  }, {
    key: 'currentSlideIndex',
    get: function get() {
      return this.state.currentSlideIndex;
    },
    set: function set(slideId) {
      this.state.currentSlideIndex = slideId;
    }
  }]);
  return SlideshowStore;
}(_baseStore2.default);

var slideshowStore = SlideshowStore.create();

exports.default = slideshowStore;

/***/ }),

/***/ 766:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(71);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _fn = __webpack_require__(15);

var _mithril = __webpack_require__(54);

var _dom = __webpack_require__(13);

var _hamburger = __webpack_require__(405);

var _ua = __webpack_require__(10);

var _headerComponents = __webpack_require__(196);

var _BaseView2 = __webpack_require__(84);

var _BaseView3 = _interopRequireDefault(_BaseView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavbarView = function (_BaseView) {
  (0, _inherits3.default)(NavbarView, _BaseView);

  function NavbarView() {
    (0, _classCallCheck3.default)(this, NavbarView);
    return (0, _possibleConstructorReturn3.default)(this, (NavbarView.__proto__ || (0, _getPrototypeOf2.default)(NavbarView)).apply(this, arguments));
  }

  (0, _createClass3.default)(NavbarView, [{
    key: 'view',
    value: function view(ctrl) {
      (0, _get3.default)(NavbarView.prototype.__proto__ || (0, _getPrototypeOf2.default)(NavbarView.prototype), 'view', this).call(this, ctrl);
      return (0, _mithril.createElementWithCallback)('.navbar-shared-component', {
        callback: this.viewRenderCallback(ctrl),
        children: this.getCurrentView(ctrl.vm)
      });
    }
  }, {
    key: 'viewRenderCallback',
    value: function viewRenderCallback(ctrl) {
      var _this2 = this;

      var vm = ctrl.vm;

      return function (element, isInit, context) {
        if (!isInit) {
          vm.registerScrollingActions();
          _this2.registerHamburgerActions();
          (0, _headerComponents.mobileHeaderOrientationHandler)(vm);
        }
      };
    }
  }, {
    key: 'getCurrentView',
    value: function getCurrentView(vm) {
      var stickyEnabledView = this.stickyEnabledView,
          stickyDisabledView = this.stickyDisabledView;

      var currentViewMethod = vm.store.isStickyEnabled ? stickyEnabledView : stickyDisabledView;
      var headerMainActions = function getHeaderActionsBemClassName(hidden) {
        return '' + (0, _dom.bem)('header-container')('header-main-actions', { hidden: hidden });
      };

      if (vm.store.isStickyEnabled && (0, _ua.getIsTablet)() && !_ua.viewport.isPortrait) {
        (0, _dom.toggleBemClass)(headerMainActions(false).split(' ').pop(), headerMainActions(true));
      } else {
        (0, _dom.toggleBemClass)(headerMainActions(true).split(' ').pop(), headerMainActions(false));
      }
      (0, _headerComponents.repositionMobileHeader)(vm);
      return currentViewMethod.apply(this, [vm]);
    }
  }, {
    key: 'stickyEnabledView',
    value: function stickyEnabledView(vm) {
      return _fn.noop;
    }
  }, {
    key: 'stickyDisabledView',
    value: function stickyDisabledView(vm) {
      return _fn.noop;
    }
  }, {
    key: 'registerHamburgerActions',
    value: function registerHamburgerActions() {
      return (0, _hamburger.registerHamburger)();
    }
  }]);
  return NavbarView;
}(_BaseView3.default);

exports.default = NavbarView;

/***/ }),

/***/ 768:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(58);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _from = __webpack_require__(49);

var _from2 = _interopRequireDefault(_from);

var _defineProperty2 = __webpack_require__(14);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _mithril = __webpack_require__(34);

var _BaseView2 = __webpack_require__(84);

var _BaseView3 = _interopRequireDefault(_BaseView2);

var _dom = __webpack_require__(13);

var _component = __webpack_require__(70);

var _mithril2 = __webpack_require__(54);

var _preRenderedSelectorsConfig = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLASS_CONSTANTS = {
  NUM_SLIDES_TO_PRELOAD: 3,
  NEXT_ANIMATION_CLASS: 'next-animation',
  PREV_ANIMATION_CLASS: 'prev-animation',
  MEDIA_SELECTORS: ['img', 'iframe']
};

var slideshowButtonsBem = (0, _dom.bem)(_preRenderedSelectorsConfig.SELECTORS.SLIDE.substring(1));
var slideshowBem = (0, _dom.bem)(_preRenderedSelectorsConfig.MOUNT_POINTS.SLIDE_CONTAINER.substring(1));

var SlideshowView = function (_BaseView) {
  (0, _inherits3.default)(SlideshowView, _BaseView);

  function SlideshowView() {
    (0, _classCallCheck3.default)(this, SlideshowView);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SlideshowView.__proto__ || (0, _getPrototypeOf2.default)(SlideshowView)).call(this));

    _this.slides = _preRenderedSelectorsConfig.MOUNT_POINTS.SLIDE_CONTAINER;
    return _this;
  }

  (0, _createClass3.default)(SlideshowView, [{
    key: 'view',
    value: function view(ctrl) {
      // Can be used without specific element. In such case creates dummy element not rendered in the Dom
      return (0, _mithril2.createElementWithCallback)({
        callback: this.viewRenderCallback(ctrl)
      });
    }
  }, {
    key: 'viewRenderCallback',
    value: function viewRenderCallback(ctrl) {
      var _this2 = this;

      var vm = ctrl.vm;

      return function (element, isInit, context) {
        _this2.conditionallyChangeSlide(vm);
        _this2.instantiateButtons(vm);
      };
    }
  }, {
    key: 'getButtonSelectors',
    value: function getButtonSelectors(modifiers) {
      return '' + slideshowButtonsBem('button', modifiers);
    }
  }, {
    key: 'navigateToRouteByNodeData',
    value: function navigateToRouteByNodeData(buttonNode, vm) {
      var url = buttonNode.dataset.title ? '/' + buttonNode.dataset.title : '';
      var routes = (0, _mithril.route)().includes('?') ? (0, _mithril.route)().substring(0, (0, _mithril.route)().indexOf('?')).split('/') : (0, _mithril.route)().split('/');
      if (_mithril.route.param('slideId')) {
        routes.pop();
      }
      routes = routes.join('/');
      url = '' + routes + url + window.location.search;
      vm.scrollPosition = window.scrollY === undefined ? document.body.parentNode.scrollTop : window.scrollY;
      (0, _mithril2.routeAndDispatch)(url);
    }
  }, {
    key: 'instantiateButtons',
    value: function instantiateButtons(vm) {
      var buttonNodes = this.buttonNodes,
          navigateToRouteByNodeData = this.navigateToRouteByNodeData;

      if (!vm.store.initializationFinished) {
        buttonNodes.forEach(function addClickHandler(buttonNode) {
          buttonNode.onclick = function buttonOnClickRouteChange(e) {
            e.preventDefault();
            navigateToRouteByNodeData(buttonNode, vm);
          };
        });
        vm.slideshowInitializationFinished();
      }
    }
  }, {
    key: 'conditionallyChangeSlide',
    value: function conditionallyChangeSlide(vm) {
      var _vm$store = vm.store,
          currentSlideIndex = _vm$store.currentSlideIndex,
          initializationFinished = _vm$store.initializationFinished;
      var newSlideIndex = vm.newSlideIndex;

      if (currentSlideIndex !== newSlideIndex || !initializationFinished) {
        var PREV_ANIMATION_CLASS = CLASS_CONSTANTS.PREV_ANIMATION_CLASS,
            NEXT_ANIMATION_CLASS = CLASS_CONSTANTS.NEXT_ANIMATION_CLASS;

        var direction = currentSlideIndex - newSlideIndex > 0 ? PREV_ANIMATION_CLASS : NEXT_ANIMATION_CLASS;
        this.changeSlide(vm, newSlideIndex, direction);
      }
    }
  }, {
    key: 'changeSlide',
    value: function changeSlide(vm, slideId, direction) {
      var _slideshowBem;

      var slides = this.slides;
      var currentSlideIndex = vm.store.currentSlideIndex;
      var PREV_ANIMATION_CLASS = CLASS_CONSTANTS.PREV_ANIMATION_CLASS,
          NEXT_ANIMATION_CLASS = CLASS_CONSTANTS.NEXT_ANIMATION_CLASS;

      slides[currentSlideIndex].className = slideshowBem((_slideshowBem = {
        visible: false
      }, (0, _defineProperty3.default)(_slideshowBem, PREV_ANIMATION_CLASS, false), (0, _defineProperty3.default)(_slideshowBem, NEXT_ANIMATION_CLASS, false), _slideshowBem));
      slides[slideId].className = slideshowBem((0, _defineProperty3.default)({
        visible: true
      }, direction, true));
      this.stopSlideVideo(currentSlideIndex);
      this.preloadNextImages(currentSlideIndex);
      vm.completeSlideChange(slideId);
      return this;
    }
  }, {
    key: 'stopSlideVideo',
    value: function stopSlideVideo(slideId) {
      var slide = this.slides[slideId];
      (0, _from2.default)(slide.getElementsByTagName('iframe'))
      // causes the iframe to reload, so if the video is playing, it will stop
      .map(function (iframeEl) {
        return iframeEl.src = iframeEl.src;
      });
    }
  }, {
    key: 'preloadNextImages',
    value: function preloadNextImages(currentIndex) {
      var preloadCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : CLASS_CONSTANTS.NUM_SLIDES_TO_PRELOAD;
      var slides = this.slides;

      var preloadUpToIndex = Math.min(slides.length, currentIndex + preloadCount);
      (0, _from2.default)(slides).slice(currentIndex, preloadUpToIndex).forEach(this.loadMedia);
      return this;
    }
  }, {
    key: 'loadMedia',
    value: function loadMedia(el) {
      if (!el) {
        return;
      }
      CLASS_CONSTANTS.MEDIA_SELECTORS.forEach(function loadMedia(typeSelector) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = (0, _getIterator3.default)(el.querySelectorAll(typeSelector + '[data-src]')), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var media = _step.value;

            media.setAttribute('src', media.getAttribute('data-src'));
            media.removeAttribute('data-src');
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      });
    }
  }, {
    key: 'slides',
    set: function set(selector) {
      this._slides = (0, _from2.default)((0, _dom.nodes)(selector));
    },
    get: function get() {
      return this._slides;
    }
  }, {
    key: 'buttonNodes',
    get: function get() {
      return (0, _from2.default)((0, _dom.nodes)(this.getButtonSelectors({
        prev: true,
        next: true,
        first: true,
        start: true
      }).split(' ').join(',.')));
    }
  }]);
  return SlideshowView;
}(_BaseView3.default);

exports.default = SlideshowView;

/***/ }),

/***/ 771:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(71);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _BaseVm2 = __webpack_require__(63);

var _BaseVm3 = _interopRequireDefault(_BaseVm2);

var _ua = __webpack_require__(10);

var _navbarActions = __webpack_require__(313);

var _dom = __webpack_require__(13);

var _socialButtonsConfig = __webpack_require__(248);

var _socialButtonsConfig2 = _interopRequireDefault(_socialButtonsConfig);

var _scrollingEventsProvider = __webpack_require__(221);

var _scrollingEventsProvider2 = _interopRequireDefault(_scrollingEventsProvider);

var _ButtonView = __webpack_require__(424);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var scrollingEvents = [{
  element: (0, _dom.getSingleElementByClass)('share-component'),
  triggerPosition: {
    bottom: 0 // height percentage from top
    // bottom: 100, // height percentage from bottom
  },
  event: 'coverSharedIconsReached',
  relativeTopElement: (0, _dom.getSingleElementByClass)('header-container')
}, {
  element: (0, _dom.getSingleElementByClass)('post-article__post-title'),
  triggerPosition: {
    bottom: 0 // height percentage from top
    // bottom: 100, // height percentage from bottom
  },
  event: 'postTitleReached',
  relativeTopElement: (0, _dom.getSingleElementByClass)('header-container')
}]; /* eslint semi:0 */

var NavbarVm = function (_BaseVm) {
  (0, _inherits3.default)(NavbarVm, _BaseVm);

  function NavbarVm() {
    (0, _classCallCheck3.default)(this, NavbarVm);
    return (0, _possibleConstructorReturn3.default)(this, (NavbarVm.__proto__ || (0, _getPrototypeOf2.default)(NavbarVm)).apply(this, arguments));
  }

  (0, _createClass3.default)(NavbarVm, [{
    key: 'onChange',
    value: function onChange(payload) {
      if (payload && payload.topHeight) {
        this.mobileHeaderTop = payload.topHeight;
      }
      (0, _get3.default)(NavbarVm.prototype.__proto__ || (0, _getPrototypeOf2.default)(NavbarVm.prototype), 'onChange', this).call(this, payload);
    }
  }, {
    key: 'coverSharedIconsReached',
    value: function coverSharedIconsReached(scrollingEventObject) {
      (0, _navbarActions.socialComponentScrollerReached)(scrollingEventObject);
    }
  }, {
    key: 'postTitleReached',
    value: function postTitleReached(scrollingEventObject) {
      (0, _navbarActions.titleScrollerReached)(scrollingEventObject);
    }
  }, {
    key: 'registerScrollingActions',
    value: function registerScrollingActions() {
      var vm = this;
      scrollingEvents.forEach(function (eventConfig) {
        eventConfig.vm = vm;
        _scrollingEventsProvider2.default.register(eventConfig);
      });
      return this;
    }
  }, {
    key: 'mobileHeaderTop',
    get: function get() {
      return this.state.mobileHeaderTop || 0;
    },
    set: function set(topHeight) {
      this.state.mobileHeaderTop = topHeight;
    }
  }, {
    key: 'mobileHeaderRepositioned',
    get: function get() {
      return this.state.mobileHeaderRepositioned;
    },
    set: function set(bool) {
      this.state.mobileHeaderRepositioned = bool;
    }
  }]);
  return NavbarVm;
}(_BaseVm3.default);

exports.default = NavbarVm;

/***/ }),

/***/ 775:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _from = __webpack_require__(49);

var _from2 = _interopRequireDefault(_from);

var _setImmediate2 = __webpack_require__(253);

var _setImmediate3 = _interopRequireDefault(_setImmediate2);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _BaseVm2 = __webpack_require__(63);

var _BaseVm3 = _interopRequireDefault(_BaseVm2);

var _dom = __webpack_require__(13);

var _mithril = __webpack_require__(54);

var _slideshowStore = __webpack_require__(762);

var _slideshowStore2 = _interopRequireDefault(_slideshowStore);

var _slideshowActions = __webpack_require__(246);

var slideshowActions = _interopRequireWildcard(_slideshowActions);

var _preRenderedSelectorsConfig = __webpack_require__(17);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint semi:0 */
var SlideshowVm = function (_BaseVm) {
  (0, _inherits3.default)(SlideshowVm, _BaseVm);

  function SlideshowVm() {
    (0, _classCallCheck3.default)(this, SlideshowVm);
    return (0, _possibleConstructorReturn3.default)(this, (SlideshowVm.__proto__ || (0, _getPrototypeOf2.default)(SlideshowVm)).apply(this, arguments));
  }

  (0, _createClass3.default)(SlideshowVm, [{
    key: 'startSlideChange',
    value: function startSlideChange(slideEventObject) {
      slideshowActions.startSlideChange(slideEventObject);
      return this;
    }
  }, {
    key: 'onChange',
    value: function onChange(slideId) {
      this.newSlideIndex = slideId;
      _mithril.m.redraw();
    }
  }, {
    key: 'completeSlideChange',
    value: function completeSlideChange(slideId) {
      (0, _setImmediate3.default)(function () {
        slideshowActions.completeSlideChange(slideId);
      });
    }
  }, {
    key: 'slideshowInitializationFinished',
    value: function slideshowInitializationFinished() {
      (0, _setImmediate3.default)(function () {
        slideshowActions.slideshowInitializationFinished();
      });
    }
  }, {
    key: 'getCurrentSlideIndex',
    value: function getCurrentSlideIndex(slideId) {
      return !slideId ? 0 : (0, _from2.default)((0, _dom.nodes)(_preRenderedSelectorsConfig.MOUNT_POINTS.SLIDE_CONTAINER)).map(function getSlideTitleAttribute(slide) {
        return slide.getAttribute('data-title-for-url');
      }).indexOf(slideId);
    }
  }, {
    key: 'newSlideIndex',
    get: function get() {
      return this.state.newSlideIndex;
    },
    set: function set(slideId) {
      this.state.newSlideIndex = slideId;
    }
  }, {
    key: 'scrollPosition',
    get: function get() {
      return this.state.currentScrollPosition || 0;
    },
    set: function set(bool) {
      this.state.currentScrollPosition = bool;
    }
  }]);
  return SlideshowVm;
}(_BaseVm3.default);

var slideshowVm = SlideshowVm.create({ store: _slideshowStore2.default });

exports.default = slideshowVm;

/***/ }),

/***/ 779:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ua = __webpack_require__(10);

if (shouldUseIframeResizer()) {
  __webpack_require__(1136).iframeResizerContentWindow;
} /* eslint semi:0 */


function shouldUseIframeResizer() {
  return _ua.isInIframe && (_ua.path.isEmbedded || _ua.path.isSyndication);
}

/***/ }),

/***/ 781:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _script = __webpack_require__(19);

var FB_CONTAINER_SELECTOR = '.facebook-container'; /* eslint semi:0 */

var FB_SCRIPT = 'facebook';
if (document.querySelector(FB_CONTAINER_SELECTOR)) {
  var fb = _script.external.load({ name: FB_SCRIPT });
  fb(function () {
    return window.FB.XFBML.parse();
  });
}

/***/ }),

/***/ 782:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _dom = __webpack_require__(13);

var _fn = __webpack_require__(15);

var _script = __webpack_require__(19);

var _preRenderedSelectorsConfig = __webpack_require__(17);

/* eslint semi:0 */
var PLAYBUZZ_SCRIPT = 'playbuzz';

if ((0, _dom.node)(_preRenderedSelectorsConfig.SELECTORS.PLAYBYZZ_CONTAINER)) {
  var playbuzz = _script.external.load({ name: PLAYBUZZ_SCRIPT });
  var renderPlayBuzz = function renderPlayBuzz() {
    return window.PlayBuzz.Feed.renderFeed();
  };
  playbuzz((0, _fn.makeSafeFn)(renderPlayBuzz));
}

/***/ }),

/***/ 784:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(255);

var _typeof3 = _interopRequireDefault(_typeof2);

exports.default = initRiddleEmbeds;

var _dom = __webpack_require__(13);

var _fn = __webpack_require__(15);

var _window = __webpack_require__(8);

var _externalScripts = __webpack_require__(52);

var _nm = __webpack_require__(26);

var _script = __webpack_require__(19);

var _analyticsActions = __webpack_require__(31);

var _analyticsActions2 = _interopRequireDefault(_analyticsActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RIDDLE_EMBED_SELECTOR = '.riddle_target';

// Riddle documentation: http://blog.riddle.com/google-event-tracking/
// Riddle example: https://examples.riddle.com/google-analytics.php
/* eslint semi:0 */
function filterRiddleMessage(_ref) {
  var data = _ref.data;

  if (data && data.riddleEvent) {
    var riddleData = data.riddleEvent;
    if ((typeof riddleData === 'undefined' ? 'undefined' : (0, _typeof3.default)(riddleData)) === 'object') {
      _analyticsActions2.default.riddleEmbedMessage(riddleData);
    }
  }
}

function addOnMessageHandlerAndInitRiddle() {
  (0, _window.addWindowEvent)('message', filterRiddleMessage, true);
  return (0, _fn.makeSafeFn)(function () {
    return window.riddleAPI.update();
  });
}

function initRiddleEmbeds() {
  if ((0, _dom.node)(RIDDLE_EMBED_SELECTOR)) {
    var riddleLoader = _script.external.load({ name: _externalScripts.externalScriptsConfig.riddle.name });
    riddleLoader(addOnMessageHandlerAndInitRiddle);
    return true;
  }
  return false;
}

(0, _nm.registerProvider)({ initRiddleEmbeds: initRiddleEmbeds });

/***/ }),

/***/ 785:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(16);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _defineProperty2 = __webpack_require__(14);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _mithril = __webpack_require__(34);

var _BaseClass2 = __webpack_require__(43);

var _BaseClass3 = _interopRequireDefault(_BaseClass2);

var _dom = __webpack_require__(13);

var _pageDataObject = __webpack_require__(5);

var _component = __webpack_require__(70);

var _slideshowRoutes = __webpack_require__(723);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Routing provider, based on Mithril. LEGACY, DO NOT USE.
 */
var initialRoute = (0, _pageDataObject.getIsSlideshow)() ? '/' : window.location.pathname;

var ROUTE_CONFIG = {
  DEFAULT_ROUTE: (0, _defineProperty3.default)({}, initialRoute, _component.empty),
  DEFAULT_ROUTE_URL: initialRoute,
  ROUTE_COMPONENTS: [_slideshowRoutes.routes]
};

var RoutingProvider = function (_BaseClass) {
  (0, _inherits3.default)(RoutingProvider, _BaseClass);

  function RoutingProvider(routeList) {
    (0, _classCallCheck3.default)(this, RoutingProvider);

    var _this = (0, _possibleConstructorReturn3.default)(this, (RoutingProvider.__proto__ || (0, _getPrototypeOf2.default)(RoutingProvider)).call(this));

    _mithril.route.mode = 'pathname';
    var defaultUrl = ROUTE_CONFIG.DEFAULT_ROUTE_URL,
        allRoutes = ROUTE_CONFIG.DEFAULT_ROUTE;

    routeList.forEach(function (routeToRegister) {
      return (0, _assign2.default)(allRoutes, routeToRegister);
    });
    (0, _mithril.route)((0, _dom.createElement)('div'), defaultUrl, allRoutes);
    _this.merge({
      routes: allRoutes,
      routingMode: _mithril.route.mode
    });
    return _this;
  }

  return RoutingProvider;
}(_BaseClass3.default);

exports.default = RoutingProvider.create(ROUTE_CONFIG.ROUTE_COMPONENTS);

/***/ }),

/***/ 786:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initTwitterEmbeds;

var _fn = __webpack_require__(15);

var _externalScripts = __webpack_require__(52);

var _nm = __webpack_require__(26);

var _script = __webpack_require__(19);

/* eslint semi:0 */
var TW_CONTAINER_SELECTOR = '.tweet-container';

function initTwitterEmbeds() {
  if (document.querySelector(TW_CONTAINER_SELECTOR)) {
    var twitterLoader = _script.external.load({ name: _externalScripts.externalScriptsConfig.twitter.name });
    twitterLoader((0, _fn.makeSafeFn)(function () {
      return window.twttr.widgets.load();
    }));
    return true;
  }
  return false;
}

(0, _nm.registerProvider)({ initTwitterEmbeds: initTwitterEmbeds });

/***/ }),

/***/ 790:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var getSocialButtonsConfig = exports.getSocialButtonsConfig = function getSocialButtonsConfig(state) {
  return state.config.socialButtonsConfig;
};

/***/ }),

/***/ 794:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var isComponentSupportedForSite = exports.isComponentSupportedForSite = function isComponentSupportedForSite(state, componentName) {
  return state.featureFlag.excludedComponentsForSite.every(function (item) {
    return item !== componentName;
  });
};

var excludedComponentsForSite = exports.excludedComponentsForSite = function excludedComponentsForSite(state) {
  return state.featureFlag.excludedComponentsForSite;
};

/***/ }),

/***/ 806:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _from = __webpack_require__(49);

var _from2 = _interopRequireDefault(_from);

exports.recommendedListReducers = recommendedListReducers;

var _recommendedVideos = __webpack_require__(223);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialRecommendedItems = (0, _from2.default)({ length: 5 }, function (v, i) {
  return i;
}).map(function (item) {
  return {
    id: 0,
    title: '',
    description: '',
    image: '',
    hlink: '#'
  };
});

var INITIAL_STATE = {
  isInitialized: false,
  recievedError: false,
  recommendedItems: initialRecommendedItems,
  playlistId: null
};

function setState(state, newState) {
  return (0, _extends3.default)({}, state, newState);
}

function recommendedListReducers() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments[1];

  switch (action.type) {
    case _recommendedVideos.RECEIVED_RECOMMENDATIONS_DATA:
      return setState(state, action.payload);
    case _recommendedVideos.RECEIVED_RECOMMENDATIONS_DATA_ERROR:
      return setState(state, action.payload);
    case _recommendedVideos.SET_PLAYLIST:
      return setState(state, { playlistId: action.payload });
    default:
      return state;
  }
}

/***/ }),

/***/ 815:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.markTiming = markTiming;
function markTiming(name) {
  if (window.performance && window.performance.mark) {
    window.performance.mark('mm_' + name);
  }
}

/***/ }),

/***/ 820:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(840), __esModule: true };

/***/ }),

/***/ 824:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(853), __esModule: true };

/***/ }),

/***/ 840:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(888);
module.exports = __webpack_require__(20).Array.map;

/***/ }),

/***/ 85:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MONTI_PREROLL_AD_TYPE_PREFIX = undefined;

var _map = __webpack_require__(225);

var _map2 = _interopRequireDefault(_map);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _keys = __webpack_require__(22);

var _keys2 = _interopRequireDefault(_keys);

exports.getVideoAdTargeting = getVideoAdTargeting;
exports.getVideoAdServerUrl = getVideoAdServerUrl;
exports.getVideoTag = getVideoTag;
exports.default = setPageTargeting;

var _array = __webpack_require__(101);

var _object = __webpack_require__(12);

var _window = __webpack_require__(8);

var _fn = __webpack_require__(15);

var _pageContext = __webpack_require__(61);

var _userStore = __webpack_require__(38);

var _ua = __webpack_require__(10);

var _i18nProvider = __webpack_require__(18);

var _adsConfig = __webpack_require__(27);

var _console = __webpack_require__(11);

var _geolocationProvider = __webpack_require__(44);

var _pageDataObject = __webpack_require__(5);

var _useridentifierTracker = __webpack_require__(136);

var _trafficAnalyzerService = __webpack_require__(214);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CUSTOM_CRITERIA_PREFIX = _adsConfig.ADS_QUERYSTRING_OVERRIDE_PREFIXES.CUSTOM_CRITERIA;
var DEBUG_CC = _window.queryString.adsDebugCc;

var getCcWithQsOverride = _window.getPossiblyOverriddenPropByQsWithPrefix.part(CUSTOM_CRITERIA_PREFIX);
var DEBUG_CC_SPORTS_TYPES = _window.queryString.adsDebugSportsTypes;
var SPORTS_TYPE_FOOTBALL = 'Soccer';
var SPORTS_TYPE_AMERICAN = 'American';
var SPORTS_TYPE_NEWS = 'News';
var SPORTS_TYPE_DEFAULT = SPORTS_TYPE_FOOTBALL;
var SPORTS_TYPE_BY_DOMAIN = {
  '12up': SPORTS_TYPE_AMERICAN,
  pluralist: SPORTS_TYPE_NEWS
};
var MONTI_PREROLL_AD_TYPE_PREFIX = exports.MONTI_PREROLL_AD_TYPE_PREFIX = 'preroll';
var MONTI_MIDROLL_AD_TYPE_PREFIX = 'midroll';
var MONTI_FIRST_PREROLLS_AD_TYPES = ['preroll0', 'preroll1'];

var affiliateId = (0, _pageContext.getInfluencerId)() || '0';

function dfpTargetingValueToString(value) {
  if ((0, _array.isArray)(value)) {
    return value;
  }
  return value.toString();
}

function debugGroup(groupName) {
  DEBUG_CC && (0, _console.groupCollapsed)('Custom Criteria: ' + groupName + ' ads');
}

function debugGroupEnd() {
  DEBUG_CC && (0, _console.groupEnd)();
}

function setTargetingViaTargetingFn(setTargetingFn, key, value) {
  DEBUG_CC && (0, _console.info)('%c[CC] %s:', 'font-style: italic; color: green;', key, value);
  (0, _fn.makeSafeFn)(setTargetingFn).invoke(key, value);
}

function setCustomCriteria(setTargetingFn, customCriteriaValue, customCriteriaName) {
  var possiblyOverridenCcValue = getCcWithQsOverride(customCriteriaName, customCriteriaValue);
  if (possiblyOverridenCcValue) {
    setTargetingViaTargetingFn(setTargetingFn, customCriteriaName, possiblyOverridenCcValue);
  }
  return setTargetingFn;
}

function addCustomCriteria(setTargetingFn, additionalCustomCriteriaKey) {
  return setCustomCriteria(setTargetingFn, undefined, additionalCustomCriteriaKey);
}

var removeCcPrefix = _window.unprefixQsProperty.part(CUSTOM_CRITERIA_PREFIX);

function isUnknownCustomCriteria(qsKey, index, allQsKeys) {
  // this function has to be bound to customCriteriaMap to work
  return qsKey.startsWith(CUSTOM_CRITERIA_PREFIX) && !(removeCcPrefix(qsKey) in this);
}

var DEFAULT_ENV = 'production';

function getAdditionalCustomCriteriaKeys(customCriteriaMap) {
  return (0, _keys2.default)(_window.queryString).filter(isUnknownCustomCriteria, customCriteriaMap).map(removeCcPrefix);
}

function getLocaleNameForDfp() {
  return (0, _i18nProvider.getShortLocale)().toUpperCase();
}

var countryCode = _geolocationProvider.NO_LOCATION;

function setCurrentCountryCode(countryCodeResult) {
  countryCode = countryCodeResult;
}

(0, _geolocationProvider.getCountryCode)().then(setCurrentCountryCode).catch(_fn.noop);

function getCustomCriteriaMapFromQueryString(qs) {
  /* eslint-disable camelcase */
  var utmMedium = qs.utm_medium,
      utmSource = qs.utm_source,
      utmCampaign = qs.utm_campaign,
      partnerId = qs.partnerId;
  // eslint-enable

  return {
    affiliateId: affiliateId,
    partnerId: partnerId,
    utmMedium: utmMedium,
    utmSource: utmSource,
    utmCampaign: utmCampaign
  };
}

function getSportsTypesByDomain(domain) {
  var singleSportsType = SPORTS_TYPE_BY_DOMAIN[domain] || SPORTS_TYPE_DEFAULT;
  DEBUG_CC_SPORTS_TYPES && (0, _console.info)('[CC]\ncurrent domain: %s,\nsports-type: %s', domain, singleSportsType);
  return [singleSportsType];
}

function getPromotedMediaCc() {
  return (0, _pageDataObject.get)('post.title', '').includes('VIDEO') ? 'video' : null;
}

function isSkinEligible() {
  return window.innerWidth > 321 ? true : false;
}

function getBaseCustomCriteriaMap() {
  var mainLevels = _pageDataObject.ads.hierarchyLevels.mainLevels;

  var baseCc = {
    // FIXME: not just football any longer!
    sportsTypes: getSportsTypesByDomain((0, _ua.domainFromFqdn)()),
    language: getLocaleNameForDfp(),
    platform: (0, _ua.getPlatform)(),
    articleId: (0, _pageDataObject.get)('post.id'),
    articleTemplate: (0, _pageDataObject.get)('post.template'),
    env: (0, _pageDataObject.get)('config.env', DEFAULT_ENV),
    categories: (0, _pageDataObject.get)('post.categories'),
    viewportOrientation: _ua.viewport.orientation,
    adUnitPath: mainLevels,
    countryCode: countryCode,
    markupFormat: 'web',
    promotedMedia: getPromotedMediaCc(),
    articleTeams: (0, _pageDataObject.get)('post.content_tags'),
    experimentId: undefined !== window.experimentId ? window.experimentId : '',
    format: _ua.path.isSyndication ? 'synd' : '',
    syndicationPartnerId: _ua.path.isSyndication ? (0, _pageContext.getSyndicationPartnerId)() : '',
    userIdentifier: (0, _useridentifierTracker.trackUserIdentifier)(),
    skinEligible: isSkinEligible()
    // TODOS:
    // contentProvider: 'ESPN'
    // sizes: requested slot sizes ['970x250', '300x600', ]
    // screenSize: viewport breakpoint
  };
  return (0, _extends3.default)({}, baseCc, getCustomCriteriaMapFromQueryString(_window.queryString), mainLevels);
}

var pageVideoCustomCriteria = new _map2.default();

function addVideoCcKeyValuePairToThis(ccValue, ccKey) {
  var isCcValueStringable = ccValue !== undefined && ccValue.toString instanceof Function;
  var value = isCcValueStringable ? ccValue.toString() : '';
  if (value.length) {
    this.push(ccKey + '=' + value);
  }
  return this;
}

function getVideoAdTargeting() {
  var instanceCustomCriteria = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _map2.default();

  if (pageVideoCustomCriteria.size === 0) {
    var setTargetingFn = pageVideoCustomCriteria.set.bind(pageVideoCustomCriteria);
    var setVideoCc = setCustomCriteria.bind(null, setTargetingFn);
    debugGroup('video');
    var baseCustomCriteriaMap = getBaseCustomCriteriaMap();
    var trafficInfo = (0, _trafficAnalyzerService.getTrafficInfo)();
    var customCriteriaMap = (0, _extends3.default)({}, baseCustomCriteriaMap, trafficInfo);
    (0, _object.iterate)(customCriteriaMap, setVideoCc);
    var additionalCustomCriteriaKeys = getAdditionalCustomCriteriaKeys(customCriteriaMap);
    var addVideoCc = addCustomCriteria.bind(null, setTargetingFn);
    additionalCustomCriteriaKeys.forEach(addVideoCc);
    debugGroupEnd();
  }
  var videoCustomCriteria = [];
  pageVideoCustomCriteria.forEach(addVideoCcKeyValuePairToThis, videoCustomCriteria);
  instanceCustomCriteria.forEach(addVideoCcKeyValuePairToThis, videoCustomCriteria);

  var videoCustomCriteriaMap = {};
  videoCustomCriteria.forEach(function (cust_param) {
    var arr = cust_param.split('=');
    videoCustomCriteriaMap[arr[0]] = arr[1];
  });
  return videoCustomCriteriaMap;
}

function adTypeParam(adType) {
  if (adType && adType.startsWith(MONTI_PREROLL_AD_TYPE_PREFIX)) {
    return 'mm_preroll=' + adType.substr(adType.indexOf(MONTI_PREROLL_AD_TYPE_PREFIX) + MONTI_PREROLL_AD_TYPE_PREFIX.length, adType.length);
  } else if (adType && adType.startsWith(MONTI_MIDROLL_AD_TYPE_PREFIX)) {
    return 'mm_midroll=' + adType.substr(adType.indexOf(MONTI_MIDROLL_AD_TYPE_PREFIX) + MONTI_MIDROLL_AD_TYPE_PREFIX.length, adType.length);
  } else {
    return '';
  }
}

function getConsent() {
  var consent = localStorage.getItem('consentData');
  var isGdpr = localStorage.getItem('gdprApplies') ? '1' : '0';
  return '&gdpr=' + isGdpr + '&gdpr_consent=' + consent;
}

function video_cust_param(adType) {
  var cust_param = getVideoAdTargeting();
  var str = '';
  for (var c in cust_param) {
    str += c + '=' + cust_param[c] + '&';
  }
  str += adTypeParam(adType) + '&';
  str += getConsent();
  return encodeURIComponent(str);
}

function getAdUnitPath() {
  var hierarchyLevels = _pageDataObject.ads.hierarchyLevels;

  hierarchyLevels.l4 = _adsConfig.AD_FORMATS.Video;
  return hierarchyLevels.toString();
}

function getVideoAdServerUrl(description_url, adType) {
  var referel = window.location.href;
  var parsedDescriptionUrl = description_url || referel;
  return 'https://pubads.g.doubleclick.net/gampad/ads?sz=640x360|480x270|400x300|640x480&iu=/' + getAdUnitPath() + '&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&url=' + referel + '&description_url=' + parsedDescriptionUrl + '&correlator=' + Date.now() + '&cust_params=' + video_cust_param(adType);
}

function getVideoTag(description_url, adType) {
  return getVideoAdServerUrl(description_url, adType);
}

function setPageTargeting(gTag) {
  var additionalCcMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var setTargetingFn = function getDfpSetTargeting(ccKey, ccValue) {
    ccValue = dfpTargetingValueToString(ccValue); // eslint-disable-line no-param-reassign
    if (DEBUG_CC === 'verbose') {
      (0, _console.info)('%c[CC] %s:', 'font-style: italic; color: blue;', 'ccKey: \'' + ccKey + '\', ccValue: \'' + ccValue + '\'');
    }
    return gTag.pubads().setTargeting(ccKey, ccValue);
  };

  var setGtagCc = setCustomCriteria.bind(null, setTargetingFn);
  var customCriteriaMap = (0, _extends3.default)({}, getBaseCustomCriteriaMap(), additionalCcMap);
  debugGroup('display');
  (0, _object.iterate)(customCriteriaMap, setGtagCc);
  var additionalCustomCriteriaKeys = getAdditionalCustomCriteriaKeys(customCriteriaMap);
  var addGtagCc = addCustomCriteria.bind(null, setTargetingFn);
  additionalCustomCriteriaKeys.forEach(addGtagCc);
  debugGroupEnd();
  return gTag;
}

/***/ }),

/***/ 853:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(897);
var $Object = __webpack_require__(20).Object;
module.exports = function getOwnPropertyNames(it){
  return $Object.getOwnPropertyNames(it);
};

/***/ }),

/***/ 86:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cloneChildrenWithProps = undefined;

var _defineProperty2 = __webpack_require__(14);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _keys = __webpack_require__(22);

var _keys2 = _interopRequireDefault(_keys);

var _extends3 = __webpack_require__(9);

var _extends4 = _interopRequireDefault(_extends3);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

exports.withParentAttributesAsProps = withParentAttributesAsProps;
exports.reactDataset = reactDataset;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _string = __webpack_require__(47);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cloneChildrenWithProps = exports.cloneChildrenWithProps = function cloneChildrenWithProps(children, props) {
  return _react2.default.Children.map(children, function (child) {
    return child ? _react2.default.cloneElement(child, props) : false;
  });
};

function withParentAttributesAsProps(Component) {
  return function (_Component) {
    (0, _inherits3.default)(WithParentAttributesAsProps, _Component);

    function WithParentAttributesAsProps() {
      (0, _classCallCheck3.default)(this, WithParentAttributesAsProps);
      return (0, _possibleConstructorReturn3.default)(this, (WithParentAttributesAsProps.__proto__ || (0, _getPrototypeOf2.default)(WithParentAttributesAsProps)).apply(this, arguments));
    }

    (0, _createClass3.default)(WithParentAttributesAsProps, [{
      key: 'componentWillMount',
      value: function componentWillMount() {}
    }, {
      key: 'render',
      value: function render() {
        var props = this.props,
            dataset = this.dataset;

        return _react2.default.createElement(Component, (0, _extends4.default)({}, props, dataset));
      }
    }]);
    return WithParentAttributesAsProps;
  }(Component);
}

function reactDataset(data) {
  return (0, _keys2.default)(data).reduce(function (acc, dataAttr) {
    return (0, _extends4.default)({}, acc, (0, _defineProperty3.default)({}, 'data-' + (0, _string.camelCaseToDashDelimited)(dataAttr), data[dataAttr]));
  }, {});
}

/***/ }),

/***/ 888:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(40)
  , $map    = __webpack_require__(325)(1);

$export($export.P + $export.F * !__webpack_require__(452)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */){
    return $map(this, callbackfn, arguments[1]);
  }
});

/***/ }),

/***/ 897:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(185)('getOwnPropertyNames', function(){
  return __webpack_require__(448).f;
});

/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(64);

var _promise2 = _interopRequireDefault(_promise);

var _keys = __webpack_require__(22);

var _keys2 = _interopRequireDefault(_keys);

exports.fetchReactions = fetchReactions;
exports.fetchPostMetadata = fetchPostMetadata;
exports.sendData = sendData;

var _actionCounterBaseProvider = __webpack_require__(153);

var _mithril = __webpack_require__(34);

var _fetch = __webpack_require__(57);

var _pageDataObject = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint semi:0 */
var POST_METADATA = 'Post_' + (0, _pageDataObject.getPostId)();
var REACTIONS = 'PostReactions_' + (0, _pageDataObject.getPostId)();

var ACTION_COUNTER_KEYS = [REACTIONS, POST_METADATA];

function canSendData() {
  var hostsUrls = (0, _actionCounterBaseProvider.getActionProviderHosts)();
  var reportingTargets = (0, _keys2.default)(hostsUrls).map(function (k) {
    return hostsUrls[k];
  });
  return !reportingTargets.includes(_actionCounterBaseProvider.NO_HOST);
}

function fetchCounterByKey(key) {
  return (0, _actionCounterBaseProvider.fetchCounters)(ACTION_COUNTER_KEYS).then(function (counters) {
    return counters[key];
  });
}

function fetchReactions() {
  return fetchCounterByKey(REACTIONS);
}

function fetchPostMetadata() {
  return fetchCounterByKey(POST_METADATA);
}

function sendData(type) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!canSendData()) {
    return _promise2.default.reject('cannot report to action counter.');
  }

  params.ts = Date.now();

  var _getActionProviderHos = (0, _actionCounterBaseProvider.getActionProviderHosts)(),
      baseUrl = _getActionProviderHos.WRITER_ACTION_PROVIDER;

  var serializedParams = _mithril.route.buildQueryString(params);
  var url = '//' + baseUrl + '/' + type + '?' + serializedParams;
  return (0, _fetch.getResponseText)(url);
}

/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SOCIAL_BAR_ACTION_TYPES = undefined;

var _object = __webpack_require__(12);

var SOCIAL_BAR_ACTION_TYPES = exports.SOCIAL_BAR_ACTION_TYPES = (0, _object.namespacedConsts)({
  REACTIONS: {
    GET_VOTES: true,
    SEND_VOTE: true,
    DISPLAY: true,
    HIDE: true,
    SET_REACTIONS_COMPONENT_STATE: true
  }
});

/***/ })

},[1359]);


// WEBPACK FOOTER //
// webpack-postPage.js